window.catalogDetails = {
  "Tyres::Triangle::AdvanteX SUV TR259": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr259",
    "description": "All Season Performance Tire The AdvanteX SUV tire has been designed to meet the performance demands of today’s modern SUV market. The SUV market is the fastest growing vehicle and tire market in the world. The new range provides optimum vehicle fitment coverage for today’s modern SUVs. 5-RIB TREAD DESIGN: For maximum surface contact and even load bearing. Results in balanced wet & dry handling performance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr259",
    "localImage": "catalog-tyres-triangle-advantex-suv-tr259-27740a6e-0a83e4-shop-74cea0.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR259-01.png"
  },
  "Tyres::Triangle::AdvanteX TC101": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tc101",
    "description": "All Season Performance Tire The AdvanteX high performance tire has been designed to blend performance, comfort and safety. The combination of new tread pattern and better compound technology has lead to an exceptional all-round performer in all conditions. LARGE SHOULDER BLOCKS AND UNIQUE SHOULDER BLOCK SHAPE: Enhances shoulder stiffness and improves shoulder stability. Results in improved cornering in wet and dry conditions. HIGH SIPE DENSITY: Increases biting edges for traction and water dispersion.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-triangle-advantex-tc101-2279829b-shop-f53c98-official-hq.webp",
    "imageSourceUrl": "https://triangletire.ca/wp-content/uploads/2025/04/TC101-01.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tc101"
  },
  "Tyres::Triangle::AdvanteX TC101 EV": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/ev",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Triangle::AgileX A/T TR292": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr292",
    "description": "The AgileX AT All Terrain tire has been developed to address the growing market for balanced on and off road performance. Specially designed for consumers wanting the flexibility of great on-road and off-road mileage and performance. The AgileX AT, as its name suggests, delivers agility in all conditions. The new range has been extended to cover more light truck sizes, creating a comprehensive global offering. OPTIMIZED BELT ANGLE AND WIDTH: For better footprint distribution.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-triangle-agilex-a-t-tr292-d4d9bd20-shop-47909c-official-hq.webp",
    "imageSourceUrl": "https://triangletire.ca/wp-content/uploads/2025/04/TR292-01.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr292"
  },
  "Tyres::Triangle::AgileX M/T TR281": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr281",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr281",
    "localImage": "catalog-tyres-triangle-agilex-m-t-tr281-57b51a54-80d6c9-shop-9099ad.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR281-01.png"
  },
  "Tyres::Triangle::ConneX Van TV701": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tv701",
    "description": "Triangle Tire is proud to have developed a world-class line of tires for a host of applications including medium and heavy truck, and off-the-road. Triangle Tire Group, headquartered overseas, is currently the 14th largest tire company in the world distributing our tires to over 130 countries across the globe. Triangle Tire’s world class team of engineers design and create professional grade and industry specific tires that are cost-effective for all applications.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tv701"
  },
  "Tyres::Triangle::EffexSport TH202": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/th202",
    "description": "Triangle Tire is proud to have developed a world-class line of tires for a host of applications including medium and heavy truck, and off-the-road. Triangle Tire Group, headquartered overseas, is currently the 14th largest tire company in the world distributing our tires to over 130 countries across the globe. Triangle Tire’s world class team of engineers design and create professional grade and industry specific tires that are cost-effective for all applications.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/th202"
  },
  "Tyres::Triangle::EffexSport TH201": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/th201",
    "description": "Summer Ultra High Performance Tire Triangle SporteX TH201 UHP tire delivers the crisp response allowing you to master the road, even in extreme conditions. Asymmetric pattern design provides balanced performance in both wet and dry conditions. Extreme driving control with improved ride comfort and lower noise level. THREE MAIN CENTRAL GROOVES WITH ASSISTED LATERAL OBLIQUE GROOVE: Maximizes water drainage. Results in improved aquaplaning and wet grip performance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-triangle-effexsport-th201-5dc53e7e-shop-19bad7-official-hq.webp",
    "imageSourceUrl": "https://triangletire.ca/wp-content/uploads/2025/04/TH201-01.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/th201"
  },
  "Tyres::Triangle::Protract TE301": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/te301",
    "description": "Triangle TE301 value segment tire is designed to maximize your vehicle’s economic performance and provide extra miles, safely. Uniform treadwear provides long mileage and good noise attenuation as the tire wears. Low rolling noise ensures comfortable driving experience. NARROW SHOULDER BLOCK LATERAL GROOVES AND FOUR MAIN CENTRAL GROOVES: For improved grip performance during wet braking. Results in shorter braking distances and increased safety.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-triangle-protract-te301-f8a4bd53-shop-75c04d-official-hq.webp",
    "imageSourceUrl": "https://triangletire.ca/wp-content/uploads/2025/04/TE301-01.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/te301"
  },
  "Tyres::Triangle::ReliaX Touring TE307": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/te307",
    "description": "Summer High Performance Tire The ReliaX Touring TE307 is a versatile touring tire designed for a smooth and comfortable drive. It offers precise handling in all road conditions, ensuring stability and control. With excellent mileage and low fuel consumption, the TE307 delivers long-lasting performance and efficiency, making it the ideal choice for drivers seeking comfort, reliability, and value.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-triangle-reliax-touring-te307-77ca21bb-shop-c1406b-official-hq.webp",
    "imageSourceUrl": "https://triangletire.ca/wp-content/uploads/2025/04/TE307-01.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/te307"
  },
  "Tyres::Triangle::Sportex TH201": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/th201",
    "description": "Summer Ultra High Performance Tire Triangle SporteX TH201 UHP tire delivers the crisp response allowing you to master the road, even in extreme conditions. Asymmetric pattern design provides balanced performance in both wet and dry conditions. Extreme driving control with improved ride comfort and lower noise level. THREE MAIN CENTRAL GROOVES WITH ASSISTED LATERAL OBLIQUE GROOVE: Maximizes water drainage. Results in improved aquaplaning and wet grip performance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-triangle-sportex-th201-5dc53e7e-shop-9fbd8f-official-hq.webp",
    "imageSourceUrl": "https://triangletire.ca/wp-content/uploads/2025/04/TH201-01.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/th201"
  },
  "Tyres::Triangle::TR246": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr246",
    "description": "Triangle Tire is proud to have developed a world-class line of tires for a host of applications including medium and heavy truck, and off-the-road. Triangle Tire Group, headquartered overseas, is currently the 14th largest tire company in the world distributing our tires to over 130 countries across the globe. Triangle Tire’s world class team of engineers design and create professional grade and industry specific tires that are cost-effective for all applications.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr246"
  },
  "Tyres::Triangle::TR257": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr257",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr257",
    "localImage": "catalog-tyres-triangle-tr257-d7290c50-ba3502-shop-692a11.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR257-01.png"
  },
  "Tyres::Triangle::TR259": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr259",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr259",
    "localImage": "catalog-tyres-triangle-tr259-27740a6e-38a638-shop-a93ec4.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR259-01.png"
  },
  "Tyres::Triangle::TR292": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr292",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr292",
    "localImage": "catalog-tyres-triangle-tr292-d4d9bd20-2a355b-shop-25a4c8.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR292-01.png"
  },
  "Tyres::Triangle::TR652": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr652",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr652",
    "localImage": "catalog-tyres-triangle-tr652-a6c20c3b-193236-shop-570264.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR652-01.png"
  },
  "Tyres::Triangle::TR665": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr665",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr665"
  },
  "Tyres::Triangle::TR689A": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr689a",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr689a"
  },
  "Tyres::Triangle::TR918": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr918",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr918",
    "localImage": "catalog-tyres-triangle-tr918-2ef2051e-90f8b7-shop-1ee124.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR918-01.png"
  },
  "Tyres::Triangle::TR928": {
    "productUrl": "https://triangle-tire.com/en/plt/tires/tr928",
    "description": "Passenger Tires Passenger TA01 TA702 TC101 TE301 TE307 TH201 TH202 TR652 TR918 TR928 TR968 TS601 TRUCK/SUV/CUV TR257 TR259 TR281 TR292 Winter LL01 PL01 PL02 TI501 TR777 TR797 TW401 Trailer TR643 TR653 TRT01S Commercial Truck Tires TR619 TR656 TR657 TR658 TR663 TR665 TR666 TR668 TR675 TR678 TR685 TR686 TR688 TR689A TR691 TR692 TR693 TR696A TR697 TR880 TR918 TRC03 TRD01 TRD02 TRD03 TRD05 TRD06 TRD66 TRD92 TRD97 TRD98 TRL01 TRS01 TRS02 TRS06 TRS66 TRT01 TRT01S TRT02 Off-the-Road Tires TB515 E-2 G-2 L-2 TB516 E-3 L-3 T",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Triangle tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://triangle-tire.com/en/plt/tires/tr928",
    "localImage": "catalog-tyres-triangle-tr928-b4f7a8d3-20eca7-shop-b01ff7.webp",
    "imageSourceUrl": "https://triangle-tire.com/wp-content/uploads/2025/04/TR928-01.png"
  },
  "Tyres::Mickey Thompson::Baja Boss A/T": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-boss-a-t",
    "description": "Hybrid all-terrain tyre from Mickey Thompson built for aggressive off-road appearance with road-friendly all-terrain usability.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hybrid all-terrain tyre",
      "4x4 and light truck fitments available by enquiry"
    ],
    "localImage": "product-catalog-tyres-mickey-thompson-baja-boss-a-t-1847d842-shop-303ed9.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-boss-a-t/1451705be2-1745134785/baja-boss-at-640x640.png"
  },
  "Tyres::Mickey Thompson::Baja Boss M/T": {
    "productUrl": "https://www.mickeythompsontires.com/news/mickey-thompsons-baja-boss-m-t-premium-extreme-mud-terrain-tire-now-available-in-15-new-sizes",
    "description": "Mickey Thompson’s Baja Boss® M/T premium extreme mud terrain tire now in 15 new sizes",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-mickey-thompson-baja-boss-m-t-19d92feb-shop-6ec167.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/news/mickey-thompsons-baja-boss-m-t-premium-extreme-mud-terrain-tire-now-available-in-15-new-sizes/f31df86b79-1745134785/baja-boss-3q-1.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/news/mickey-thompsons-baja-boss-m-t-premium-extreme-mud-terrain-tire-now-available-in-15-new-sizes"
  },
  "Tyres::Mickey Thompson::Baja Legend EXP": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-legend-exp",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-mickey-thompson-baja-legend-exp-a3318589-shop-00d291.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-legend-exp/5904d60928-1745134785/baja-legend-exp.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-legend-exp"
  },
  "Tyres::Mickey Thompson::Baja Legend MTZ": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-legend-mtz",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-mickey-thompson-baja-legend-mtz-cd36bd2c-shop-5b18a6.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-legend-mtz/063d7d6b62-1745134785/baja-legend-mtz-q3-left.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-legend-mtz"
  },
  "Tyres::Mickey Thompson::Baja Legend MTZ Pro": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-mickey-thompson-baja-legend-mtz-pro-dc2fe48c-shop-c50f5c.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-legend-mtz/37ca67d464-1763428671/bajalegend_mtz-3qtr-r-640px-2.png"
  },
  "Tyres::Mickey Thompson::Baja Legend APZ": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-mickey-thompson-baja-legend-apz-d4f979a6-shop-f922af.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-legend-exp/4091b77793-1763428047/bajalegend_exp-3qtr-l-640px.png"
  },
  "Tyres::Mickey Thompson::Baja Pro XS": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-pro-xs",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-pro-xs",
    "rejectedImageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-pro-xs/4087612502-1745134785/Baja-pro-xs-side.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Mickey Thompson::Baja Pro X": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-pro-xs",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-pro-xs",
    "rejectedImageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-pro-xs/4087612502-1745134785/Baja-pro-xs-side.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Mickey Thompson::Baja Pro X Competition": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-mickey-thompson-baja-pro-x-competition-5f5febb3-78a86b-shop-6a9229.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/dcd76a8bb1-1745134785/259a6166-quick-edit.jpg"
  },
  "Tyres::Mickey Thompson::Baja Claw TTC": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-claw-ttc-54",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Mickey Thompson::Deegan 38 All-Terrain": {
    "productUrl": "https://www.mickeythompsontires.com/news/new-sizes-for-the-deegan-38-all-terrain",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-mickey-thompson-deegan-38-all-terrain-50f2d0ad-shop-99fc35-official-hq-cutout.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/news/new-sizes-for-the-deegan-38-all-terrain/2355781cea-1745134785/deegan-all-terrain-3q.jpg",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/news/new-sizes-for-the-deegan-38-all-terrain"
  },
  "Tyres::Mickey Thompson::Deegan 38 Mud-Terrain": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-mickey-thompson-deegan-38-mud-terrain-edf1f336-shop-6e2db7.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/ee4e6b1338-1745134785/mt-truck-builds-code-red.webp"
  },
  "Tyres::Mickey Thompson::Street Comp": {
    "productUrl": "https://www.mickeythompsontires.com/street-tires/street-comp",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-mickey-thompson-street-comp-af73d55c-shop-5d1858.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/street-tires/street-comp/86fe53cb9a-1745134785/mt-street-comp-3q-lf-300dpi-shadow-clipped.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/street-tires/street-comp"
  },
  "Tyres::Mickey Thompson::ET Street R": {
    "productUrl": "https://www.mickeythompsontires.com/drag-tires/et-street-r",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-mickey-thompson-et-street-r-c5a9db4f-shop-2dfc43-official-hq.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/drag-tires/et-street-r/64ba5d3c33-1745134785/mt-drag-qc_et-street-r-sw-overlay.jpg",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/drag-tires/et-street-r"
  },
  "Tyres::Mickey Thompson::ET Street S/S": {
    "productUrl": "https://www.mickeythompsontires.com/drag-tires/et-street-s-s",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-mickey-thompson-et-street-s-s-dc74c80c-shop-7ef36b-official-hq.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/drag-tires/et-street-s-s/e0f4695f9e-1745134785/mt-drag-qc_et-street-ss-sw-overlay.jpg",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/drag-tires/et-street-s-s"
  },
  "Tyres::Mickey Thompson::ET Street Radial Pro": {
    "productUrl": "https://www.mickeythompsontires.com/drag-tires/et-street-radial-pro",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-mickey-thompson-et-street-radial-pro-ce338b1e-shop-242edd-official-hq.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/drag-tires/et-street-radial-pro/3a35aad16e-1745134785/mt-drag-qc_et-street-radial-pro-sw-overlay.jpg",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/drag-tires/et-street-radial-pro"
  },
  "Tyres::Yokohama::ADVAN Sport V107": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Sport%20V107?type=ALL",
    "description": "The ADVAN Sport V107 is Yokohama’s flagship tyre, carrying on the original concept of the ADVAN Sport V105 while bringing it to new heights with superior driving performance. Developed on the demanding conditions of the world famous Nurburgring race circuit, the ADVAN Sport V107 enables steering stability and braking at levels surpassing those of its predecessor without compromising overall balance in performance and ride comfort. Not only does this tyre excel in performance, but it also provides drivers with a premium touch, featuring a stylish tread and sidewall design suited for the world’s premier performance cars such as Mercedes’ AMG and BMW’s M range of cars.",
    "availableSizes": [
      "235/45R17 97Y",
      "225/60R18 104W (*)",
      "225/50R18 99Y (*)",
      "225/45ZR18 95Y",
      "235/45ZR18 98Y",
      "245/45R18 96W",
      "245/45ZR18 100Y",
      "245/45R18 100Y (*)",
      "255/45ZR18 103Y",
      "225/40ZR18 92Y",
      "235/40ZR18 95Y",
      "245/40ZR18 97Y",
      "255/40R18 99Y",
      "275/40R18 103Y *",
      "275/40ZR18 XL 103Y",
      "285/40R18 105Y",
      "245/35ZR18 92Y",
      "255/35ZR18 94Y",
      "265/35ZR18 97Y",
      "235/55R19 105Y",
      "255/55R19 111Y",
      "235/50R19 99Y MO1",
      "245/50R19 105W *",
      "245/50R19 XL 105Y",
      "255/50R19 107Y",
      "225/45R19 96Y (*)",
      "245/45ZR19 102Y",
      "255/45ZR19 104Y",
      "265/45R19 105Y",
      "225/40ZR19 XL 93Y",
      "235/40ZR19 92Y",
      "235/40ZR19 96Y",
      "245/40R19 98Y",
      "245/40R19 98Y (*)",
      "255/40ZR19 100Y",
      "265/40ZR19 XL 102Y",
      "265/40R19 102Y MO",
      "275/40ZR19 105Y",
      "285/40ZR19 107Y",
      "295/40R19 108Y",
      "225/35ZR19 88Y",
      "235/35ZR19 91Y",
      "245/35ZR19 93Y",
      "255/35ZR19 96Y",
      "265/35R19 98Y",
      "275/35ZR19 100Y",
      "275/35ZR19 XL 100Y",
      "285/35R19 103Y *",
      "295/35R19 104Y MO",
      "255/30ZR19 91Y",
      "285/30ZR19 98Y",
      "235/55R20 105Y",
      "255/55R20 110Y",
      "235/50R20 104Y",
      "255/50R20 109Y",
      "265/50R20 111W",
      "275/50R20 113Y MO",
      "245/45R20 103W *",
      "255/45ZR20 105Y",
      "255/45R20 105Y",
      "265/45ZR20 108Y",
      "275/45R20 110Y",
      "285/45R20 112Y",
      "245/40ZR20 XL 99Y",
      "245/40R20 103Y",
      "255/40R20 101Y",
      "275/40R20 106W *",
      "275/40ZR20 XL 106Y",
      "285/40R20 108Y",
      "295/40ZR20 110Y",
      "305/40ZR20 112Y",
      "225/35ZR20 90Y",
      "235/35ZR20 92Y",
      "245/35ZR20 91Y",
      "245/35ZR20 95Y",
      "255/35ZR20 97Y",
      "265/35ZR20 99Y",
      "265/35R20 99Y MO1",
      "275/35ZR20 102Y",
      "285/35R20 104Y",
      "295/35ZR20 101W",
      "315/35ZR20 XL 110Y",
      "245/30ZR20 90Y",
      "255/30ZR20 92Y",
      "265/30ZR20 XL 94Y",
      "275/30ZR20 97Y",
      "285/30ZR20 XL 99Y",
      "285/30ZR20 XL 99Y *",
      "285/30R20 XL 99Y",
      "295/30ZR20 101Y",
      "295/30R20 101Y MO1",
      "305/30R20 103Y",
      "245/45R21 104Y",
      "255/45R21 106Y",
      "265/45R21 108Y",
      "275/45R21 110Y (*)",
      "275/45R21 XL 110Y",
      "285/45R21 113Y",
      "245/40R21 100Y",
      "255/40ZR21 102Y",
      "255/40R21 102Y *",
      "265/40ZR21 105Y",
      "275/40R21 107Y (*)",
      "275/40R21 107Y *",
      "285/40R21 109Y",
      "315/40R21 115Y (*)",
      "315/40ZR21 115Y",
      "245/35ZR21 96Y",
      "255/35R21 98Y MO1",
      "265/35R21 101Y",
      "275/35ZR21 XL 103Y",
      "285/35R21 105Y",
      "295/35ZR21 107Y",
      "315/35R21 111Y (*)",
      "315/35R21 111Y",
      "265/30R21 96Y",
      "275/30ZR21 98Y",
      "285/30R21 100Y",
      "295/30R21 102Y",
      "305/30R21 104Y",
      "315/30ZR21 XL 105Y",
      "295/25ZR21 XL 96Y *",
      "285/45R22 114Y MO1",
      "265/40R22 106Y",
      "275/40R22 XL 107Y (*)",
      "285/40R22 110Y MO1",
      "285/40R22 110Y NC0",
      "295/40R22 112Y",
      "325/40R22 114Y MO1",
      "265/35ZR22 102Y",
      "275/35R22 104Y MO1",
      "275/35R22 104Y",
      "295/35ZR22 XL 108Y",
      "315/35R22 111Y (*)",
      "315/35R22 111Y NC0",
      "325/35R22 114Y MO1",
      "245/30R22 92Y",
      "255/30R22 95Y",
      "285/30R22 101Y",
      "295/30R22 XL 103Y",
      "315/30ZR22 107Y",
      "295/25R22 97Y",
      "285/40ZR23 111Y",
      "HL275/35R23 108Y (*)",
      "285/35R23 107Y",
      "295/35ZR23 108Y",
      "305/35R23 111Y",
      "325/35R23 115Y",
      "305/30R23 105W",
      "HL315/30R23 111Y (*)",
      "295/30ZR24 104Y",
      "335/30R24 112Y"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Variable Width Circumferential Grooves Wider 3+1 main grooves enable exceptional hydroplaning resistance at high speeds",
      "High-Rigidity Wide Shoulder Improves pattern rigidity at ultrahigh speeds, realising powerful grip in the dry.",
      "Revised Silent Sipe Shape Thin slits positioned on the inside of the ribs suppress external vehicle noise"
    ],
    "specifications": {
      "Published size variants": "152 listed",
      "Published rim diameters": [
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch",
        "21 inch",
        "22 inch",
        "23 inch",
        "24 inch"
      ],
      "Supplier use categories": [
        "Performance",
        "Quieter Ride",
        "Superior Handling",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-advan-sport-v107-92fa0c01-shop-6d9eb9.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-advan-sport-v107-92fa0c01-shop-6d9eb9.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/advan-sport-v107.png?h=800&w=800&la=en&hash=17BCC9E8E124DA395ED594E9258167D2DA47504E",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Sport%20V107?type=ALL"
  },
  "Tyres::Yokohama::ADVAN Sport V105": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Sport%20V105?type=ALL",
    "description": "The ADVAN Sport V105 was developed on the demanding Nurburgring race circuit in Germany. This tyre delivers effortless handling in wet and dry conditions, whilst also offering a quiet and comfortable ride. Crowned ‘Best Tyre’ in the 2015 Wheels Tyre Test, the Yokohama ADVAN Sport V105 is the definitive answer for those seeking ultimate performance.",
    "availableSizes": [
      "205/55R16 91V MO",
      "225/55R16 95W",
      "195/50R16 84V",
      "195/50R16 84W LO",
      "225/50R16 92V MO",
      "235/65R17 108W",
      "255/60R17 110W",
      "205/55R17 91Y",
      "225/55R17 101Y",
      "225/55R17 97Y",
      "205/50R17 93Y",
      "205/50R17 89W",
      "225/50R17 98Y",
      "235/50R17 96Y",
      "215/45R17 91Y",
      "225/45R17 91W MO",
      "225/45R17 94Y",
      "235/45R17 97Y",
      "245/45R17 99Y",
      "245/40R17 91W MO",
      "255/40R17 98Y",
      "235/60R18 103V MO",
      "235/60R18 107W",
      "255/55R18 109Y",
      "225/50R18 95W",
      "235/50R18 101Y",
      "245/50R18 100W",
      "225/45R18 95Y",
      "225/45R18 91Y",
      "235/45R18 98Y",
      "245/45R18 100Y",
      "245/45R18 96Y",
      "255/45R18 103Y",
      "265/45R18 101Y",
      "275/45R18 107Y",
      "215/40R18 89Y",
      "225/40R18 92W",
      "225/40R18 92Y",
      "225/40ZR18 92W",
      "235/40R18 95Y",
      "245/40R18 97Y",
      "245/40R18 93Y",
      "255/40R18 95Y MO",
      "255/40R18 95Y",
      "255/40R18 99Y MO",
      "265/40R18 101Y",
      "275/40R18 99Y",
      "275/40R18 103Y",
      "245/35R18 92Y",
      "255/35R18 94Y",
      "265/35R18 97Y",
      "275/35R18 96Y",
      "285/35R18 97Y MO",
      "235/65R19 109V",
      "235/55R19 101V MO",
      "255/55R19 107Y",
      "275/55R19 111W",
      "235/50R19 99W",
      "245/50R19 105W *",
      "255/50R19 107Y",
      "235/45R19 95Y",
      "245/45R19 98Y",
      "255/45R19 100Y",
      "225/40R19 93Y",
      "235/40R19 92Y N0",
      "235/40R19 96Y",
      "245/40R19 98Y MO",
      "245/40R19 98Y",
      "245/40R19 94Y",
      "255/40R19 100Y",
      "265/40R19 98Y N0",
      "265/40R19 102Y",
      "275/40R19 105Y",
      "275/40R19 105Y *",
      "285/40R19 103Y",
      "285/40R19 107Y *",
      "225/35R19 88Y",
      "235/35R19 91Y",
      "245/35R19 93Y",
      "245/35R19 89W",
      "255/35R19 96Y MO",
      "255/35R19 96Y",
      "265/35R19 98Y",
      "275/35R19 100Y MO",
      "275/35R19 100Y",
      "275/35R19 96Y",
      "285/35R19 99Y",
      "295/35R19 100Y N0",
      "295/35R19 104Y",
      "255/30R19 91Y",
      "265/30R19 93Y",
      "275/30R19 96Y",
      "285/30R19 98Y MO",
      "285/30R19 98Y",
      "295/30R19 100Y",
      "305/30R19 102Y",
      "255/50R20 109Y",
      "265/50R20 111W",
      "285/50R20 112V",
      "245/45R20 103Y",
      "245/45R20 103Y *",
      "245/45R20 99Y",
      "255/45R20 105W",
      "265/45R20 108Y",
      "285/45R20 112Y",
      "295/45R20 114W",
      "245/40R20 99Y",
      "255/40R20 101Y N0",
      "265/40R20 104Y",
      "275/40R20 106Y",
      "275/40R20 XL 106Y",
      "275/40R20 106Y *",
      "275/40R20 106Y N0",
      "295/40R20 110Y",
      "225/35R20 90Y",
      "235/35R20 92Y",
      "245/35R20 95Y MO",
      "245/35R20 95Y",
      "245/35R20 XL 95Y",
      "255/35R20 97Y AO",
      "265/35R20 99Y",
      "275/35R20 102Y RO1",
      "285/35R20 104Y",
      "295/35R20 105Y N0",
      "315/35R20 110Y",
      "315/35R20 110Y N0",
      "245/30R20 90Y",
      "255/30R20 92Y AO",
      "255/30R20 92Y",
      "265/30R20 94Y",
      "275/30R20 97Y MO",
      "275/30R20 97Y",
      "275/30R20 XL 97Y",
      "285/30R20 99Y",
      "295/30R20 101Y",
      "305/30R20 103Y",
      "285/25R20 93Y",
      "275/45R21 110W",
      "285/45R21 113Y",
      "255/40R21 102Y",
      "265/40R21 105Y",
      "275/40R21 107Y *",
      "285/40R21 109Y",
      "295/40R21 111Y",
      "315/40R21 111Y",
      "285/35R21 105Y",
      "295/35R21 107Y N2",
      "315/35R21 111Y *",
      "305/30R21 100Y",
      "325/30ZR21 108Y",
      "295/25R21 96Y",
      "305/25R21 98Y",
      "325/25R21 102Y",
      "275/40R22 107Y",
      "285/40R22 106Y",
      "265/35R22 102Y",
      "285/35R22 106Y N0",
      "295/35R22 108Y",
      "265/30R22 97Y",
      "295/30R22 103Y",
      "315/30R22 107Y N0",
      "305/35R23 111Y",
      "305/30R23 105W",
      "315/25R23 102Y"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High Performance High speed cornering, maximum grip in any conditions, quiet and comfortable ride.",
      "Reduced Tyre Weight Improves steering response and fuel efficiency.",
      "5 Pitch Variation Reduces external noise.",
      "Matrix Body Ply Structure Enhances steering stability.",
      "Variable Width Grooves Increases wet performance at high speeds",
      "Large Shoulder Blocks Improves rigidity and dry performance at high speeds."
    ],
    "specifications": {
      "Published size variants": "164 listed",
      "Published rim diameters": [
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch",
        "21 inch",
        "22 inch",
        "23 inch"
      ],
      "Supplier use categories": [
        "Performance",
        "Quieter Ride",
        "Superior Handling",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-advan-sport-v105-785340e2-shop-8c273c.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-advan-sport-v105-785340e2-shop-8c273c.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/advan-sport-v105.png?h=800&w=800&la=en&hash=029CBA33A094B2929DE0F1BADD0FB5C4AF8E2698",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Sport%20V105?type=ALL"
  },
  "Tyres::Yokohama::ADVAN Fleva V701": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Fleva%20V701?type=ALL",
    "description": "The ADVAN Fleva V701 is a high performance sport tyre suitable for sport hatch and sedan performance cars. It offers agile handling in wet and dry conditions and is surprisingly quiet and comfortable for a sporty tyre. Developed by Yokohama’s expert engineers, the ADVAN range of tyres give drivers greater confidence to push harder without sacrificing grip.",
    "availableSizes": [
      "185/55R15 82V",
      "195/55R15 85V",
      "205/55R15 88V",
      "195/50R15 82V",
      "205/50R15 86V",
      "195/55R16 87V",
      "205/55R16 91W",
      "215/55R16 93W",
      "195/50R16 84V",
      "205/50R16 87V",
      "225/50R16 92W",
      "195/45R16 84W",
      "205/45R16 87W",
      "215/45R16 90W",
      "205/55R17 91V",
      "215/55R17 94W",
      "225/55R17 97W",
      "205/50R17 93W",
      "215/50R17 95W",
      "225/50R17 98W",
      "195/45R17 85W",
      "205/45R17 88W",
      "215/45R17 91W",
      "225/45R17 94W",
      "235/45R17 97W",
      "195/40R17 81W",
      "205/40R17 84W",
      "215/40R17 87W",
      "235/40R17 90W",
      "245/40R17 95W",
      "255/40R17 94W",
      "225/50R18 99W",
      "235/50R18 97V",
      "215/45R18 93W",
      "225/45R18 95W",
      "245/45R18 100W",
      "255/45R18 99W",
      "205/40R18 86W",
      "215/40R18 89W",
      "225/40R18 92W",
      "235/40R18 95W",
      "245/40R18 97W",
      "255/40R18 99W",
      "275/40R18 103W",
      "215/35R18 84W",
      "225/35R18 87W",
      "245/35R18 92W",
      "255/35R18 94W",
      "265/35R18 97W",
      "275/35R18 99W",
      "225/45R19 96W",
      "225/45R19 92W",
      "235/45R19 95W",
      "225/40R19 93W",
      "245/40R19 98W",
      "275/40R19 105W",
      "225/35R19 88W",
      "235/35R19 91W",
      "245/35R19 93W",
      "255/35R19 96W",
      "275/35R19 100W",
      "255/30R19 91W",
      "265/30R19 93W",
      "245/40R20 99W",
      "225/35R20 90W",
      "275/35R20 102W",
      "255/30R20 92W",
      "275/30R20 97W",
      "285/30R20 99W"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Directional Tread Pattern Enhances tread block stiffness for improved handling in wet and dry conditions.",
      "Solid Centre Rib High speed stability.",
      "Claw Groove Disperses water to improve drainage.",
      "Wide Sword Groove Improves grip when cornering.",
      "Lightning Straight Groove Increases contact area and improves wet traction.",
      "5 Pitch Variation Low tyre and cabin noise."
    ],
    "specifications": {
      "Published size variants": "69 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Fuel Efficiency",
        "Performance",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-advan-fleva-v701-a9ab1318-shop-a1210f.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-advan-fleva-v701-a9ab1318-shop-a1210f.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/advan-fleva-v701.png?h=800&w=800&la=en&hash=3F9F6277F625FD2998BE33B932170732EEC36FAF",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Fleva%20V701?type=ALL"
  },
  "Tyres::Yokohama::ADVAN Neova AD09": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Neova%20AD09?type=ALL",
    "description": "The ADVAN Neova AD09 represents the pinnacle of circuit and street usability, offering outstanding performance on tracks, winding roads and every day streets while showcasing a stylish design well suited for customised sports cars. The all new asymmetrical tread pattern allows for exceptional performance in all conditions, making it the perfect tyre for your premium or modified car.",
    "availableSizes": [
      "185/55R15 82V",
      "195/55R15 85V",
      "195/50R15 82V",
      "205/50R15 86V",
      "205/55R16 91V",
      "195/50R16 84V",
      "205/50R16 87V",
      "225/50R16 92V",
      "195/45R16 80W",
      "205/45R16 XL 87W",
      "215/45R16 86W",
      "225/45R16 89W",
      "205/50R17 89W",
      "225/50R17 XL 98W",
      "195/45R17 81W",
      "205/45R17 XL 88W",
      "215/45R17 XL 91W",
      "225/45R17 XL 94W",
      "235/45R17 94W",
      "245/45R17 95W",
      "255/45R17 102W",
      "215/40R17 XL 87W",
      "235/40R17 90W",
      "245/40R17 91W",
      "255/40R17 XL 98W",
      "245/50R18 104W",
      "215/45R18 93W",
      "225/45R18 XL 95W",
      "245/45R18 100W",
      "215/40R18 89W",
      "225/40R18 XL 92W",
      "235/40R18 XL 95W",
      "245/40R18 XL 97W",
      "255/40R18 XL 99W",
      "275/40R18 103W",
      "245/35R18 XL 92W",
      "255/35R18 94W",
      "265/35R18 XL 97W",
      "295/35R18 XL 103W",
      "285/30R18 97W",
      "295/30R18 98W",
      "225/40R19 93W",
      "235/40R19 96W",
      "245/40R19 98W",
      "255/40R19 XL 100W",
      "265/40R19 102W",
      "265/40R19 101W",
      "275/40R19 105W",
      "225/35R19 88W",
      "235/35R19 XL 91W",
      "245/35R19 XL 93W",
      "255/35R19 XL 96W",
      "265/35R19 XL 98W",
      "275/35R19 XL 100W",
      "285/35R19 103W",
      "255/30R19 91W",
      "265/30R19 XL 93W",
      "275/30R19 96W",
      "295/30R19 100W",
      "305/30R19 102W",
      "325/30R19 105W",
      "245/40R20 XL 99W",
      "255/40R20 XL 101W",
      "235/35R20 92W",
      "245/35R20 95W",
      "255/35R20 97W",
      "265/35R20 99W",
      "275/35R20 102W",
      "285/35R20 XL 104W",
      "295/35R20 101W",
      "295/35R20 105W",
      "245/30R20 XL 90W",
      "265/30R20 94W",
      "275/30R20 XL 97W",
      "285/30R20 99W",
      "305/30R20 103W",
      "335/30R20 108W",
      "305/30R21 104W",
      "325/30R21 108W",
      "295/25R21 96W"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Asymmetrical Tread Pattern Improves performance in both dry and wet conditions.",
      "Wide Wavy Grooves Enhances water evacuation resulting in exceptional hydroplaning resistance at high speeds.",
      "Wide Shoulders Improves pattern rigidity allowing for enhanced performance in dry conditions.",
      "Slightly Rounded Profile Enables high rigidity and high cornering force."
    ],
    "specifications": {
      "Published size variants": "80 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch",
        "21 inch"
      ],
      "Supplier use categories": [
        "Motorsport",
        "Performance",
        "Superior Handling",
        "Ultimate Grip"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-advan-neova-ad09-137f410a-shop-be3c7c.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-advan-neova-ad09-137f410a-shop-be3c7c.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/advan-neova-ad09.png?h=800&w=800&la=en&hash=275FC8C92A76A5EEE0D6B6AA750B13236D1DFA2C",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20Neova%20AD09?type=ALL"
  },
  "Tyres::Yokohama::ADVAN A052": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20A052?type=ALL",
    "description": "The ADVAN A052 is an Ultra High Performance street legal Trackday and Competition tyre, developed for use in circuit, gymkhana, and Targa events. The ADVAN A052 is the successor to the ADVAN A048 R-Spec Tyre. Not only does the ADVAN A052 deliver unprecedented grip performance in wet and dry conditions, it also offers a comfortable ride with fuel efficient performance thanks to Yokohama’s BluEarth technology. Hand-picked by Lotus as the OE Tyre on the Elise Cup 250 (195/50ZR16 front and 225/45ZR17 rear) for the phenomenal grip provided under a broad range of temperatures on road and track.",
    "availableSizes": [
      "185/60R13 80V",
      "205/60R13 86V",
      "195/55R15 89V",
      "195/50R15 86V",
      "205/50R15 89V",
      "225/50R15 95V",
      "205/55R16 94W",
      "195/50R16 88W LO",
      "205/50R16 91W",
      "225/50R16 96W",
      "195/45R16 84W",
      "225/45R16 93W",
      "245/45R16 94W",
      "205/45R17 88W",
      "215/45R17 91W",
      "225/45R17 94W LO",
      "235/45R17 97W",
      "205/40R17 84W",
      "215/40R17 87W",
      "245/40R17 95W",
      "255/40R17 98W",
      "235/45R18 98Y",
      "265/45R18 104Y",
      "225/40R18 92Y",
      "235/40R18 95Y",
      "245/40R18 97Y",
      "255/40R18 99Y",
      "265/40R18 101Y",
      "275/40R18 103Y",
      "255/35R18 94Y",
      "265/35R18 97Y",
      "295/35R18 103Y",
      "295/30R18 98Y",
      "315/30R18 98Y",
      "235/40R19 96Y",
      "265/40R19 102Y",
      "235/35ZR19 XL 91Y",
      "245/35R19 93Y",
      "255/35R19 96Y",
      "265/35ZR19 XL 98Y",
      "275/35R19 100Y",
      "285/35R19 XL 103Y",
      "295/35R19 104Y",
      "305/35R19 XL 106Y",
      "265/30ZR19 XL 93Y",
      "295/30R19 XL 100Y",
      "305/30R19 XL 102Y",
      "325/30R19 XL 105Y",
      "255/40R20 101Y",
      "235/35ZR20 XL 92Y",
      "245/35R20 95Y",
      "265/35R20 XL 99Y",
      "285/35R20 104Y",
      "245/30R20 90Y",
      "265/30ZR20 XL 94Y",
      "285/30R20 XL 99Y",
      "295/30R20 101Y",
      "305/30R20 XL 103Y"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Asymmetric Tread Pattern Unprecedented levels of grip in wet & dry conditions.",
      "High-Rigidity Tread Rib Two main outer tread ribs expand the contact area and deliver powerful cornering ability.",
      "Dual Straight Inner Grooves Enhances straight line stability and superior anti-hydroplaning.",
      "New Sport Compound Combination of Motorsport Technology for extreme grip and BluEarth Technology for fuel efficiency, specially developed for the A052.",
      "Straight Thin Groove Dissipates heat and prevents time drop."
    ],
    "specifications": {
      "Published size variants": "58 listed",
      "Published rim diameters": [
        "13 inch",
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch"
      ],
      "Supplier use categories": [
        "Motorsport",
        "Performance",
        "Sports Driving",
        "Ultimate Grip"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-advan-a052-aa1fddec-shop-9fe345.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-advan-a052-aa1fddec-shop-9fe345.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/advan-a052.png?h=800&w=800&la=en&hash=FEB415B60336397D86C581161B35081C40ED21A5",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/ADVAN%20A052?type=ALL"
  },
  "Tyres::Yokohama::BluEarth-GT AE51": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth-GT%20AE51?type=ALL",
    "description": "BluEarth-GT AE51 is packed with features that deliver everything you want from a tyre. Sport Performance, Wet Braking Performance, Fuel Saving Performance, Mileage Performance and Ride Comfort. Why not step up from the basic standard tyre to the “Next Level” BluEarth-GT AE51 and experience the extra margin of safety, performance and comfort. The BluEarth-GT AE51 is already recognised by Global Car Manufacturers such as Lexus, Toyota and Mazda and has been selected as original equipment due to its high level all round performance. This All Round Performer is unbeatable value for money.",
    "availableSizes": [
      "205/65R16 95H",
      "205/60R16 92V MA",
      "205/60R16 96W",
      "215/60R16 99V",
      "225/60R16 98H",
      "185/55R16 83V",
      "195/55R16 87V",
      "205/55R16 94V",
      "215/55R16 97W",
      "225/55R16 99W",
      "195/50R16 88V",
      "205/50R16 87W",
      "195/45R16 84V",
      "205/45R16 87W",
      "215/45R16 90V",
      "205/55R17 95V",
      "215/55R17 94V",
      "215/55R17 98W",
      "225/55R17 101W",
      "235/55R17 99W",
      "205/50R17 93W",
      "215/50R17 95W",
      "225/50R17 98W",
      "205/45R17 88W",
      "215/45R17 87W",
      "215/45R17 91W",
      "225/45R17 94W",
      "235/45R17 97W",
      "245/45R17 99W",
      "245/40R17 91W",
      "225/50R18 95W",
      "235/50R18 101W",
      "245/50R18 100W",
      "215/45R18 93W",
      "225/45R18 95W",
      "225/45R18 91W (GZ)",
      "235/45R18 94W",
      "245/45R18 100W",
      "255/45R18 99W",
      "205/40R18 86W",
      "215/40R18 89W",
      "225/40R18 92W",
      "235/40R18 95W",
      "245/40R18 97W",
      "255/40R18 99W",
      "225/35R18 87W",
      "255/35R18 94W",
      "265/35R18 97W",
      "225/45R19 96W",
      "235/45R19 95W",
      "245/45R19 98W",
      "225/40R19 93W",
      "235/40R19 96W",
      "245/40R19 98W",
      "225/35R19 88W",
      "235/35R19 91W",
      "245/35R19 93W",
      "255/35R19 96W",
      "275/35R19 100W",
      "275/30R19 96W",
      "245/35R20 95W",
      "275/30R20 97W"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Asymmetrical Tread Pattern Better grip, handling & comfort.",
      "Lightning Grooves Enhances wet grip performance.",
      "Advanced Construction Achieves both light weight and high durability.",
      "Two-Layered Tread Provides both high fuel economy and manoeuvrability.",
      "Side Wall Profile Reduces deformation and results in lower heat generation.",
      "Unique ART Rubber Blending Technology Improves dispersion and uniformity of silica within the compound, reducing wet braking distance."
    ],
    "specifications": {
      "Published size variants": "62 listed",
      "Published rim diameters": [
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Fuel Efficiency",
        "Quieter Ride",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-bluearth-gt-ae51-de2b915c-shop-1f8d5c.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-bluearth-gt-ae51-de2b915c-shop-1f8d5c.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/bluearth-gt-ae51.png?h=800&w=800&la=en&hash=34AE936DA8F66B5E575B915111CAA28FE12A4B38",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth-GT%20AE51?type=ALL"
  },
  "Tyres::Yokohama::BluEarth AE01": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth%20AE01?type=ALL",
    "description": "The BluEarth AE01 ‘eco tyre’ gives a quiet ride and reassuring grip on wet and slippery roads. Designed to take drivers up to 10% further on a tank, this is the tyre for everyday motorists who want to save money. This tyre is a fuel efficient eco tyre and has the grip Yokohama is famous for.",
    "availableSizes": [
      "175/65R15 84H"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Low Rolling Resistance Tyre Go 8-10% further on fuel.",
      "Five Pitch Variation Tread Design Low tyre and cabin noise.",
      "Small- Medium Cars 13 to 16 inch.",
      "Eco Friendly Uses less fuel"
    ],
    "specifications": {
      "Published size variants": "1 listed",
      "Published rim diameters": [
        "15 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Fuel Efficiency",
        "Quieter Ride",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-bluearth-ae01-ae34552a-shop-8f65e5.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-bluearth-ae01-ae34552a-shop-8f65e5.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/bluearth-ae01.png?h=800&w=800&la=en&hash=576E39D3E770154892DF8B45A6A6B31C2389E570",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth%20AE01?type=ALL"
  },
  "Tyres::Yokohama::BluEarth ES32": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth-Es%20ES32?type=ALL",
    "description": "BluEarth-Es ES32 provides a well balanced package of the four core performance traits of any tyre - wet grip, wear resistance, durability and fuel efficiency. Suitable for compact cars and family sedans, the BluEarth-Es ES32 gives a quiet ride with reassuring grip on wet slippery roads. The BluEarth-Es ES32 is built using Yokohama’s patented Nano Blend Compound; this technology allows the tyre to be more flexible which results in an optimal contact area between tyre and road promoting even wear.",
    "availableSizes": [
      "175/70R13 82T",
      "165/70R14 85T",
      "175/70R14 84H",
      "185/70R14 88H",
      "195/70R14 91H",
      "165/65R14 79T",
      "175/65R14 82H",
      "185/65R14 86H",
      "195/65R14 89H",
      "185/60R14 82H",
      "195/60R14 86H",
      "175/65R15 84H",
      "185/65R15 88H",
      "185/65R15 88S",
      "195/65R15 95V",
      "205/65R15 99H",
      "185/60R15 88H",
      "195/60R15 88H",
      "205/60R15 91H",
      "185/55R15 82V",
      "195/55R15 85V",
      "195/50R15 82V",
      "205/65R16 95H",
      "175/60R16 82H",
      "195/60R16 89H",
      "205/60R16 92H",
      "215/60R16 99V",
      "225/60R16 98V",
      "185/55R16 83V",
      "195/55R16 87V",
      "205/55R16 91V",
      "215/55R16 97V",
      "225/55R16 95V",
      "195/50R16 84V",
      "205/50R16 87V",
      "195/45R16 80V",
      "205/45R16 83V",
      "215/60R17 96H",
      "225/60R17 99H",
      "215/55R17 94V",
      "225/55R17 97W",
      "205/50R17 89V",
      "215/50R17 95V",
      "225/50R17 94V",
      "205/45R17 84V",
      "215/45R17 91V",
      "225/45R17 94V",
      "235/45R17 97V",
      "205/40R17 84V",
      "215/40R17 87V",
      "245/40R17 91V",
      "225/55R18 98V",
      "225/50R18 95V",
      "235/50R18 97W",
      "215/45R18 93W",
      "225/45R18 95W",
      "215/40R18 85W",
      "225/40R18 92W",
      "235/40R18 95W",
      "245/40R18 93W",
      "255/35R18 90W",
      "265/35R18 93W",
      "245/40R19 94W",
      "225/35R19 84W"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Rolling Resistance Characteristics Lowers fuel consumption & decreases exhaust emissions",
      "5 Pitch Variation Low tyre & cabin noise.",
      "Strong Profile Durable & Long Lasting.",
      "Lightning Groove Improves handling in wet and dry conditions.",
      "Enhanced Shoulder Blocks Improves stability and even wear.",
      "Wide Straight Grooves Increases water evacuation."
    ],
    "specifications": {
      "Published size variants": "64 listed",
      "Published rim diameters": [
        "13 inch",
        "14 inch",
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Fuel Efficiency",
        "Quieter Ride",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-bluearth-es32-3983f505-shop-c47c59.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-bluearth-es32-3983f505-shop-c47c59.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/bluearth-es-es32.png?h=800&w=800&la=en&hash=2BD5408B6CDEAEE774B46FC57FBF13D90F9F9C02",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth-Es%20ES32?type=ALL"
  },
  "Tyres::Yokohama::BluEarth RV-02": {
    "productUrl": "https://www.y-yokohama.com/global/product/tire/tires/passenger/bluearth_rv02/",
    "description": "A BluEarth grand touring tyre tuned for CUVs and MPVs, with an asymmetric pattern developed to support stable handling, low noise and resistance to uneven wear.",
    "availableSizes": [],
    "notes": [
      "This model is not listed in Yokohama Australia's current online range; Australian special-order availability must be confirmed by 110 Garage"
    ],
    "features": [
      "Asymmetric pattern developed for stable handling and low noise",
      "Four straight grooves support wet drainage and straight-line stability",
      "Shoulder and sipe design helps reduce uneven wear and road noise"
    ],
    "specifications": {
      "Market availability": "Official international model; Australian availability must be confirmed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-bluearth-rv-02-d0894133-shop-c2cf2d-official-hq-cutout.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-bluearth-rv-02-d0894133-shop-c2cf2d.webp"
    ],
    "imageSourceUrl": "https://tr.tyrereviews.com/images/tyres/Yokohama-BluEarth-RV02.jpg",
    "descriptionSource": "official-international-product-page",
    "descriptionSourceUrl": "https://www.y-yokohama.com/global/product/tire/tires/passenger/bluearth_rv02/"
  },
  "Tyres::Yokohama::BluEarth Van RY55": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth%20Van%20RY55?type=ALL",
    "description": "The BluEarth-Van RY55 is Yokohama’s flagship tyre for vans, providing the perfect combination of wear resistance, wet grip and fuel efficiency. Wear resistance and wet grip performance have been enhanced by the development of a special tread pattern along with a revised profile that optimises surface contact and pressure. The new compound includes triple polymer to boost the tyre’s durability and resistance to uneven wear and silica to enhance fuel efficiency and wet grip performance. The BluEarth-Van RY55 goes beyond your typical 9am - 5pm business days.",
    "availableSizes": [
      "185R14C 102/100S",
      "195R14C 106/104S",
      "195/70R15C 104/102S",
      "205/70R15 106/104S",
      "215/70R15 109/107S",
      "225/70R15 112/110s",
      "205/65R15C 102/100T",
      "215/65R15 104/102T",
      "195R15 106/104S",
      "185/75R16 104/102S",
      "195/75R16 110/108T",
      "205/75R16 113/111R",
      "215/75R16 116/114R",
      "225/75R16 121/120R",
      "215/70R16C 108/106S",
      "195/65R16 104/102T",
      "205/65R16C 107/105T",
      "215/65R16C 109/107T",
      "225/65R16 112/110T",
      "235/65R16C 121/119R",
      "235/65R16C 115/113T",
      "215/60R16 103/101T",
      "215/60R17 109/107T",
      "225/55R17 109/107H"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Circumferential Tread Grooves Wide Straight grooves along with multiple triangle blocks create better water drainage shortening wet braking by 9%* (*Compared to its predecessor Delivery Star RY818).",
      "Tough Shoulder Design Deep Shoulder grooves optimise surface contact which reduces uneven wear & promotes increased mileage.",
      "Fuel Efficient Compound Employing silica in the compound enhances the Rolling Resistance of the tyre by 19%*. This allows for less fuel consumption making the tyre environmentally friendly (*Compared to its predecessor Delivery Star RY818).",
      "Improved Tread Compound Triple polymer utilised in the new compound resists against uneven wear equating to high durability."
    ],
    "specifications": {
      "Published size variants": "24 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Fuel Efficiency",
        "Highway Driving",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-bluearth-van-ry55-a5168e0b-shop-953e3e.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-bluearth-van-ry55-a5168e0b-shop-953e3e.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/bluearth-van-ry55.png?h=800&w=800&la=en&hash=569703A13CCD5A76F2E87AF177C7E86A00A1CC16",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/BluEarth%20Van%20RY55?type=ALL"
  },
  "Tyres::Yokohama::Geolandar A/T G015": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20A%20T%20G015?type=ALL",
    "description": "Go beyond where the road ends and experience limitless adventures with the Yokohama Geolandar A/T G015. Engineered to provide ultimate traction where others fear to tread, the Geolandar A/T G015 is suitable for SUVs, 4WDs and Utes. It provides durability, long tread life, off-road traction, on road handling, low noise and a comfortable ride. Available in PC and LT constructions, the reinforced casing has improved resistance to cuts and chipping, temperature changes and wear due to its exclusive compound developed specifically to ensure it is suitable for a diverse range of surfaces.",
    "availableSizes": [
      "235/75R15 109H",
      "LT235/75R15 110Q",
      "205/70R15 96H",
      "215/70R15 98H",
      "255/70R15 112S",
      "265/70R15 112H",
      "33x12.50R15 108S",
      "32x11.50R15 113S",
      "31x10.50R15 109S",
      "30x9.50R15 104S",
      "235/85R16 120R",
      "205/80R16 104T",
      "225/75R16 115R",
      "245/75R16 120S",
      "265/75R16 123R",
      "265/75R16 114T",
      "285/75R16 126R",
      "295/75R16 128R",
      "315/75R16 127R",
      "215/70R16 100H",
      "225/70R16 103H",
      "235/70R16 106H",
      "245/70R16 111H",
      "LT245/70R16 118/115R",
      "255/70R16 111H",
      "255/70R16 115/112S",
      "265/70R16 112H",
      "275/70R16 114H",
      "215/65R16 98H",
      "215/65R16C 109S",
      "255/65R16 109H",
      "215/60R16 95H",
      "235/60R16 100H",
      "245/75R17 121S",
      "255/75R17 113T",
      "285/75R17 121S",
      "225/70R17 108T",
      "235/70R17 109H",
      "245/70R17 119R",
      "LT255/70R17 121S",
      "265/70R17 121S",
      "285/70R17 121S",
      "315/70R17 121S",
      "215/65R17 103H",
      "225/65R17 102H",
      "225/65R17 102T",
      "235/65R17 108H",
      "245/65R17 111H",
      "245/65R17 117/114S",
      "255/65R17 114H",
      "255/65R17 119/116S",
      "255/65R17 110H",
      "265/65R17 112H",
      "265/65R17 120/117R",
      "275/65R17 115H",
      "285/65R17 116H",
      "215/60R17 96H",
      "225/60R17 99H",
      "225/60R17 99T",
      "235/60R17 102T",
      "LT285/75R18 129S",
      "255/70R18 113H",
      "265/70R18 124R",
      "275/70R18 125S",
      "295/70R18 129S",
      "255/65R18 111H",
      "265/65R18 114H",
      "275/65R18 123S",
      "285/65R18 125S",
      "225/60R18 104H",
      "235/60R18 107H",
      "245/60R18 109H",
      "265/60R18 110H",
      "LT265/60R18 119S",
      "275/60R18 113H",
      "285/60R18 116H",
      "225/55R18 98H",
      "235/55R18 104H",
      "255/55R18 109H",
      "225/50R18 95H",
      "35x12.50R18 123R",
      "235/55R19 105H",
      "255/55R19 111H",
      "275/65R20 126R",
      "LT285/65R20 127/124S",
      "275/60R20 115H",
      "LT285/60R20 125S",
      "LT295/60R20 126S",
      "255/55R20 110H",
      "275/55R20 117H",
      "275/55R20 120/117S",
      "285/55R20 122S",
      "LT295/55R20 123S",
      "305/55R20 121S",
      "245/50R20 105H",
      "255/50R20 109H",
      "265/50R20 107H",
      "LT265/50R20 115S",
      "275/50R20 113H",
      "285/50R20 112H",
      "35x12.50R20 121R",
      "285/45R22 114H"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "New Exclusive Compound Resistance to temperature change, wear, cut and chips.",
      "Wide Shoulder Profile Improves off-road traction and promotes long, even wear.",
      "Aggressive Shoulder Design Improves off-road traction and protection from sidewall cuts and abrasions.",
      "Lug Grooves Improves off-road traction and exceptional self cleaning ability.",
      "3D Shape Sipes Strengthens tread block rigidity and prevents uneven wear for longer mileage.",
      "4 Deep Main Grooves Disperses water to help prevent hydroplaning.",
      "Road Hazard Protection Free puncture repair or tyre replacement *Conditions apply."
    ],
    "specifications": {
      "Published size variants": "102 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch",
        "22 inch"
      ],
      "Supplier use categories": [
        "Fuel Efficiency",
        "Off Road Durability",
        "On Off Road Traction",
        "Road Hazard Protection"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-geolandar-a-t-g015-86b81b56-shop-0e3705.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-geolandar-a-t-g015-86b81b56-shop-0e3705.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/geolandar-a-t-g015.png?h=800&w=800&la=en&hash=4775940A27BEE81C9BDCC79401F9AC37BFD7FC74",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20A%20T%20G015?type=ALL"
  },
  "Tyres::Yokohama::Geolandar A/T4 G018": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20A%20T4%20G018?type=ALL",
    "description": "The NEW Yokohama Geolandar AT4 is the best all terrain tyre for off-road use and city driving from the comprehensive Yokohama 4x4 tyre range. Ideal for family four-wheel drives and dual-cab work utes that require high level performance on and off-road, this tyre offers spirited drivers the best of both worlds. As the successor to the much-loved and best-selling Geolandar A/T G015 tyre, the A/T4 boasts similar on-road comfort and low noise qualities. However, it takes a leap forward with its rugged design and off-road durability. The precisely spaced angled tread block design, deep biting shoulder grooves and robust cut-resistant rubber compound equip the AT4 all terrain tyre for long-term performance on the unforgiving dirt roads and off-road tracks around Australia. It’s also designed for safety and comfort on suburban streets and highways. It has features which ensure confident wet grip, low noise, and a good steering feel.",
    "availableSizes": [
      "LT215/75R15 106S",
      "LT235/75R15 110/107S",
      "235/75R15 109T",
      "205/70R15 96H",
      "215/70R15 98H",
      "255/70R15C 112/110S",
      "265/70R15 112H",
      "33x12.50R15LT 108S",
      "32x11.50R15LT 113S",
      "31x10.50R15LT 109S",
      "33x10.50R15LT 114S",
      "30x9.50R15LT 104S",
      "LT235/85R16 120/116S",
      "LT225/75R16 115/112S",
      "LT245/75R16 120/116S",
      "245/75R16 111T",
      "265/75R16 116T",
      "LT265/75R16 123S",
      "LT285/75R16 126/123S",
      "LT295/75R16 128R",
      "LT315/75R16 127/124R",
      "215/70R16 100H",
      "225/70R16 103H",
      "235/70R16 106T",
      "LT245/70R16 118/115R",
      "245/70R16 111H",
      "255/70R16 111H",
      "255/70R16LT 120S",
      "265/70R16 112T",
      "LT265/70R16 121/118S",
      "275/70R16 114H",
      "LT305/70R16 124/121S",
      "215/65R16C 109S",
      "215/65R16 98H",
      "255/65R16 109H",
      "215/60R16 95H",
      "235/60R16 100H",
      "LT245/75R17 121/118S",
      "255/75R17 115T",
      "LT285/75R17 121/118S",
      "LT245/70R17 119/116S",
      "245/70R17 110T",
      "LT255/70R17 121S",
      "255/70R17 112T",
      "265/70R17 115T",
      "LT265/70R17 121S",
      "LT275/70R17 124/121S",
      "LT285/70R17 121/118S",
      "285/70R17 117T",
      "LT295/70R17 121/118S",
      "LT305/70R17 121R",
      "LT315/70R17 121/118S",
      "215/65R17 103H",
      "LT225/65R17 107/103S",
      "225/65R17 102H",
      "235/65R17 108H",
      "LT245/65R17 111S",
      "245/65R17 111H",
      "LT255/65R17 119/116S",
      "255/65R17 114H",
      "265/65R17 112T",
      "LT265/65R17 120/117S",
      "275/65R17 115H",
      "285/65R17 116H",
      "215/60R17 96H",
      "225/60R17 99H",
      "225/55R17 101H",
      "35x12.50R17LT 125R",
      "LT285/75R18 129S",
      "LT255/70R18 117/114S",
      "255/70R18 116H",
      "265/70R18 116H",
      "LT265/70R18 124/121S",
      "LT275/70R18 125/122S",
      "275/70R18 116T",
      "LT295/70R18 129/126S",
      "LT305/70R18 126/123R",
      "235/65R18 100H",
      "255/65R18 115H",
      "265/65R18 114H",
      "LT265/65R18 122/119S",
      "275/65R18 116H",
      "LT275/65R18 123S",
      "LT285/65R18 125/122S",
      "LT305/65R18 124/121S",
      "LT325/65R18 127S",
      "225/60R18 104H",
      "235/60R18 107H",
      "245/60R18 109H",
      "255/60R18 112H",
      "LT265/60R18 119/116S",
      "265/60R18 110H",
      "285/60R18 116H",
      "LT325/60R18 124S",
      "225/55R18 98H",
      "235/55R18 104H",
      "255/55R18 109H",
      "33x12.50R18LT 118S",
      "35x12.50R18LT 123S",
      "235/55R19 105H",
      "255/55R19 111H",
      "265/55R19 109H",
      "LT275/65R20 126/123S",
      "275/65R20 116H",
      "LT285/65R20 127/124S",
      "LT295/65R20 129S",
      "LT265/60R20 121/118S",
      "275/60R20 115H",
      "LT275/60R20 123/120S",
      "LT285/60R20 125S",
      "LT295/60R20 126/123S",
      "LT325/60R20 126S",
      "255/55R20 110H",
      "265/55R20 113H",
      "275/55R20 117H",
      "LT275/55R20 120/117S",
      "LT285/55R20 122S",
      "LT295/55R20 123/120S",
      "LT305/55R20 121/118S",
      "245/50R20 105H",
      "255/50R20 109H",
      "265/50R20LT 115S",
      "265/50R20 111H",
      "285/50R20 112H",
      "305/50R20 120S",
      "33x12.50R20LT 114S",
      "35x12.50R20LT 121R",
      "LT285/55R22 124S",
      "LT305/55R22 122/119S",
      "275/50R22 115H",
      "LT285/50R22 121S",
      "LT325/50R22 127Q",
      "285/45R22 114H",
      "305/45R22 118T"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Angled Centre Blocks - Rugged off-road appearance and performance.",
      "Zig-Zag Grooves - Wet road traction and less tread pattern noise.",
      "EdgeTec™ Grooves - Biting edges for traction off-road and in deep snow.",
      "Mud & Snow Ejectors - Keep grooves clear and protect against stone drilling.",
      "Enduro-Compound - Triple polymer compound fights cutting and chipping.",
      "Geo-Shield® Construction - Strength off-road.",
      "Dual Sidewall Protectors - Choose between 2 protective sidewall designs.",
      "Severe Snow Service Rated - Marked with the three-peak mountain snowflake rating."
    ],
    "specifications": {
      "Published size variants": "134 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch",
        "22 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Fuel Efficiency",
        "Quieter Ride",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-geolandar-a-t4-g018-dc84747e-shop-1a33e4.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-geolandar-a-t4-g018-dc84747e-shop-1a33e4.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/geolandar-a-t4-g018.png?h=800&w=800&la=en&hash=68AA28519961D5CD1056CAD9A53FE55B80BEF9A8",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20A%20T4%20G018?type=ALL"
  },
  "Tyres::Yokohama::Geolandar X-AT G016": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20X-AT%20G016?type=ALL",
    "description": "The Geolandar X-AT G016 is designed for extreme traction wherever you go, with the strength of a Mud Terrain tyre in an All Terrain pattern. Suitable for 4WDs and Utes requiring durability, long tread life, off road & wet surface traction, on road handling, low noise and a comfortable ride. Suited for drivers who use their vehicle 70% off road and 30% on road.",
    "availableSizes": [
      "31x10.50R15 109Q",
      "LT235/85R16 120Q",
      "245/75R16 111T",
      "265/75R16 123Q",
      "LT285/75R16 126Q",
      "LT315/75R16 127Q",
      "LT215/70R16 100Q",
      "LT235/70R16 104Q",
      "LT245/70R16 118Q",
      "265/70R16 116T",
      "LT265/70R16 121Q",
      "LT275/70R16 119Q",
      "245/75R17 121/118Q",
      "LT255/75R17 111Q",
      "LT285/75R17 121Q",
      "LT285/75R17 121S",
      "LT245/70R17 119S",
      "245/70R17 110T",
      "265/70R17 121Q",
      "265/70R17 115T",
      "LT275/70R17 114R",
      "285/70R17 121Q",
      "295/70R17 121Q",
      "LT305/70R17 121Q",
      "LT315/70R17 113S",
      "255/65R17 114T",
      "265/65R17 120Q",
      "265/65R17 116T",
      "LT275/65R17 121Q",
      "LT285/65R17 121Q",
      "35x12.50R17 121Q",
      "37x12.50R17 121Q",
      "37x12.50R17 124Q",
      "35x11.50R17LT 128Q",
      "285/75R18 129Q",
      "255/70R18 116T",
      "LT265/70R18 124Q",
      "275/70R18 125Q",
      "LT285/70R18 127Q",
      "295/70R18 129Q",
      "305/70R18 126Q",
      "LT265/65R18 122Q",
      "265/65R18 114T",
      "LT275/65R18 123Q",
      "275/65R18 116T",
      "285/65R18 125Q",
      "285/65R18 116T",
      "LT305/65R18 124Q",
      "325/65R18 127/124Q",
      "LT235/60R18 108Q",
      "LT255/60R18 117Q",
      "LT265/60R18 119Q",
      "265/60R18 114T",
      "285/60R18 122Q",
      "37x13.50R18 128Q",
      "33x12.50R18 118Q",
      "35x12.50R18 128Q",
      "37x12.50R18 128Q",
      "275/65R20 126Q",
      "275/65R20 116T",
      "LT285/65R20 127Q",
      "295/65R20 129Q",
      "LT265/60R20 121Q",
      "265/60R20 112H",
      "LT275/60R20 123Q",
      "LT275/60R20 123S",
      "275/60R20 116T",
      "285/60R20 125Q",
      "LT295/60R20 126/123Q",
      "LT275/55R20 120Q",
      "275/55R20 117T",
      "285/55R20 122Q",
      "285/55R20 116T",
      "LT295/55R20 123Q",
      "295/55R20 116T",
      "305/55R20 121Q",
      "305/55R20 116S",
      "LT285/50R20 119Q",
      "35x13.50R20 121Q",
      "37x13.50R20 127Q",
      "38x13.50R20LT 128Q",
      "33x12.50R20 114Q",
      "35x12.50R20 121Q",
      "37x12.50R20 126Q",
      "33x11.50R20LT 118Q",
      "35x11.50R20LT 124Q",
      "37x11.50R20LT 128Q",
      "LT285/55R22 124/121Q",
      "LT295/55R22 125/122Q",
      "LT285/50R22 121/118Q",
      "37x13.50R22 123Q",
      "35x12.50R22LT 121Q"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Triple Polymer Compound Provides longer mileage, anti-cut & chipping, extreme handling and off road traction.",
      "Aggressive Tread New aggressive 2 in 1 block pattern provides extreme off-road traction and superior performance.",
      "Alternate Sidewall Two different sidewall designs to choose from, Protector & Lug.",
      "Wide Lug Grooves Create biting edges for improved off road traction and creates more void area to help expel dirt and mud.",
      "Wide Flat Profile Distributes stress evenly across the entire tread resulting in longer wear and mileage.",
      "Road Hazard Protection Free puncture repair or tyre replacement. *Conditions apply."
    ],
    "specifications": {
      "Published size variants": "92 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "20 inch",
        "22 inch"
      ],
      "Supplier use categories": [
        "Off Road Durability",
        "On Off Road Traction",
        "Road Hazard Protection",
        "Ultimate Grip"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-geolandar-x-at-g016-0707624f-shop-b98db1.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-geolandar-x-at-g016-0707624f-shop-b98db1.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/geolandar-x-at-g016.png?h=800&w=800&la=en&hash=145F0F010DACC895831A18CF6A61C6CBEF3B0A29",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20X-AT%20G016?type=ALL"
  },
  "Tyres::Yokohama::Geolandar M/T G003": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20M%20T%20G003?type=ALL",
    "description": "The Geolandar M/T G003 is for the extreme off road adventurer. It is designed to conquer some of the wildest terrains. The Geolandar M/T G003 has reinforced casing delivering crushing performance, intimidating looks & long tread life that inspires confidence wherever you go.",
    "availableSizes": [
      "LT215/75R15 100Q",
      "235/75R15 104/100Q",
      "33x12.50R15 108Q",
      "35x12.50R15 113Q",
      "32x11.50R15 113Q",
      "31x10.50R15 109Q",
      "30x9.50R15 104Q",
      "32x9.50R15 101Q",
      "235/85R16 120Q",
      "255/85R16 123Q",
      "225/75R16 115/112Q",
      "245/75R16 120Q",
      "265/75R16 123Q",
      "285/75R16 126Q",
      "315/75R16 127Q",
      "215/70R16C 100/97Q",
      "305/70R16 124/121Q",
      "205R16 110/108Q",
      "245/75R17 121Q",
      "255/75R17 111Q",
      "LT285/75R17 121/118Q",
      "LT245/70R17 119Q",
      "265/70R17 121Q",
      "275/70R17 121/118Q",
      "285/70R17 121Q",
      "295/70R17 121Q",
      "225/65R17 107Q",
      "265/65R17 120/117Q",
      "40x13.50R17 121Q",
      "33x12.50R17 120Q",
      "35x12.50R17 121Q",
      "37x12.50R17 124Q",
      "275/70R18 125Q",
      "285/70R18 127/124Q",
      "295/70R18 129Q",
      "305/70R18 126Q",
      "275/65R18 123Q",
      "285/65R18 125Q",
      "33x12.50R18 118Q",
      "35x12.50R18 123Q",
      "37x12.50R18LT 128Q",
      "275/65R20 126Q",
      "LT285/65R20 123Q",
      "LT285/65R20 127Q",
      "295/65R20 129/126Q",
      "LT275/60R20 123Q",
      "295/60R20 126Q",
      "275/55R20 120Q",
      "295/55R20 123/120Q",
      "305/55R20 121Q",
      "37x13.50R20 127Q",
      "33x12.50R20 114Q",
      "35x12.50R20 121Q",
      "37x12.50R20 126Q"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High Density Compound Triple polymer provides exceptional wear performance.",
      "Aggressive Tread Off-road traction and protection.",
      "GEO-SHIELD Technology A full nylon cap with multiple sidewall plies, steel belts and a turn up carcass for extreme traction and reliable protection",
      "Improved Sidewall Off-road traction, durability and appearance.",
      "Optimised Lug Grooves Increases grip and wet traction.",
      "Wide Flat Profile Distributes stress evenly resulting in longer wear.",
      "Mud & Stone Ejector Prevents stone drilling and keeps the grooves clear."
    ],
    "specifications": {
      "Published size variants": "54 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "20 inch"
      ],
      "Supplier use categories": [
        "Off Road Durability",
        "On Off Road Traction",
        "Ultimate Grip",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-geolandar-m-t-g003-a7b908c1-shop-9fbffb.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-geolandar-m-t-g003-a7b908c1-shop-9fbffb.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/geolandar-m-t-g003.png?h=800&w=800&la=en&hash=6FF8A4614E1FFAB1E3899475A4FB990500316051",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20M%20T%20G003?type=ALL"
  },
  "Tyres::Yokohama::Geolandar CV G058": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20CV%20G058?type=ALL",
    "description": "Geolandar CV G058 is a highway tyre for the everyday SUV. With a phenomenal treadwear rating of 740, you can expect the Geolandar CV G058 to deliver exceptional mileage performance. Yokohama’s advancement in silica and rubber compound technology has also resulted in huge improvements in wet safety and fuel efficiency performance. The Geolandar CV G058 is the ultimate Grand Touring SUV Tyre that delivers exceptional mileage, confident safety performance with impressive road manners. It is the tyre you need if you spend a lot of time driving your SUV covering vast distances.",
    "availableSizes": [
      "205/70R15 96H",
      "215/70R16 100H",
      "225/70R16 103H",
      "235/70R16 106H",
      "215/65R16 98H",
      "215/60R16 95V",
      "235/60R16 100V",
      "215/70R17 101H",
      "215/65R17 99H",
      "225/65R17 102H",
      "235/65R17 108V",
      "245/65R17 107H",
      "215/60R17 96H",
      "215/60R17 96V",
      "225/60R17 99H",
      "225/60R17 99V",
      "235/60R17 102V",
      "255/60R17 106H",
      "215/55R17 94V",
      "225/55R17 97V",
      "235/55R17 99H",
      "235/65R18 106V",
      "255/65R18 111H",
      "225/60R18 100H",
      "235/60R18 107V",
      "245/60R18 105H",
      "265/60R18 110V",
      "215/55R18 99V",
      "225/55R18 98V",
      "225/55R18 102V",
      "235/55R18 100V",
      "255/55R18 109V",
      "215/50R18 92V",
      "225/50R18 95V",
      "235/50R18 97V",
      "255/60R19 113V",
      "225/55R19 99V",
      "235/55R19 105V",
      "245/55R19 103H",
      "245/55R19 103V",
      "235/50R19 103V",
      "255/50R19 107V",
      "235/55R20 102V",
      "255/55R20 110V",
      "245/50R20 102V",
      "255/50R20 109V",
      "265/50R20 107V"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Symmetrical Tread Pattern Sipe based to increase traction and reduce uneven wear.",
      "4 Combination Grooves Enhances traction on wet surfaces.",
      "Combination of 2D & 3D Sipes Improves traction on wet surfaces and better mileage.",
      "Wide & Flat Contact Patch Even wear and long mileage.",
      "New Blend Polymer and Micro Silica Compound Stability in wet and dry conditions plus low rolling resistance.",
      "Road Hazard Protection Free puncture repair or tyre replacement *Conditions apply."
    ],
    "specifications": {
      "Published size variants": "47 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Fuel Efficiency",
        "Road Hazard Protection",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-geolandar-cv-g058-81b155f5-shop-0fb918.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-geolandar-cv-g058-81b155f5-shop-0fb918.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/geolandar-cv-g058.png?h=800&w=800&la=en&hash=DE8D62DBD7B0166312A1828780893CB4D7584396",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20CV%20G058?type=ALL"
  },
  "Tyres::Yokohama::Geolandar H/T G056": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20H%20T%20G056?type=ALL",
    "description": "The Geolandar H/T G056 is Yokohama’s highway terrain tyre developed for drivers of 4WDs & SUVs who spend limited time off road and are looking for a quiet comfortable ride with long tread life. The Geolandar H/T G056 features a multi combination tyre compound, designed to enhance wet traction, provide better fuel efficiency and improve treadlife by up to 21%* (*In comparison to its predecessor, the Geolandar H/T-S G051).",
    "availableSizes": [
      "235/75R15 109H",
      "215/70R15 98H",
      "255/70R15 112/110S",
      "265/70R15 112H",
      "265/75R16 116H",
      "245/70R16 111H",
      "255/70R16 111H",
      "265/70R16 112H",
      "275/70R16 114H",
      "255/65R16 109H",
      "225/70R17 108T",
      "265/70R17 115S",
      "255/65R17 114H",
      "265/65R17 112H",
      "275/65R17 115H",
      "285/65R17 116H",
      "275/65R18 116H",
      "255/60R18 108H",
      "255/60R18 112V",
      "265/60R18 110H",
      "285/60R18 116H",
      "265/55R19 109V",
      "285/50R20 112V"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "5-Pitch Variation Reduces pattern noise by dispersing the noise frequency peaks.",
      "4 Main Zigzag Grooves Improves traction and provides excellent hydroplaning resistance.",
      "Multiple Lug Grooves Traction on wet roads.",
      "Adaptive Shoulder Blocks Reduces tread noise and promotes even wear.",
      "3D Sipes Reduces deformation.",
      "Multi Combination Compound Extends treadlife and superior traction.",
      "Road Hazard Protection Free puncture repair or tyre replacement. *Conditions apply."
    ],
    "specifications": {
      "Published size variants": "23 listed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Performance",
        "Quieter Ride",
        "Road Hazard Protection"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-geolandar-h-t-g056-ef039349-shop-c870ec.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-geolandar-h-t-g056-ef039349-shop-c870ec.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/geolandar-h-t-g056.png?h=800&w=800&la=en&hash=06C3723040C36DE6680FD07EBCEF0FA63256E15C",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20H%20T%20G056?type=ALL"
  },
  "Tyres::Yokohama::Geolandar X-CV G057": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20X-CV%20G057?type=ALL",
    "description": "The Geolandar X-CV G057 is the all new high performance tyre for Premium Crossover SUVs. Geolandar X-CV G057 boasts an Asymmetrical tread pattern that allows for better grip, handling and comfort. It features long lasting mileage performance and has a treadwear rating of 520. The Geolandar X-CV G057’s performance is outstanding in all weather conditions providing exceptional reliability all year round.",
    "availableSizes": [
      "245/70R18 110H",
      "235/60R18 107W",
      "265/60R18 110H",
      "255/55R18 109W",
      "235/60R19 103W",
      "235/55R19 105W",
      "255/55R19 111W",
      "265/55R19 109W",
      "275/55R19 111W",
      "255/50R19 107W",
      "265/50R19 110W",
      "275/50R19 112W",
      "225/45R19 96W",
      "235/45R19 99W",
      "265/60R20 112H",
      "255/55R20 110W",
      "265/55R20 109V",
      "235/50R20 104W",
      "255/50R20 109W",
      "265/50R20 111W",
      "275/50R20 113W",
      "235/45R20 100W",
      "245/45R20 103W",
      "255/45R20 105W",
      "265/45R20 108W",
      "275/45R20 110W",
      "285/45R20 112W",
      "255/40R20 101W",
      "275/40R20 106W",
      "295/40R20 110W",
      "305/40R20 112W",
      "235/50R21 101W",
      "255/50ZR21 106W",
      "235/45R21 101W",
      "245/45R21 104W",
      "265/45R21 104W",
      "275/45R21 110W",
      "285/45R21 113W",
      "255/40R21 102W",
      "265/40R21 105W",
      "275/40R21 107W",
      "285/40R21 109W",
      "295/40R21 111W",
      "315/40R21 115W",
      "295/35R21 107W",
      "315/35R21 111W",
      "265/50R22 112V",
      "255/45R22 107W",
      "275/45R22 115W",
      "265/40R22 106W",
      "275/40R22 108W",
      "285/40R22 110W",
      "265/35R22 102W",
      "285/35R22 106W",
      "315/35R22 111W"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Asymmetric Tread pattern for better grip, handling & comfort.",
      "4 wide straight grooves enhance traction especially on wet surfaces.",
      "Combination of 2D & 3D Sipes that strengthen block rigidity and prevent uneven wear for long mileage.",
      "Wide & Flat contact patch for even wear & long mileage.",
      "Micro Silica and Polymer Compound Stability in wet and dry conditions plus low rolling resistance.",
      "Road Hazard Protection Free puncture repair or tyre replacement."
    ],
    "specifications": {
      "Published size variants": "55 listed",
      "Published rim diameters": [
        "18 inch",
        "19 inch",
        "20 inch",
        "21 inch",
        "22 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Road Hazard Protection",
        "Superior Handling",
        "Wet Traction"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-geolandar-x-cv-g057-01c5b85e-shop-42f9ad.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-geolandar-x-cv-g057-01c5b85e-shop-42f9ad.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/geolandar-x-cv-g057.png?h=800&w=800&la=en&hash=9543D46B105A5122F32F5CE083F9415BE2234DDB",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Geolandar%20X-CV%20G057?type=ALL"
  },
  "Tyres::Yokohama::Advan dB V552": {
    "productUrl": "https://www.yokohama.com.au/our-range/tyres/Advan%20dB%20V552?type=ALL",
    "description": "The ADVAN dB V552 was designed with the automotive industry’s movement towards electric and hybrid vehicles in mind. Yokohama wanted to develop a tyre with high performance characteristics while excelling in providing premium comfort, low cabin noise and maximum fuel efficiency. Utilising an innovative silent base-compound and small block tread pattern the ADVAN dB V552 accomplishes this task, providing drivers with unparalleled silence and comfortable performance.",
    "availableSizes": [
      "225/65R17 106V",
      "215/60R17 96H",
      "225/60R17 99H",
      "215/55R17 94W",
      "225/55R17 97W",
      "235/55R17 99V",
      "215/50R17 95V",
      "225/50R17 94W",
      "235/50R17 96V",
      "205/45R17 88W",
      "215/45R17 91W",
      "225/45R17 91W",
      "245/45R17 95W",
      "235/60R18 107W",
      "225/55R18 98V",
      "225/55R18 98H",
      "235/50R18 97W",
      "245/50R18 100W",
      "215/45R18 89W",
      "225/45R18 91W",
      "235/45R18 98W",
      "245/45R18 96W",
      "225/40R18 92W",
      "235/40R18 95Y",
      "245/40R18 93Y",
      "255/40R18 95W",
      "265/35R18 97W",
      "235/60R19 103W",
      "225/55R19 103V",
      "235/55R19 XL 105W",
      "195/50R19 88H",
      "245/50R19 101W",
      "255/50R19 XL 107W",
      "225/45R19 92W",
      "245/45R19 102Y",
      "225/40R19 93W",
      "235/40R19 96Y",
      "245/40R19 98W",
      "235/55R20 102V",
      "235/50ZR20 104W",
      "255/45R20 105Y",
      "275/45R20 110Y",
      "245/40R20 99W",
      "245/40R20 103Y",
      "275/40R20 106Y",
      "235/50R21 101W",
      "225/45R21 95W",
      "245/45R21 100Y",
      "255/40ZR21 102Y",
      "275/35R21 103Y"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Twist Edge Cutting Improves stiffness and prevents uneven wear allowing for longer lasting high level silence.",
      "Single Edge Cutting Reduces deterioration resulting in longer lasting handling performance and road silence.",
      "Precise Groove Arrangement Disperses the sound generated by the tyre, eliminating harsh noises.",
      "Straight Centre Ribs Improves straight line stability and handling."
    ],
    "specifications": {
      "Published size variants": "50 listed",
      "Published rim diameters": [
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch",
        "21 inch"
      ],
      "Supplier use categories": [
        "Comfort",
        "Performance",
        "Quieter Ride",
        "Superior Handling"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-advan-db-v552-0ae1da22-shop-528b09.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-advan-db-v552-0ae1da22-shop-528b09.webp"
    ],
    "imageSourceUrl": "https://www.yokohama.com.au/-/media/images/tyres/tyreimages/advan-db-v552.png?h=800&w=800&la=en&hash=F756D325C115FEEE78919A7DA82E0EED86C4BF2B",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.yokohama.com.au/our-range/tyres/Advan%20dB%20V552?type=ALL"
  },
  "Tyres::Yokohama::Avid Ascend GT": {
    "productUrl": "https://www.yokohamatire.com/tires/avid-ascend-gt",
    "description": "A premium grand touring all-season tyre developed for confident wet and light-snow traction, a quiet ride and long tread life across passenger cars, crossovers and minivans.",
    "availableSizes": [],
    "notes": [
      "This model is not listed in Yokohama Australia's current online range; Australian special-order availability must be confirmed by 110 Garage"
    ],
    "features": [
      "TriBlend compound supports all-season grip",
      "Asymmetric grooves are designed for wet and snow braking",
      "Multi-pitch tread and adaptive shoulder help control road noise",
      "Three-dimensional sipes and a square contact patch support even wear"
    ],
    "specifications": {
      "Market availability": "Official international model; Australian availability must be confirmed",
      "Published rim diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch",
        "20 inch"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-avid-ascend-gt-42861afc-shop-01c397.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-avid-ascend-gt-42861afc-shop-01c397.webp"
    ],
    "imageSourceUrl": "https://ytc-bm.s3.us-east-2.amazonaws.com/AVID-Ascend-GT-3QL-Web.webp",
    "descriptionSource": "official-international-product-page",
    "descriptionSourceUrl": "https://www.yokohamatire.com/tires/avid-ascend-gt"
  },
  "Tyres::Yokohama::iceGUARD iG53": {
    "productUrl": "https://www.yokohamatire.com/tires/iceguard-ig53",
    "description": "A studless winter tyre engineered for grip on snow and ice, with a directional tread pattern designed to support predictable handling and fuel-efficient road use.",
    "availableSizes": [],
    "notes": [
      "This model is not listed in Yokohama Australia's current online range; Australian special-order availability must be confirmed by 110 Garage"
    ],
    "features": [
      "Triple three-dimensional sipes create additional snow-biting edges",
      "Zig-zag circumferential grooves support snow traction",
      "Absorptive tread compound is designed to improve ice grip",
      "Directional tread pattern increases the contact area"
    ],
    "specifications": {
      "Market availability": "Official international model; Australian availability must be confirmed",
      "Published rim diameters": [
        "14 inch",
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch"
      ]
    },
    "localImage": "product-catalog-tyres-yokohama-iceguard-ig53-59faa012-shop-8817c4.webp",
    "galleryImages": [
      "product-catalog-tyres-yokohama-iceguard-ig53-59faa012-shop-8817c4.webp"
    ],
    "imageSourceUrl": "https://ytc-bm.s3.us-east-2.amazonaws.com/iceGUARD-iG53-3QL-Web.webp",
    "descriptionSource": "official-international-product-page",
    "descriptionSourceUrl": "https://www.yokohamatire.com/tires/iceguard-ig53"
  },
  "Tyres::Maxxis::Razr AT811": {
    "productUrl": "https://maxxistyres.com.au/tyres/at811-razr/",
    "description": "Showcasing the Maxxis RAZR AT811! A worthy companion to the RAZR MT772. Engineered using the know-how Maxxis has gained from years of research in the off-road and all-terrain tyre market, the Maxxis RAZR AT811 is cutting edge in every way! 3 Peak Mountain Snowflake rated",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-razr-at811-0fc551fc-shop-6038f8.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2020/07/Maxxis-RAZR-AT811_Tread.png"
  },
  "Tyres::Maxxis::Razr MT772": {
    "productUrl": "https://maxxistyres.com.au/tyres/mt-772-razr/",
    "description": "The Maxxis RAZR MT772 pattern features deeply sculpted centre blocks for excellent mud traction, while stone and mud ejectors improve self-cleaning performance and minimise rock retention. An innovative armour sidewall design maximises sidewall traction and puncture resistance, while deeply staggered shoulder blocks provide additional traction in difficult terrains.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-razr-mt772-e4949e64-shop-15c840.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2018/04/Img2633-2.png"
  },
  "Tyres::Maxxis::Razr HT780": {
    "productUrl": "https://maxxistyres.com.au/tyres/razr-ht780/",
    "description": "The flagship Maxxis RAZR HT780 is a premium quality highway terrain tyre, designed specifically for SUV and utility drivers wanting optimal comfort, a quiet ride, and prolonged tyre life.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-razr-ht780-f1590e92-shop-32ef56.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2023/04/HT780-02.png"
  },
  "Tyres::Maxxis::Bravo AT771": {
    "productUrl": "https://maxxistyres.com.au/tyres/at771/",
    "description": "The Maxxis Bravo AT771 is designed to offer strong on road performance with good ride qualities and low noise generation, while still able to provide confident “off the road” handling and traction.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-bravo-at771-063b3971-shop-aa7d0b.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2016/05/Maxxis-AT771-Tread-4WD-1.png"
  },
  "Tyres::Maxxis::Bravo AT771 HP": {
    "productUrl": "https://maxxistyres.com.au/tyres/at771/",
    "description": "The Maxxis Bravo AT771 is designed to offer strong on road performance with good ride qualities and low noise generation, while still able to provide confident “off the road” handling and traction.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-bravo-at771-hp-063b3971-shop-e38702.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2016/05/Maxxis-AT771-Tread-4WD-1.png"
  },
  "Tyres::Maxxis::Bravo HT770": {
    "productUrl": "https://maxxistyres.com.au/tyres/ht770/",
    "description": "Known as the Maxxis flagship highway terrain tyre, the HT770 development team perfected the finer details to create a tyre worthy of being a flagship. Based on the Maxxis motor sports experience, the team created a new sidewall design that delivers a supple ride while maintaining excellent stability under heavy braking and crosswinds. The engineers also utilised a closed shoulder pattern design and multi-pitch tread blocks to create a comfortable driving experience.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-bravo-ht770-8f891dc7-shop-b76e6c.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2016/05/Maxxis-HT770-Tread-4WD-1.png"
  },
  "Tyres::Maxxis::Bravo HP-M3": {
    "productUrl": "https://maxxistyres.com.au/tyres/hpm3/",
    "description": "An all-season premium touring tyre, the HPM3 is designed as an all-around performer in dry and wet conditions as well as light snow. The HPM3 features cross-hatch sipes across the tread for added traction on slippery surfaces, while the four circumferential grooves improve hydroplaning resistance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-bravo-hp-m3-a03660be-shop-b0faa7.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2016/05/HPM3.png"
  },
  "Tyres::Maxxis::Bravo UE-168": {
    "productUrl": "https://maxxistyres.com.au/shop/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Maxxis::Premitra HP5": {
    "productUrl": "https://maxxistyres.com.au/tyres/hp5/",
    "description": "The Maxxis HP5 is a modern touring /sport tyre engineered to meet the high standards of safety, handling and grip required by late model cars and SUVs and the expectations of the most discerning drivers. Incorporating the latest silica tread compound technologies, the HP5 is not only high performing, but also provides superior levels of safety and grip in a wide range of conditions, ensuring peace of mind for drivers both in the wet and the dry.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-premitra-hp5-cc632b69-shop-7cbccf.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2018/05/Img1902.png"
  },
  "Tyres::Maxxis::Victra Sport VS5": {
    "productUrl": "https://maxxistyres.com.au/another-podium-win-for-maxxis/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-maxxis-victra-sport-vs5-6e125074-2ca316-shop-d2da90-official-hq-cutout.webp",
    "imageSourceUrl": "https://tr.tyrereviews.com/images/tyres/Maxxis-Victra-Sport-5.jpg"
  },
  "Tyres::Maxxis::Victra Sport EV": {
    "productUrl": "https://maxxistyres.com.au/tyres/vs01/",
    "description": "An asymmetric UHP tyre designed for premium sport sedans, the VS01 features modern tread technologies to minimise perceived pattern noise. The tyre also features many structural reinforcements and high-strength materials to sharpen handling while maintaining a safe and easily managed drive.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-victra-sport-ev-8272f499-shop-f2fddb.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2016/05/Maxxis-VS01-Tread-Pass.png"
  },
  "Tyres::Maxxis::Victra MA-Z4S": {
    "productUrl": "https://maxxistyres.com.au/tyres/maz4s/",
    "description": "The MAZ4S is an all-season UHP tyre designed for superb wet weather performance. It features aggressive directional grooves to channel water away with great efficiency - to ensure ultimate peace of mind when driving in wet weather conditions. The MAZ4S features a robust construction for maximum high-speed stability and driving confidence.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-victra-ma-z4s-7ce45600-shop-e1c377.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2016/05/Maxxis-MAZ4S-Tread-Pass.png"
  },
  "Tyres::Maxxis::Victra MA510": {
    "productUrl": "https://maxxistyres.com.au/shop/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-maxxis-victra-ma510-a3029b0c-b31d0f-shop-649f71-official-hq.webp",
    "imageSourceUrl": "https://tr.tyrereviews.com/images/tyres/Maxxis-Victra-MA510.png"
  },
  "Tyres::Maxxis::Mecotra ME3": {
    "productUrl": "https://maxxistyres.com.au/shop/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Maxxis::MA-P5": {
    "productUrl": "https://maxxistyres.com.au/tyres/map5/",
    "description": "Enhance your driving experience with Maxxis MAP5 fuel efficient tyres. Enjoy reduced noise, increased comfort, and excellent fuel savings.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://maxxistyres.com.au/tyres/map5/",
    "localImage": "catalog-tyres-maxxis-ma-p5-2cf93f8c-8dea2e-shop-55d070.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2020/11/maxxis-car-tyres.jpg"
  },
  "Tyres::Maxxis::MA-751": {
    "productUrl": "https://maxxistyres.com.au/shop/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-maxxis-ma-751-c9b0f224-aa4f7f-shop-1eb1d6-official-hq-cutout.webp",
    "imageSourceUrl": "https://tr.tyrereviews.com/images/tyres/Maxxis-Bravo-MA751.jpg"
  },
  "Tyres::Maxxis::MA-589": {
    "productUrl": "https://maxxistyres.com.au/shop/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Maxxis::Mudzilla M8080": {
    "productUrl": "https://maxxistyres.com.au/shop/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Maxxis::Bighorn MT-764": {
    "productUrl": "https://maxxistyres.com.au/tyres/mt764/",
    "description": "A premium mud-terrain tyre with a motor sports pedigree, the MT764 features a tough, durable construction and boasts superb off-road performance due to the aggressive pattern that improves self-cleaning performance in mud. The shoulders feature staggered lugs for additional bite when sidewall traction is needed.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-maxxis-bighorn-mt-764-b6c9e6d4-shop-d90ef4.webp",
    "imageSourceUrl": "https://maxxistyres.com.au/wp-content/uploads/2016/05/Maxxis-MT764-Tread-4WD-1.png"
  },
  "Tyres::Maxxis::Creepy Crawler M8090": {
    "productUrl": "https://maxxistyres.com.au/shop/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Maxxis tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Michelin::Pilot Sport 5": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-5-energy",
    "description": "The MICHELIN CAR TYRE PILOT SPORT 5 ENERGY is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-pilot-sport-5-0dba3dff-shop-abe407.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xoc763h7d37pnh/4w-1871_3528702845721_tire_michelin_pilot-sport-5-energy_255-slash-45-r19-104y-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-5-energy"
  },
  "Tyres::Michelin::Pilot Sport 4": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-4-suv",
    "description": "The MICHELIN CAR TYRE PILOT SPORT 4 SUV is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-4-suv",
    "rejectedImageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xuurgci4ufnsmy/4w-365_3528700002072_tire_michelin_pilot-sport-4-suv_295-slash-35-r21-107y-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Michelin::Pilot Sport 4 SUV": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-4-suv",
    "description": "The MICHELIN CAR TYRE PILOT SPORT 4 SUV is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-4-suv",
    "rejectedImageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xuurgci4ufnsmy/4w-365_3528700002072_tire_michelin_pilot-sport-4-suv_295-slash-35-r21-107y-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Michelin::Pilot Sport 4 S": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-4-suv",
    "description": "The MICHELIN CAR TYRE PILOT SPORT 4 SUV is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-4-suv",
    "rejectedImageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xuurgci4ufnsmy/4w-365_3528700002072_tire_michelin_pilot-sport-4-suv_295-slash-35-r21-107y-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Michelin::Pilot Sport Cup 2": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-cup-2-r",
    "description": "The MICHELIN CAR TYRE PILOT SPORT CUP 2 R is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-pilot-sport-cup-2-88518a65-shop-ebff9a.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4qz4jrgatu8uyze/4w-368_3528703112235_tire_michelin_pilot-sport-cup-2-r_325-slash-30-zr21-108y-xl_n0_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-cup-2-r"
  },
  "Tyres::Michelin::Pilot Sport A/S 4": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-a-s-4",
    "description": "The MICHELIN CAR TYRE PILOT SPORT A/S 4 is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-pilot-sport-a-s-4-df434c28-shop-875969.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xgr9bgbcx6kj9y/4w-363_3528709347266_tire_michelin_pilot-sport-a-slash-s-4_245-slash-40-zr18-97y-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-pilot-sport-a-s-4"
  },
  "Tyres::Michelin::Primacy 5": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-5-energy",
    "description": "The MICHELIN CAR TYRE PRIMACY 5 ENERGY is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-primacy-5-be725541-shop-7d17ac.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4q8jckfzoopbn7o/4w-1827_3528703797128_tire_michelin_primacy-5-energy_235-slash-40-r19-96w-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-5-energy"
  },
  "Tyres::Michelin::Primacy 4": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-4-suv",
    "description": "The MICHELIN CAR TYRE PRIMACY 4 SUV is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-primacy-4-32b0d5a6-shop-608594.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4qks9wj4df7an1o/4w-460_3528708402195_tire_michelin_primacy-4-suv_225-slash-65-r17-102h_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-4-suv"
  },
  "Tyres::Michelin::Primacy 4+": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-4-suv",
    "description": "The MICHELIN CAR TYRE PRIMACY 4 SUV is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-primacy-4-32b0d5a6-shop-608594.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4qks9wj4df7an1o/4w-460_3528708402195_tire_michelin_primacy-4-suv_225-slash-65-r17-102h_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-4-suv"
  },
  "Tyres::Michelin::Primacy SUV+": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-suv-plus",
    "description": "The MICHELIN CAR TYRE PRIMACY SUV+ is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-primacy-suv-b611e065-shop-d3ddf7.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xqxh3tkdr7h57e/4w-989_3528702273791_tire_michelin_primacy-suv-plus_235-slash-60-r18-103v_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-primacy-suv-plus"
  },
  "Tyres::Michelin::Primacy Tour A/S": {
    "productUrl": "https://www.michelin.com.au/auto/browse-tyres/all-tyres",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Michelin::Energy XM2+": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-energy-xm2-plus",
    "description": "The MICHELIN CAR TYRE ENERGY XM2 + is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-energy-xm2-bec75cfd-shop-91b2da.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xm69hss7h6oyne/4w-387_3528708368866_tire_michelin_energy-xm2-plus_205-slash-55-r16-91v_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-energy-xm2-plus"
  },
  "Tyres::Michelin::e.Primacy": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-e-primacy-2",
    "description": "The MICHELIN CAR TYRE E PRIMACY 2 is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-e-primacy-b2c55f8f-shop-6cc8f5.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4q3rianwcnqpn3c/4w-1565_3528709453080_tire_michelin_e-primacy-2_235-slash-55-r19-105w-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-e-primacy-2"
  },
  "Tyres::Michelin::Latitude Sport 3": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-latitude-sport-3",
    "description": "The MICHELIN CAR TYRE LATITUDE SPORT 3 is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-latitude-sport-3-e3194fef-shop-d745d7.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xutukrx1ztcjio/4w-45_3528709223034_tire_michelin_latitude-sport-3_275-slash-40-r20-106y-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-latitude-sport-3"
  },
  "Tyres::Michelin::Latitude Tour HP": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-latitude-tour-hp",
    "description": "The MICHELIN CAR TYRE LATITUDE TOUR HP is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-latitude-tour-hp-2b0108aa-shop-2f95cd.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4qy8bc4wpzostic/4w-47_3528709483391_tire_michelin_latitude-tour-hp_245-slash-60-r18-105h_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-latitude-tour-hp"
  },
  "Tyres::Michelin::LTX Trail": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-ltx-trail",
    "description": "The MICHELIN CAR TYRE LTX TRAIL is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-ltx-trail-8392a5c1-shop-70ea57.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4qgn8kzy63kfzdo/4w-502_3528700124194_tire_michelin_ltx-trail-st_265-slash-65-r17-112t_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-ltx-trail"
  },
  "Tyres::Michelin::LTX Force": {
    "productUrl": "https://www.michelin.com.au/auto/browse-tyres/all-tyres",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Michelin::Agilis 3": {
    "productUrl": "https://www.michelin.com.au/auto/tyres/michelin-agilis-3",
    "description": "The MICHELIN CAR TYRE AGILIS 3 is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. MICHELIN, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-michelin-agilis-3-b2e702dd-shop-9f79b7.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xonehx5pmasaqh/4w-465_3528703714026_tire_michelin_agilis-3_215-slash-65-r16c-109-slash-107t_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.michelin.com.au/auto/tyres/michelin-agilis-3"
  },
  "Tyres::Michelin::Agilis CrossClimate": {
    "productUrl": "https://www.michelin.com.au/auto/browse-tyres/all-tyres",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Michelin::CrossClimate 2": {
    "productUrl": "https://www.michelin.com.au/auto/browse-tyres/all-tyres",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Michelin tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-michelin-crossclimate-2-78da43ef-shop-940cad.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xgr9bgbcx6kj9y/4w-363_3528709347266_tire_michelin_pilot-sport-a-slash-s-4_245-slash-40-zr18-97y-xl_a_main_1-30_nopad.webp?t=resize&height=700"
  },
  "Tyres::Pirelli::P ZERO": {
    "productUrl": "https://www.pirelli.com/tyres/en-ww/car/discover-new-p-zero-e",
    "description": "New tyre generation P Zero™ E: more than 55% Bio-based & recycled materials; no stress in case of puncture with Runforward™ Tech",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-ww/car/discover-new-p-zero-e",
    "localImage": "product-catalog-tyres-pirelli-p-zero-9f33a669-shop-4967fd.webp",
    "imageSourceUrl": "https://www.pirelli.com/tyres/car/next/assets/images?url=https%3A%2F%2Ftyre24.pirelli.com%2Fdynamic_engine%2Fassets%2Fglobal%2Ftyre-4505534351042.png&w=3840&q=75"
  },
  "Tyres::Pirelli::P ZERO (PZ4)": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/new-p-zero/28",
    "description": "Fourth generation P ZERO tyre developed from Pirelli motorsport and original-equipment partnerships, designed for high-performance vehicle fitments.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Performance tyre",
      "Original-equipment fitments available on selected vehicles"
    ],
    "localImage": "product-catalog-tyres-pirelli-p-zero-pz4-84da4b1e-shop-cddeea.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/visori/3_4/pzeroPZ4.png"
  },
  "Tyres::Pirelli::P ZERO (PZ5)": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/p-zero-5",
    "description": "Homepage Motorcycle Motorsport Bicycle Collezione Truck & Bus Pirelli Calendar Pirelli Design Fondazione Pirelli Pirelli HangarBicocca Safe driving and tyre features home catalogue p zero™ (pz5) Superior performance chosen by the best car makers Overview Reasons to choose Pirelli technologies Collaborations",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/p-zero-5",
    "localImage": "catalog-tyres-pirelli-p-zero-pz5-4154dde6-c53615-shop-706770.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/visori/3_4/PZ5_visorePDP_3-4.png"
  },
  "Tyres::Pirelli::P ZERO E": {
    "productUrl": "https://www.pirelli.com/tyres/en-ww/car/discover-new-p-zero-e",
    "description": "New tyre generation P Zero™ E: more than 55% Bio-based & recycled materials; no stress in case of puncture with Runforward™ Tech",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-ww/car/discover-new-p-zero-e",
    "localImage": "product-catalog-tyres-pirelli-p-zero-e-9f33a669-shop-44370a.webp",
    "imageSourceUrl": "https://www.pirelli.com/tyres/car/next/assets/images?url=https%3A%2F%2Ftyre24.pirelli.com%2Fdynamic_engine%2Fassets%2Fglobal%2Ftyre-4505534351042.png&w=3840&q=75"
  },
  "Tyres::Pirelli::P ZERO CORSA SYSTEM": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/p-zero-corsa-system",
    "description": "P Zero Corsa System, a tyre developed by Pirelli with excellent braking behaviour and good wet performance",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-p-zero-corsa-system-6f3979b6-shop-0d3048.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Pzero-Corsa-System-Direzionale-1505470088408.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/p-zero-corsa-system"
  },
  "Tyres::Pirelli::P ZERO ROSSO": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/p-zero-rosso",
    "description": "P Zero Rosso: a tyre with electronic traction and stability control systems, ideal for sports preparations",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/p-zero-rosso",
    "localImage": "product-catalog-tyres-pirelli-p-zero-rosso-8063e773-shop-87a625.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/PZero-Rosso-1505470088712.png"
  },
  "Tyres::Pirelli::POWERGY": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/powergy",
    "description": "Powergy is the smart choice for drivers looking for safety and green performance with a low environmental impact",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-powergy-d3a11fb8-shop-2a829a.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Powergy-4505522086822.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/powergy"
  },
  "Tyres::Pirelli::DRAGON SPORT": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/dragon-sport",
    "description": "Premium tyre Dragon Sport enhances drive performance on wet and dry roads without sacrificing safety and comfort",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-dragon-sport-fec884ba-shop-efaf69.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Dragon-Sport-1505470062438.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/dragon-sport"
  },
  "Tyres::Pirelli::CINTURATO P1": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-p1",
    "description": "Ideal for city and compact cars, Pirelli Cinturato P1 tyre gives you a comfortable drive on dry or wet surfaces",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-cinturato-p1-d776f87a-shop-07763c.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Cinturato-P1-1505470070420.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-p1"
  },
  "Tyres::Pirelli::CINTURATO P6": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-p6",
    "description": "Cinturato P6 tyre provides the perfect equilibrium of performances, fuel saving, comfort and high level of safety",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-p6",
    "localImage": "product-catalog-tyres-pirelli-cinturato-p6-df8a073c-shop-d9ab8a.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Cinturato-P6-4505495677490.png"
  },
  "Tyres::Pirelli::CINTURATO P7": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-p7",
    "description": "Cinturato P7: summer tyre with perfect mix of low rolling resistance and plastic and acoustic comfort",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-p7",
    "localImage": "product-catalog-tyres-pirelli-cinturato-p7-8561f176-shop-60a82a.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Cinturato-P7-1505470083092.png"
  },
  "Tyres::Pirelli::CINTURATO P7 (P7C2)": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/new-cinturato-p7",
    "description": "Homepage Motorcycle Motorsport Bicycle Collezione Truck & Bus Pirelli Calendar Pirelli Design Fondazione Pirelli Pirelli HangarBicocca Safe driving and tyre features home catalogue cinturato p7™ (p7c2) Confidence and comfort for premium commuter Overview Why to choose Pirelli technologies Collaborations",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/new-cinturato-p7",
    "localImage": "catalog-tyres-pirelli-cinturato-p7-p7c2-40f73eb5-6fbc88-shop-e74bdd.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Cinturato-P7-P7C2-4505517104514.png"
  },
  "Tyres::Pirelli::CINTURATO ROSSO": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-rosso",
    "description": "Pirelli Cinturato Rosso tyres guarantee greater mileage and improved grip in both wet and dry conditions. Discover more!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/cinturato-rosso",
    "localImage": "product-catalog-tyres-pirelli-cinturato-rosso-75060cdd-shop-d7f26f.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Cinturato-Rosso-4505527556704.png"
  },
  "Tyres::Pirelli::CARRIER": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/carrier",
    "description": "CARRIER Summer: the long-lasting tyre with new tread and next-generation compound.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-carrier-02baef2c-shop-c0ee1b.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Carrier-1505470086581.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/carrier"
  },
  "Tyres::Pirelli::SCORPION ATR": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-atr",
    "description": "Scorpion ATR: a tyre for the most demanding off-road use, resistant to the most severe impact on rough roads",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-atr",
    "localImage": "product-catalog-tyres-pirelli-scorpion-atr-34499161-shop-ad8739.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-Atr-1505470067539.png"
  },
  "Tyres::Pirelli::SCORPION STR": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-str",
    "description": "The ideal choice for SUVs, all season safety with enhanced ride comfort, low noise level and high mileage",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-str",
    "localImage": "product-catalog-tyres-pirelli-scorpion-str-1bc650ed-shop-9689eb.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-STR-1505470088180.png"
  },
  "Tyres::Pirelli::SCORPION VERDE": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-verde",
    "description": "Scorpion Verde: a tyre for Crossover and SUV, with excellent grip and wet braking combined with stability",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-verde",
    "localImage": "product-catalog-tyres-pirelli-scorpion-verde-2dab113f-shop-9c62f2.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-Verde-1505470074533.png"
  },
  "Tyres::Pirelli::SCORPION VERDE ALL SEASON": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-verde-all-season",
    "description": "Scorpion Verde All Season: a tyre for Crossover and SUV, ideal for high mileage and light off-road use",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-verde-all-season",
    "localImage": "product-catalog-tyres-pirelli-scorpion-verde-all-season-5f07f8cd-shop-05a324.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-Verde-All-Season-1505470075906.png"
  },
  "Tyres::Pirelli::SCORPION ZERO": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-zero-asimmetrico",
    "description": "Scorpion Zero Asimmetrico: a tyre with asymmetrical tread pattern for powerful SUVs and pick-ups",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-zero-asimmetrico",
    "localImage": "product-catalog-tyres-pirelli-scorpion-zero-f86c495b-shop-72b42e.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-Zero-Asimmetrico-1505470076172.png"
  },
  "Tyres::Pirelli::SCORPION ZERO ALL SEASON": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-zero-all-season",
    "description": "Scorpion Zero All Season: a tyre with maximum performance in all seasons, and all driving conditions",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-scorpion-zero-all-season-0310d7a0-shop-9e0d74.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-Zero-All-Season-1505470086399.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-zero-all-season"
  },
  "Tyres::Pirelli::SCORPION ZERO ASIMMETRICO": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-zero-asimmetrico",
    "description": "Scorpion Zero Asimmetrico: a tyre with asymmetrical tread pattern for powerful SUVs and pick-ups",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-zero-asimmetrico",
    "localImage": "product-catalog-tyres-pirelli-scorpion-zero-asimmetrico-f86c495b-shop-24f924.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-Zero-Asimmetrico-1505470076172.png"
  },
  "Tyres::Pirelli::SCORPION ALL TERRAIN PLUS": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-all-terrain-plus",
    "description": "The Scorpion All Terrain Plus tyre is designed to deliver high off-road performance even on difficult surfaces",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-all-terrain-plus",
    "localImage": "product-catalog-tyres-pirelli-scorpion-all-terrain-plus-aa4d6199-shop-6744b4.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-All-Terrain-Plus-4505483375619.png"
  },
  "Tyres::Pirelli::SCORPION MTR": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-mtr",
    "description": "Scorpion MTR features a self-cleaning pattern able to channel mud and gravel out of the tread and lugs",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-scorpion-mtr-6b20bf09-shop-c390d1.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/dynamic_engine/assets/global/Scorpion-MTR-1505470071047.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-mtr"
  },
  "Tyres::Pirelli::SCORPION MS": {
    "productUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-ms",
    "description": "The Pirelli SCORPION MS is the new reference tyre for crossover and SUV applications.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pirelli tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-pirelli-scorpion-ms-b3656ce0-shop-fdc8b0-official-hq.webp",
    "imageSourceUrl": "https://tyre24.pirelli.com/staticfolder/Tyre/resources/gfx/v2/product-details/Scorpion_ms_base.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue/product/scorpion-ms"
  },
  "Tyres::Cooper::ROAD+TRAIL AT": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/roadtrail-at/",
    "description": "Everyday comfort with grip for weekend escapes The Cooper Road+Trail AT is made for everyday driving with the flexibility to handle weekend escapes and unsealed tracks. It suits SUV owners who need reliable grip, good road manners and light off-road capability without sacrificing comfort. Strengthened carcass helps resist punctures and maintain a smooth ride Silica tread compound improves wet grip and extends tyre life Deep tread grooves assist with water drainage and wet weather control Angled traction shoulders enhance grip on uneven or loose surfaces A dependable option for road trips, commutes and light trail use 3PMSF for reliable performance in snow and cold conditions",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-road-trail-at-f7258579-shop-f7e8d3.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2024/11/ROADTRAIL.webp"
  },
  "Tyres::Cooper::STRONGHOLD AT": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/stronghold-at/",
    "description": "Tough and stable for load-carrying and rough roads The Cooper Stronghold AT is designed for drivers who need a tyre that handles heavy loads and rugged conditions without compromising ride comfort. It delivers confident traction on dirt and gravel while maintaining stability on sealed roads, making it well suited to towing, tradie work and rural driving.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-stronghold-at-cae046ed-shop-dffc1d.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2024/11/STRONGHOLD-AT-1.webp"
  },
  "Tyres::Cooper::LTZ PRO": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/ltz-pro/",
    "description": "Sporty looks with reliable grip on and off-road The Cooper LTZ Pro is a hybrid all-terrain tyre made for drivers who want a sportier look without giving up strength or comfort. It suits dual-cab utes, 4WDs and performance-oriented SUVs that need traction across sealed roads and light off-road tracks. Steel-belted construction helps increase load-carrying strength and impact resistance Silica compound improves wet grip, braking and tread life Aggressive shoulder design adds off-road traction and a tough visual stance Dual ‘Z’ shaped sipes provide balanced wear and year-round handling Backed by an Australia-wide mileage warranty of up to 50,000 km",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-ltz-pro-78d46dec-shop-64146e.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/LTZ-PRO-1.webp"
  },
  "Tyres::Cooper::RUGGED TREK": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/rugged-trek/",
    "description": "Off-road traction with on-road comfort and standout looks The Cooper Rugged Trek is made for drivers who want genuine off-road capability without sacrificing on-road comfort. It delivers confident handling on gravel, mud and rutted tracks, while remaining smooth and quiet around town. With aggressive styling, long tread life and dependable grip, it’s well suited to touring 4WDs, dual-cabs and lifestyle vehicles that do it all.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rough-terrain tyre",
      "4x4 fitments available by enquiry"
    ],
    "localImage": "product-catalog-tyres-cooper-rugged-trek-0eea7740-shop-639315.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/RUGGED-TREK-1.webp"
  },
  "Tyres::Cooper::STT PRO": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/stt-pro/",
    "description": "Extreme traction and durability for serious off-road tracks The Cooper STT Pro is made for serious off-road driving in Australia’s harshest conditions. From deep mud to sharp rocks, it delivers confident traction, strong sidewall protection and a surprisingly smooth ride back on bitumen. It’s a purpose-built tyre for 4WDers who push the limits. 3-ply Armor-Tek3 sidewall helps protect against cuts and punctures Mud Slinger lugs and stone ejectors clear debris and grip through tough terrain Silica compound reduces chipping and improves wet-weather braking Flex grooves absorb impacts for better ride comfort off-road",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-stt-pro-d04692b3-shop-f274a8.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/STT-PRO-1.webp"
  },
  "Tyres::Cooper::AT3 LT": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/at3-lt/",
    "description": "Reliable, quiet and safe all-terrain performance The Cooper AT3 LT is designed for utes, 4WDs and light trucks that carry heavy loads and see a mix of sealed and unsealed roads. It offers long-lasting performance, solid towing stability and dependable grip in all weather, making it a smart choice for tradies, tourers and regional drivers.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-at3-lt-52fc11d4-shop-0db314.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/02/AT3-LT4.png"
  },
  "Tyres::Cooper::AT3 4S": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/at3-4s/",
    "description": "Everyday comfort with dependable grip in all conditions The Cooper AT3 4S is ideal for drivers who mostly stay on-road but still need confident all-terrain performance. It’s well suited to SUVs and crossovers that handle city driving, weekend getaways and occasional dirt or gravel roads. Silica compound improves wet grip and extends tread life Deep tread channels enhance control in rain and on loose surfaces 3D Micro-Gauge sipes improve stability and handling Aqua Vac channels help resist hydroplaning in heavy rain Backed by an Australia-wide mileage warranty of up to 60,000 km Mileage Warranty terms and conditions apply.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-at3-4s-18af99bd-shop-348274.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/AT3-4S-1.webp"
  },
  "Tyres::Cooper::AT3 XLT": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/at3-xlt/",
    "description": "All-terrain strength and traction for heavy-duty 4WDs The Cooper AT3 XLT is designed for heavy-duty 4WDs that see hard work and off-road use. It combines extra load strength with all-terrain traction, making it ideal for towing, touring and vehicles that carry constant weight on mixed surfaces.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-at3-xlt-ed30a074-shop-3551e7.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/AT3XLT_BLK_RR_HR.webp"
  },
  "Tyres::Cooper::S/T MAXX": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/st-maxx/",
    "description": "Trusted traction and toughness for harsh Australian terrain The Cooper S/T MAXX handles demanding off-road conditions while maintaining stability on sealed roads. Its tread and carcass are designed to manage sharp gravel, rocky trails and heavy loads, making it suitable for remote travel, rural work and towing. 3-ply sidewall construction helps reduce punctures and sidewall damage Cut and chip-resistant compound suited to rough Australian surfaces Hybrid tread design provides steady traction across all terrains Stone ejectors minimise debris retention and aid self-cleaning Load-rated for heavy vehicles and consistent towing performance",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-s-t-maxx-375b3e43-shop-f9de80.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/02/ST-MAXX3.png"
  },
  "Tyres::Cooper::ATT": {
    "productUrl": "https://coopertires.com.au/our-range/4x4-tyres/att/",
    "description": "Smooth and quiet with grip for everyday SUV use The Cooper ATT is made for modern SUVs that spend most of their time on-road but still need reliable performance on unsealed surfaces. It delivers a smooth, quiet ride with dependable grip in wet and dry conditions, making it a strong choice for families, commuters and weekenders. High-tensile construction improves strength and damage resistance Silica compound enhances wet braking and tread life Whisper Grooves™ help reduce road noise for a quieter ride Raised curb-bar design offers added sidewall protection Backed by an Australia-wide mileage warranty of up to 60,000 km Mileage Warranty terms and conditions apply.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-att-88e47608-shop-238860.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/ATT-1.webp"
  },
  "Tyres::Cooper::Pro Control": {
    "productUrl": "https://coopertires.com.au/our-range/car-tyres/pro-control/",
    "description": "Up to 2.6x more mileage versus a traditional OEM tyre. The Cooper ProControl is made for drivers who want confident handling, safety and longevity in a daily-use tyre. It delivers strong wet-weather grip, even wear and a quiet, stable ride, making it ideal for passenger cars and SUVs that clock up serious kilometres on-road. Armour Belt Technology adds strength for responsive steering and control Silica-rich compound improves braking and grip in wet conditions Even Wear Arc design helps maximise tread life and reduce uneven wear Water evacuation grooves enhance wet traction and hydroplaning resistance Backed by an Australia-wide mileage warranty of up to 70,000 km Mileage Warranty terms and conditions apply.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-pro-control-fab39ca1-shop-90ee76.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2024/02/PRO-CONTROL.webp"
  },
  "Tyres::Cooper::CTT": {
    "productUrl": "https://coopertires.com.au/our-range/suv-tyres/ctt/",
    "description": "Quiet, safe and efficient for everyday SUV driving The Cooper CTT is designed for SUV drivers who value safety, comfort and durability for everyday driving. It offers a quiet ride, reliable wet traction and long-lasting performance for commuting and weekend use. Silica-rich compound improves wet grip, wear life and fuel efficiency Noise isolation bars and a sound-absorbing layer help reduce cabin noise U-shaped grooves help clear water to reduce the risk of hydroplaning Chamfered shoulders improve steering feel and braking response Backed by an Australia-wide mileage warranty of up to 50,000 km Mileage Warranty terms and conditions apply.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-ctt-5d79c59c-shop-de42ef.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/CTT-1.webp"
  },
  "Tyres::Cooper::Discoverer HT3": {
    "productUrl": "https://coopertires.com.au/our-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Cooper::Discoverer SRX": {
    "productUrl": "https://coopertires.com.au/our-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Cooper::Evolution C5": {
    "productUrl": "https://coopertires.com.au/our-range/car-tyres/evolution-c5/",
    "description": "Comfortable, quiet and safe for everyday city driving The Cooper Evolution C5 is designed for everyday driving comfort with reliable grip in wet and dry conditions. It suits passenger cars and compact SUVs, delivering a smooth, quiet ride and long-lasting performance for daily commuters and city drivers. Silica-rich compound improves braking, wet traction and tread life High-density sipes enhance grip and safety in changing conditions Four wide circumferential grooves help reduce the risk of hydroplaning Solid shoulder design helps reduce road noise and improve stability Backed by an Australia-wide mileage warranty of up to 50,000 km Mileage Warranty terms and conditions apply.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-cooper-evolution-c5-5678b9e4-shop-feb12b.webp",
    "imageSourceUrl": "https://coopertires.com.au/wp-content/uploads/2022/08/C5.webp"
  },
  "Tyres::Cooper::Zeon RS3-G1": {
    "productUrl": "https://coopertires.com.au/our-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Cooper tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::BF Goodrich::All-Terrain T/A KO3": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-all-terrain-t-slash-a-ko3",
    "description": "BFGoodrich all-terrain tyre engineered with a new tread pattern and all-terrain compound for durability, longevity and grip across rough conditions.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "All-terrain tyre",
      "Light truck, SUV and 4x4 fitments available by enquiry"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-all-terrain-t-a-ko3-278d7bd7-shop-e0af7a.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4x7ma7misnkcmry/4w-996_3528702987483_tire_bfgoodrich_all-terrain-t-slash-a-ko3_lt-265-slash-70-r17-123-slash-120s_rwl_a_main_1-30_nopad.webp?t=resize&height=500"
  },
  "Tyres::BF Goodrich::All-Terrain T/A KO2": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-all-terrain-t-a-ko2",
    "description": "The BFGoodrich CAR TYRE ALL-TERRAIN T/A KO2 is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. BFGoodrich, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-all-terrain-t-a-ko2-6e7ac6b1-shop-056a18.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4q4recz76hfabio/4w-250_3528701242156_tire_bfgoodrich_all-terrain-t-slash-a-ko2_lt-265-slash-70-r17-121-slash-118s-lre_rwl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-all-terrain-t-a-ko2"
  },
  "Tyres::BF Goodrich::Trail-Terrain T/A": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-trail-terrain-t-a",
    "description": "The BFGoodrich CAR TYRE TRAIL-TERRAIN T/A is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. BFGoodrich, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-trail-terrain-t-a-c47f8594-shop-bde942.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4quj4z6fer6eq1c/4w-490_3528708261297_tire_bfgoodrich_trail-terrain-t-slash-a_265-slash-70-r17-115t_owl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-trail-terrain-t-a"
  },
  "Tyres::BF Goodrich::Mud-Terrain T/A KM3": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-mud-terrain-t-a-km3",
    "description": "The BFGoodrich CAR TYRE MUD-TERRAIN T/A KM3 is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. BFGoodrich, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-mud-terrain-t-a-km3-f7a9cc5a-shop-f6f34f.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xf8sbi86qxnr7o/4w-354_3528700726046_tire_bfgoodrich_mud-terrain-t-slash-a-km3_lt-265-slash-70-r17-121-slash-118q-lre_rbl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-mud-terrain-t-a-km3"
  },
  "Tyres::BF Goodrich::HD-Terrain T/A KT": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-hd-terrain-t-a-kt",
    "description": "The BFGoodrich CAR TYRE HD TERRAIN T/A KT is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. BFGoodrich, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-hd-terrain-t-a-kt-42090e4d-shop-c0b0a2.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xjbz3yr1qfi6te/4w-488_3528708120587_tire_bfgoodrich_hd-terrain-t-slash-a-kt_265-slash-70-r17-123q-lre_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-hd-terrain-t-a-kt"
  },
  "Tyres::BF Goodrich::g-Force Phenom T/A": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-g-force-phenom-t-a",
    "description": "The BFGoodrich CAR TYRE G-FORCE PHENOM T/A is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. BFGoodrich, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-g-force-phenom-t-a-b1e935ae-shop-342b20.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4qqodtk57ujowah/4w-998_3528700029765_tire_bfgoodrich_g-force-phenom-t-slash-a_245-slash-40-zr18-92y-xl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-g-force-phenom-t-a"
  },
  "Tyres::BF Goodrich::g-Force Sport Comp-2": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/browse-tyres/all-tyres",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-bf-goodrich-g-force-sport-comp-2-fe411245-shop-acfdd8.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4qqodtk57ujowah/4w-998_3528700029765_tire_bfgoodrich_g-force-phenom-t-slash-a_245-slash-40-zr18-92y-xl_a_main_1-30_nopad.webp?t=resize&height=700"
  },
  "Tyres::BF Goodrich::Advantage Control": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-advantage-control",
    "description": "The BFGoodrich CAR TYRE ADVANTAGE CONTROL is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. BFGoodrich, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-advantage-control-8e60cef0-shop-cf39a8.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4xiu7xppnpk6q5o/4w-494_3528701128610_tire_bfgoodrich_advantage-control_215-slash-60-r17-96h_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-advantage-control"
  },
  "Tyres::BF Goodrich::Radial T/A": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-radial-t-a",
    "description": "The BFGoodrich CAR TYRE RADIAL T/A is designed for long-lasting performance! Discover its features and all its benefits, as well as reviews from our consumers. BFGoodrich, a tyre specialist since 1889, is a premium brand known for its high-quality and high-performance products.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bf-goodrich-radial-t-a-51adce41-shop-d7cd9f.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4q5pp1oo55x3tao/4w-285_3528701170053_tire_bfgoodrich_radial-t-slash-a_p295-slash-50-r15-105s_rwl_a_main_1-30_nopad.webp?t=resize&height=500",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bfgoodrich.com.au/auto/tyres/bfgoodrich-radial-t-a"
  },
  "Tyres::BF Goodrich::Commercial T/A All-Season 2": {
    "productUrl": "https://www.bfgoodrich.com.au/auto/browse-tyres/all-tyres",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "BF Goodrich tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-bf-goodrich-commercial-t-a-all-season-2-31c40616-shop-a9dc3c.webp",
    "imageSourceUrl": "https://dxm.contentcenter.michelin.com/api/wedia/dam/transform/b98rpyxf61b4x7ma7misnkcmry/4w-996_3528702987483_tire_bfgoodrich_all-terrain-t-slash-a-ko3_lt-265-slash-70-r17-123-slash-120s_rwl_a_main_1-30_nopad.webp?t=resize&height=700"
  },
  "Tyres::Bridgestone::Potenza Sport": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/potenza_sport",
    "description": "Potenza Sport tyres, the best sport and performance tyre choice for the street performance & track performance. Click to learn about the enhanced grip & tractions.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-potenza-sport-clean-c4312cf9-f6747b-shop-32c64f.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/703f5671-e707-4228-9d08-46e0e9f41b05.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/potenza_sport",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/potenza-sport"
  },
  "Tyres::Bridgestone::Potenza RE-71RS": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/re_71rs",
    "description": "Engineered to deliver the performance enthusiasts demand on the track, while still providing practicality for everyday use",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-potenza-re-71rs-clean-f815da5a-78ffa8-shop-6209d2.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/4365-1723096288-manf-angle-large.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/re_71rs",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/re-71rs"
  },
  "Tyres::Bridgestone::Potenza Adrenalin RE003": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/adrenalin_re003",
    "description": "Potenza Adrenalin RE003 tyres, the ultimate tyre choice for the street performance for sport cars, engineered enhanced grip & tractions. Click to.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-potenza-adrenalin-re003-clean-4c5f0d4a-611cfb-shop-37ef91.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/2f56d890-dbc8-40aa-90e8-2aa5c1fefbc9.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/adrenalin_re003",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/potenza-adrenalin-re003"
  },
  "Tyres::Bridgestone::Potenza S007A": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/s007a",
    "description": "Developed to provide exceptional grip and outstanding steering response, the Potenza S007A is a high speed performance tyre, click to find out more.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-potenza-s007a-40f8799e-shop-4b5dd6.webp",
    "imageSourceUrl": "https://www.bridgestone.com.au/-/media/project/bridgestone-global/apac/apac-shared/tyres/bridgestone/potenza/s007a/s007a-1.png?h=438&iar=0&w=330&rev=f4b86fa66266419c86d6ca167bbf07ef&hash=D2B179A06132A2DAFC96AC3B6A7C7092",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/potenza/s007a",
    "imageStatus": "blocked-watermark",
    "imageStatusReason": "Visible Bridgestone watermark on downloaded catalogue image; replace with a clean product image before re-enabling."
  },
  "Tyres::Bridgestone::Turanza T005": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/t005",
    "description": "Bridgestone Turanza T005 designed to help you to stay in control, even in challenging driving conditions, click to read the full specification.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-turanza-t005-clean-d15a2d02-bc88c3-shop-6dc395.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/bfa55241-239b-417f-9f1b-fc4e08067354.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/t005",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/turanza-t005"
  },
  "Tyres::Bridgestone::Turanza T005A": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/t005a",
    "description": "Turanza T005A has the latest in tyre technology for superior safety & comfort. Click to about the outstanding grip in the wet.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-turanza-t005a-clean-d8284c9e-db8a6a-shop-8752ca.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/d64d98f9-4a07-4111-8435-23e7ed0cd417.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/t005a",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/turanza-t005a"
  },
  "Tyres::Bridgestone::Turanza T006": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/t006",
    "description": "Select your store 131 229 Let's find the right tyres for your vehicle Categories 4x4 and SUV Tyres Tyre Warranties Manufacturer’s Warranty Why Buy from Bridgestone Tyre Price Promise",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/t006",
    "imageStatus": "blocked-duplicate-or-generic-source",
    "imageStatusReason": "Visible Bridgestone watermark on downloaded catalogue image; replace with a clean product image before re-enabling.",
    "rejectedImageSourceUrl": "https://www.bridgestone.com.au/-/media/project/bridgestone-global/apac/bridgestone-au/testing-page-images/black-bg.jpg?rev=d823b2392d8a45c5ae5fbb9dd1d36fc0"
  },
  "Tyres::Bridgestone::Turanza Serenity Plus": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/serenity_plus",
    "description": "Turanza Serenity Plus has superior safety & comfort with the latest in tyre technology. Click to about the outstanding grip in the wet and comfort.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-turanza-serenity-plus-f789f553-shop-6cccb8.webp",
    "imageSourceUrl": "https://www.bridgestone.com.au/-/media/project/bridgestone-global/apac/apac-shared/tyres/bridgestone/turanza/serenity_plus/serenity_plus-1.png?h=438&iar=0&w=330&rev=fb9f1bfb39a647f78c753eb0e7cb9a04&hash=99D8F44425369D169C32A11BEB778E31",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/turanza/serenity_plus",
    "imageStatus": "blocked-watermark",
    "imageStatusReason": "Visible Bridgestone watermark on downloaded catalogue image; replace with a clean product image before re-enabling."
  },
  "Tyres::Bridgestone::Ecopia EP300": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/ecopia/ep300",
    "description": "Find out more about the Bridgestone Ecopia EP300 tyre, designed for superior perfromance and greater cost savings, click to.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-ecopia-ep300-clean-7e6efa3b-b7397a-shop-6cf6cd.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/5a14420e-7295-4ab9-bbb2-41559479e1b3.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/ecopia/ep300",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/ecopia-ep300"
  },
  "Tyres::Bridgestone::Ecopia H/L 001": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/ecopia/h_l_001",
    "description": "The best SUV tyre, delivering a fuel saving tyre with excellent wear life. Click to about the Ecopia HL001 improved wet braking & handling!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-ecopia-h-l-001-clean-3c2b17d0-203df0-shop-52df11.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/93e39c14-881e-49fd-bc59-36564c875f09.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/ecopia/h_l_001",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/ecopia-hl-001"
  },
  "Tyres::Bridgestone::Dueler A/T 002": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/a_t_002",
    "description": "Dueler All-Terrain A/T002 brings versatility, economy and comfort to the All-Terrain market. Click to about the Dueler All-Terrain A/T002 tyre range.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-dueler-a-t-002-e87d0264-shop-1a3300.webp",
    "imageSourceUrl": "https://www.bridgestone.com.au/-/media/project/bridgestone-global/apac/apac-shared/tyres/bridgestone/dueler/a_t_002/a_t_002-1.png?h=438&iar=0&w=330&rev=b42b2bdc119f431c9a50a965b953368f&hash=C3EA626E0DCC9D38FFDBDCDC9D80FA16",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/a_t_002",
    "imageStatus": "blocked-watermark",
    "imageStatusReason": "Visible Bridgestone watermark on downloaded catalogue image; replace with a clean product image before re-enabling."
  },
  "Tyres::Bridgestone::Dueler A/T 697": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/a_t_697",
    "description": "Bridgestone Dueler A/T 697, the ultimate 4x4 all terrain tyre, designed & tested to withstand the harshest outback conditions. Click to learn about the all terrain tyre.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-dueler-a-t-697-clean-f1c44d27-eb8d25-shop-ab92cc.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/9a6273a2-76cd-41a0-a582-4ea82265ac91.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/a_t_697",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/dueler-at-697"
  },
  "Tyres::Bridgestone::Dueler H/T 684": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/h_t_684",
    "description": "4x4 tyre features a modern tread pattern for excellent handling stability and a quieter, smoother, more comfortable highway ride.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-dueler-h-t-684-clean-6f9f06dc-f3dcd4-shop-7574a4.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/cc23865f-7e8b-409c-acef-400bd534f256.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/h_t_684",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/dueler-ht-684"
  },
  "Tyres::Bridgestone::Dueler H/P Sport": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/h_p_sport",
    "description": "Bridgestone Dueler H/P Sport was developed as original equipment for many of today",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-dueler-h-p-sport-clean-bf8b0174-736660-shop-97c57f.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/76d76c4c-388c-4a13-a164-e6d959769210.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/h_p_sport",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/dueler-hp-sport"
  },
  "Tyres::Bridgestone::Dueler M/T 674": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/m_t_674",
    "description": "Dueler M/T 674 tyre are the premium mud terrain tyre, designed to meet the demands of off road driving, through heavy mud. Click to learn about the mud terrain tyres.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-dueler-m-t-674-clean-a3a2e47f-0c1dc4-shop-f18838.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/69913161-8e7f-472d-aa9f-d2a52838c66b.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/dueler/m_t_674",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/dueler-mt-674"
  },
  "Tyres::Bridgestone::Alenza 001": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/alenza/001",
    "description": "Alenza 001 SUV tyres are best for SUVs, offering high-level braking performance, outstanding tyre life, and enhanced grip on wet and dry roads. Click to!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-alenza-001-clean-a53ed14b-64164c-shop-210812.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/42647ef2-8e97-4539-be43-9bc5786fd91f.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/alenza/001",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/alenza-001"
  },
  "Tyres::Bridgestone::Alenza Sport A/S": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/alenza/sport_a_s",
    "description": "Confirm your preferred store Your preferred store Select your preferred store Select store Your selected store Bridgestone Pricing Available Online Home &gt; Tyres &gt; Bridgestone &gt; Alenza &gt; Sport A/S &gt; The Alenza Sport A/S is a premium all season SUV tyre offering exceptional comfort and fuel efficiency. It is available as an original equipment product only, fitted from new to SUV's such as the 2024 Porsche Cayenne and 2023 Nissan X-Trail.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-alenza-sport-a-s-clean-8bee8fc7-f7fd4a-shop-99e8e3.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/3989-1699831236-manf-angle-large.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/alenza/sport_a_s",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/alenza-sport-as"
  },
  "Tyres::Bridgestone::Weather Control A005": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/weather_control/a005",
    "description": "Select your store 131 229 Let's find the right tyres for your vehicle Categories 4x4 and SUV Tyres Tyre Warranties Manufacturer’s Warranty Why Buy from Bridgestone Tyre Price Promise",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/weather_control/a005",
    "imageStatus": "blocked-duplicate-or-generic-source",
    "imageStatusReason": "Visible Bridgestone watermark on downloaded catalogue image; replace with a clean product image before re-enabling.",
    "rejectedImageSourceUrl": "https://www.bridgestone.com.au/-/media/project/bridgestone-global/apac/bridgestone-au/testing-page-images/black-bg.jpg?rev=d823b2392d8a45c5ae5fbb9dd1d36fc0"
  },
  "Tyres::Bridgestone::Duravis R660": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/duravis/r660",
    "description": "Developed to meet the multi-purpose needs of the modern commercial vehicle driver for safety, durability, comfort and efficiency to make the Duravis the perfect workmate.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-duravis-r660-clean-010d6a5e-a037b3-shop-7085f5.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/0548ead6-ba62-4c56-8d92-91764afc669b.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/bridgestone/duravis/r660",
    "imageSourcePageUrl": "https://tyrepowersale.com.au/tyres/bridgestone/duravis-r660"
  },
  "Tyres::Bridgestone::Supercat A/T": {
    "productUrl": "https://www.bridgestone.com.au/tyres/au/supercat/supercat_a_t",
    "description": "Supercat A/T is designed for Australasian conditions with strong cut and chip resistance, wear life and all-round performance. Its aggressive all-terrain tread supports off-road traction, while light truck construction and deep tread help with puncture resistance and long wear life.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Bridgestone tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-bridgestone-supercat-a-t-official-shop-e097be.webp",
    "imageSourceUrl": "https://www.bridgestone.com.au/-/media/project/bridgestone-global/apac/apac-shared/tyres/supercat/supercat_a_t/supercat_a_t-1.png?h=438&iar=0&w=330&rev=1f54c30e0e76464fbedf40df2b33c42c&hash=7C2C4BA8E067D689C676813041078D86",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.bridgestone.com.au/tyres/au/supercat/supercat_a_t",
    "imageStatus": "blocked-watermark",
    "imageStatusReason": "Visible Bridgestone watermark on downloaded catalogue image; replace with a clean product image before re-enabling."
  },
  "Tyres::Continental::SportContact 7": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/sportcontact-7",
    "description": "Stick to your dreams. And to the asphalt.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-sportcontact-7-df5452df-shop-89e812.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/May2023/cxRfUptv2FB4U2CKpH8e.webp"
  },
  "Tyres::Continental::SportContact 6": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/sportcontact-6",
    "description": "Thrilling safety",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-sportcontact-6-c9503fed-shop-bf5c61.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/June2023/dmQ9O6hGLBto9cdTbTWC.webp"
  },
  "Tyres::Continental::PremiumContact 7": {
    "productUrl": "https://www.continental-tires.com/products/car/tires/premiumcontact-7/",
    "description": "The Continental PremiumContact 7: Driving safely has never felt better. Enjoy safety and comfort no matter which drive you choose.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Continental::PremiumContact 6": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/premiumcontact-6",
    "description": "Developed for all classes of passenger cars",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-premiumcontact-6-a953960b-shop-e50a44.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/October2023/Nt8XvkmoPxfYSwhpMe20.png"
  },
  "Tyres::Continental::EcoContact 6": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/ecocontact-6",
    "description": "The next standard enhanced by German technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-ecocontact-6-b4c49ccf-shop-69b9e0.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/October2023/2GY2Z4BhUwWyF3WwGDG6.png"
  },
  "Tyres::Continental::EcoContact 6 Q": {
    "productUrl": "https://www.continental-tires.com/au/en/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Continental::UltraContact": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/ultracontact",
    "description": "Made to endure",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-ultracontact-0dcd4e9d-shop-b7d115.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/October2023/v7ISax2am6XiE0LpZS5k.png"
  },
  "Tyres::Continental::ComfortContact CC7": {
    "productUrl": "https://www.continental-tires.com/products/car/tires/comfortcontact-cc7/",
    "description": "Smoother Drive. Quiet Ride. Long Tire Life.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Continental::MaxContact MC7": {
    "productUrl": "https://www.continental-tires.com/au/en/products/car/tyres/maxcontact-mc7/",
    "description": "MaxContact MC7 MaxContact MC7 pdf 1 MB \\r\\n&lt;li>&lt;a href=\\\"#\\\" target=\\\"_blank\\\" title=\\\"Continental Corporation\\\" rel=\\\"noopener noreferrer\\\">Continental Corporation&lt;/a>&lt;/li>\\r\\n&lt;li>&lt;a href=\\\"#\\\" target=\\\"_blank\\\" title=\\\"Continental Industry\\\" rel=\\\"noopener noreferrer\\\">Continental Industry&lt;/a>&lt;/li>\\r\\n&lt;li>&lt;a href=\\\"/content/conti-tires-cms/au/en/about-us.html\\\" target=\\\"_blank\\\" title=\\\"About Continental\\\" rel=\\\"noopener noreferrer\\\">About Continental&lt;/a>&lt;/li>\\r\\n&lt;/ul>\\r\\n\"}",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.continental-tires.com/au/en/products/car/tyres/maxcontact-mc7/"
  },
  "Tyres::Continental::MaxContact MC6": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/maxcontact-mc6",
    "description": "Superior dry handling and braking",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-maxcontact-mc6-896988ea-shop-2bad14.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/June2023/gS7w96kbRb4NIrK81Vyg.webp"
  },
  "Tyres::Continental::CrossContact LX25": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/crosscontact-lx25",
    "description": "The next generation premium all-season tire with exceptional wet braking performance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-crosscontact-lx25-8972ac74-shop-d0e64d.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/April2026/i75xT3WAAWHDDTaX6ZgT.webp"
  },
  "Tyres::Continental::CrossContact LX Sport": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/crosscontact-lx-sport",
    "description": "Infinite terrains, unlimited safety.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-crosscontact-lx-sport-0c528fb2-shop-d1f68e.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/June2023/OrWp8RTBiPJPBxX59EU4.webp"
  },
  "Tyres::Continental::CrossContact ATR": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/crosscontact-atr",
    "description": "Own the road, no matter what surface.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-crosscontact-atr-48e53ad8-shop-7c722a.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/June2023/TBqb4BfRrz2lFjTVyYTT.webp"
  },
  "Tyres::Continental::CrossContact H/T": {
    "productUrl": "https://www.continental-tires.com/products/car/tires/crosscontact-h-t/",
    "description": "The Continental CrossContact H/T: Made for everyday. Ready for the unexpected. Experience great adaptability with exceptionally low noise for enhanced driving comfort.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Continental::ContiSportContact 5": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/contisportcontact-5",
    "description": "Control has never been sportier",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-contisportcontact-5-ce4199ee-shop-bd9f0b.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/June2023/b1UOdjzR3sbPrMKtAjCy.png"
  },
  "Tyres::Continental::ContiPremiumContact 5": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/contipremiumcontact-5",
    "description": "Now you are prepared for any situation.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-contipremiumcontact-5-1b5d9da1-shop-471a39.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/June2023/JxHTVbSV9iRQ12qL8ezQ.webp"
  },
  "Tyres::Continental::VanContact Eco": {
    "productUrl": "https://www.continental-tires.com/products/car/tires/vancontact-eco/",
    "description": "Comfortable driving with maximum efficiency. Maximum fuel efficiency thanks to an innovative compound Enhanced mileage through a wear optimised pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Continental::VanContact Ultra": {
    "productUrl": "https://www.continental-tires.com/products/car/tires/vancontact-ultra/",
    "description": "The Continental VanContact Ultra: Made to endure. For years and years. German engineered reliability. Benefit from superb durability and high sidewall robustness.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.continental-tires.com/au/en/products/car/vancontact--ultra--for-ultra-mileage-/"
  },
  "Tyres::Continental::AllSeasonContact": {
    "productUrl": "https://eg.continental-me.com/en/tires/car/allseasoncontact",
    "description": "Be in control of every season.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-continental-allseasoncontact-ba3746e7-shop-a1ff76.webp",
    "imageSourceUrl": "https://eg.continental-me.com/storage/patterns/July2023/HZ6tbgXyJhfHdnZfr15j.webp"
  },
  "Tyres::Continental::WinterContact TS 870": {
    "productUrl": "https://www.continental-tires.com/products/car/tires/wintercontact-ts-870/",
    "description": "The Continental WinterContact TS 870: All winter tires are the same. Until the streets turn white. Experience what makes the new WinterContact so outstanding.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Continental tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Kenda::Klever R/T KR601": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-klever-rt-kr601",
    "description": "The terrain you drive on doesn't care and it is not willing to compromise. The Kenda Klever R/T was designed to conquer rough terrain without...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-klever-r-t-kr601-c34aff50-shop-b481da.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/3147-1712278500-manf-angle-large.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-klever-rt-kr601"
  },
  "Tyres::Kenda::Klever A/T2 KR628": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-klever-at2-kr628",
    "description": "Kenda AT2K628 is an all-terrain tyre engineered for versatility and durability. Designed to perform on both highways and rugged off-road conditions,...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-klever-a-t2-kr628-95f074f4-shop-6cf935.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/3417-1712277038-manf-angle-large.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-klever-at2-kr628"
  },
  "Tyres::Kenda::Klever M/T2 KR629": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-klever-mt2-kr629",
    "description": "The Kenda Klever M/T2 KR629 is the 2nd generation mud terrain tyre designed for enthusiasts and consumers who desire maximum traction in off-road...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-klever-m-t2-kr629-0781f9f1-shop-8bb314.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/3932-1717379764-manf-angle-large.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-klever-mt2-kr629"
  },
  "Tyres::Kenda::Klever H/T2 KR600": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-klever-kr600-ht2",
    "description": "Designed for highway driving, the Klever H/T2 KR600 uses an optimised footprint for consistent wear and handling under different loads. Strong shoulder blocks support handling and cornering stability, while its siping and circumferential grooves help wet-weather traction.",
    "availableSizes": [
      "215/85R16 115/112R",
      "225/75R16 115/112R",
      "235/65R16 121/119R",
      "235/85R16 120/116Q",
      "245/75R16 120/116R",
      "265/70R16 111T",
      "265/75R16 123/120Q",
      "235/80R17 120/117R",
      "245/70R17 119/116R",
      "245/75R17 121/118R",
      "255/70R17 110T",
      "265/65R17 110T",
      "265/70R17 121/118R",
      "265/70R17 113T",
      "255/70R18 112T",
      "265/60R18 109H",
      "265/65R18 112H",
      "265/70R18 124/121R",
      "275/65R18 123/120R",
      "275/70R18 125/122R",
      "265/60R20 121/118R",
      "275/65R20 126/123R",
      "285/45R22 114H XL"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-kenda-klever-h-t2-kr600-verified-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/3ccbc94d-a7d4-4e46-8d4d-089c8d4f5944.png"
  },
  "Tyres::Kenda::Komet Plus KR23": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-komet-plus-kr23a",
    "description": "Touring radial featuring a revolutionary tread design refined by Kenda NMA technology creates one of the quietest tires in Kenda's lineup. Water...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-komet-plus-kr23-f256dcf3-shop-df5bd2.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/aa44f83d-4b61-43eb-b667-1664b3a9cd0d.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-komet-plus-kr23a"
  },
  "Tyres::Kenda::Kenetica KR217": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-kenetica-kr217",
    "description": "The Kenda Kenetica KR217 is our T & H-rated touring tyre designed to fit the needs of many drivers. The KR217 is the 2nd generation of our popular...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-kenetica-kr217-f780f208-shop-7ceb58.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/1a0181d7-d757-494d-aa42-4c68f368998b.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-kenetica-kr217"
  },
  "Tyres::Kenda::Vezda UHP A/S KR400": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-vezda-uhp-as-kr400",
    "description": "The Vezda UHP, is Kenda's Ultra High Performance tyre formulated with a special silica compound combining summer levels of wet and dry...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-vezda-uhp-a-s-kr400-b25e93b9-shop-bf32ae.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/f5d0a855-3408-4ea6-a7b8-84a7c2215196.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-vezda-uhp-as-kr400"
  },
  "Tyres::Kenda::Vezda Touring A/S KR205": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-vezda-touring-as-kr205",
    "description": "Kenda USA's new Vezda Touring A/S KR205 is designed for drivers of coupes, sedans and luxury touring cars. Created for diverse all-season...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-vezda-touring-a-s-kr205-607a57d0-shop-9288ee.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/169481b8-96ea-434a-ac0d-3935a6c2569f.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-vezda-touring-as-kr205"
  },
  "Tyres::Kenda::Vezda Eco KR30": {
    "productUrl": "https://www.kendatires.com.au/tyres/kenda-vezda-eco-kr30",
    "description": "Designed for premium, high performance touring cars, the Kenda VezdaEco is manufactured with a silica infused tread compound that reduces C02...",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kenda-vezda-eco-kr30-87aed664-shop-b2f533.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/19/1ee24242-b6a4-49a8-93fb-095d6427c0e9.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.kendatires.com.au/tyres/kenda-vezda-eco-kr30"
  },
  "Tyres::Kenda::Kargo Trail KR500": {
    "productUrl": "https://www.kendatires.com.au/tyres/offroad",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Kenda::Karrier KR33": {
    "productUrl": "https://www.kendatires.com.au/tyres/offroad",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Kenda::Komendo KR33A": {
    "productUrl": "https://www.kendatires.com.au/tyres/offroad",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kenda tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Kumho::Ecsta PS71": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/ps71/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator ECSTA PS71 A sports performance tyre designed for driving refinement Design to deliver fine and stable driving with superb handling and braking performance on wet and dry surfaces Compound technology - High Dispersion ‘Micro Silica’: Maximises wear, handling performance and fuel efficiency by application of high-dispersion silica. Maxmized driving performance - 4 main wide grooves direct water drainage out of tread area performance resin",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/ps71/",
    "localImage": "catalog-tyres-kumho-ecsta-ps71-88187a5a-54f23c-shop-978a92.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/with-tags/PS71_30deg.png"
  },
  "Tyres::Kumho::Ecsta PA51": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/ecsta-pa51/",
    "description": "With its state of the art tread design & new innovative compound, the ECSTA PA51 is able to deliver the enhanced handling, traction & extended tread life.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kumho-ecsta-pa51-df248ae4-shop-f89dd4.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/with-tags/PA51_30deg.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/ecsta-pa51/"
  },
  "Tyres::Kumho::Ecsta PS91": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/ps91/",
    "description": "About History What's next is already here Original Equipment Manufacturer Kumho Dealer Program FAQs Tyres Passenger 4X4/SUV EV Tyres Light Commercial Truck & Bus Racing Mileage Warranty Road Hazard Warranty Dealer Locator Dealer Locator AU News Kumho Marketing Dealers Motorsports Sports Products Events Competitions Kumho Global News Downloads Videos Sponsorships Motorsports Sports All About Rubber How to read tyre size Tyre maintenance How to measure tread depth Kumho Summer Safety Series Contact QUICK LINKS Tyre S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/ps91/"
  },
  "Tyres::Kumho::Ecsta HS52": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/hs52/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator ECSTA HS52 ECSTA HS52 Replacing the ECSTA HS51, the Award winning new ECSTA HS52 pattern has been designed to provide the perfect balance between comfort and performance, offering drivers of premium sedans and sports vehicles a comfortable ride along with high levels of safety through high grip and braking performance Asymmetrical Tread Design Asymmetric tread design provides the highly balanced handling performance on both wet and dry surfaces.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/hs52/",
    "localImage": "catalog-tyres-kumho-ecsta-hs52-fefaa3d4-18ee80-shop-d4f24a.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/HS52_website_new-optimised.png"
  },
  "Tyres::Kumho::Ecsta HS51": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/hs51/",
    "description": "About History What's next is already here Original Equipment Manufacturer Kumho Dealer Program FAQs Tyres Passenger 4X4/SUV EV Tyres Light Commercial Truck & Bus Racing Mileage Warranty Road Hazard Warranty Dealer Locator Dealer Locator AU News Kumho Marketing Dealers Motorsports Sports Products Events Competitions Kumho Global News Downloads Videos Sponsorships Motorsports Sports All About Rubber How to read tyre size Tyre maintenance How to measure tread depth Kumho Summer Safety Series Contact QUICK LINKS Tyre S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/hs51/"
  },
  "Tyres::Kumho::Ecsta KU39": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/ku39/",
    "description": "About History What's next is already here Original Equipment Manufacturer Kumho Dealer Program FAQs Tyres Passenger 4X4/SUV EV Tyres Light Commercial Truck & Bus Racing Mileage Warranty Road Hazard Warranty Dealer Locator Dealer Locator AU News Kumho Marketing Dealers Motorsports Sports Products Events Competitions Kumho Global News Downloads Videos Sponsorships Motorsports Sports All About Rubber How to read tyre size Tyre maintenance How to measure tread depth Kumho Summer Safety Series Contact QUICK LINKS Tyre S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/ku39/"
  },
  "Tyres::Kumho::Solus TA21": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/solus-ta21/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator SOLUS TA21 The TA21 is developed from 60 years of Kumho technology to provide a mid-level touring tyre which provides drivers with a balanced performance with a quiet and comfortable ride.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/solus-ta21/",
    "localImage": "catalog-tyres-kumho-solus-ta21-d660b31c-62124f-shop-a52c27.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/3779-SOLUS%20TA21.png"
  },
  "Tyres::Kumho::Solus TA31": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/solus-ta31/",
    "description": "About History What's next is already here Original Equipment Manufacturer Kumho Dealer Program FAQs Tyres Passenger 4X4/SUV EV Tyres Light Commercial Truck & Bus Racing Mileage Warranty Road Hazard Warranty Dealer Locator Dealer Locator AU News Kumho Marketing Dealers Motorsports Sports Products Events Competitions Kumho Global News Downloads Videos Sponsorships Motorsports Sports All About Rubber How to read tyre size Tyre maintenance How to measure tread depth Kumho Summer Safety Series Contact QUICK LINKS Tyre S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/solus-ta31/",
    "localImage": "catalog-tyres-kumho-solus-ta31-3310f21c-6cde72-shop-85069a.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/2087-TA31.png"
  },
  "Tyres::Kumho::Solus KH17": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/kh17/",
    "description": "About History What's next is already here Original Equipment Manufacturer Kumho Dealer Program FAQs Tyres Passenger 4X4/SUV EV Tyres Light Commercial Truck & Bus Racing Mileage Warranty Road Hazard Warranty Dealer Locator Dealer Locator AU News Kumho Marketing Dealers Motorsports Sports Products Events Competitions Kumho Global News Downloads Videos Sponsorships Motorsports Sports All About Rubber How to read tyre size Tyre maintenance How to measure tread depth Kumho Summer Safety Series Contact QUICK LINKS Tyre S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/kh17/"
  },
  "Tyres::Kumho::Sense KR26": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/kr26/",
    "description": "About History What's next is already here Original Equipment Manufacturer Kumho Dealer Program FAQs Tyres Passenger 4X4/SUV EV Tyres Light Commercial Truck & Bus Racing Mileage Warranty Road Hazard Warranty Dealer Locator Dealer Locator AU News Kumho Marketing Dealers Motorsports Sports Products Events Competitions Kumho Global News Downloads Videos Sponsorships Motorsports Sports All About Rubber How to read tyre size Tyre maintenance How to measure tread depth Kumho Summer Safety Series Contact QUICK LINKS Tyre S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/kr26/"
  },
  "Tyres::Kumho::Crugen HP71": {
    "productUrl": "https://www.kumho.com.au/tyres/suv/crugen-hp71/",
    "description": "For reliable 4WD tyres, CRUGEN HP71 from Kumho Tyres is the way to go, here.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kumho-crugen-hp71-ef61015d-shop-3ecfc6.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/with-tags/HP71_30deg.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/suv/crugen-hp71/"
  },
  "Tyres::Kumho::Crugen HP91": {
    "productUrl": "https://www.kumho.com.au/tyres/suv/crugen-hp91/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator CRUGEN HP91 Ultra high performance tyre for SUVs Asymmetric tread design with low noise and up-graded UHP tread compound for SUV vehicles Designed for luxury and sporty SUV’s Outstanding resistance against aquaplaning with high cornering stability Also gives a quiet and comfortable ride Straight driving stability - Longitudinal centre ribs for high speed driving stability with splitting edge blocks Maximum steering performance (Outside) - Maximised block stiffness for improv",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/suv/crugen-hp91/",
    "localImage": "catalog-tyres-kumho-crugen-hp91-234e2f09-e6cd9f-shop-82bb9e.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/1118-HP91.png"
  },
  "Tyres::Kumho::Crugen HT51": {
    "productUrl": "https://www.kumho.com.au/tyres/suv/crugen-ht51/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator CRUGEN HT51 Engineered with quality, features and details to go the distance in hard working, hard driving, all-weather conditions Improved straight line driving performance - Stiff centre block design reinforces stability, traction and handling capabilities. Extended tread life - An optimal block shape and four channel symmetric layout improves long tread life.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/suv/crugen-ht51/",
    "localImage": "catalog-tyres-kumho-crugen-ht51-8b9b0114-187d8f-shop-6b067e.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/with-tags/1863-HT51.png"
  },
  "Tyres::Kumho::Crugen KL33": {
    "productUrl": "https://www.kumho.com.au/tyres/suv/crugen-kl33/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator CRUGEN KL33 Crugen Premium is the all-new premium SUV offering high quality comfort and optimum steering stability in on-road conditions High class premium all season touring tyre for luxury SUV’s High class premium all season touring tyre for luxury SUV’s Lower noise & outstanding ride comfort Well balanced dry & wet traction OE for Hyundai Santa Fe, KIA Sorento etc.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/suv/crugen-kl33/",
    "localImage": "catalog-tyres-kumho-crugen-kl33-015c0e3d-385fa1-shop-ccb086.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/KL33_R1-optimised.png"
  },
  "Tyres::Kumho::Road Venture AT52": {
    "productUrl": "https://www.kumho.com.au/tyres/4x4/at52/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator ROAD VENTURE AT52 The new AT52 blends the perfect combination of performance to take command of rugged terrains whilst also delivering on-road comfort and providing year-round all-season traction Enhanced traction tread design - Deep lateral and wide sub-lateral grooves combined with high-density siping help provide the perfect combination of clawing action off road, whilst also improving wet performance both on and off-road Extreme side-biters - Rugged and aggressive side-b",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/4x4/at52/",
    "localImage": "catalog-tyres-kumho-road-venture-at52-6a97bb07-09de7a-shop-cf85f2.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/AT52.png"
  },
  "Tyres::Kumho::Road Venture AT51": {
    "productUrl": "https://www.kumho.com.au/tyres/4x4/road-venture-at51/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator ROAD VENTURE AT51 Inspired by deep ruts and washed-out roads, the ROAD VENTURE T51 has versatility as its pedigree. Able to withstand the most demanding off-road conditions as well as provide a comfortable highway driving experience. Each all-terrain trait is meticulously engineered and produced from the finest materials and compounds available. The Road Venture AT51 provides impressive all-terrain performance every time out.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/4x4/road-venture-at51/",
    "localImage": "catalog-tyres-kumho-road-venture-at51-ec4b45b4-e873f7-shop-cd9e1a.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/1358-AT51-optimised.png"
  },
  "Tyres::Kumho::Road Venture MT71": {
    "productUrl": "https://www.kumho.com.au/tyres/4x4/road-venture-mt71/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator ROAD VENTURE MT71 Dual pitch designed with zig-zag center block offers maximum off-road traction Improved vertical & lateral block rigidity offers better handling Chamfer cut: Angled c-cut design applied for maximum traction Aggressive design for increased climbing performance and off-road traction Enhanced durability with cut-and-chip resistance Exceptional off-road performance with excellent highway handling",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/4x4/road-venture-mt71/",
    "localImage": "catalog-tyres-kumho-road-venture-mt71-774a1bb5-be4a8e-shop-898013.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/MT71_30deg_1_small.png"
  },
  "Tyres::Kumho::Road Venture MT51": {
    "productUrl": "https://www.kumho.com.au/tyres/4x4/road-venture-mt51/",
    "description": "Durability improvement - Prevention of crack, cut & chip, stone drilling Traction performance improvement - 3 level height block improves its stiffness - Zigzag groove, notching shoulder reduces damage, off road traction up Mud & stone emission - Stone reject bar & under groove decoration improves stones & mud rejection Click here for MT51 \"HOW TO GET THE MOST OUT OF YOUR ROAD VENTURE MT51 OFF ROAD KUMHO TYRES\" Pink Fitters Day Pink Fitters Day Pink Fitters Day",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-kumho-road-venture-mt51-0bcd08e8-shop-3405ab.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/1359-Road_Venture_MT51-optimised.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/4x4/road-venture-mt51/"
  },
  "Tyres::Kumho::PorTran KC53": {
    "productUrl": "https://www.kumho.com.au/tyres/commercial/portran-kc53/",
    "description": "QUICK LINKS Tyre Selector Dealer Locator PORTRAN KC53 The PorTran KC53 van tyre is a powerful tyre designed for heavy commercial usage, and is ideal for vans, people movers and mobile homes The new generation for light commercial vehicle tyre with high mileage and good handling properties Handling performance - Wider tread width & solid centre rib for dry handling - Increased cavity volume wide straight circumferential for wet handling /aquaplaning Low RR and high mileage - Rib style tread pattern • Optimised pitch",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/commercial/portran-kc53/",
    "localImage": "catalog-tyres-kumho-portran-kc53-d5f9183a-af684b-shop-815432.webp",
    "imageSourceUrl": "https://www.kumho.com.au/images/tyres/706-KC53.png"
  },
  "Tyres::Kumho::WinterCraft WP72": {
    "productUrl": "https://www.kumho.com.au/tyres/passenger/wp72/",
    "description": "About History What's next is already here Original Equipment Manufacturer Kumho Dealer Program FAQs Tyres Passenger 4X4/SUV EV Tyres Light Commercial Truck & Bus Racing Mileage Warranty Road Hazard Warranty Dealer Locator Dealer Locator AU News Kumho Marketing Dealers Motorsports Sports Products Events Competitions Kumho Global News Downloads Videos Sponsorships Motorsports Sports All About Rubber How to read tyre size Tyre maintenance How to measure tread depth Kumho Summer Safety Series Contact QUICK LINKS Tyre S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kumho tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kumho.com.au/tyres/passenger/wp72/"
  },
  "Tyres::Falken::Wildpeak A/T3W": {
    "productUrl": "https://www.falken.com.au/product/wildpeak-at3w/",
    "description": "The WILDPEAK AT3W is engineered for adventure, any time and in any weather. The tyre combines aggressive off-road ability and rugged terrain driving without compromise on the pavement. An optimised tread design combined with a silica tread compound enables the tyre to excel in three areas: wear, winter, and wet performance. The tyre is packed with technology, from Falken’s patented 3D Canyon Sipes to an all-new proprietary lower sidewall. Full-depth sipes and grooves maintain consistent performance and appearance throughout the life of the tyre.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-falken-wildpeak-a-t3w-5b99fecb-shop-58d563.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2017/04/Falken-Tyres-WPAT3W-250X500-MAIN.jpg"
  },
  "Tyres::Falken::Wildpeak A/T4W": {
    "productUrl": "https://www.falken.com.au/product/wildpeak-at4w/",
    "description": "Australia's wildest tracks demand a tyre built tougher than most. The new Falken Wildpeak AT4W delivers the next evolution in all-terrain performance - built for rugged 4x4 touring, daily ute use, and everything in between. Whether you're crawling over rocks, hauling loads, or cruising the blacktop, the AT4W offers superior grip, endurance, and comfort across any surface. Upgraded for Aussie Conditions Designed for maximum versatility, the AT4W builds on the proven success of the Wildpeak AT3W, with enhanced off-road durability, longer tread life, and quieter on-road performance. It’s the tyre for drivers who do it all.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-falken-wildpeak-a-t4w-9d3ef395-shop-8ceb36.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2025/10/Wilkpeak-AT4W-469x197-1.png"
  },
  "Tyres::Falken::Wildpeak R/T01": {
    "productUrl": "https://www.falken.com.au/product/wildpeak-rt01/",
    "description": "When the trail gets rough and the road never ends, you need a tyre that does both. The Falken Wildpeak RT01 (Rugged Terrain) blends the aggressive strength of a mud-terrain with the road comfort of an all-terrain, built to handle Australia’s harshest conditions without compromising daily drivability. From red dust tracks to remote worksites, the Wildpeak RT01 is the go-anywhere tyre that lets 4x4 drivers push further with confidence. Rugged by Design. Ready for Anything. Sitting between the Wildpeak M/T and AT4W, the RT01 delivers outstanding traction, resilience, and on-road refinement, making it ideal for heavy-duty utes, lifted 4WDs and dual-purpose off-road setups.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-falken-wildpeak-r-t01-dba22462-shop-94316d.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2025/10/Falken-Wildpeak-RT-469-x-197.png"
  },
  "Tyres::Falken::Wildpeak M/T01": {
    "productUrl": "https://www.falken.com.au/product/wildpeak-mt/",
    "description": "Built for maximum off-road traction in mud, snow and rocks, the Wildpeak M/T uses Falken's three-ply DURASPEC sidewall construction for protection in punishing terrain. Its aggressive upper sidewall adds low-pressure traction, while the variable three-pitch tread pattern keeps its road manners controlled between trails.",
    "availableSizes": [
      "30X9.50R15LT 104Q",
      "31X10.50R15LT 109Q",
      "33X12.50R15LT 108Q",
      "35X12.50R15LT 113Q",
      "LT235/85R16 120Q",
      "LT245/75R16 120Q",
      "LT265/75R16 123Q",
      "LT285/75R16 126Q",
      "LT315/75R16 127Q",
      "LT265/70R17 121Q",
      "LT285/70R17 121Q",
      "LT295/70R17 121Q",
      "LT315/70R17 121Q",
      "LT285/65R18 125Q",
      "LT305/55R20 121Q"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-falken-wildpeak-m-t01-dba22462-shop-5cee07-official-hq.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2017/04/Falken-Tyres-WPMT-500X500-01.png"
  },
  "Tyres::Falken::Wildpeak H/T02": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Falken::Wildpeak H/T HT01": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Falken::Azenis FK520": {
    "productUrl": "https://www.falken.com.au/product/azenis-fk520l/",
    "description": "Falken’s next-generation racetrack technology for the road is here. AZENIS FK520L is the latest generation ultra high-performance tyre, designed for drivers of premium vehicles looking for an outstanding combination of grip, reliability, performance, and efficiency. It offers high-stiffness shoulder blocks for optimum road contact, which helps with braking force and grip when cornering in dry conditions. The FK520L also has you covered in wet conditions with larger water evacuation grooves to reduce hydroplaning and provide stability for your safety.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-falken-azenis-fk520-d5545c93-83f05e-shop-32bb78-cutout.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/Azenis-FK520L-Nano-Black_469x197px.jpg"
  },
  "Tyres::Falken::Azenis FK510": {
    "productUrl": "https://www.falken.com.au/product/azenis-fk510suv/",
    "description": "The AZENIS FK510SUV is Falken’s answer for today’s growing market of performance luxury crossovers and SUVs. Falken’s latest generation ultra high performance tyre, the AZENIS FK510SUV is designed for drivers of premium vehicles looking for excellent grip and outstanding performance. 4D Nano Design enables Falken engineers to optimise new high-performance compounds at the molecular level, enhancing both wear and wet weather traction. Featuring hybrid undertread materials, the FK510SUV delivers confidence-inspiring handling and stability. The FK510SUV allows your performance crossover or SUV to handle the way it was meant to. product description",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-falken-azenis-fk510-0f5ccca7-shop-b551d9.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2018/01/Falken-Tyres-FK520-250X500-MAIN.jpg"
  },
  "Tyres::Falken::Azenis FK510 SUV": {
    "productUrl": "https://www.falken.com.au/product/azenis-fk510suv/",
    "description": "The AZENIS FK510SUV is Falken’s answer for today’s growing market of performance luxury crossovers and SUVs. Falken’s latest generation ultra high performance tyre, the AZENIS FK510SUV is designed for drivers of premium vehicles looking for excellent grip and outstanding performance. 4D Nano Design enables Falken engineers to optimise new high-performance compounds at the molecular level, enhancing both wear and wet weather traction. Featuring hybrid undertread materials, the FK510SUV delivers confidence-inspiring handling and stability. The FK510SUV allows your performance crossover or SUV to handle the way it was meant to. product description",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-falken-azenis-fk510-suv-0f5ccca7-shop-569984.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2018/01/Falken-Tyres-FK520-250X500-MAIN.jpg"
  },
  "Tyres::Falken::Azenis RT615K+": {
    "productUrl": "https://www.falken.com.au/product/azenis-rt615kplus/",
    "description": "Developed for the maximum performance-minded driver, the AZENIS RT615K+ is derived from the original competition-winning RT615K. The PLUS encompasses an all-new digitally-engineered, nanotech-formulated compound for superior grip and excellent handling. Its confidence inspiring straight line and cornering traits allow drivers to push the limits of their vehicle in safe, closed-course environments, while its street-capable durability and DOT approval allow for street-legal daily use as well. With 13 sizes from 14 to 18-inch rim diameters and a 200 A-A UTQG rating, the AZENIS RT615K+ is the ultimate choice for performance compacts, sports coupes, sports sedans and muscle cars.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-falken-azenis-rt615k-663bb02b-shop-4d831c.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2018/01/Falken-Tyres-RT615-250X500-MAIN.jpg"
  },
  "Tyres::Falken::Azenis RT660": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Falken::Ziex ZE310 EcoRun": {
    "productUrl": "https://www.falken.com.au/product/ziex-ze310r-ecorun/",
    "description": "If you’re looking for a tyre that offers excellent traction and grip on wet and dry roads, then the Falken ZIEX ZE310 ECORUN is the perfect choice. Not only does it deliver outstanding performance, but it also comes with enhanced wear resistance, meaning you can enjoy longer-lasting tyres. Plus, with its improved noise reduction, you can enjoy a quieter ride, and if bad weather strikes, don’t worry - the Falken ZIEX ZE310 ECORUN is resistant to aquaplaning, so you’ll stay safe on the road.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-falken-ziex-ze310-ecorun-b4e58833-shop-b382fd.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2023/01/Falken-Tyres-ZIEX-ZE310R-250X500-MAIN-R.jpg"
  },
  "Tyres::Falken::Ziex ZE914 EcoRun": {
    "productUrl": "https://www.falken.com.au/product/ziex-ze914-ecorun/",
    "description": "The ZIEX ZE914 ECORUN is the next generation, high-performance tyre made for Australian roads. Engineered for performance and cost saving fuel efficiency, the low rolling resistance compound offers more mileage and better wet braking. The tyre features an asymmetric tread pattern with four straight and wide circumferential grooves for hydroplane resistance. The high-rigidity rib construction provides good wet and dry braking stability. Slots and sipes can be found throughout the tyre, optimised for even tread wear, comfort and traction. Product Long Description",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-falken-ziex-ze914-ecorun-56edf740-shop-62f6a8.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2015/08/Falken-Tyres-ZE914-250X500-MAIN.jpg"
  },
  "Tyres::Falken::Ziex CT60 A/S": {
    "productUrl": "https://www.falken.com.au/product/ziex-ct60/",
    "description": "The ZIEX CT60 is specifically designed for modern SUVs and CUVs so it provides a combination of long tread life and all-weather safety. Featuring advanced tread compound technology, drivers will experience shorter stopping distances in wet and dry weather, providing a more durable, trustworthy tyre for everyday driving. The crossover-specific tyre construction ensures the tyre footprint is always firmly in contact with the road, providing optimal handling, stability and defence against rough weather conditions and other obstacles. The new ZIEX CT60 is available in many popular SUV and CUV sizes. product description",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-falken-ziex-ct60-a-s-820f8eb2-0fec03-shop-b96d25-cutout.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2020/06/Falken-Tyres-CT60-250X500-MAIN.jpg"
  },
  "Tyres::Falken::Sincera SN110": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Falken::Sincera SN832i": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Falken::Euroall Season AS220 Pro": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Falken::Linam VAN01": {
    "productUrl": "https://www.falken.com.au/product/van01/",
    "description": "Our newest generation of commercial tyres for light trucks and vans. The LINAM VAN01 offers excellent mileage, superb durability and great safety and outstanding performance on wet roads in all applications.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-falken-linam-van01-6a19bec2-shop-bfb263.webp",
    "imageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2018/01/Falken-Tyres-LINAM-VAN01-250X500-MAIN.jpg"
  },
  "Tyres::Falken::Linam R51": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Falken::ZIEX S/TZ05": {
    "productUrl": "https://www.falken.com.au/category/products/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Falken tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.falken.com.au/wp-content/uploads/2024/05/01_falken_cupra_final-cmyk-angesetzt.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::General::Grabber ATX": {
    "productUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-all-new-grabber-a-tx",
    "description": "Kick off spring in a big way as the new GRABBER™ A/T X arrives to your local General Tire dealership today!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-all-new-grabber-a-tx",
    "localImage": "catalog-tyres-general-grabber-atx-eb75a248-ae4163-shop-6751ea-cutout.webp",
    "imageSourceUrl": "https://generaltire.com/sites/default/files/inline-images/2018-03/General_GrabberATX_OWL_Rt3Q_8_72.jpg"
  },
  "Tyres::General::Grabber A/TX": {
    "productUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-all-new-grabber-a-tx",
    "description": "Kick off spring in a big way as the new GRABBER™ A/T X arrives to your local General Tire dealership today!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-all-new-grabber-a-tx",
    "localImage": "catalog-tyres-general-grabber-a-tx-eb75a248-4904c7-shop-947347-cutout.webp",
    "imageSourceUrl": "https://generaltire.com/sites/default/files/inline-images/2018-03/General_GrabberATX_OWL_Rt3Q_8_72.jpg"
  },
  "Tyres::General::Grabber AT3": {
    "productUrl": "https://generaltire.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::General::Grabber APT": {
    "productUrl": "https://generaltire.com/our-world/latest-news/general-tire-introduces-new-grabber-apt",
    "description": "The all-new General Tire GRABBER™ APT is the newest member of the GRABBER family of light truck and SUV tires.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/general-tire-introduces-new-grabber-apt",
    "rejectedImageSourceUrl": "https://generaltire.com/sites/default/files/our_world_articles/images/0I9B5099.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::General::Grabber X3": {
    "productUrl": "https://generaltire.com/our-world/latest-news/celebrities-ride-on-general-grabber-x3s-at-the-mint-400-off-road-race",
    "description": "Celebrities Ride On General Grabber X3’s At The Mint 400 Off Road Race",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "twitter:description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/celebrities-ride-on-general-grabber-x3s-at-the-mint-400-off-road-race",
    "rejectedImageSourceUrl": "https://generaltire.com/sites/default/files/our_world_articles/images/17bitd-mint400-gt-1.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::General::Grabber HTS60": {
    "productUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-grabber-hts60",
    "description": "General Tire’s newest, all-season, highway terrain tire, the GrabberTM HTS60 is available at General Tire dealers across the U.S.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-grabber-hts60",
    "rejectedImageSourceUrl": "https://generaltire.com/sites/default/files/our_world_articles/images/150307_gen-grabber-hts60-a1_9015.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::General::Grabber HTS": {
    "productUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-grabber-hts60",
    "description": "General Tire’s newest, all-season, highway terrain tire, the GrabberTM HTS60 is available at General Tire dealers across the U.S.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/general-tire-launches-grabber-hts60",
    "rejectedImageSourceUrl": "https://generaltire.com/sites/default/files/our_world_articles/images/150307_gen-grabber-hts60-a1_9015.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::General::Grabber UHP": {
    "productUrl": "https://generaltire.com/our-world/latest-news/exploring-montanas-ghost-town-of-garnet-on-grabber-uhps",
    "description": "Exploring Montana’s Ghost Town of Garnet on Grabber UHPs",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "twitter:description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/exploring-montanas-ghost-town-of-garnet-on-grabber-uhps",
    "rejectedImageSourceUrl": "https://generaltire.com/sites/default/files/our_world_articles/images/Garnet_ghost_town_on_Grabber_UHPs_1.JPG",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::General::Grabber GT": {
    "productUrl": "https://generaltire.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::General::Grabber GT Plus": {
    "productUrl": "https://generaltire.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::General::Altimax One": {
    "productUrl": "https://generaltire.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::General::Altimax One S": {
    "productUrl": "https://generaltire.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::General::Altimax RT45": {
    "productUrl": "https://generaltire.com/tires/passenger/altimax-rt45",
    "description": "A long-lasting, all-season touring tire for passenger cars and crossovers. Developed for year-round driving with confident handling in all conditions.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-general-altimax-rt45-1d6d1f5d-shop-77a1b5.webp",
    "imageSourceUrl": "https://generaltire.com/sites/default/files/styles/square_medium/public/tires/images/product_images/2022-06/GT_ALTIMAX_RT45_Lt3Q.png?itok=J1cOzUcG",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/tires/passenger/altimax-rt45"
  },
  "Tyres::General::Altimax 365AW": {
    "productUrl": "https://generaltire.com/tires/passenger/altimax365-aw",
    "description": "A versatile all-weather touring tire for passenger cars and crossovers. Allowing drivers the freedom to drive on one set of tires year-round.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/tires/passenger/altimax365-aw",
    "localImage": "catalog-tyres-general-altimax-365aw-a0902fa8-ac0120-shop-212c01.webp",
    "imageSourceUrl": "https://generaltire.com/sites/default/files/styles/square_medium/public/media/image/2024-06/gt_webpage_altimax_365_aw_l3qt_2000x2000.png?itok=hcTR3Uar"
  },
  "Tyres::General::G-MAX RS": {
    "productUrl": "https://generaltire.com/tires/performance/g-max-rs",
    "description": "An ultra-high performance all-season tire offering all-season traction and providing visual wear alerts, performance in all seasons and longer tread life.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-general-g-max-rs-1dee770c-shop-2056ba.webp",
    "imageSourceUrl": "https://generaltire.com/sites/default/files/styles/square_medium/public/tires/images/product_images/2018-08/GmaxRS_Lt3Q.png?itok=bvreXGW6",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/tires/performance/g-max-rs"
  },
  "Tyres::General::G-MAX AS-05": {
    "productUrl": "https://generaltire.com/our-world/latest-news/general-tire-introduces-g-max-as-05-and-grabber-hd",
    "description": "General Tire is introducing two new products to the product family. The ultra-high performance all-season G-MAX AS-05 and the Grabber HD.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "General tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://generaltire.com/our-world/latest-news/general-tire-introduces-g-max-as-05-and-grabber-hd"
  },
  "Tyres::GT Radial::SportActive 2": {
    "productUrl": "https://gtradial.com.au/tyre-range/sportactive2/",
    "description": "Four wide grooves for improved water drainage and aquaplaning resistance Micro sipes for enhanced grip and traction Innovative tread compound for strong wet and dry performance Optimised pattern block for low noise and driving comfort The SportActive 2 brings great performance upgrades for premium and sports car drivers, including top control and performance attributes. Its braking and handling offer strong advantages over others in its class.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-sportactive-2-89fe8be5-shop-f8c307-official-hq.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/sportactive2-1.webp?fit=800%2C1200&ssl=1"
  },
  "Tyres::GT Radial::SportActive": {
    "productUrl": "https://www.gtradial.com/product/sportactive",
    "description": "Developed for high-powered premium cars, the SportActive combines an innovative profile with wide grooves and sipes for responsive steering, high-speed handling and wet-road control. Its stiffer tread blocks support cornering, while the tread compound is designed to maintain consistent performance through the tyre's service life.",
    "availableSizes": [
      "245/40R17 91Y",
      "255/40R17 98Y",
      "265/35R18 97Y",
      "225/35R19 88Y"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-sportactive-89fe8be5-shop-446591-verified-hq.webp",
    "imageSourceUrl": "https://www.gtradial.com/storage/images/product-sliders/sportactive/ChinaPattern000853/CTR_ChinaPattern000853_1__201789103856.png"
  },
  "Tyres::GT Radial::Champiro SX2": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::Champiro FE2": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::Champiro VP1": {
    "productUrl": "https://gtradial.com.au/tyre-range/champiro-vp1/",
    "description": "Optimised tread block design for wet handling and noise reduction Four wide grooves for water dispersion and hydroplaning resistance Stable shoulder block for better steering and cornering grip Advanced tread compound for strong grip and fuel efficiency As a versatile tyre, the CHAMPIRO VP1 balances control, comfort, security and high mileage in all weather conditions. It is designed especially for drivers of family sedans, wagons and crossovers.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-champiro-vp1-067836f2-shop-56951e-official-hq.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/Champiro-VP1-1.webp?fit=800%2C1200&ssl=1"
  },
  "Tyres::GT Radial::Champiro ECO": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::FE2 SUV": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::Savero SUV": {
    "productUrl": "https://gtradial.com.au/tyre-range/savero-suv/",
    "description": "Four wide grooves for superior wet performance and water drainage Geometrically optimised sipes for wet grip and reduced noise Stiff circumferential ribs for braking and stability Stable shoulder blocks for cornering and traction The SAVERO SUV is a high-performance SUV tyre that combines outstanding driving comfort with balanced performance in wet and dry conditions.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-savero-suv-5b187ef6-shop-b150dd-official-hq.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/Savero-SUV-1.webp?fit=800%2C1200&ssl=1"
  },
  "Tyres::GT Radial::Savero HT2": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::Savero AT Plus": {
    "productUrl": "https://gtradial.com.au/tyre-range/savero-a-t-plus/",
    "description": "Optimised all-terrain tread pattern for traction and reduced noise Extra-wide footprint for even wear and longevity Robust construction with double steel belts for strength and mileage Large shoulder blocks for improved handling and stability For those who enjoy driving 4WDs and SUVs on and off the highway, the all-terrain SAVERO AT PLUS delivers a smooth, secure highway ride along with stability and traction for off-road excursions.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-savero-at-plus-8c5fd8ca-shop-6001b0-official-hq.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/Savero-AT-Plus-1.webp?fit=800%2C1200&ssl=1"
  },
  "Tyres::GT Radial::Savero A/T Pro": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::Savero M/T": {
    "productUrl": "https://gtradial.com.au/tyre-range/savero-at-s/",
    "description": "Superior traction: Features a cross-ditch between the block design, along with reinforced ribs, enhancing the dry, wet, and winter weather road gripping ability. All-season capabilities: The Savero AT-S comes with an all-season tread that makes it ideal to be used throughout the year. Solid handling: The tyre comes with a wide tread pattern with deep solid blocks and lugs that ensure great vehicle handling. Longer tread life: Designed with a special wear rubber formula that reduces the rolling resistance of the tyre and improves wet grip. The SAVERO AT-S is a premium off-road offering, featuring an attractive and aggressive pattern.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-savero-m-t-b16569e1-shop-0eaca7.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2026/01/gt-radial-savero-at-s.webp?fit=750%2C750&ssl=1"
  },
  "Tyres::GT Radial::Adventuro AT3": {
    "productUrl": "https://gtradial.com.au/tyre-range/adventuro-at3/",
    "description": "Enhanced tread compound for better grip and durability Interlocked center rib for stability and traction 3D chamfered-edge grooves for self-cleaning performance Five-pitch pattern technology for reduced road noise The ADVENTURO AT3 is an all-terrain tyre for 4WD and SUV drivers wanting aggressive looks and civilized on-road manners. The enhanced tread compound and dual-purpose tread design provide excellent handling, wet grip and a comfortable ride. Superb off-road capabilities are maintained with features that provide stability and grip on soft and loose surfaces as well as a self-cleaning tread design.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-adventuro-at3-6546d948-shop-ff312e-official-hq.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/Adventuro-AT3-1.webp?fit=800%2C1200&ssl=1"
  },
  "Tyres::GT Radial::Adventuro M/T": {
    "productUrl": "https://gtradial.com.au/tyre-range/adventuro-m-t/",
    "description": "Aggressive pattern design for strong traction High void ratio with pyramidal tread for self-cleaning and aquaplaning resistance Solid shoulder pattern for enhanced traction and cornering Reinforced casing for superior damage resistance For the “mudders” out there, the ADVENTURO M/T mud terrain tyre for 4WDs and SUVs features the most aggressive tread pattern in the GT Radial family; perfect for conquering rough, harsh, or muddy terrains.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-adventuro-m-t-5e281ad1-shop-484c41-official-hq.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/Adventuro-MT-1.webp?fit=800%2C1200&ssl=1"
  },
  "Tyres::GT Radial::Maxmiler Pro": {
    "productUrl": "https://gtradial.com.au/tyre-range/maxmiler-pro/",
    "description": "Square footprint for even wear and increased mileage Large siped shoulder blocks for better stability and braking Wide tread grooves for improved water evacuation and hydroplaning resistance Reinforced sidewall for high load-carrying capacity The Maxmiler Pro is designed for today’s light commercial vehicles. The durable reinforced sidewall is built to carry heavy loads of compact and full-size multi-purpose vans. The tread pattern delivers all-season performance for highway use with the toughness needed for some off-road driving near the job site.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-maxmiler-pro-26a18aa0-shop-aff411-official-hq.webp",
    "imageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/Maxmiler-Pro-1.webp?fit=800%2C1200&ssl=1"
  },
  "Tyres::GT Radial::Maxmiler WT2": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::Maxmiler CX": {
    "productUrl": "https://staging.me.giti.com/storage/images/product-pdf/MAXMILER%20CX.pdf",
    "description": "A commercial van and light-truck tyre designed for mileage, comfort and load capacity. Its reinforced two-steel-belt and nylon construction supports durability, while vertical and slanted grooves provide wet and dry grip and the low-heat tread compound helps extend service life.",
    "availableSizes": [
      "155R12C 88/86R",
      "165R13C 94/92R",
      "175R13C 97/95R",
      "175R14C 99/98R",
      "185R14C 102/100R",
      "195R14C 106/104R",
      "205R14C 109/107R",
      "165/70R14C 89/87R",
      "195R15C 106/104R",
      "205/65R15C 102/100T",
      "195/70R15C 104/102R",
      "225/70R15C 112/110R",
      "195/65R16C 104/102T",
      "205/65R16C 107/105T",
      "215/65R16C 109/107T",
      "225/65R16C 112/110T",
      "175/75R16C 101/99R",
      "185/75R16C 104/102T",
      "195/75R16C 107/105R",
      "225/75R16C 118/116R"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-gt-radial-maxmiler-cx-26a18aa0-shop-2387d9-verified-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/tyre-patterns/18/3adebfa5-e3ee-420b-b936-685b52d86ac6.png"
  },
  "Tyres::GT Radial::Komodo M/T Plus": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::GT Radial::IcePro SUV 3": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/SUV-Tyres.webp?fit=800%2C534&#038;ssl=1);",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::GT Radial::WinterPro 2": {
    "productUrl": "https://gtradial.com.au/tyre-range/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Radial tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://i0.wp.com/gtradial.com.au/wp-content/uploads/2022/08/SUV-Tyres.webp?fit=800%2C534&#038;ssl=1);",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Nexen::N'Fera Sport": {
    "productUrl": "https://www.nexentire.com/kr/product/passenger/nfera-sport-s.php",
    "description": "엔페라 스포츠 S N'FERA Sport S INVESTOR RELATIONS 공시/공고 --> 국내 타이어社 유일! 공식 HN Replacement 마크 획득 타이어 판매점 찾기 타이어 비교하기 월 렌탈료 계산하기 3+1 그루브 최적화 -->마른 노면과 젖은 노면의 성능 밸런스에 최적화된 디자인으로 수막현상 방지 및 마른 노면에서의 그립력을 극대화하였습니다.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.nexentire.com/kr/product/passenger/nfera-sport-s.php"
  },
  "Tyres::Nexen::N'Fera SU1": {
    "productUrl": "https://www.nexentire.com/au/product/passenger/nfera-su1.php",
    "description": "Discover the ultimate tyre solution for your vehicle at NEXEN TYRE. Whether you’re cruising in a Passenger Car, dominating the road in an SUV/4x4, or conquering tasks with a Van/Light Truck, WE GOT YOU. Explore our range today!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-nexen-n-fera-su1-d644f4dc-shop-945541.webp",
    "imageSourceUrl": "https://www.nexentire.com/au/product/passenger/__icsFiles/afieldfile/2020/12/04/nfera_su1_product.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.nexentire.com/au/product/passenger/nfera-su1.php"
  },
  "Tyres::Nexen::N'Fera SU4": {
    "productUrl": "http://www.nexentire.com/cn/product/passenger/nfera-su4.php",
    "description": "中国专用高端 高附加值产品 N’FERA SU4 是一款为满足中国日益增加的大中型高级车市场专门开发的高附加值产品 肋条细小曲线沟槽设计，提升轮胎湿地路面的牵引性能，防止轮胎打滑，有效降低轮胎产生的噪音。 胎肩大花纹块设计，强化轮胎高速转弯时的抓地性能和操控性能 NEXEN TIRE Corporation 上海耐克森轮胎销售有限公司, 上海市闵行区吴中路1439号莱茵虹景中心A栋507室 热线 4008758200 E-mail: nexentire@nexentire.co.kr --> | 条款和条件 | 隐私政策 | 禁止非法收集电子邮件 | SUPPORT | --> 사이트맵 | --> 联系我们 Family Site NEXEN Corp. NEXEN TECH Corp.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "http://www.nexentire.com/cn/product/passenger/nfera-su4.php"
  },
  "Tyres::Nexen::N'Fera AU7": {
    "productUrl": "https://www.nexentire.com/kr/product/passenger/nfera-au7.php",
    "description": "IN SIDE - 향상된 배수성능 최적의 배수 공간 확보와 블록 강성 밸런스 설계를 통해 빗길 주행 시 핸들링 및 주행 성능을 향상시켜줍니다. OUT SIDE - 제동성능 및 코너링 외측 블록 접지면적을 증대하여 마른 노면 제동 성능 및 코너링을 강화시켜줍니다. 눈길 주행성능 강화 Advanced 3D Sipe - 제동 성능 향상 및 불규칙 마모를 방지합니다. Bite Edge - 눈길 견인력을 향상시켜줍니다. 저소음 및 승차감 향상 패턴 소음을 분산시키기 위해 5개의 최적 가변 피치 블록으로 낮은 음압과 부드러운 음색으로 정숙성과 편안한 승차감을 실현시켜 줍니다. Key Performance Indicators 마른노면",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-nexen-n-fera-au7-b1a8179d-38e525-shop-98416c.webp",
    "imageSourceUrl": "https://www.nexentire.com/kr/product/passenger/__icsFiles/afieldfile/2022/11/22/nfera_au7_product.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.nexentire.com/kr/product/passenger/nfera-au7.php"
  },
  "Tyres::Nexen::N'Blue HD Plus": {
    "productUrl": "https://www.nexentire.com/au/product/passenger/nblue-hd-plus.php",
    "description": "Discover the ultimate tyre solution for your vehicle at NEXEN TYRE. Whether you’re cruising in a Passenger Car, dominating the road in an SUV/4x4, or conquering tasks with a Van/Light Truck, WE GOT YOU. Explore our range today!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-nexen-n-blue-hd-plus-a7f7694a-shop-0ac783.webp",
    "imageSourceUrl": "https://www.nexentire.com/au/product/passenger/__icsFiles/afieldfile/2020/12/04/nblue_hd_plus_product.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.nexentire.com/au/product/passenger/nblue-hd-plus.php"
  },
  "Tyres::Nexen::N'Blue 4Season": {
    "productUrl": "https://www.nexentire.com/kr/product/passenger/nblue-4season2.php",
    "description": "엔블루 포시즌2 N'BLUE 4Season2 INVESTOR RELATIONS 공시/공고 --> 빗길과 눈길에 강한 고성능 올웨더 타이어 타이어 판매점 찾기 타이어 비교하기 월 렌탈료 계산하기 사계절 오랜 주행이 가능한 뛰어난 마모 성능",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-nexen-n-blue-4season-457fde3e-00c73a-shop-609f07-official-hq.webp",
    "imageSourceUrl": "https://www.nexentire.com/kr/product/passenger/__icsFiles/afieldfile/2026/04/20/keyvisual_nblue4season2.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.nexentire.com/kr/product/passenger/nblue-4season2.php"
  },
  "Tyres::Nexen::N'Priz AH8": {
    "productUrl": "http://www.nexentire.com/cn/product/passenger/npriz-ah8.php",
    "description": "驾驶自如，畅享舒适静音 N’PRIZ AH8 是为满足中高级车型使用而研发的新一代产品，产品采用网格式和交叉式花纹设计，为车辆行驶提供了优越的稳定性和舒适性，花纹沟槽间采用细化设计有效地降低噪音，也增强了冬季雪地行驶性能。为现代生活 驾驶出行带来全新的感受。 胎面花纹块采用网格设计，增强了轮胎行驶的稳定性和舒适性。 内侧花纹块采用交叉式设计，减少胎面花纹承重压力，提升轮胎静音性能。 中心花纹块采用双半肋条设计，提升轮胎直行行驶稳定性能。 NEXEN TIRE Corporation 上海耐克森轮胎销售有限公司, 上海市闵行区吴中路1439号莱茵虹景中心A栋507室 热线 4008758200 E-mail: nexentire@nexentire.co.kr --> | 条款和条件 | 隐私政策 | 禁止非法收集电子邮件 | SUPPORT | --> 사이트맵 | --> 联系我们",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-nexen-n-priz-ah8-cc6c9211-shop-22f917.webp",
    "imageSourceUrl": "http://www.nexentire.com/cn/product/passenger/__icsFiles/afieldfile/2020/12/04/npriz_ah8_product.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "http://www.nexentire.com/cn/product/passenger/npriz-ah8.php"
  },
  "Tyres::Nexen::N'Priz AH5": {
    "productUrl": "https://www.nexentire.com/kr/product/passenger/npriz-ah5.php",
    "description": "숄더 블록 강성을 확보하면서 블록엣지 형상을 보강한 설계로 코너링 성능 및 조종 안정성을 강화했습니다. 숄더 블록을 리브형으로 설계하여 부드러운 승차감과 정숙성을 실현했습니다. 커프와 횡그루브의 최적 조합 설계로 변형 에너지를 분산하여 제동 성능 강화 및 마모 성능을 향상시켰습니다. ※ 위 이미지는 소비자의 이해를 돕기 위한 것으로 실제와 다소 차이가 있을 수 있습니다. 일부 규격의 경우 제품의 성능을 유지하면서 그루브의 개수나 세부 형상 등에 변경이 있을 수 있습니다. Key Performance Indicators 마른노면",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-nexen-n-priz-ah5-0adc1286-e9e89e-shop-d0cae0.webp",
    "imageSourceUrl": "https://www.nexentire.com/kr/product/passenger/__icsFiles/afieldfile/2020/12/04/npriz_ah5_product.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.nexentire.com/kr/product/passenger/npriz-ah5.php"
  },
  "Tyres::Nexen::Roadian ATX": {
    "productUrl": "https://www.nexentire.com/kr/product/suv/roadian-atx.php",
    "description": "로디안 ATX(ROADIAN ATX) - 온로드와 오프로드 등 모든 도로에 최적화된 전천후 올터레인(All Terrain) SUV 타이어. 험지 주행과 윈터 성능을 강화하였습니다.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-nexen-roadian-atx-db71acb6-31e533-shop-56f3d7.webp",
    "imageSourceUrl": "https://www.nexentire.com/kr/product/suv/__icsFiles/afieldfile/2023/08/22/product_roadian-atx_new.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.nexentire.com/kr/product/suv/roadian-atx.php"
  },
  "Tyres::Nexen::Roadian AT Pro RA8": {
    "productUrl": "http://www.nexentire.com/cn/product/suv/roadian-at-pro-ra8.php",
    "description": "采用细小锯齿沟槽设计，提升雪地和湿滑路面抓地性能，增强行驶的牵引性能。 采用坚固的交错式中央肋条设计，增强了行驶的稳定性和安全性能 [耐克森轮胎] 全路况越野型SUV轮胎 针对中国地区和城市地区的路况特征，研发的一款SUV产品。行驶在险路时，轮胎损伤最小化来提高行驶里程。防止夹石子和提高制动力来强化轮胎耐久性。 Youtube --> NEXEN TIRE Corporation 上海耐克森轮胎销售有限公司, 上海市闵行区吴中路1439号莱茵虹景中心A栋507室 热线 4008758200 E-mail: nexentire@nexentire.co.kr --> | 条款和条件 | 隐私政策 | 禁止非法收集电子邮件 | SUPPORT | --> 사이트맵 | --> 联系我们 Family Site NEXEN Corp. NEXEN TECH Corp.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "http://www.nexentire.com/cn/product/suv/roadian-at-pro-ra8.php"
  },
  "Tyres::Nexen::Roadian MTX": {
    "productUrl": "https://www.nexentire.com/au/product/suv/roadian-mtx.php",
    "description": "Discover the ultimate tyre solution for your vehicle at NEXEN TYRE. Whether you’re cruising in a Passenger Car, dominating the road in an SUV/4x4, or conquering tasks with a Van/Light Truck, WE GOT YOU. Explore our range today!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-nexen-roadian-mtx-8389cfcb-shop-bede4f.webp",
    "imageSourceUrl": "https://www.nexentire.com/au/product/suv/__icsFiles/afieldfile/2020/12/04/roadian_mtx_product.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.nexentire.com/au/product/suv/roadian-mtx.php"
  },
  "Tyres::Nexen::Roadian HTX RH5": {
    "productUrl": "http://www.nexentire.com/cn/product/suv/roadian-htx-rh5.php",
    "description": "采用Z字形细小锯齿沟槽设计，提升轮胎牵引和制动性能 采用3D断面倒角设计，防止夹石块和提升排石子性能 截面采用花纹块优化组合设计，提升了轮胎综合性能，如：磨耗性、低噪音、排水性等 [耐克森轮胎] 城市越野舒适型SUV轮胎 为了满足中国路况特征，特别设计的花纹。无论在铺装路或非铺装路。都可以发挥卓越性能。考虑高速行驶安全性和舒适性开发的新一代产品。 Youtube --> NEXEN TIRE Corporation 上海耐克森轮胎销售有限公司, 上海市闵行区吴中路1439号莱茵虹景中心A栋507室 热线 4008758200 E-mail: nexentire@nexentire.co.kr --> | 条款和条件 | 隐私政策 | 禁止非法收集电子邮件 | SUPPORT | --> 사이트맵 | --> 联系我们",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "http://www.nexentire.com/cn/product/suv/roadian-htx-rh5.php"
  },
  "Tyres::Nexen::Roadian GTX": {
    "productUrl": "http://www.nexentire.com/cn/product/suv/roadian-gtx.php",
    "description": "耐克森轮胎80周年，一路与您随行！了解耐克森全新升级城市高级SUV轮胎Roadian GTX，操控运动型N",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "http://www.nexentire.com/cn/product/suv/roadian-gtx.php"
  },
  "Tyres::Nexen::Roadian HP": {
    "productUrl": "https://www.nexentire.com/au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Nexen::Roadian CT8": {
    "productUrl": "http://www.nexentire.com/cn/product/ltr/roadian-ct8.php",
    "description": "胎肩采用符合材料以及大花纹块设计，增强LTR车辆使用的承载性及转向性能 花纹块采用四角沟槽设计，有助于协调沟槽间的磨耗性能。 NEXEN TIRE Corporation 上海耐克森轮胎销售有限公司, 上海市闵行区吴中路1439号莱茵虹景中心A栋507室 热线 4008758200 E-mail: nexentire@nexentire.co.kr --> | 条款和条件 | 隐私政策 | 禁止非法收集电子邮件 | SUPPORT | --> 사이트맵 | --> 联系我们 Family Site NEXEN Corp. NEXEN TECH Corp.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-nexen-roadian-ct8-4938e243-shop-b808c2.webp",
    "imageSourceUrl": "http://www.nexentire.com/cn/product/ltr/__icsFiles/afieldfile/2020/12/04/roadian_ct8_product_28.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "http://www.nexentire.com/cn/product/ltr/roadian-ct8.php"
  },
  "Tyres::Nexen::Winguard Sport 2": {
    "productUrl": "https://www.nexentire.com/kr/product/passenger/winguard-sport2.php",
    "description": "윈가드 스포츠 2 WINGUARD Sport2 INVESTOR RELATIONS 공시/공고 --> 눈길을 강력하게 제압한다! 더욱 진보된 고성능 겨울용 타이어 타이어 판매점 찾기 타이어 비교하기 월 렌탈료 계산하기 Key Performance Indicators 눈길성능",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-nexen-winguard-sport-2-caccfcb7-057feb-shop-c924aa-official-hq.webp",
    "imageSourceUrl": "https://www.nexentire.com/kr/product/passenger/__icsFiles/afieldfile/2017/10/23/WINGUARDSPORT2.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.nexentire.com/kr/product/passenger/winguard-sport2.php"
  },
  "Tyres::Nexen::Winguard Ice Plus": {
    "productUrl": "https://www.nexentire.com/au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Nexen tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Open Country A/T III": {
    "productUrl": "https://www.toyotires.com.au/tyres/toyo-open-country-at-iii",
    "description": "All-terrain Toyo Open Country pattern focused on wet performance, durability and treadwear life for 4x4, SUV and light truck use.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "All-terrain tyre",
      "4x4, SUV and light truck fitments available by enquiry"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-toyo-open-country-a-t-iii-77f9ef09-shop-762b97-official-hq-cutout.webp",
    "imageSourceUrl": "https://toyotires.s3.ap-southeast-2.amazonaws.com/public/patterns/three-angle/Open-Country-AT-III.jpg"
  },
  "Tyres::Toyo::Open Country A/T II": {
    "productUrl": "https://www.toyotires.com.au/tyres/toyo-open-country-at-ii",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Open Country R/T": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Open Country M/T": {
    "productUrl": "https://www.toyotires.com.au/news/open-country-m-t-tested-on-was-tough-tracks",
    "description": "Brayden’s no-nonsense, hands-on approach to exploring Western Australia brought 4x4 Camping and Adventures to our attention, so after following his exploits over the life of a set of Open Country M/Ts, we reached out to hear his final thoughts.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.toyotires.com.au/news/open-country-m-t-tested-on-was-tough-tracks",
    "rejectedImageSourceUrl": "https://toyotires.s3.ap-southeast-2.amazonaws.com/public/Images/Blog_new/Open-Country-MT-4x4-Camping-Adventures-4.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Toyo::Open Country H/T II": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Open Country U/T": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Open Country Q/T": {
    "productUrl": "https://www.toyotires.com.au/tyres/toyo-open-country-qt",
    "description": "Add a touch of class to your trip with the Open Country Q/T, a quiet-touring tyre that provides premium performance, exceptionally long tread life and a level of comfort that suits even the most luxurious CUVs and small-to-medium SUVs. Building on the strengths of the popular Versado CUV, this long-wearing touring tyre handles the unique demands of compact SUVs with poise and grace, encouraging confidence with strong all-weather grip and optimising fuel economy across an impressively long wear life.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-toyo-open-country-q-t-a1a848d9-shop-f066e7-official-hq-cutout.webp",
    "imageSourceUrl": "https://toyotires.s3-ap-southeast-2.amazonaws.com/public/patterns/three-angle/Open-Country-QT.jpg",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.toyotires.com.au/tyres/toyo-open-country-qt"
  },
  "Tyres::Toyo::Open Country C/T": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Proxes Sport": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Proxes Sport 2": {
    "productUrl": "https://www.toyotires.com.au/tyres/toyo-proxes-sport-2",
    "description": "Toyo's flagship high-performance tyre for modern performance cars and SUVs combines sharp steering response with dependable wet and dry braking. Its asymmetric compounds and tread design are engineered for grip, stability and everyday road refinement.",
    "availableSizes": [
      "225/45R17 94Y",
      "245/40R17 95Y",
      "245/45R17 99Y",
      "215/40R18 89Y",
      "225/40R18 92Y",
      "225/45R18 95Y",
      "235/40R18 95Y",
      "235/45R18 98Y",
      "245/40R18 97Y",
      "255/35R18 94Y",
      "225/40R19 93Y",
      "235/35R19 91Y",
      "235/40R19 96Y",
      "245/35R19 93Y",
      "245/40R19 98Y",
      "255/35R19 96Y",
      "255/40R19 100Y",
      "255/45R19 104Y",
      "275/35R19 100Y",
      "275/40R19 105Y",
      "235/35R20 92Y",
      "245/30R20 90Y",
      "245/35R20 95Y",
      "245/40R20 99Y",
      "255/35R20 97Y",
      "255/40R20 101Y",
      "265/45R20 108Y",
      "275/30R20 97Y",
      "275/35R20 102Y",
      "275/40R20 106Y",
      "255/40R21 102Y",
      "275/45R21 110Y",
      "295/35R21 107Y",
      "295/40R21 111Y",
      "265/35R22 102Y",
      "275/40R22 107Y"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-toyo-proxes-sport-2-c87b129b-a3b158-shop-9a5de3-official-hq.webp",
    "imageSourceUrl": "https://toyotires.s3.ap-southeast-2.amazonaws.com/public/patterns/three-angle/ProxesSport2.png"
  },
  "Tyres::Toyo::Proxes Sport SUV": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Proxes C1S": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Proxes C100 Plus": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Proxes CF2": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Proxes R888R": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Proxes R1R": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::NanoEnergy 3": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::NanoEnergy Van": {
    "productUrl": "https://www.toyotires.com.au/news/NanoEnergy-Van-Review",
    "description": "With a 29% reduction in rolling resistance and a 10% reduction in wet stopping distances when compared to the H08 it replaces, the NanoEnergy Van brings modern performance and comfort to the light-commercial category to keep professional drivers safe and protect their profitability.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.toyotires.com.au/news/NanoEnergy-Van-Review",
    "rejectedImageSourceUrl": "https://toyotires.s3.ap-southeast-2.amazonaws.com/public/articles/content/NanoEnergy_Van_Review1.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Toyo::Observe GSi-6": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Toyo::Tranpath MPZ": {
    "productUrl": "https://www.toyotires.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Toyo tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Radar::Renegade A/T Pro": {
    "productUrl": "https://radartyres.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Radar::Renegade R/T+": {
    "productUrl": "https://radartyres.com.au/tyre/renegade-x/",
    "description": "The Renegade X is made for the wild stuff. Mud, rock, gravel, sand - it chews through the rough so you don’t have to. Designed with GFG Style, it’s all muscle with a stealth edge. Looks tough. Drives tougher. Grip feels strong and steady, even when the track turns ugly. Big tread gaps clear out the gunk, deep side blocks dig in, and the mud-rescue shoulder keeps you moving when things get sticky. Sharp rocks? No drama. Stone ejectors and chunky tread edges help shrug off hits, while the reinforced sidewall takes the brunt so your rig doesn’t have to. And when the dirt ends? Renegade X still holds its line. It stays steady on sealed roads and wears slow, so you get more k’s out of every run.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-radar-renegade-r-t-74ef6c87-shop-b2eb9a.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/07/Renegade-X-1.webp"
  },
  "Tyres::Radar::Renegade R7 M/T": {
    "productUrl": "https://radartyres.com.au/tyre/renegade-r7-mt/",
    "description": "The Renegade R7 takes its lead from Baja - built to handle long, punishing tracks where only the toughest gear survives. That same grit lives in every R7, made for Aussie 4WDs that see more dust than driveway. Tread clears fast. Shoulders grip when the ground turns soft. The casing holds strong when things get sharp and ugly. Designed for lifted 4WDs and hard-driven utes. Solid traction. Reliable wear. No-nonsense style that looks the part. If your weekends start where the road ends, the R7’s ready.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-radar-renegade-r7-m-t-7cedbafe-shop-f0d262.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/Renegade_R7.webp"
  },
  "Tyres::Radar::Renegade R5": {
    "productUrl": "https://radartyres.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Radar::Renegade R/T": {
    "productUrl": "https://radartyres.com.au/tyre/renegade-x/",
    "description": "The Renegade X is made for the wild stuff. Mud, rock, gravel, sand - it chews through the rough so you don’t have to. Designed with GFG Style, it’s all muscle with a stealth edge. Looks tough. Drives tougher. Grip feels strong and steady, even when the track turns ugly. Big tread gaps clear out the gunk, deep side blocks dig in, and the mud-rescue shoulder keeps you moving when things get sticky. Sharp rocks? No drama. Stone ejectors and chunky tread edges help shrug off hits, while the reinforced sidewall takes the brunt so your rig doesn’t have to. And when the dirt ends? Renegade X still holds its line. It stays steady on sealed roads and wears slow, so you get more k’s out of every run.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-radar-renegade-r-t-74ef6c87-shop-b2eb9a.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/07/Renegade-X-1.webp"
  },
  "Tyres::Radar::Dimax R8+": {
    "productUrl": "https://radartyres.com.au/tyre/dimax-r8-plus/",
    "description": "The Dimax R8+ delivers sharp handling and smooth control for ultra-high-performance cars and SUVs. It grips hard in the dry, stays sure in the wet, and keeps road noise low. Corner hard. Cruise easy. It responds when you push it, but stays comfortable when you don’t. Select run-flat sizes let you keep moving after a puncture, so you’re not stuck waiting roadside. Just steady driving until you’re sorted. Sporty, responsive, and ready for the road - the Dimax R8+ brings real performance to every drive.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/Dimax_R8-Plus.webp",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Radar::Dimax R8": {
    "productUrl": "https://radartyres.com.au/tyre/dimax-r8-plus/",
    "description": "The Dimax R8+ delivers sharp handling and smooth control for ultra-high-performance cars and SUVs. It grips hard in the dry, stays sure in the wet, and keeps road noise low. Corner hard. Cruise easy. It responds when you push it, but stays comfortable when you don’t. Select run-flat sizes let you keep moving after a puncture, so you’re not stuck waiting roadside. Just steady driving until you’re sorted. Sporty, responsive, and ready for the road - the Dimax R8+ brings real performance to every drive.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/Dimax_R8-Plus.webp",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Radar::Dimax AS-8": {
    "productUrl": "https://radartyres.com.au/tyre/dimax-r8-plus/",
    "description": "The Dimax R8+ delivers sharp handling and smooth control for ultra-high-performance cars and SUVs. It grips hard in the dry, stays sure in the wet, and keeps road noise low. Corner hard. Cruise easy. It responds when you push it, but stays comfortable when you don’t. Select run-flat sizes let you keep moving after a puncture, so you’re not stuck waiting roadside. Just steady driving until you’re sorted. Sporty, responsive, and ready for the road - the Dimax R8+ brings real performance to every drive.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/Dimax_R8-Plus.webp",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Radar::Dimax Classic": {
    "productUrl": "https://radartyres.com.au/tyre/dimax-classic/",
    "description": "The Dimax Classic brings vintage style to life with a smooth, quiet ride made for Aussie roads. Designed for classic and vintage cars, it blends nostalgic looks with modern comfort and grip. A sporty tread pattern gives sharper handling and shorter stops than the old-school rubber it replaces. The advanced compound stretches tread life, so you can keep cruising in comfort. Available in sleek black or bold white sidewalls to match the lines of your classic. Daily driver or weekend cruiser, it keeps the ride sharp and sorted. Made for open roads, warm days, and timeless style.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-radar-dimax-classic-31fc68bf-shop-3094c0.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/Dimax_Classic.webp"
  },
  "Tyres::Radar::Dimax 4 Season": {
    "productUrl": "https://radartyres.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-radar-dimax-4-season-ccadad03-shop-39d7a6.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2025/03/dalelyons224.webp"
  },
  "Tyres::Radar::Rivera Pro 2": {
    "productUrl": "https://radartyres.com.au/tyre/rivera-pro-2/",
    "description": "The Rivera Pro 2 is designed for compact and mid-size cars that don’t settle for bland. It’s your daily driver’s upgrade, blending modern looks with smooth handling and a ride that feels just right. Designed to go the distance, it pairs solid grip with smart efficiency. The tread compound works harder for longer, delivering more mileage while keeping rolling resistance low. Responsive steering and a quiet, comfortable ride make it ideal for city runs, highway stretches, and everything in between. It’s dependable without being dull, stylish without being over the top. When your tyres do their job so well you barely notice them, that’s Rivera Pro 2 doing its thing.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-radar-rivera-pro-2-ec9c1b8e-shop-5e345c.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/Rivera_Pro_2.webp"
  },
  "Tyres::Radar::Rivera Sport": {
    "productUrl": "https://radartyres.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Radar::RPX800": {
    "productUrl": "https://radartyres.com.au/tyre/rpx800-plus/",
    "description": "Made for SUVs that do more, the RPX 800+ brings sport touring performance to your daily drive. Sharp through corners, smooth on the straight, and locked in when the weather turns - it’s control that feels effortless, from the highway to the city run. With bold tread and clean lines, it adds a refined edge to your SUV without losing everyday practicality. Dry or wet, fast or steady, the ride stays planted, quiet, and composed. Underneath, smart construction keeps things comfortable, while the advanced tread compound delivers solid grip and longer wear. Every detail works harder to give you more out of every drive - no compromises. Safe, stylish, and always road-ready.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-radar-rpx800-6070ba08-shop-821c14.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/RPX_8002.webp"
  },
  "Tyres::Radar::RPX10": {
    "productUrl": "https://radartyres.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Radar::Argonite RV-4": {
    "productUrl": "https://radartyres.com.au/tyre/argonite-rv-4t/",
    "description": "The Argonite RV-4T is made for trailers that carry the load - tool carriers, delivery setups, tippers, and caravans alike. It’s a reliable choice for tradies, fleet drivers, and anyone who needs tyres that stay strong under pressure. Designed specifically for trailers, it stays steady under pressure. Every size is made to roll free, handle the load, and track straight behind your ute or van. With a tough carcass, even shape, and clever tread that channels water away, you get predictable handling in all kinds of Aussie conditions. It shrugs off heavy loads, keeps wear even, and holds its ground when things get wet, rough or unpredictable.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-radar-argonite-rv-4-730e9480-shop-70c5e3-cutout.webp",
    "imageSourceUrl": "https://radartyres.com.au/wp-content/uploads/2023/06/Argonite_RV4.webp"
  },
  "Tyres::Radar::Argonite Alpine": {
    "productUrl": "https://radartyres.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Radar::Angler RST22": {
    "productUrl": "https://radartyres.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Radar tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Hankook::Ventus S1 evo3": {
    "productUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Ventus%20S1%20evo3",
    "description": "This is the search result page of the Ventus S1 evo3. Check out Hankook Tire's various product information and contents. | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Ventus%20S1%20evo3",
    "rejectedImageSourceUrl": "https://www.hankooktire.com/content/dam/hankooktire/local/img/main/pop-size-info.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Ventus S1 evo3 SUV": {
    "productUrl": "https://www.hankooktire.com/au/en/home.html",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/global/video/main/LC_ventus_1920_970_1125.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Ventus S1 evo Z": {
    "productUrl": "https://www.hankooktire.com/au/en/home.html",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "rejectedImageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/global/video/main/LC_ventus_1920_970_1125.jpg",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Ventus Prime 4": {
    "productUrl": "https://www.hankooktire.com/au/en/tire/ventus/prime4.html",
    "description": "Ventus Prime4 K135 - Ventus - Optimum driving control and a comfortable ride | Hankook Tyre Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-tyres-hankook-ventus-prime-4-90ee0b6f-shop-8645c2.webp",
    "imageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/local/img/product-detil-page/test-result/k135/Ventus_Prime_4_avd_ENbrit_2026.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tire/ventus/prime4.html"
  },
  "Tyres::Hankook::Ventus V12 evo2": {
    "productUrl": "https://www.hankooktire.com/au/en/home.html",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Hankook::Ventus RS4": {
    "productUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Ventus%20RS4",
    "description": "This is the search result page of the Ventus RS4. Check out Hankook Tire's various product information and contents. | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Ventus%20RS4",
    "rejectedImageSourceUrl": "https://www.hankooktire.com/content/dam/hankooktire/local/img/main/pop-size-info.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Dynapro AT2": {
    "productUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Dynapro%20AT2%20Xtreme",
    "description": "This is the search result page of the Dynapro AT2 Xtreme. Check out Hankook Tire's various product information and contents. | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Dynapro%20AT2%20Xtreme",
    "rejectedImageSourceUrl": "https://www.hankooktire.com/content/dam/hankooktire/local/img/main/pop-size-info.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Dynapro AT2 Xtreme": {
    "productUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Dynapro%20AT2%20Xtreme",
    "description": "This is the search result page of the Dynapro AT2 Xtreme. Check out Hankook Tire's various product information and contents. | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Dynapro%20AT2%20Xtreme",
    "rejectedImageSourceUrl": "https://www.hankooktire.com/content/dam/hankooktire/local/img/main/pop-size-info.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Dynapro MT2": {
    "productUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Dynapro%20MT2",
    "description": "This is the search result page of the Dynapro MT2. Check out Hankook Tire's various product information and contents. | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/search.html?keyword=Dynapro%20MT2",
    "rejectedImageSourceUrl": "https://www.hankooktire.com/content/dam/hankooktire/local/img/main/pop-size-info.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Dynapro HP2": {
    "productUrl": "https://www.hankooktire.com/au/en/tire/dynapro/hp2-ra33.html",
    "description": "Find your nearest dealer You can find size data on the side of the tyre. Hankook in your country Australia Dynapro HP2 High-performance tyre for luxury SUVs Key features SUV All Season M+S Wet Noise",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-hankook-dynapro-hp2-22940fb0-8f7992-shop-f9aad8.webp",
    "imageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/local/img/product-detil-page/suv/ra33/1_top/d_Product_KV(export).jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tire/dynapro/hp2-ra33.html"
  },
  "Tyres::Hankook::Dynapro HT": {
    "productUrl": "https://www.hankooktire.com/au/en/tirelist/brand-family/dynapro.html",
    "description": "Discover Hankook’s Dynapro tyres, built for SUVs and utes with rugged off-road traction, durability, and control. Shop now and conquer any terrain.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-hankook-dynapro-ht-140ca6e8-shop-ccb579-official-hq.webp",
    "imageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/local/img/tires/tires-kv/search-by-product-family/d_kv_113_2_Dynapro_241106.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tirelist/brand-family/dynapro.html"
  },
  "Tyres::Hankook::Dynapro HPX": {
    "productUrl": "https://www.hankooktire.com/au/en/tire/dynapro/hpx.html",
    "description": "Dynapro HPX - Dynapro - Where safety takes you further, optimum driving control for SUV | Hankook Tyre Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tire/dynapro/hpx.html",
    "rejectedImageSourceUrl": "https://www.hankooktire.com/content/dam/hankooktire/local/img/main/pop-size-info.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::Kinergy Eco2": {
    "productUrl": "https://www.hankooktire.com/au/en/tire/kinergy/eco2-k435.html",
    "description": "Kinergy Eco2 K435 - Kinergy - Total balance for everyday driving | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tire/kinergy/eco2-k435.html"
  },
  "Tyres::Hankook::Kinergy GT": {
    "productUrl": "https://www.hankooktire.com/au/en/tire/kinergy/gt-h436.html",
    "description": "Kinergy GT H436 - Kinergy - Grand touring all-season tire | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-hankook-kinergy-gt-b64437f9-shop-b077db-official-hq.webp",
    "imageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/local/img/product-detil-page/pcr/h436/top/d_Keyvisual(export).jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tire/kinergy/gt-h436.html"
  },
  "Tyres::Hankook::Kinergy 4S2": {
    "productUrl": "https://www.hankooktire.com/au/en/home.html",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Hankook::Optimo K415": {
    "productUrl": "https://www.hankooktire.com/au/en/home.html",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Hankook::Vantra LT": {
    "productUrl": "https://www.hankooktire.com/au/en/tire/vantra/lt-ra18.html",
    "description": "Vantra LT RA18 - Vantra - Improved durability and internal anti-abrasion qualities | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "product-catalog-tyres-hankook-vantra-lt-6af00706-shop-849408-official-hq.webp",
    "imageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/local/img/product-detil-page/suv/ra18/1_top/d_Product_KV(export).jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tire/vantra/lt-ra18.html"
  },
  "Tyres::Hankook::Vantra Trailer": {
    "productUrl": "https://www.hankooktire.com/au/en/home.html",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ]
  },
  "Tyres::Hankook::iON evo": {
    "productUrl": "https://www.hankooktire.com/au/en/search.html?keyword=iON%20evo%20AS%20SUV",
    "description": "This is the search result page of the iON evo AS SUV. Check out Hankook Tire's various product information and contents. | Hankook Tire Australia",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/search.html?keyword=iON%20evo%20AS%20SUV",
    "rejectedImageSourceUrl": "https://www.hankooktire.com/content/dam/hankooktire/local/img/main/pop-size-info.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Tyres::Hankook::iON evo SUV": {
    "productUrl": "https://www.hankooktire.com/au/en/home.html",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-hankook-ion-evo-suv-fc7c77e4-55614d-shop-494e60.webp",
    "imageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/eu/product/tire_list/suv/IH01_hover.jpg"
  },
  "Tyres::Hankook::iON ST AS": {
    "productUrl": "https://www.hankooktire.com/au/en/tire/ion/st-as-suv.html",
    "description": "Find your nearest dealer You can find size data on the side of the tyre. Hankook in your country Australia iON ST AS SUV Maximise your EV's range with iON Key features Battery EV Plug-in Hybrid All Season M+S Noise Mileage Comfort RR",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Hankook tyre model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched into wheel and tyre packages where suitable"
    ],
    "localImage": "catalog-tyres-hankook-ion-st-as-d3b82df0-6fb99a-shop-2412fc.webp",
    "imageSourceUrl": "https://asset.hankooktire.com/content/dam/hankooktire/eu/product/ion/ih61a/kv/d_Keyvisual(export).jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.hankooktire.com/au/en/tire/ion/st-as-suv.html"
  },
  "Wheels::PDXX::Control V8": {
    "productUrl": "https://pdxxoffroad.com/products/control-v8",
    "description": "The PDXX Control V8 forged wheel is a premium wheel developed specifically for the Australian \"V8 SuperUte Series\". With its superior design and construction, this super-light wheel is perfectly suited for racing and off-road adventures. The Control V8 forged wheel is forged using the latest manufacturing techniques to deliver maximum strength and reliability while keeping its weight to a minimum. Crafted from T6061 aircraft-grade aluminum alloy, the Control V8 offers exceptional strength-to-weight ratio and corrosion resistance. This super-light rim is available in custom sizes ranging from 17\" to 20\", allowing drivers to choose the perfect fit for their vehicle. * Contact us for a quote.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "PDXX wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-pdxx-control-v8-dcd7592d-shop-83b3f6.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0599/7923/5487/files/pdxxoffroadcontrolv8_1.png?v=1702083797"
  },
  "Wheels::PDXX::Fury": {
    "productUrl": "https://pdxxoffroad.com/products/copy-of-fury-18-satin-black",
    "description": "The PDXX off road FURY wheel is designed for use, featuring 6 sturdy spokes. It is built to handle heavy loads, this wheel has a load capacity of 1,250 kg and is engineered for durability and toughness. providing exceptional durability and performance. Its satin finish gives it a sleek, stylish look, making it a great addition to any off-road vehicle. With its perfect fitment and heavy load capabilities, the FURY wheel is your best choice for those who demand the most from their wheels.! Please Note: Please give us a call first to confirm the cap fitment, if you are purchasing this design for a Nissan Nissan Patrol GU or Isuzu D-Max Year 2021 and under.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "PDXX wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pdxx-fury-aa2dc4f3-shop-49487e.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0599/7923/5487/files/FURY-1790-SatinBlack-PDXX-WheelsAPE-Brands-Group_3_1_4e467d69-add8-43b5-8670-8e38a678eaa3.jpg?v=1702082783"
  },
  "Wheels::PDXX::Rock": {
    "productUrl": "https://pdxxoffroad.com/products/rock-17-silver-w-machined-ring",
    "description": "Rock Beadlock Wheels - Tough Looks, Real Performance Upgrade your 4x4 with wheels built for strength and style. The Rock beadlock wheels are made from durable, lightweight materials and engineered with a high load rating of 1,250kg, giving you confidence on and off the road. The silver w/ machined ring finish is easy to clean and highly resistant to weathering, while the anodised aluminium bolts deliver a bold beadlock appearance without the maintenance of a true beadlock. Designed to combine stiffness with reduced weight, the Rock is a versatile choice for drivers who want wheels that perform as good as they look - equally at home on city streets or rugged tracks.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "PDXX wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-pdxx-rock-7b48ec91-shop-fc2f7c.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0599/7923/5487/files/PDXX_ROCK_17INCH_SILVER_1.png?v=1764840580"
  },
  "Wheels::PDXX::Enforcer": {
    "productUrl": "https://pdxxoffroad.com/products/wheel-enforcer-17-matte-bronze-w-black-ring",
    "description": "The Enforcer of our PDXX Offroad range. A stunning beadlock wheel with a mesh style design and anodised aluminium bolts will be sure to turn heads on any 4x4. A one-piece cast wheel with maximum stiffness and weight reduction. The wheel is load-rated at 1250kg and suits most popular 4x4 and SUV vehicles including the Ranger, Hilux, D-Max, BT-50, Triton, Navara, and Prado. The wheel is available in satin black and satin gunmetal, both have anti-weathering durability. Model Size P.C.D ET CB Finish ENFORCER 17X9.0J 6X139.7 P15 110 SATIN BRONZE W/ BLACK RING",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "PDXX wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pdxx-enforcer-81d1845c-shop-3374ba.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0599/7923/5487/products/ENFORCER-17inch-MatteBronzeWithBlackRng-PDXX-WheelsAPE-Brands-Group_4_c438f6bd-b76f-47a8-b30e-2e34b6bfc7db.jpg?v=1672035430"
  },
  "Wheels::PDXX::Viking": {
    "productUrl": "https://pdxxoffroad.com/products/wheel-viking-17-matte-bronze-w-black-ring",
    "description": "Add a touch of distinction to your vehicle without compromising on performance. These stylish and lightweight beadlock wheels are crafted from lightweight, durable materials, offering a 1,250 kg load capacity. Engineered to enhance the performance of most 4x4 vehicles. The Viking is a one-piece cast wheel, ensuring maximum stiffness and weight reduction. The anodised aluminium bolts provide a bold beadlock look while the satin black finish is easy clean and has anti- weathering durability. The Viking is a versatile wheel that is equally at home on the road or the trail. Model Size P.C.D ET CB Finish VIKING 17X9.0J 6X139.7 P0 110 SATIN BRONZE W/ BLACK RING",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "PDXX wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pdxx-viking-06fbcf14-shop-72397c.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0599/7923/5487/products/VIKING-17inch-MatteBronzeWithBlackRing-PDXX-WheelsAPE-Brands-Group_13.jpg?v=1672035626"
  },
  "Wheels::PDXX::Kito Beadlock": {
    "productUrl": "https://pdxxoffroad.com/collections/all",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "PDXX wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Dirty Life::9316 Journey Street Series": {
    "productUrl": "https://www.dirtylifewheels.com/9316-matte-black",
    "description": "Street Series Journey 9316 wheel from Dirty Life, shown in the supplier catalogue in matte black and bronze finishes.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Street Series wheel",
      "Available finishes vary by fitment"
    ],
    "images": [
      "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1677108190938-KMZDJ60L4QQP2YVLFJOT/DIRTYLIFE9316SB1.png?format=1500w"
    ],
    "localImage": "product-catalog-wheels-dirty-life-9316-journey-street-series-f0c11c06-shop-d93d57.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1677108190938-KMZDJ60L4QQP2YVLFJOT/DIRTYLIFE9316SB1.png"
  },
  "Wheels::Dirty Life::9315 Compound Street Series": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9315-compound-street-series-39c6c112-shop-61483a.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1649172418582-8PQCXROM9ZWSN7IKQU44/DIRTYLIFE_9315-5_1709_matteblk_0001.png"
  },
  "Wheels::Dirty Life::9317 DT-3": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9317-dt-3-a4d6d1d1-shop-1ea5cb.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1769716969053-2C03ZYK8FD49M5LZ6EPY/DLRW9317-+5MB1.png"
  },
  "Wheels::Dirty Life::9303 DT-1": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9303-dt-1-63d1f342-shop-b0a71c.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1519257614264-MWAJ5KHYO8MVNLBSC9F5/DIRTYLIFE9303MB1_MAIN.png"
  },
  "Wheels::Dirty Life::9310 Canyon": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9310-canyon-dc96c11a-shop-1462f0.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1653349549926-HVYRI93UJNZQ8W593KE3/DIRTYLIFE_9310S_matteblk_0001.png"
  },
  "Wheels::Dirty Life::9309 Canyon Pro": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9309-canyon-pro-8c21ab21-shop-9a0035.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1613170910481-UI7JUYEXHSJXH7GPGEMY/DIRTYLIFE9309MB1.png"
  },
  "Wheels::Dirty Life::9305 Theory": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Dirty Life::9306 Mesa": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9306-mesa-c548e5d9-shop-fb27e2-cutout-clean.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1579648096222-V2Q1LY571MF9C5PU77Y1/DIRTYLIFE9306MB1.jpg"
  },
  "Wheels::Dirty Life::9307 Roadkill": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Dirty Life::9301 Roadkill": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Dirty Life::9302 Hammer": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9302-hammer-d67ae659-shop-ccc076.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1559598919295-RZGWK8LIJWDC6U0PVUZN/DIRTYLIFE9302MB1.png"
  },
  "Wheels::Dirty Life::9311 Enigma": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9311-enigma-cf51bb74-shop-eb8524.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1613171589593-20T7MFUJJPM698AXXA9D/DIRTYLIFE9311MB1.png"
  },
  "Wheels::Dirty Life::9312 Race": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9312-race-a3e87faa-shop-bc77c2-cutout.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1625696815903-WEI0QSHM24RK2OIHE385/DIRTYLIFE9312M1.jpg"
  },
  "Wheels::Dirty Life::9313 Mesa Race": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9313-mesa-race-4ea7ef99-shop-af6137.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1645056314895-PA2I1ZDTJTV6B30WKQ75/DIRTYLIFE_9313-5_1709_crimswblk_0001.png"
  },
  "Wheels::Dirty Life::9314 DT-2": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9314-dt-2-5d4ce638-shop-6591de.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1649172552180-789F71HNTDXYWP9O7KQZ/DIRTYLIFE_9314_matteblk_0001.png"
  },
  "Wheels::Dirty Life::9400 Roadkill Forged Beadlock": {
    "productUrl": "https://www.dirtylifewheels.com/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Dirty Life wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-dirty-life-9400-roadkill-forged-beadlock-41f962a4-shop-228c8d.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1712851163499-IT4J60OA235UDAMNK979/9400FB1.png"
  },
  "Wheels::R Series::R10": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R20": {
    "productUrl": "https://rserieswheels.com/products/hammer-20-hyper-black",
    "description": "VE/VF Fitment: Square: 20x8.0 p40 PRE-VE Fitment: Square: 20x8.0 p40 Brake Clearance Normal/ Red/ Silver/ Yellow SIZE HOLES PCD OFFSET CENTER BORE 20X8.0J 5 120 P40 69.6 Wheel Nuts: Designed to accommodate Original Equipment (OE) nuts (wheel nuts not included). TPMS Compatibility: Compatible with OE TPMS sensors where fitted. Rseries Wheel Cap: Included free. Caps are interchangeable with the OE wheel cap.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-r-series-r20-7dbb2217-shop-afc709.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0654/0938/4536/files/RSERIES_HAMMER_HYPER_BLACK_19_20_HOLDEN_WHEELS_1.png?v=1764510076"
  },
  "Wheels::R Series::R30": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R40": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R50": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R60": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R70": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R80": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R90": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R100": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R150": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R200": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R300": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R400": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R500": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R600": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R700": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::R Series::R800": {
    "productUrl": "https://rserieswheels.com/collections",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "R Series wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::AXR Alonso 5": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/axr-alonso-5",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::AXR Predator 5": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/axr-predator-5",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::AXR Predator 6": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/axr-predator-6",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::AXR Stomper": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/axr-stomper",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::M8501": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/m8501",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::Magnum": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/magnum",
    "description": "Magnum features a 6 spoke design with machined lip and rivets for a distinctive and attractive look.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-advanti-racing-magnum-3b0adc59-shop-6feaec.webp",
    "imageSourceUrl": "https://static.wixstatic.com/media/51b1ba_06218edb868445309ca6247fac6284f7~mv2.png/v1/fit/w_500,h_500,q_90/file.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.advantiracingwheels.com/product-page/magnum"
  },
  "Wheels::Advanti Racing::MR82": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/mr82",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::TT11 Titan": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/tt11-titan",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::Verona": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/verona",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::DST": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/dst",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::Vigoroso V1": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/vigoroso-v1",
    "description": "The Vigoroso V1 is a classic mesh styled wheel that has been developed by utilizing Advanti Racing’s DST, Flow Forming Technology process. With a wide range of sizing, fitments and 2 different spoke profiles. The Vigoroso V1 is an ideal wheel option for so many passenger vehicle especially those looking to stagger fit.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-advanti-racing-vigoroso-v1-f86bcbca-shop-f1dc33.webp",
    "imageSourceUrl": "https://static.wixstatic.com/media/51b1ba_dee101bba7214eaf811d723bd082ca47~mv2.png/v1/fit/w_500,h_500,q_90/file.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.advantiracingwheels.com/product-page/vigoroso-v1"
  },
  "Wheels::Advanti Racing::Vigoroso V2": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/vigoroso-v2",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::Hybris": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/hybris",
    "description": "The Hybris is a Face-Forward split 5-spoke design that offers extraordinary brake caliper clearance and stance for many popular passenger vehicles. The Hydra is developed using Advanti Racing’s DST, Flow Forming technology to offer the user a state of the art product. Also offered in the Advanti Racing series in smaller sizes.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-advanti-racing-hybris-6f0d369e-shop-45070a.webp",
    "imageSourceUrl": "https://static.wixstatic.com/media/51b1ba_2aa351fbd53a4065895bca242cbc6c21~mv2.png/v1/fit/w_500,h_500,q_90/file.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.advantiracingwheels.com/product-page/hybris"
  },
  "Wheels::Advanti Racing::Racing Storm S1": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/storm-s1",
    "description": "The Advanti Racing Storm S1 is developed utilizing Flow Forming Technology. This wheel is incredibly lightweight while offering all the reliability that should be expected. The Storm S1 is a 10-spoke tuning inspired wheel that has become one of Advanti Racing’s most popular designs.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-advanti-racing-racing-storm-s1-322e2734-shop-034fd0.webp",
    "imageSourceUrl": "https://static.wixstatic.com/media/51b1ba_5b065949c9c041da8f39eb81baa80afc~mv2.png/v1/fit/w_500,h_500,q_90/file.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.advantiracingwheels.com/product-page/storm-s1"
  },
  "Wheels::Advanti Racing::Racing Storm S2": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/storm-s2",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::Racing Storm S3": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/storm-s3",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::Advanti Storm": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/advanti-storm",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Advanti Racing::Advanti Denaro": {
    "productUrl": "https://www.advantiracingwheels.com/product-page/advanti-denaro",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Advanti Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::American Racing::500 Mono Cast": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-500-mono-cast",
    "description": "VN50157012700 - American Racing VN501 500 MONO CAST - SATIN BLACK - 15\" Diameter - 15X7 00MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-500-mono-cast"
  },
  "Wheels::American Racing::AR23": {
    "productUrl": "https://www.americanracing.com/american-racing-ar23",
    "description": "The AR23 has been a trusted choice for light trucks and SUVs for decades, carrying forward the rugged, functional style American Racing is known for. Its one-piece cast aluminum construction and bold 8-hole design give it a clean, purposeful look that’s easy to recognize. Originally popularized in the off-road and truck scene of the ’80s and ’90s, the AR23 still delivers the same balance of strength and simplicity that made it a staple.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-ar23-4363e97a-shop-1d296c.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar23ar0233standardg0maiiapf1z3ivfvza9.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-ar23"
  },
  "Wheels::American Racing::AR904": {
    "productUrl": "https://www.americanracing.com/american-racing-ar904",
    "description": "AR90467012440 - American Racing AR904 - SILVER MACHINED - 16\" Diameter - 16X7 40MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-ar904-bc236efe-shop-4a6682.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar9047-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-ar904"
  },
  "Wheels::American Racing::AR907": {
    "productUrl": "https://www.americanracing.com/american-racing-ar907",
    "description": "The AR907 brings a modern multi-spoke design to the American Racing lineup, pairing lightweight construction with a sharp, contemporary look. Built from one-piece cast aluminum, it’s offered in a sleek finish that complements both daily drivers and enthusiast builds. Available in 16\", 17\", and 18\" diameters and engineered for a variety of 5-lug bolt patterns, the AR907 delivers a refined balance of style and everyday performance. The AR907 wheel looks great on a wide range of modern cars.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-ar907-14ce94d0-shop-6bdd0d.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar9073-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-ar907"
  },
  "Wheels::American Racing::Baja": {
    "productUrl": "https://www.americanracing.com/american-racing-baja-dually",
    "description": "Born from one of American Racing’s most iconic truck wheels, the Baja Dually brings the classic circular-hole design of the original Baja to heavy-duty dually applications. First popularized in the 1970s off-road scene and a familiar sight on trucks and SUVs for decades, the Baja style has become a staple in truck culture. Built from one-piece cast aluminum and engineered with load ratings up to 3,200 lbs, the Baja Dually carries that same rugged spirit into the dual rear-wheel segment.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-baja-dually",
    "localImage": "catalog-wheels-american-racing-baja-5d656380-shop-0981e0.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar2041-rear-a1l-png.png"
  },
  "Wheels::American Racing::Baja Dually": {
    "productUrl": "https://www.americanracing.com/american-racing-baja-dually",
    "description": "Born from one of American Racing’s most iconic truck wheels, the Baja Dually brings the classic circular-hole design of the original Baja to heavy-duty dually applications. First popularized in the 1970s off-road scene and a familiar sight on trucks and SUVs for decades, the Baja style has become a staple in truck culture. Built from one-piece cast aluminum and engineered with load ratings up to 3,200 lbs, the Baja Dually carries that same rugged spirit into the dual rear-wheel segment.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-baja-dually",
    "localImage": "catalog-wheels-american-racing-baja-dually-5d656380-shop-84546b.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar2041-rear-a1l-png.png"
  },
  "Wheels::American Racing::Barrage": {
    "productUrl": "https://www.americanracing.com/american-racing-barrage",
    "description": "AR92799012735 - American Racing AR927 BARRAGE - SATIN BLACK - 19\" Diameter - 19X9 35MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-barrage-dc693103-shop-bc18c0.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar9277-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-barrage"
  },
  "Wheels::American Racing::Bishop": {
    "productUrl": "https://www.americanracing.com/american-racing-ar942-bishop-2020-dodge-challenger-scatpack-19",
    "description": "2020 Dodge Challenger Scatpack - American Racing AR942 BISHOP - Gray",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-bishop-1895ff30-shop-be09b4.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/american%20racing-ar942-bishop-matte%20gunmetal%20with%20machined%20lip-20x11-20x12-2020%20dodge%20-0a4bMCDWmd",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-ar942-bishop-2020-dodge-challenger-scatpack-19"
  },
  "Wheels::American Racing::Boss TT": {
    "productUrl": "https://www.wheelprosaustralia.com.au/product/wheels/vn338-boss-tt/",
    "description": "",
    "availableSizes": [
      "18x8",
      "18x9.5",
      "20x8.5",
      "20x10"
    ],
    "notes": [],
    "localImage": "product-official-american-racing-boss-tt-1-shop-417cae.webp",
    "imageSourceUrl": "https://drwrp0peova35.cloudfront.net/wp-content/uploads/2020/12/hVN3389-1024x962.png",
    "descriptionSource": "official-page-no-description",
    "descriptionSourceUrl": "https://www.wheelprosaustralia.com.au/product/wheels/vn338-boss-tt/",
    "specifications": {
      "Material": "Cast aluminium",
      "Diameters": "18\", 20\"",
      "Finishes": "Graphite with diamond cut lip, Textured black with diamond cut lip"
    },
    "galleryImages": [
      "product-official-american-racing-boss-tt-2-shop-604169.webp"
    ]
  },
  "Wheels::American Racing::Burnout": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-burnout",
    "description": "VN472710XX - American Racing VN472 BURNOUT - Two-Piece Black Milled Center Polished Rim - 17\" Diameter - 17X10 XXMM offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-burnout-4e6654f6-shop-35719a.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/e/3/e365b2e8b1e1751cf7de28dd01b8b4ddcadcd43c365365ff10997e43c547c52e.jpeg",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-burnout"
  },
  "Wheels::American Racing::Classic Torq Thrust II": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-classic-torq-thrust-ii",
    "description": "VN2158961 - American Racing VN215 CLASSIC TORQ THRUST II - MAG GRAY W/ MACHINED LIP - 18\" Diameter - 18X9 0MM offset - 5X120.65 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-classic-torq-thrust-ii"
  },
  "Wheels::American Racing::Classic Torq Thrust II Custom": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-classic-torq-thrust-ii-custom",
    "description": "VNCL205460XX - American Racing VN205 CLASSIC TORQ THRUST II CUSTOM - TORQ THRUST GRAY POLISHED LIP - 14\" Diameter - 14X6 XXMM offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-classic-torq-thrust-ii-custom"
  },
  "Wheels::American Racing::Crossfire": {
    "productUrl": "https://www.americanracing.com/american-racing-crossfire",
    "description": "AR92498534750 - American Racing AR924 CROSSFIRE - SATIN BLACK - 19\" Diameter - 19X8.5 50MM offset - 5X120.65 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-crossfire-fd265594-shop-001d48.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar9247-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-crossfire"
  },
  "Wheels::American Racing::Draft": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-draft",
    "description": "Designed for the pro-touring crowd, the VN510 Draft blends modern performance with classic American Racing attitude. Its spoke layout is clean and aggressive, taking cues from the 2-piece forged VF510, but built using flow formed construction to reduce weight without sacrificing strength. The result is a wheel that delivers forged-like performance with cast-level cost efficiency.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-draft-d108b1dc-shop-ab2173.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/v/n/vn5103-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-draft"
  },
  "Wheels::American Racing::G-Force": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-g-force",
    "description": "VN516AD18103412 - American Racing VN516 G-FORCE - MATTE ANTHRACITE W/ DC-LIP - 18\" Diameter - 18X10 12MM offset - 5X120.65 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-g-force-3153a8ea-shop-afd587.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/m/american-racing-vn516px-g-force-20x8-5-5-et6-chrome-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-g-force"
  },
  "Wheels::American Racing::Gasser": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-gasser",
    "description": "VN474710XX - American Racing VN474 GASSER - POLISHED - 17\" Diameter - 17X10 XXMM offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-gasser-4838b634-shop-5c4fe3.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/d/3/d37fb169308569b7a9649a097edbad1baae0b52a08d4e0e5b78031540449934e.jpeg",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-gasser"
  },
  "Wheels::American Racing::Groove": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-groove",
    "description": "VN514AD18105000 - American Racing VN514 GROOVE - ANTHRACITE W/ DIAMOND CUT LIP - 18\" Diameter - 18X10 0MM offset - 5X127 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-groove-8da28875-shop-b5f32d.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/h/v/hvn514px.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-groove"
  },
  "Wheels::American Racing::GT Street": {
    "productUrl": "https://www.americanracing.com/american-racing-gt-street-2024-ford-mustang-gt-140",
    "description": "2024 Ford Mustang GT - American Racing GT STREET - Gun Metal",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-gt-street-3f8b215d-shop-085600.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/american%20racing-ar952-gt%20street-gunmetal-20x10-20x11-2024%20ford%20mustang%203",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-gt-street-2024-ford-mustang-gt-140"
  },
  "Wheels::American Racing::Hopster": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-hopster",
    "description": "VNC450510XX - American Racing VN450 HOPSTER - CHROME - 15\" Diameter - 15X10 XXMM offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-hopster-f58b8cef-shop-959495.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/v/n/vn5501-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-hopster"
  },
  "Wheels::American Racing::Mach Five": {
    "productUrl": "https://www.americanracing.com/ar941-mach-five-old",
    "description": "Designed for the industry’s best, by the industry’s best. Our American Racing has earned the trust of some of the most discerning critics in the automotive industry.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.americanracing.com/ar941-mach-five-old",
    "localImage": "product-catalog-wheels-american-racing-mach-five-927b2623-shop-6414fe.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/.renditions/wysiwyg/americanracing/cms/2023/ar941machfive/ar-image-1-min.jpg"
  },
  "Wheels::American Racing::Mainline": {
    "productUrl": "https://www.americanracing.com/american-racing-mainline",
    "description": "AR89328550335 - American Racing AR893 MAINLINE - GLOSS BLACK MACHINED - 20\" Diameter - 20X8.5 35MM offset - 5X127 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-mainline-ccdb6f3f-shop-fed666.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar8932-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-mainline"
  },
  "Wheels::American Racing::Marauder": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-marauder",
    "description": "VN517BD20858506 - American Racing VN517 MARAUDER - GLOSS BLACK MCH W/ DIA-CUT LIP - 20\" Diameter - 20X8.5 6MM offset - 5X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-marauder-1b964b82-shop-69ee1f.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/m/american-racing-vn517px-maurauder-20x10-5-et6-chrome-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-marauder"
  },
  "Wheels::American Racing::Nova": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-nova",
    "description": "Launched as part of American Racing’s Vintage series, the Nova (VN701) draws inspiration from midcentury OEM alloys and period steel wheels like Magnum 500, the types gracing trucks and pony cars of the late ’60s and early ’70s. Available in 20″ and 22″ diameters and 5×5 bolt pattern, the Nova blends retro cues like a clean fivespoke face and pronounced lip with a modern cast aluminum build. It’s ideal for Chevrolet and GMC OBS pickups and the 95-96 Impala SS where classic fitment meets modern ride height.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-american-racing-nova-f0ce54c8-shop-ba5eb8.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/v/n/vn7013-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-nova"
  },
  "Wheels::American Racing::Outlaw I": {
    "productUrl": "https://www.americanracing.com/american-racing-outlaw-i",
    "description": "The American Racing Outlaw I is a one-piece cast aluminium truck wheel with a classic eight-hole design. American Racing lists 14 and 15 inch diameters across 5-lug and 6-lug applications.",
    "availableSizes": [
      "14 and 15 inch diameters"
    ],
    "notes": [
      "One-piece cast aluminium construction",
      "Machined finish with clear coat",
      "Vehicle-specific fitment must be confirmed"
    ],
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-outlaw-i",
    "localImage": "wheel-american-racing-outlaw-i-official-shop-411e07.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar0613-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::American Racing::Outlaw II": {
    "productUrl": "https://www.americanracing.com/american-racing-outlaw-ii",
    "description": "The Outlaw II is one of the most iconic truck wheels American Racing has ever built. First introduced in the late ’70s, its lightweight one-piece cast aluminum construction and 12-hole layout with rivet-style accents captured the look of true off-road racing beadlocks. That desert-racer style, paired with real-world durability, made the Outlaw II a favorite for Chevy C/K trucks, Broncos, Jeeps, and countless pickups and SUVs through the ’80s and ’90s. Today, it’s still going strong.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-outlaw-ii",
    "localImage": "catalog-wheels-american-racing-outlaw-ii-7ce489fe-shop-608814.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar62ar0623standardg0malut5s7amup4bttx.png"
  },
  "Wheels::American Racing::Satin Black AR172": {
    "productUrl": "https://www.americanracing.com/wheels/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-american-racing-satin-black-ar172-c18bf10c-shop-a56d68-hq.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/a/r/ar1721-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::American Racing::Torq Thrust D": {
    "productUrl": "https://www.americanracing.com/american-racing-vintage-torq-thrust-d",
    "description": "Born in 1965 to keep pace with the rise of disc brakes, the Torq Thrust D is a subtle evolution of American Racing’s most iconic wheel. Designed with curved spokes for added caliper clearance, it was a natural fit for the Corvette and other muscle cars of the era. The bold five-spoke layout, stepped lip, and bolt-in cap are all present and accounted for, true to form and faithful to the original magnesium-style look.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.americanracing.com/american-racing-vintage-torq-thrust-d",
    "rejectedImageSourceUrl": "https://www.americanracing.com/media/catalog/product/v/n/vn215-22x11-et18-mag-grey-w-machined-lip-a1-png.png?quality=80&fit=bounds&height=350&width=350",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::American Racing::VN105 Torq Thrust D": {
    "productUrl": "https://www.americanracing.com/wheels/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.americanracing.com/media/catalog/product/v/n/vn215-22x11-et18-mag-grey-w-machined-lip-a1-png.png?quality=80&fit=bounds&height=360&width=360",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::American Racing::VN309 Torq Thrust Original": {
    "productUrl": "https://www.americanracing.com/wheels/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.americanracing.com/media/catalog/product/v/n/vn215-22x11-et18-mag-grey-w-machined-lip-a1-png.png?quality=80&fit=bounds&height=360&width=360",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::American Racing::VN427 Shelby Cobra": {
    "productUrl": "https://www.americanracing.com/wheels/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "American Racing wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-american-racing-vn427-shelby-cobra-b5e6c38b-shop-e96207.webp",
    "imageSourceUrl": "https://www.americanracing.com/media/catalog/product/v/n/vn5015-png.png?quality=80&fit=bounds&height=&width="
  },
  "Wheels::Asanti Wheels::Corona": {
    "productUrl": "https://www.wheelpros.com/asanti-black-corona-truck",
    "description": "ABL30-20055638BK - Asanti ABL30 CORONA - GLOSS BLACK - 20\" Diameter - 20X10.5 38MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-corona-3025e2a8-shop-02b17e.webp",
    "imageSourceUrl": "https://www.wheelpros.com/media/catalog/product/a/b/ab30ab0303standardg0bej8kw14q64bviicb.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.wheelpros.com/asanti-black-corona-truck"
  },
  "Wheels::Asanti Wheels::Viceroy": {
    "productUrl": "https://www.wheelpros.com/asanti-black-viceroy",
    "description": "The ABL48 Viceroy features a concave profile and a scalpel-precision multi-spoke design, providing luxury enthusiasts with a modern style solution for their big-body luxury sedans or SUV haulers. This cast monoblock wheel is available in diameters ranging from 20\" to 26\" and offsets to accommodate a variety of fitment styles. Choose from our standard center cap or opt for our floater cap and dial in the fine details. Level up your ride's luxury with the ABL48.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-viceroy-e5dd853f-shop-771dbe.webp",
    "imageSourceUrl": "https://www.wheelpros.com/media/catalog/product/a/s/asanti-abl48-viceroy-22x10-5-5-et38-gloss-black-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.wheelpros.com/asanti-black-viceroy"
  },
  "Wheels::Asanti Wheels::Ablaze": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::Axiom": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::Black Label ABL-1": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/s/asanti-abl48-viceroy-22x10-5-5-et38-gloss-black-w-machined-face-a1-png.png?quality=80&fit=bounds&height=360&width=360",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::Black Label ABL-2": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/s/asanti-abl48-viceroy-22x10-5-5-et38-gloss-black-w-machined-face-a1-png.png?quality=80&fit=bounds&height=360&width=360",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::Black Label ABL-5": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/s/asanti-abl48-viceroy-22x10-5-5-et38-gloss-black-w-machined-face-a1-png.png?quality=80&fit=bounds&height=360&width=360",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::Black Label ABL-12": {
    "productUrl": "https://www.discounttire.com/buy-wheels/asanti-abl-12/p/61663",
    "description": "The Asanti Black Label ABL-12 Orion is a split five-spoke cast wheel offered in gloss black, matte graphite and brushed silver finishes.",
    "availableSizes": [
      "19 to 22 inch diameters"
    ],
    "notes": [
      "Retired Asanti Black Label design",
      "Published fitments vary by diameter, width and vehicle",
      "Confirm current availability with 110 Garage"
    ],
    "localImage": "catalog-wheels-asanti-abl-12-verified.webp",
    "imageSourceUrl": "https://www.customwheelsexpress.com/images/thumbs/500_500/Asanti-ABL12-Black-1.jpg",
    "specifications": {
      "Construction": "One-piece cast aluminium",
      "Diameters": "19, 20, 21 and 22 inch",
      "Finishes": "Gloss black, matte graphite, brushed silver"
    },
    "descriptionSource": "manufacturer-retailer-archive",
    "descriptionSourceUrl": "https://www.discounttire.com/buy-wheels/asanti-abl-12/p/61663"
  },
  "Wheels::Asanti Wheels::Black Label ABL-14": {
    "productUrl": "https://www.customwheelsexpress.com/custom-wheels-by-brand-asanti-asanti-black-label-asanti-black-label-abl-14-black-custom-wheels-rims-p-3546.html",
    "description": "The Asanti Black Label ABL-14 Polaris is a multi-spoke cast wheel for luxury passenger and SUV applications, shown here in gloss black.",
    "availableSizes": [
      "19 to 22 inch diameters"
    ],
    "notes": [
      "Retired Asanti Black Label design",
      "Published widths include 8.5, 9, 9.5 and 10.5 inches",
      "Confirm current availability with 110 Garage"
    ],
    "localImage": "catalog-wheels-asanti-abl-14-verified.webp",
    "imageSourceUrl": "https://www.customwheelsexpress.com/images/thumbs/500_500/Asanti-ABL14-Black-1.jpg",
    "specifications": {
      "Construction": "One-piece cast aluminium",
      "Diameters": "19, 20 and 22 inch",
      "Finishes": "Graphite, gloss black, brushed silver"
    },
    "descriptionSource": "manufacturer-retailer-archive",
    "descriptionSourceUrl": "https://www.customwheelsexpress.com/custom-wheels-by-brand-asanti-asanti-black-label-asanti-black-label-abl-14-black-custom-wheels-rims-p-3546.html"
  },
  "Wheels::Asanti Wheels::Black Label ABL-15": {
    "productUrl": "https://www.customwheelsexpress.com/custom-wheels-by-brand-asanti-asanti-black-label-asanti-black-label-abl-15-chrome-custom-wheels-rims-p-3545.html",
    "description": "The Asanti Black Label ABL-15 Apollo is a six-spoke cast truck and SUV wheel, shown here in chrome.",
    "availableSizes": [
      "22, 24, 26 and 28 inch diameters"
    ],
    "notes": [
      "Retired Asanti Black Label design",
      "Published fitments include selected six-lug truck and SUV applications",
      "Confirm current availability with 110 Garage"
    ],
    "localImage": "catalog-wheels-asanti-abl-15-verified.webp",
    "imageSourceUrl": "https://www.customwheelsexpress.com/images/thumbs/500_500/Asanti-ABL15-Chrome-1.jpg",
    "specifications": {
      "Construction": "One-piece cast aluminium",
      "Diameters": "22, 24, 26 and 28 inch",
      "Finish": "Satin black milled"
    },
    "descriptionSource": "manufacturer-retailer-archive",
    "descriptionSourceUrl": "https://www.customwheelsexpress.com/custom-wheels-by-brand-asanti-asanti-black-label-asanti-black-label-abl-15-chrome-custom-wheels-rims-p-3545.html"
  },
  "Wheels::Asanti Wheels::Black Label ABL-18": {
    "productUrl": "https://www.customwheelsexpress.com/custom-wheels-by-brand-asanti-asanti-black-label-asanti-black-label-abl-18-black-custom-wheels-rims-p-3538.html",
    "description": "The Asanti Black Label ABL-18 Matar is a directional cast truck, SUV and rear-wheel-drive passenger wheel, shown here in gloss black.",
    "availableSizes": [
      "20, 22, 24, 26 and 28 inch diameters"
    ],
    "notes": [
      "Retired Asanti Black Label design",
      "Published widths include 8.5, 9 and 10 inches",
      "Confirm current availability with 110 Garage"
    ],
    "localImage": "catalog-wheels-asanti-abl-18-verified.webp",
    "imageSourceUrl": "https://www.customwheelsexpress.com/images/thumbs/500_500/Asanti-ABL18-Black-1.jpg",
    "specifications": {
      "Construction": "One-piece cast aluminium",
      "Diameters": "20, 22, 24, 26 and 28 inch",
      "Finish": "Gloss black"
    },
    "descriptionSource": "manufacturer-retailer-archive",
    "descriptionSourceUrl": "https://www.customwheelsexpress.com/custom-wheels-by-brand-asanti-asanti-black-label-asanti-black-label-abl-18-black-custom-wheels-rims-p-3538.html"
  },
  "Wheels::Asanti Wheels::Black Label ABL-22": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/s/asanti-abl48-viceroy-22x10-5-5-et38-gloss-black-w-machined-face-a1-png.png?quality=80&fit=bounds&height=360&width=360",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::Black Label ABL-23": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::AF111": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af111",
    "description": "afaf111chrome - Asanti AF111 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-af111-bb87cd73-shop-ede65b.webp",
    "imageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/f/af111_1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af111"
  },
  "Wheels::Asanti Wheels::AF112": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af112",
    "description": "afaf112chrome - Asanti AF112 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-af112-f0aa71cb-shop-249690.webp",
    "imageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/f/af112_1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af112"
  },
  "Wheels::Asanti Wheels::AF113": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af113",
    "description": "afaf113chrome - Asanti AF113 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-af113-85141ff3-shop-3abffe.webp",
    "imageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/f/af113.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af113"
  },
  "Wheels::Asanti Wheels::AF114": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af114",
    "description": "afaf114chrome - Asanti AF114 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-af114-05b1ff45-shop-ecea3d.webp",
    "imageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/f/af114.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af114"
  },
  "Wheels::Asanti Wheels::AF115": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af115",
    "description": "afaf115chrome - Asanti AF115 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-af115-20e96b83-shop-546034.webp",
    "imageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/f/af115.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af115"
  },
  "Wheels::Asanti Wheels::AF116": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af116",
    "description": "afaf116chrome - Asanti AF116 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af116"
  },
  "Wheels::Asanti Wheels::AF117": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af117",
    "description": "afaf117chrome - Asanti AF117 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af117"
  },
  "Wheels::Asanti Wheels::AF118": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af118",
    "description": "afaf118chrome - Asanti AF118 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af118"
  },
  "Wheels::Asanti Wheels::AF119": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af119",
    "description": "afaf119chrome - Asanti AF119 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af119"
  },
  "Wheels::Asanti Wheels::AF120": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af120",
    "description": "afaf120chrome - Asanti AF120 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-asanti-wheels-af120-e3b4ae1a-shop-6fcd5b.webp",
    "imageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/f/af120.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af120"
  },
  "Wheels::Asanti Wheels::AF121": {
    "productUrl": "https://www.asantiwheels.com/asanti-forged-af121",
    "description": "afaf121chrome - Asanti AF121 - CHROME - Custom Diameter - Custom offset - BLANK Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.asantiwheels.com/asanti-forged-af121"
  },
  "Wheels::Asanti Wheels::AF122": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::AF123": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::AF124": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::AF125": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::AF126": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Asanti Wheels::AF127": {
    "productUrl": "https://www.asantiwheels.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Asanti Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.asantiwheels.com/media/catalog/product/a/b/ab22ab0223standardg0be4gi9bd-xkyn62oh.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Enkei::RPF1": {
    "productUrl": "https://enkei.com/shop/wheels/racing/rpf1/",
    "description": "The Enkei RPF1 uses a twin-spoke layout to distribute stress under cornering, braking and track use. Enkei lists the wheel in 14, 15, 16, 17 and 18 inch diameters, with MAT construction and Spec-E inspection.",
    "availableSizes": [
      "14, 15, 16, 17 and 18 inch diameters"
    ],
    "notes": [
      "MAT process",
      "Spec-E inspected",
      "Available in Silver, Gold, Black and special-order SBC"
    ],
    "localImage": "wheel-enkei-rpf1-official-shop-386eda-cutout.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-RPF1-SP-144-WEB-510x510.jpg",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://enkei.com/shop/wheels/racing/rpf1/"
  },
  "Wheels::Enkei::RPF1RS": {
    "productUrl": "https://enkei.com/shop/wheels/racing/rpf1rs/",
    "description": "The RPF1RS is everything you love about the RPF1 with the addition of a deep face creating a large lip. The RPF1RS is made in Japan and has been in the works for years. We at Enkei wanted to make sure we created a \"big lip\" RPF1 that lived up to the strong structural quality you expect from us. It is available in low insets and even a negative inset for the 11\" wide version. The twin spokes on the Enkei RPF1RS achieve better stress dispersion on curves, hard braking, and extreme race driving. CENTER DESIGN: Enkei’s pocket design around the bolt circles increases rigidity and keeps the wheel cooler during aggressive race driving. MAT PROCESS: Shaping by the MAT process reduces wheel weight by 10%-15%.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-rpf1rs-61458810-shop-d60274.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2022/11/ENKEI-RPF1RS-GM.jpg"
  },
  "Wheels::Enkei::NT03+M": {
    "productUrl": "https://enkei.com/shop/wheels/racing/nt03m/",
    "description": "NT03+M is designed with a perimeter brace ring that enhances the wheel strength so it’s able to resist deformation or distortion from outer forces, resulting in highly accurate steering response and strength. The NT03+M also features a racing twin valve design which allows for accurate monitoring while adjusting the pressure. NT03＋Mの特徴は、性能を最大限にするブレースリング。外から加わる力に対し、スポークのたわみを防ぐことで正確なコーナリングを実現できる。レース仕様のツインバルブを採用。 18 Inch Available in F1 Silver or Hyper Black Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-nt03-m-34629268-shop-435ebf.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/01/ENKEI-TOCLIP-NT03-M-SP-102.jpg"
  },
  "Wheels::Enkei::NT03RR": {
    "productUrl": "https://enkei.com/shop/wheels/racingrevolution/nt03rr/",
    "description": "Another Enkei Racing legend has received an RR makeover with Enkei’s latest MAT DURA II flow forming rim, the NT03RR. This next generation MAT rim provides improved rim rigidity over the original NT03+M. The wheel’s iconic brace ring evenly distributes stresses on spokes to help rim rigidity even further, giving NT03RR superb cornering and steering response capabilities. Dynamic design with concave rear face offers a beautiful, yet powerful form to complete any true racing setup. The NT03RR is offered in sizes ranging from 17×7 all the way up to 18×11 with a variety of bolt patterns and concaveness profiles. Similar to the GTC01RR and RS05RR, the NT03RR is available in three different concave faces.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-enkei-nt03rr-d302a52c-d7cbe6-shop-689fd7-cutout-clean.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-NT03RR-GM-192-WEB.jpg"
  },
  "Wheels::Enkei::GTC01": {
    "productUrl": "https://enkei.com/shop/wheels/racingrevolution/gtc01rr/",
    "description": "The GTC01RR is made after one of our strongest wheels, the GTC01. After vast research, we were able to keep the high rigidity while making it lightweight, comparable to the RPF1. The GTC01RR has been tested in high-performance categories including cornering, braking, acceleration, deceleration, and steering response. The GTC01RR is available in three different concave faces. ｢GTC01｣ レーシングレボリューションコンセプトホイール ■ 応力分散、ブレーキ冷却に優れる2×6マルチスポークコンケイブデザイン ■ レーシングホイールレベルの高い基本性能を獲得したモデル Sizes 18″ Matte Gunmetal Includes two red Enkei Racing badges Spec-E Inspected MAT Process",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-gtc01-851610de-shop-2d34e9.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-GTR-GM-186-WEB.jpg"
  },
  "Wheels::Enkei::GTC02": {
    "productUrl": "https://enkei.com/shop/wheels/racing/gtc02/",
    "description": "Racing is where all of the best R&D happens. Engineers obsess over every detail looking for the slightest advantage to shave fractions of a second off of lap times. What we learn on the world’s premier circuits is eventually implemented into mainstream products and made available to the weekend racer. That’s how the new Enkei GTC02 was born. Based on the RA series wheels used in the Super GT racing series, the GTC02 pulls from the same bag of tricks as the RA series to give weekend racers the competitive edge they need to win.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-gtc02-a19d226c-shop-ec35c1.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-WHEELS-gtc02-hyper-silver-side-2.jpg"
  },
  "Wheels::Enkei::RS05RR": {
    "productUrl": "https://enkei.com/shop/wheels/racingrevolution/rs05rr/",
    "description": "Designed to look incredible while retaining Enkei’s racing spirit & functionality. The light weight RS05RR is made using Enkei’s MAT-DURA flow forming method. Made in 18×8.5-18×11 with 3 different concave face designs. In Silver or Matte Gunmetal. This is a special order wheel. Please ask your Enkei dealer for details. ｢RS05｣ レーシングレボリューションコンセプトホイール ■ シャープな15フィン×コンケイブデザイン ■ レーシングホイールレベルの高い基本性能とデザイン性を両立 Sizes 18″ Matte Gunmetal or Sparkle Silver Spec-E Inspected MAT Process",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-enkei-rs05rr-e0c1a3c1-a9278d-shop-f8250e-cutout-clean.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-RS05RR-GM-190-WEB.jpg"
  },
  "Wheels::Enkei::PF01": {
    "productUrl": "https://enkei.com/shop/wheels/racing/pf01/",
    "description": "Made with Enkei’s MAT technology, the PF01 is a light, racer-friendly wheel. Sized from 15” to 18”, with plenty of clearance for large brake calipers. The new PF01 is a high quality, very lightweight wheel offered at a competitive price. ULTRA LIGHT-WEIGHT DESIGN Utilizing Enkei’s MAT flow-forming technology, the PF01 is designed to be an ultra lightweight wheel. The PF01 is engineered to take Enkei’s light-weight racing wheel line to the next level. PF01’s split five-spoke design represents its lightness and sporty feel. The subtle edge on the sides of the spokes adds a unique dimensional accent to its design.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-pf01-253a1ebf-shop-ea12fe.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-PF01-SP-104-WEB.jpg"
  },
  "Wheels::Enkei::PF01EVO": {
    "productUrl": "https://enkei.com/shop/wheels/racing/pf01evo/",
    "description": "From time attack to drifters, the PF01EVO wheel is designed to maximize the performance of 17 and 18-inch tires. When mounted on a vehicle with over fenders, the minimum inset starts from 0 mm, widening the settable tread width range. The PF01EVO wheel adopts ENKEI’s proprietary MAT process technology to ensure both the high rigidity and lightness required for an uncompromising sport wheel. ROULETTE PATTERN Our unique roulette pattern is grooved on the rim to reduce the slippage ratio between tire and rim. The roulette-pattern maintains the best condition of the wheel and tire assembly, thus achieving the highest performance during extreme acceleration and deceleration.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-pf01evo-058ac9bf-shop-4c2a6a.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-PF01EVO-SBC-172-WEB.jpg"
  },
  "Wheels::Enkei::PF05": {
    "productUrl": "https://enkei.com/shop/wheels/racing/pf05/",
    "description": "Five-Spoke wheel that inherits ENKEI tradition. Engineered by the highest design technology and the latest manufacturing technology. Dynamic yet classy concave spoke design with meticulous attention. ENKEIの伝統を受け継ぐ 5スポークホイール ■ 高度な設計技術と最新製法により高い次元で バランスを整えた5スポーク・スポーツホイール。 ■ デザイン細部にも拘った、上品且つ躍動感溢れる コンケイブスポークデザイン。 Sizes 16, 17, 18, 19″ Available in Dark Silver, Gold (Special Order), Blue (Special Order) Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-pf05-199fc648-shop-42a6ec.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/PF05-DS-1.jpg"
  },
  "Wheels::Enkei::PF07": {
    "productUrl": "https://enkei.com/shop/wheels/racing/pf07-2/",
    "description": "(The Enkei PF07 is Special Order only) Seven dynamic spokes reach toward the edge of the flange in a concave fashion to give the wheel additional depth and the appearance of being one size larger. The sides of the spokes are thinned to make them lighter while emphasizing the concave shape. This is combined with a double-lipped flange for an, especially aggressive look. The concepts of toughness and sport serve as inspiration for these design features. The wheel’s rim is a formed metallic structure forged with MAT technology to achieve a high level of strength, rigidity, and light weight.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-pf07-f626ee56-shop-4151ca.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-PF07-DS-146-WEB.jpg"
  },
  "Wheels::Enkei::PF09": {
    "productUrl": "https://enkei.com/shop/wheels/racing/pf09/",
    "description": "The PF09 is the latest addition to Enkei’s Racing Series lineup. Featuring 9 smartly contoured spokes designed to curve around big brakes found on modern sports cars, the PF09 is an excellent choice for track day enthusiasts and weekend autocrossers alike. The PF09 is available in sizes ranging from 16x7 to 18x10.5 and is available in Enkei’s Dark Silver or Matte Gunmetal Finish. All PF09s feature Enkei’s signature flat center cap. Sizes 16, 17, 18 Matte Gunmetal or Dark Silver Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-pf09-024b97e5-shop-679154.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2020/10/ENKEI-PF09-Racing-Wheel-Gunmetal.jpg"
  },
  "Wheels::Enkei::TS-5": {
    "productUrl": "https://enkei.com/shop/wheels/performance/yx-5/",
    "description": "The all-new Enkei YX-5 is big and bold in all the right ways. It takes the split 5-spoke design that Enkei has perfected many times over and sharpens all of its edges to create an ultramodern design to perfectly complement today’s sports sedans and unibody SUVs. The YX-5 is available in 17”, 18”, and 20” sizing. All specs come in our gloss gunmetal finish and include Enkei’s signature flat center cap. Sizes 17, 18, or 20 inch Gunmetal Spec-E Inspected",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-ts-5-6ebe1121-shop-2102e0.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2020/10/ENKEI-SEPT2020-16-SM173.jpg"
  },
  "Wheels::Enkei::TS-7": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/ts-7/",
    "description": "The TS-7 is Enkei’s newest addition to the Tuning Series lineup. In fact, the TS-7 is essentially a revival of the classic Enkei RS-7. It’s not just a recreation of the old wheel though. The TS-7 utilizes Enkei’s innovative MAT technology in order to build a wheel that is both lightweight and strong. The TS-7 is available in gloss black, bronze, and storm gray, and all specs come with Enkei’s signature flat center cap. With sizing ranging from 18x8 up to 18x9.5, the TS-7 is a solid choice for cars like the Subaru WRX STI, Civic Type R, Toyota GT86, and many others. Sizes 18 Matte Bronze, Gloss Black, Storm Grey Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-ts-7-b6dbd25e-shop-c60f9c.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2020/10/TS-7-Tuning-Series-Wheel-Enkei-bronze-1.jpg"
  },
  "Wheels::Enkei::TS-V": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/ts-v/",
    "description": "Building on the success of the Enkei M52 and YS5 as inspiration for a lightweight new tuning wheel led us to create the all-new TSV. The TSV features 10 paired spokes that are spaced perfectly to evenly distribute the loads and stresses placed on wheels at the track. Doing this allows us to reduce the weight on the wheel without sacrificing rigidity. The result is a classic and clean wheel design that works beautifully with late model sports sedans and coupes. The TSV comes in 17” and 18” sizing and widths up to 9.5”, and is available in Storm Gray, Gloss Black, and limited Gloss Bronze. Sizes 17, 18 Storm Gray, Gloss Bronze, and Gloss Black Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-ts-v-33edeb3d-shop-0bfd7e.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-TSV-ZP-180-SM131-1.jpg"
  },
  "Wheels::Enkei::TS10": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/ts-10/",
    "description": "The all-new Enkei TS-10 takes the simplest approach to achieving Enkei’s philosophy in creating a lightweight and strong wheel. It’s 10 cleanly cut spokes reach the very edge of the wheel, creating the illusion that the wheel is bigger than its true size. The TS-10 is available in concave and flat face profiles dependent on size and width. The TS-10 is finished off with Enkei’s signature flat center cap and is available in new storm gray, gloss black, or limited gold paint. Sizes 17, 18 Storm Gray, Gloss Black or in Gold (limited sizes) Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-ts10-4959ce26-shop-53dd70.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-TS10-GR-182-SM133-1.jpg"
  },
  "Wheels::Enkei::TS9": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/ts9/",
    "description": "Clean. Simple. Effective. We kept these three elements at heart when de- signing the TS9. The TS9’s lines are clean with nothing unnecessary added. The spokes and center of the TS9 also keep this philosophy. With simple contours and equally simple side-cuts, the spokes fold into a deep center to evoke a sense of elegance. Most importantly, the TS9 achieves its real-world effectiveness through its MAT construction, which makes the wheel both light and strong. The TS9 comes standard with Enkei’s signature flat center cap, which is the perfect finishing touch. Sizes 17, 18 Platinum Gray, Matte Black, Matte Silver (Limited Sizes) Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-ts9-5c6a5cb0-shop-98297b.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-TS9-BK-92-SM83-1.jpg"
  },
  "Wheels::Enkei::T6R": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/t6r/",
    "description": "Enkei is excited to introduce the all-new T6R to our lineup. We've taken some of the most dramatic design aspects that have made the TS-5 so popular and utilized them to build an equally awesome 6-spoke wheel. The T6R is an ideal option for modern sports coupes and sedans like the Civic Type R, WRX, STI, Q50, Q60, Golf GTI, and many others. Available from 17x8 up to 18x9.5 in finishes including our popular matte bronze, classic gloss black, and striking gloss gunmetal. Sizes 17, 18 Matte Bronze, Gloss Black, Gloss Gunmetal Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-t6r-16c97548-shop-a6d7f9.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2021/02/ENKEI-T6R-Gloss-Black-Front-1.jpg"
  },
  "Wheels::Enkei::T6S": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/t6s/",
    "description": "The T6S borrows its spoke profile and general design cues from the highly successful Kojin and adds a sixth spoke to achieve an aggressive, yet subtle appearance. The T6S comes standard with Enkei’s signature flat center cap, and is available in 17 and 18 inch. The T6S is also built using Enkei’s original MAT technology to achieve the ultimate in strength and light weight. Sizes 17, 18 Matte Silver, Matte Black or in Gold (limited sizes) Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-t6s-5c8310b1-shop-e8141f.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-T6S-GG-160-SM119.jpg"
  },
  "Wheels::Enkei::TFR": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/tfr/",
    "description": "Simplify and add lightness. That’s the approach Enkei has taken with the all new TFR Tuning Series wheel. Seven perfectly contoured spokes start from a center with carefully placed cuts to save every ounce possible. The TFR is the wheel you can autocross with on the weekends and drive to work with during the week. It is truly versatile. The TFR is available in 17”, 18”, and 19” sizing in all new Copper, Storm Gray, and limited Gunmetal finishes. The wheel is finished off with Enkei’s signature flat center cap. Sizes 17, 18 Storm Gray, Copper Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-tfr-e2d951f6-shop-062835.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-TFR-ZP-68-SM59-1.jpg"
  },
  "Wheels::Enkei::TM7": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/tm-7/",
    "description": "For decades, mesh wheel designs have been popular for numerous applications ranging from luxury sedans to hardcore track machines. It is truly a timeless design. Enkei has put a literal twist on this classic style with the all new Enkei TM-7 Tuning Series wheel. Utilizing a clean and balanced seven-split-spoke design, the TM-7 perfectly combines style with strength. The TM-7 is built using Enkei’s world-class MAT process to keep its weight low for increased performance both on the street and the race track. The TM7 is available in Storm Gray or Gloss Black with flat or concave face profiles, both with Enkei’s signature flat center cap. Sizes 17, 18 Storm Gray, Gloss Black Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-tm7-e65c05ee-shop-3abda6.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-TM7-GR-48-SM41.jpg"
  },
  "Wheels::Enkei::TMS": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/tms/",
    "description": "The all-new Enkei TMS exudes sportiness and class. It’s the mesh wheel that will win autocross competitions on Saturday and look stunning at car shows on Sunday. The spokes split almost immediately off center to create a distinct and elegant profile. Every other spoke set has a diamond cut at the transition from the center. The TMS is available in 17” and 18” sizing in Storm Gray and Gloss Black. The wheel is finished off with Enkei’s signature flat center cap. Sizes 17, 18 Storm Gray, Gloss Black Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-tms-5ecc2e78-shop-a4edf0.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-TMS-GR-114-SM101-1.jpg"
  },
  "Wheels::Enkei::Raijin": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/raijin/",
    "description": "The RAIJIN is a light weight street wheel designed for the everyday driver but with added MAT technology performance benefits. Named after the Japanese god of thunder, the Raijin is bound to help you bolt through traffic not only with style but with better overall performance. Having a light weight wheel helps brake more efficiently, helps accelerate quicker and can even help with fuel economy. You’d be surprised how much difference a few pounds makes. Sizes 18 or 19″ Silver, Black, Matte Gunmetal, Copper, or Bronze (limited sizes) Spec-E Inspected MAT Technology Optional Flat Cap sold separately",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-raijin-dfcb3ed3-shop-39a96b.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-RAIJIN-HS-174-SM125-1.jpg"
  },
  "Wheels::Enkei::Kojin": {
    "productUrl": "https://enkei.com/shop/wheels/tuning/kojin/",
    "description": "The Kojin takes the traditional 5-spoke design and adds just the right contours to give it an aggressive tuner look without being too loud about it. The Kojin is built using Enkei’s original MAT technology to achieve the ultimate in strength and light weight. The Enkei Kojin is where art and science meet to create the next big step forward in wheels. 17×9 and 18×9.5 are more concave than smaller width fitments (The photo on the left is of an 18×9.5 +15) Sizes 17, 18 Matte Silver or Matte Black Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-kojin-fa7e7d2d-shop-1cd427.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-KOJIN-SP-214-SM153.jpg"
  },
  "Wheels::Enkei::Fujin": {
    "productUrl": "https://enkei.com/introducing-the-new-enkei-fujin-lightweight-mat-tuning-series-wheel/",
    "description": "Facebook Instagram 0 Items Wheels Racing Series Racing Revolution Tuning Series Performance Series Classic Series Truck & SUV Engineering Drivers Amanda Sorensen Branden Sorensen Camren Sorensen Dmitriy Brutskiy Hiroya Minowa News Merch Downloads Find a Dealer INTRODUCING THE NEW ENKEI FUJIN - LIGHTWEIGHT MAT TUNING SERIES WHEEL by Alex Nunez | Jan 4, 2011 | Enkei Wheel Features Enkei Wheels is proud to introduce a completely new wheel to its tuning series.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://enkei.com/introducing-the-new-enkei-fujin-lightweight-mat-tuning-series-wheel/",
    "localImage": "catalog-wheels-enkei-fujin-73075772-443e8c-shop-e28e16-cutout-clean.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2011/01/Enkei_Tuning_Fujin_WHEEL_SILVER-2.jpg"
  },
  "Wheels::Enkei::Tenjin": {
    "productUrl": "https://enkei.com/new-for-2013-enkei-tenjin-mat-tuning-wheel/",
    "description": "Facebook Instagram 0 Items Wheels Racing Series Racing Revolution Tuning Series Performance Series Classic Series Truck & SUV Engineering Drivers Amanda Sorensen Branden Sorensen Camren Sorensen Dmitriy Brutskiy Hiroya Minowa News Merch Downloads Find a Dealer NEW FOR 2013: ENKEI TENJIN (MAT TUNING WHEEL) by Alex Nunez | Oct 18, 2012 | Other The Enkei Tenjin is the latest addition to the Enkei lightweight tuning line.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://enkei.com/new-for-2013-enkei-tenjin-mat-tuning-wheel/",
    "localImage": "catalog-wheels-enkei-tenjin-4b0f876a-89b972-shop-3e43b4.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2012/10/tenjin-black.jpg"
  },
  "Wheels::Enkei::Compe": {
    "productUrl": "https://enkei.com/shop/wheels/classic/compe/",
    "description": "Enkei Wheels is bringing back its COMPE (short for Competition), reviving a classic wheel associated with the heydays of import car racing. The true old school eight-spoke wheel is the latest addition from Enkei. Available in 15 and 16 with offsets ranging from 0 to 38. Sizes 15×5.5, 15×7, 15×8, 16×7, or 16×8 Matte Gunmetal, Silver in limited sizes Spec-E Inspected * Cap may not fit with aftermarket axles",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-compe-062afcee-shop-6ecb22.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-COMPE-GM-30-WEB.jpg"
  },
  "Wheels::Enkei::Apache II": {
    "productUrl": "https://enkei.com/shop/uncategorized/apache-ii/",
    "description": "Enkei Wheels is bringing back its Apache II, reviving a classic wheel associated with the heydays of import car racing. The true old school 4-spoke wheel is the latest addition from Enkei. Offering deep lips and aggressive offsets, we are raising the bar on wheel design yet again. Sizes 15x7 or 15x8 Silver or Black with Diamond Cut Lip Spec-E Inspected Size Chart Classic Series Introducing Enkei’s Classic Series. Enkei Wheels is reviving three classic wheels associated with the heydays of import car tuning. The Enkei J-Speed, ENKEI-92 and Apache II are the latest creation from the Japanese wheel manufacturer and promises to bring a new level of excitement to the wheel market.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-apache-ii-85f562be-shop-cb1eb9.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2015/01/apache-silver-lr.jpg"
  },
  "Wheels::Enkei::Enkei92": {
    "productUrl": "https://enkei.com/shop/wheels/classic/enkei92/",
    "description": "Enkei Wheels is bringing back its Enkei92, reviving a classic wheel associated with the heydays of import car tuning. The true old school mesh wheel is the latest addition from the Enkei. Offering deep lips and aggressive offsets, we are bringing a whole new level of excitement to the wheel market. Sizes 15×7 or 15×8 Silver, Black or Gold with Machined Lipl Spec-E Inspected",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-enkei92-ed1cd657-shop-5c0060.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2016/12/ENKEI-92-Gold-150-1.jpg"
  },
  "Wheels::Enkei::RPT1": {
    "productUrl": "https://enkei.com/shop/wheels/racing/rpt1/",
    "description": "The Enkei RPF1 was first introduced to the world in 2002 and it was an instant hit thanks to its high strength, low weight, and no-nonsense design. Truck and SUV owners have often asked for Enkei to develop an RPF1 for them and we listened. The all-new Enkei RPT1 features the same clean split-spoke design as the RPF1 but is built to higher loading capacities to suit 6-lug trucks and SUVs. Available in 16” 17\" and 18” applications and a variety of colors, the RPT1 is one of the lightest weight and toughest truck wheels on the market today. RPF1デザイン リアルクロスカントリーホイール ■ 骨太2×6マルチスポークデザイン ■ RPF1デザインを踏襲しつつ、クロスカントリーに対応する屈強なモデル Sizes 16, 17, 18 Available in Matte Dark Gunmetal Spec-E Inspected MAT Technology",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-rpt1-53d2fea2-shop-4d660a.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-RPT1-GM-166-WEB.jpg"
  },
  "Wheels::Enkei::Overlander": {
    "productUrl": "https://enkei.com/shop/wheels/performance/overlander/",
    "description": "The all-new Overlander is designed with crossovers and small SUVs in mind. It is a multispoked wheel with rouged rally aesthetics. The Overlander has everything you’d expect from an Enkei wheel - built strong, with industry-leading quality standards, and designed to last. If you’re looking for a strong rugged wheel, not only in looks but also in build quality, the new Enkei Overlander is made for you. Important: The Overlander 18x8, 5x108 bolt pattern fitment is a Special Order part number. Special Order part numbers do not go into production until ordered and will likely have a longer delivery time. The Matte Gunmetal finish is also a Special Order finish on all Overlander part numbers.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-overlander-7dfca0c4-shop-3d2e4d.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2022/11/ENKEI-Overlander-Crossteck-Wheels-2023-Bronze-3.jpg"
  },
  "Wheels::Enkei::M5": {
    "productUrl": "https://enkei.com/shop/wheels/performance/m52/",
    "description": "The M52 is Enkei’s take on the traditional split 5-spoke wheel. Available in 15” through 18” sizing and in hyper black or matte black, the M52 is the perfect choice to add sporty flair to any sporty coupe, sedan, or crossover. Sizes 15, 16, 17 & 18 Inch Available In Hyper Black, Matte Black, or Matte Gray Spec-E Inspected",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-m5-fd020e60-shop-428d1e.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2018/12/ENKEI-TOCLIP-M52-HB-10-SM11.jpg"
  },
  "Wheels::Enkei::M6": {
    "productUrl": "https://enkei.com/shop/wheels/performance/xm-6/",
    "description": "The automotive landscape is changing. Our mid-size sedans have been replaced with versatile SUVs. That doesn’t mean that we have to give up cool wheels though. Introducing the all-new Enkei XM6. Its clean and concave mesh design can dramatically improve the look of any modern unibody SUV or even large sedan. Available in sizes starting at 17x7.5 and going all the way up to 20x9.5, the XM6 is available in fitments for a wide variety of cars and SUVs Sizes 17, 18, and 20 inch Storm Gray or Gloss Black Spec-E Inspected",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-m6-d9493d39-shop-dd424a.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2019/12/ENKEI-TOCLIP-XM6-BK-70-SM61.jpg"
  },
  "Wheels::Enkei::FD-05": {
    "productUrl": "https://enkei.com/shop/wheels/performance/fd-05/",
    "description": "Enkei Wheels introduces a new wheel that captures the excitement of drifting. Named the FD-05, this is the official wheel of Formula Drift. Good looks, the right sizes and the high quality associated with the ENKEI brand will make this wheel a winner with enthusiasts & every-day drivers alike. Available in gloss black with bright-machined accents. Sizes 15, 16, 17, & 18 Black Machined Spec-E Inspected",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-fd-05-07c0a870-shop-7193f7.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2015/10/ENKEI-TOCLIP-FD05-BKM-02-SM05.jpg"
  },
  "Wheels::Enkei::TSP-5": {
    "productUrl": "https://enkei.com/shop/uncategorized/new-tsp-5/",
    "description": "The design cues of the RPF1 are known in motorsports circles around the world. We’ve taken those elements and applied them to an all-new split 5-spoke tuning wheel from Enkei. The TSP-5 provides a perfect balance between light-weight and strength and is available in concave or flat face profiles dependent on size and width. The TSP-5 is finished off with Enkei’s signature flat center cap and is available in silver, matte black, or limited gold paint. Sizes 17, 18 Silver, Matte Black or in Gold (select sizes) Spec-E Inspected MAT Technology NOW SHIPPING! Click here to find a dealer!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-enkei-tsp-5-2197e187-1cd782-shop-7ef082-cutout.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2015/11/TSP-5-Silver.jpg"
  },
  "Wheels::Enkei::GW8": {
    "productUrl": "https://enkei.com/shop/wheels/performance/gw8/",
    "description": "Sizes 17 & 18 Inch Available In Black with Red or Chrome Trim Spec-E Inspected",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-gw8-06ba93f4-shop-a0f61a.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2022/10/GW8_Black_RED.jpg"
  },
  "Wheels::Enkei::Lusso": {
    "productUrl": "https://enkei.com/shop/wheels/performance/lusso/",
    "description": "Sizes 18 & 20 Inch Available in Black with Machined Lip or Silver Spec-E Inspected. Fits some small SUV/Crossover Vehicles Accepts OEM BMW wheel caps",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-lusso-a67f098a-shop-bbf038.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2016/09/ENKEI-TOCLIP-LUSSO-BK-66-SM57.jpg"
  },
  "Wheels::Enkei::RSM9": {
    "productUrl": "https://enkei.com/shop/uncategorized/rsm9/",
    "description": "The RSM9 is a sports wheel infused with Enkei’s racing technology. Its sporty nine spoke design incorporates an ideal depth-to-height ratio for a striking look and features deep “side cut” to shave off extra weight to achieve the ultimate in performance. Enkei’s original MAT- Dura flow forming process gives the RSM9 unrivaled strength and rigidity. The face of the RSM9 is painted using Enkei’s exclusive piano black finish, which contrasts perfectly against its machined lip. Anti- slip paint on the inside of the wheel reduces the tendency toward tire distortion during extreme acceleration.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-rsm9-77324431-shop-948df5.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2015/01/RSM9_Platinum.jpg"
  },
  "Wheels::Enkei::RP03": {
    "productUrl": "https://enkei.com/shop/uncategorized/rp03/",
    "description": "UNDER-CUT The RPO3’s spokes are long and aggressive, reaching the edge of the rim. This feature gives the wheel the appearance of being one size larger. SPOKE DESIGN The aggressive 5-spoke power rib design reinforces rigidity needed for cornering and steering while eliminating extra weight from excess aluminum. The spokes curve toward the center of the wheel, adding a 3-D look to large engine race cars. SBC (SPECIAL BRILLIANT COATING) Breakthrough technology has enabled ENKEI to achieve a chrome-looking finish using synthetic coating and cosmetic techniques.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Enkei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-enkei-rp03-01bbcb83-shop-c30114.webp",
    "imageSourceUrl": "https://enkei.com/wp-content/uploads/2015/01/RP03_BSilver.jpg"
  },
  "Wheels::GT Form::Anvil": {
    "productUrl": "https://www.gtformwheels.com/wheels/anvil-silver-machined-face/",
    "description": "The GT form Anvil wheel is a minimal, yet complex classic multi-spoke concave wheel design. The spokes are designed to run from the outer lip all the way to the center giving the illusions of a larger overall diameter. The Anvil wheel fits right into the realm of unprecedented quality and trend-setting style. SIZES 19x8.5, 19x9.5, 20x9, 20x10, 22x9, 22x10.5 BOLT PATTERNS 5x98, 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-anvil-279ca69d-shop-798310.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2021/12/GT-Form-Anvil-Silver-Machined-Face-Rims-Performance-Wheels.jpg"
  },
  "Wheels::GT Form::Argon": {
    "productUrl": "https://www.gtformwheels.com/wheels/argon-gloss-black-tinted/",
    "description": "Argon is a new, modern multi-spoke wheel style that brings elegant design with timeless forward styling together. The sleek and slender spokes allow creating deep concave design that is ideal proposition for customers who want their cars to radiate sportiness. SIZES 20x9, 20x10.5 BOLT PATTERNS 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-argon-1147ec41-shop-e5447d.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2020/10/coming-soon-gt-form-wheels.jpg"
  },
  "Wheels::GT Form::GFS1": {
    "productUrl": "https://www.gtformwheels.com/wheels/gfs1-silver-machined-face/",
    "description": "The GFS1 wheel belongs to GT form’s 6-lug series made specifically for truck and SUV applications. The GT form GFS1 features a complex mesh design and sharp look that immediately attracts the eye. The intricate spoke design lightens the rim and creates strength in each individual spoke. SIZES 18x9, 20x9, 20x9.5, 22x9, 22x10.5 BOLT PATTERNS 6x114.3, 6x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-gfs1-01310704-shop-2a5f91.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2023/06/GT_Form_GFS1_Silver_Machined_Face_18_20_22_Inch_4x4_Offroad_Performance_Wheels_Truck_SUV_Rims.jpg"
  },
  "Wheels::GT Form::Shadow": {
    "productUrl": "https://www.gtformwheels.com/wheels/shadow-gloss-silver/",
    "description": "The Shadow is high-performance wheel design with spokes extending from the center to the outer edge of the lip for car and SUV fitments. Offered in staggered fitments and support large caliper upgrades that modernize the appearance of any vehicle SIZES 19x8.5, 19x9.5, 20x8.5, 20x9.5 BOLT PATTERNS 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-shadow-e1b7c4d3-shop-60af7d.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2022/08/GT-FORM-SHADOW-GLOSS-SILVER-RED-CAP-RIMS-WHEELS-PERFORMANCE.jpg"
  },
  "Wheels::GT Form::Legacy": {
    "productUrl": "https://www.gtformwheels.com/wheels/legacy-black-machined/",
    "description": "The Legacy is our signature solid and performance inspired five-spoke wheel design that is bold through its simplicity. The Legacy rim showcases an industry-leading configuration of concave spokes with a deep-dish chrome lip design, flowing into a sunken profile. SIZES 19x8.5, 19x9.5, 20x8.5, 20x10 BOLT PATTERNS 5x98, 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-legacy-23b24ed9-shop-30c1b7.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2021/02/PERFORMANCE_WHEELS_GT_FORM_LEGACY_BLACK_MACHINED_STAGGERED_20INCH_WHEELS.jpg"
  },
  "Wheels::GT Form::Marquee": {
    "productUrl": "https://www.gtformwheels.com/wheels/marquee-silver-machined-face/",
    "description": "Aggressive and complex, the Marquee wheel is a mesh aesthetic wheel design that become reality for nearly any vehicle. The GT form Marquee wheel provides a sharp look that modernizes the appearance of any vehicle. A concave profile is added to increases the aggressive styling and fitment. SIZES 18x8, 19x8.5, 19x9.5, 20x9, 20x10.5, 22x9, 22x10.5 BOLT PATTERNS 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-marquee-a29462dc-shop-d2bc2a.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2021/08/GT-FORM-MARQUEE-SILVER-MACHINED-FACE-RIMS-WHEELS-PERFORMANCE.jpg"
  },
  "Wheels::GT Form::Venom": {
    "productUrl": "https://www.gtformwheels.com/wheels/venom-silver-machined-face/",
    "description": "The Venom rim is a modern, split 5-spoke wheel style that brings elegant design with timeless forward styling together. Its curved Y spokes and rounded edges allow the creation of deep concave design that is ideal proposition for customers who want their cars to radiate sportiness. SIZES 19x8.5, 19x9.5, 20x8.5, 20x10, 22x10 BOLT PATTERNS 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-venom-6b8a09b5-shop-24ef95.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2021/12/GT-Form-Venom-Silver-Machined-Face-Rims-Performance-Wheels.jpg"
  },
  "Wheels::GT Form::Interflow": {
    "productUrl": "https://www.gtformwheels.com/wheels/interflow-gloss-silver/",
    "description": "GT form Wheels presents the Interflow rim. The Interflow is part of our luxury wheel collection addressed to drivers emphasizing their uniqueness and dynamism. It features twisted open five-spoke design, mid concave profile and engineered specifically for maximum performance. SIZES 19x8.5, 19x9.5, 20x8.5, 20x10 BOLT PATTERNS 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-interflow-991954c7-shop-18bcb5.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2021/10/GT-FORM-INTERFLOW-GLOSS-SILVER-RIMS-WHEELS-PERFORMANCE-CAR-SUV.jpg"
  },
  "Wheels::GT Form::Torque": {
    "productUrl": "https://www.gtformwheels.com/wheels/torque-silver-machined-face/",
    "description": "The Torque features a split 5 spoke shape with an aggressive Y-pattern design. The rim is built from form and function, applying state of the art technology and complex engineering. The Torque is specifically designed for performance vehicles. SIZES 20x8.5, 20x10, 22x9.5, 22x11 BOLT PATTERNS 5x100, 5x105, 5x108, 5x110, 5x112, 5x114.3, 5x115, 5x118, 5x120, 5x127, 5x130, 5x139.7",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "GT Form wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-gt-form-torque-4f7459c2-shop-0eb779.webp",
    "imageSourceUrl": "https://www.gtformwheels.com/wp-content/uploads/2022/02/GT-FORM-TORQUE-SILVER-MACHINED-FACE-RIMS-WHEELS-PERFORMANCE-CAR-SUV.jpg"
  },
  "Wheels::Motegi::MR154 Battle": {
    "productUrl": "https://www.motegiwheels.com/motegi-battle",
    "description": "MR15489512738 - Motegi MR154 BATTLE - MATTE BLACK - 18\" Diameter - 18X9.5 38MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mr154-battle-f87ffa86-shop-8c59d2.webp",
    "imageSourceUrl": "https://www.motegiwheels.com/media/catalog/product/m/o/motegi-mr154-18x9-5-5-et15-polished-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-battle"
  },
  "Wheels::Motegi::MR159 Battle V": {
    "productUrl": "https://www.motegiwheels.com/motegi-battle-v",
    "description": "",
    "availableSizes": [
      "17x8.5",
      "17x9.5",
      "18x8.5",
      "18x9.5",
      "18x10.5"
    ],
    "notes": [],
    "localImage": "product-official-motegi-mr159-battle-v-blackbird-metallic-shop-4e50d9.webp",
    "imageSourceUrl": "https://www.motegiwheels.com/media/catalog/product/m/o/motegi-mr159bx-battle-v-18x10-5-5-et25-blackbird-metallic-a1-png.png",
    "descriptionSource": "official-page-no-description",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-battle-v",
    "specifications": {
      "Material": "Cast aluminium",
      "Diameters": "17\", 18\"",
      "Finishes": "BLACKBIRD METALLIC, GUNZILLA W MACHINED LIP STRIPE, MATSURI WHITE PEARL MACH LIP, OBSIDIAN BLUE MACH LIP STRIPE"
    },
    "galleryImages": [
      "product-official-motegi-mr159-battle-v-obsidian-blue-mach-lip-stripe-shop-1f3b80.webp",
      "product-official-motegi-mr159-battle-v-matsuri-white-pearl-mach-lip-shop-81f025.webp",
      "product-official-motegi-mr159-battle-v-gunzilla-w-machined-lip-stripe-shop-40cfd4.webp"
    ]
  },
  "Wheels::Motegi::MR160 Battle VI": {
    "productUrl": "https://www.wheelpros.com/motegi-mr160-battle-vi-2018-subaru-wrx-sti-146",
    "description": "2018 Subaru WRX STI - Motegi MR160 BATTLE VI - Black",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-motegi-mr160-battle-vi-cd56bb5d-shop-81b1fc.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi-mr160-battle%20vi-matte%20blackbird%20metallic-18x9.5-2018%20subaru%20wrx%20sti%206",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mr160-battle-vi-2018-subaru-wrx-sti-146"
  },
  "Wheels::Motegi::MR147 CM7": {
    "productUrl": "https://www.motegiwheels.com/motegi-cm7",
    "description": "MR14778012738 - Motegi MR147 CM7 - SATIN BLACK - 17\" Diameter - 17X8 38MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-cm7"
  },
  "Wheels::Motegi::MR157 CM8": {
    "productUrl": "https://www.motegiwheels.com/motegi-cm8",
    "description": "MR15778008438 - Motegi MR157 CM8 - GLOSS GUNMETAL - 17\" Diameter - 17X8 38MM offset - 4X100/4X108 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-cm8"
  },
  "Wheels::Motegi::MR127 CS10": {
    "productUrl": "https://www.motegiwheels.com/motegi-cs10",
    "description": "MR12728512725 - Motegi MR127 CS10 - SATIN BLACK - 20\" Diameter - 20X8.5 25MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-cs10"
  },
  "Wheels::Motegi::MR143 CS6": {
    "productUrl": "https://www.motegiwheels.com/motegi-cs6",
    "description": "MR14356598740 - Motegi MR143 CS6 - SATIN BLACK - 15\" Diameter - 15X6.5 40MM offset - 4X100/4X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-cs6"
  },
  "Wheels::Motegi::MR142 CS8": {
    "productUrl": "https://www.motegiwheels.com/motegi-cs8",
    "description": "MR14288017735 - Motegi MR142 CS8 - SATIN BLACK - 18\" Diameter - 18X8 35MM offset - 5X114.3/5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-cs8"
  },
  "Wheels::Motegi::MR116 FS5": {
    "productUrl": "https://www.motegiwheels.com/motegi-fs5",
    "description": "MR11656531340 - Motegi MR116 FS5 - GLOSS BLACK W/ MACHINED FLANGE - 15\" Diameter - 15X6.5 40MM offset - 5X100/5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-fs5"
  },
  "Wheels::Motegi::MR161 Kojin": {
    "productUrl": "https://www.wheelpros.com/motegi-mr161-kojin-1994-toyota-supra-148",
    "description": "1994 Toyota Supra - Motegi MR161 KOJIN - Black",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mr161-kojin-edff85c4-shop-eab67a.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi-kojin-mr161-matte%20black-18x9.5-18x10.5-1994%20toyota%20supra%201",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mr161-kojin-1994-toyota-supra-148"
  },
  "Wheels::Motegi::MR144 M9": {
    "productUrl": "https://www.motegiwheels.com/motegi-m9",
    "description": "MR14478052740 - Motegi MR144 M9 - SATIN BLACK - 17\" Diameter - 17X8 40MM offset - 5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-m9"
  },
  "Wheels::Motegi::MR131 Traklite": {
    "productUrl": "https://www.motegiwheels.com/motegi-mr131",
    "description": "Vehicle Gallery View MR131 TRAKLITE Gallery Understanding Fitment \\r\\n SureFit This wheel is a direct bolt-on replacement for your factory setup. We make this wheel with a hub-centric design and single bolt pattern, so installation is easy and requires no modification. \\r\\n SpecFit We engineer this wheel for drivers seeking an OEM to a slightly more aggressive OEM+ fitment. It may contain dual bolt patterns and require hub-centric rings. When paired with the proper tire size, no modification is needed.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-mr131",
    "localImage": "catalog-wheels-motegi-mr131-traklite-8bcc849f-shop-538f0f.webp",
    "imageSourceUrl": "https://www.motegiwheels.com/media/catalog/product/m/r/mr1316-matte-bronze-a1-png.png"
  },
  "Wheels::Motegi::MR118 MS7": {
    "productUrl": "https://www.motegiwheels.com/motegi-ms7",
    "description": "MR11878052732US - Motegi MR118 MS7 - MATTE BLACK - 17\" Diameter - 17X8 32MM offset - 5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-ms7"
  },
  "Wheels::Motegi::MR139 RF11": {
    "productUrl": "https://www.motegiwheels.com/motegi-rf11",
    "description": "MR13967551940 - Motegi MR139 RF11 - WHITE - 16\" Diameter - 16X7.5 40MM offset - 5X100 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-rf11"
  },
  "Wheels::Motegi::MR145 Traklite 3.0": {
    "productUrl": "https://www.motegiwheels.com/motegi-traklite-3-0",
    "description": "MR14588557635 - Motegi MR145 TRAKLITE 3.0 - MATTE BRONZE - 18\" Diameter - 18X8.5 35MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-traklite-3-0"
  },
  "Wheels::Motegi::MR146 SS6": {
    "productUrl": "https://www.motegiwheels.com/products/wheels/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-motegi-mr146-ss6-eed4c1c0-shop-de7a67-hq.webp",
    "imageSourceUrl": "https://www.motegiwheels.com/media/catalog/product/a/8/a81d7640c0059c81b23a2e7078657693a13b603ec11473671debc4d24df8e7bf.jpeg?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::Motegi::MR151 CS5": {
    "productUrl": "https://wheelwiz.ca/products/mr15189551940",
    "description": "The Motegi MR151 CS5 is a cast aluminium five-spoke wheel. The current distributor guide lists 18 and 19 inch variants in Gunmetal with Machined Lip, Hyper Silver, Satin Black and Satin Metallic Blue.",
    "availableSizes": [
      "18 and 19 inch diameters"
    ],
    "notes": [
      "Cast aluminium construction",
      "Published variants use 5-lug bolt patterns",
      "Final stock and Australian availability require confirmation"
    ],
    "localImage": "wheel-motegi-mr151-cs5-exact-shop-cf0229.webp",
    "imageSourceUrl": "https://wheelwiz.ca/cdn/shop/files/MR151-19x9-5-5LUG-ET15-SATIN-METALLIC-BLUE-A1-png_1200x.png?v=1772224708",
    "descriptionSource": "official-distributor-spec-guide",
    "descriptionSourceUrl": "https://www.mljinc.co.jp/img/products/spec_guide_2026-v2_motegiracing.pdf"
  },
  "Wheels::Motegi::MR152 SS5": {
    "productUrl": "https://www.motegiwheels.com/products/wheels/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-motegi-mr152-ss5-89db2c36-shop-25fda1-hq.webp",
    "imageSourceUrl": "https://www.motegiwheels.com/media/catalog/product/4/6/46c494ba66ef2fed6218a40398a54eed0b17a6cd62831d288677aeb649003936.jpeg?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::Motegi::MR153 CM10": {
    "productUrl": "https://www.wheelpros.com/news/the-new-mr153-cm10",
    "description": "The Motegi MR153 CM10 is a cast aluminium ten-spoke wheel offered in Machined Gunmetal, Rally Gold and Satin Black. Published variants cover 18, 19 and 20 inch diameters.",
    "availableSizes": [
      "18, 19 and 20 inch diameters"
    ],
    "notes": [
      "Cast aluminium construction",
      "Published 5-lug variants",
      "Final stock and Australian availability require confirmation"
    ],
    "localImage": "wheel-motegi-mr153-cm10-exact-shop-72e2a8.webp",
    "imageSourceUrl": "https://wheelwiz.ca/cdn/shop/files/MR153-20x8-5-5LUG-ET25-MACHINED-GUNMETAL-A1-png_ceb5b743-8049-4313-a426-21810eb6bb91_1200x.png?v=1772224720",
    "descriptionSource": "official-wheel-pros-release",
    "descriptionSourceUrl": "https://www.wheelpros.com/news/the-new-mr153-cm10"
  },
  "Wheels::Motegi::MR156 Hypergram": {
    "productUrl": "https://www.motegiwheels.com/products/wheels/all-wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-motegi-mr156-hypergram-89da0ea6-shop-4b86aa-hq.webp",
    "imageSourceUrl": "https://www.motegiwheels.com/media/catalog/product/m/o/motegi-mr156-15x8-4lug-et28-gloss-gunmetal-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::Motegi::MF412 SS5": {
    "productUrl": "https://www.wheelpros.com/motegi-mf412-ss5-2020-toyota-supra-86",
    "description": "2020 Toyota Supra - Motegi MF412 SS5 - Black",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf412-ss5-66fb3ca2-shop-ad71c4.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi%20forged-mf412-ss5-18x7-matte%20black-2020%20toyota%20supra%201",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf412-ss5-2020-toyota-supra-86"
  },
  "Wheels::Motegi::MF413 SS6": {
    "productUrl": "https://www.wheelpros.com/motegi-mf413-ss6-2022-toyota-gr86-87",
    "description": "2022 Toyota GR86 - Motegi MF413 SS6 - White",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf413-ss6-21d8b46d-shop-78902c.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi%20forged-mf413-ss6-white-17x9-2022%20toyota%20gr86%201",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf413-ss6-2022-toyota-gr86-87"
  },
  "Wheels::Motegi::MF414 Tsubaki": {
    "productUrl": "https://www.wheelpros.com/motegi-mf414-tsubaki-1986-toyota-trueno-88",
    "description": "1986 Toyota Trueno - Motegi MF414 Tsubaki - Polished",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf414-tsubaki-d9ba31ea-shop-bfa293.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi%20forged-mf414-tsubaki-15x9-15x10-polished-1986%20toyota%20trueno%2013",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf414-tsubaki-1986-toyota-trueno-88"
  },
  "Wheels::Motegi::MF415 Battle": {
    "productUrl": "https://www.wheelpros.com/motegi-mf415-battle-1999-mitsubishi-eclipse-99",
    "description": "1999 Mitsubishi Eclipse - Motegi MF415 Battle - Silver",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf415-battle-4eea68b2-shop-2639b7.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi-mf415-battle-satin%20silver-18x10-1999%20mitsubishi%20eclipse%2012",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf415-battle-1999-mitsubishi-eclipse-99"
  },
  "Wheels::Motegi::MF416 Battle V": {
    "productUrl": "https://www.wheelpros.com/motegi-mf416-battle-v-1998-toyota-supra-89",
    "description": "1998 Toyota Supra - Motegi MF416 Battle V - Polished",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf416-battle-v-2b81b76c-shop-a0efb9.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi%20forged-mf416-battle%205-polished-18x10-18x11-1998%20toyota%20supra%2022",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf416-battle-v-1998-toyota-supra-89"
  },
  "Wheels::Motegi::MF417 Millennium": {
    "productUrl": "https://www.wheelpros.com/motegi-mf417-millennium-2010-bmw-m3-91",
    "description": "2010 BMW M3 - Motegi MF417 Millennium - Bronze",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf417-millennium-323e1806-shop-1cca39.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi%20forged-mf417-millenium-18x11-matte%20bronze-2010%20bmw%20m3%2012",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf417-millennium-2010-bmw-m3-91"
  },
  "Wheels::Motegi::MF418 EXO6": {
    "productUrl": "https://www.wheelpros.com/motegi-mf418-exo6-2023-nissan-z-122",
    "description": "2023 Nissan Z - Motegi MF418 EXO6 - Custom",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf418-exo6-d30ae37c-shop-70c2c5.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi-mf418-exo6-custom-18x10-18x12-2023%20nissan%20z%202",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf418-exo6-2023-nissan-z-122"
  },
  "Wheels::Motegi::MF419 EXO4": {
    "productUrl": "https://www.motegiwheels.com/motegi-forged-mf419-exo4",
    "description": "MF419HX1510OXX - Motegi MF419 EXO4 - CUSTOM - 15\" Diameter - 15X10 XXMM offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-motegi-mf419-exo4-d7f80312-shop-39f5b3.webp",
    "imageSourceUrl": "https://www.motegiwheels.com/media/catalog/product/m/o/motegi-mf419-exo4-15x9_a1.1291.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motegiwheels.com/motegi-forged-mf419-exo4"
  },
  "Wheels::Motegi::MF420 EXO": {
    "productUrl": "https://www.wheelpros.com/motegi-mf420-exo-1999-nissan-300zx-124",
    "description": "1999 Nissan 300ZX - Motegi MF420 EXO - Polished",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf420-exo-9e3049ac-shop-629f2b.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi-mf420-exo-polished-18x10-18x11-1999%20nissan%20300zx%203",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf420-exo-1999-nissan-300zx-124"
  },
  "Wheels::Motegi::MF421 SS3": {
    "productUrl": "https://www.wheelpros.com/motegi-mf421-ss3-2000-mazda-rx-7-129",
    "description": "2000 Mazda RX-7 - Motegi MF421 SS3 - Polished",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Motegi wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-motegi-mf421-ss3-b57ce813-shop-1b451a.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/motegi-mf421-ss3-polished-18x9-18x11-2000%20mazda%20rx7%205",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.wheelpros.com/motegi-mf421-ss3-2000-mazda-rx-7-129"
  },
  "Wheels::Orbit::Casa": {
    "productUrl": "https://www.jaxtyres.com.au/wheels/orbit",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Orbit wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Orbit::Fitti": {
    "productUrl": "https://www.jaxtyres.com.au/wheels/orbit",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Orbit wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Orbit::Venator": {
    "productUrl": "https://www.jaxtyres.com.au/wheels/orbit",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Orbit wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Orbit::Lotus": {
    "productUrl": "https://www.jaxtyres.com.au/wheels/orbit",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Orbit wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Orbit::Monza": {
    "productUrl": "https://www.jaxtyres.com.au/wheels/orbit",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Orbit wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P0A": {
    "productUrl": "https://www.petrolwheels.com/petrol-p0a",
    "description": "1780P0A355120B76 - Petrol P0A - GLOSS BLACK W/ MACH CUT FACE - 17\" Diameter - 17X8 35MM offset - 5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-petrol-p0a-1a5b8cf2-shop-3774dd.webp",
    "imageSourceUrl": "https://www.petrolwheels.com/media/catalog/product/p/e/petrol-p0a-5-lugs-gloss-black-machine-face-std-org-copy-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.petrolwheels.com/petrol-p0a"
  },
  "Wheels::Petrol::P1A": {
    "productUrl": "https://www.petrolwheels.com/petrol-p1a",
    "description": "1780P1A355100B72 - Petrol P1A - GLOSS BLACK W/ MACH CUT FACE - 17\" Diameter - 17X8 35MM offset - 5X100 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-petrol-p1a-f8d5584a-shop-65449d.webp",
    "imageSourceUrl": "https://www.petrolwheels.com/media/catalog/product/p/e/petrol-p1a-5-lugs-gloss-black-machine-cut-face-std-org-copy-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.petrolwheels.com/petrol-p1a"
  },
  "Wheels::Petrol::P2A": {
    "productUrl": "https://www.petrolwheels.com/petrol-p2a",
    "description": "1880P2A325112S72 - Petrol P2A - SILVER W/ MACHINED CUT FACE - 18\" Diameter - 18X8 32MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-petrol-p2a-4ebe2634-shop-22db98.webp",
    "imageSourceUrl": "https://www.petrolwheels.com/media/catalog/product/p/e/petrol-p2a-5-lugs-silver-machine-cut-face-std-org-copy-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.petrolwheels.com/petrol-p2a"
  },
  "Wheels::Petrol::P3C": {
    "productUrl": "https://www.petrolwheels.com/petrol-p3c",
    "description": "1880P3C405105B72 - Petrol P3C - SEMI GLOSS BLACK - 18\" Diameter - 18X8 40MM offset - 5X105 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-petrol-p3c-540be2f1-shop-ad55cd.webp",
    "imageSourceUrl": "https://www.petrolwheels.com/media/catalog/product/p/e/petrol-p3c-wheel-5-lug-gloss-black-machined-face-std-org-copy-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.petrolwheels.com/petrol-p3c"
  },
  "Wheels::Petrol::P4B": {
    "productUrl": "https://www.petrolwheels.com/petrol-p4b",
    "description": "1780P4B405110B72 - Petrol P4B - GLOSS BLACK - 17\" Diameter - 17X8 40MM offset - 5X110 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-petrol-p4b-08b87985-shop-cb12dc.webp",
    "imageSourceUrl": "https://www.petrolwheels.com/media/catalog/product/p/e/petrol-p4b-gloss-black-std-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.petrolwheels.com/petrol-p4b"
  },
  "Wheels::Petrol::P5C": {
    "productUrl": "https://www.petrolwheels.com/petrol-p5c",
    "description": "1780P5C405115G76 - Petrol P5C - GLOSS GUNMETAL - 17\" Diameter - 17X8 40MM offset - 5X115 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-petrol-p5c-a27fee53-shop-5d9dd1.webp",
    "imageSourceUrl": "https://www.petrolwheels.com/media/catalog/product/p/e/petrol-p5c-20x8-5-5lug-et40-gloss-blk-n-machined-a1-copy-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.petrolwheels.com/petrol-p5c"
  },
  "Wheels::Petrol::P6A": {
    "productUrl": "https://www.petrolwheels.com/petrol-p6a",
    "description": "1980P6A355120B76 - Petrol P6A - GLOSS BLACK W/ MACH CUT FACE - 19\" Diameter - 19X8 35MM offset - 5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-petrol-p6a-7e8aff74-shop-48ab9d.webp",
    "imageSourceUrl": "https://www.petrolwheels.com/media/catalog/product/a/f/aftermarket-wheels-rims-petrol-p6a-5-lug-matte-black-std-org-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.petrolwheels.com/petrol-p6a"
  },
  "Wheels::Petrol::P7C": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P8A": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P9B": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P10A": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P11B": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P12C": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P13A": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P14B": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P15C": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P16A": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P17B": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P18C": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Petrol::P19A": {
    "productUrl": "https://www.petrolwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Petrol wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Reproduction Wheels::Commodore VE SSV": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/light-blue-modified-holden-commodore-vl-aftermarket-wheels-body-kit.webp?v=1733804793&width=3840",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Reproduction Wheels::Commodore VF SSV": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/light-blue-modified-holden-commodore-vl-aftermarket-wheels-body-kit.webp?v=1733804793&width=3840",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Reproduction Wheels::Commodore HSV GTS": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/articles/reproduction-wheels-holden-commodore-hsv.webp?v=1711929152&width=533",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Reproduction Wheels::Commodore HSV Senator": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/articles/reproduction-wheels-holden-commodore-hsv.webp?v=1711929152&width=533",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Reproduction Wheels::Commodore Walkinshaw": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-reproduction-wheels-commodore-walkinshaw-770fe694-shop-b09ad1.webp",
    "imageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/white-car-mobil-1-livery-group-wheels.webp?v=1733804931&width=3840"
  },
  "Wheels::Reproduction Wheels::Ford Falcon FG GT": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "",
    "availableSizes": [],
    "notes": [],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/silver-ford-falcon-sedan-orange-stripes-custom-wheels.webp?v=1733804847&width=3000",
    "imageStatus": "blocked-mismatched-lifestyle-image"
  },
  "Wheels::Reproduction Wheels::Ford Falcon XR6 Turbo": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "",
    "availableSizes": [],
    "notes": [],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/silver-ford-falcon-sedan-orange-stripes-custom-wheels.webp?v=1733804847&width=3000",
    "imageStatus": "blocked-mismatched-lifestyle-image"
  },
  "Wheels::Reproduction Wheels::Ford Mustang GT": {
    "productUrl": "https://www.reproductionwheels.com.au/products/mustang-spare-wheel-and-tyre-for-s550-5-0l-gt-ecoboost-ford",
    "description": "Mustang Space Saver Spare Wheel Solution for Brembo Equipped GT Mustangs and Eco Boost Mustangs 2015-2023 Ford Mustang S550 5.0L GT & EcoBoost Clears Brembo Brakes Wheel manufactured to JWL and VIA standards and 850KGS load ratings OEM 19 \"Alloy wheel and tyre assembly in box Fitted with Tyre - 135/7OR19 Made to fits over Brembo Brakes To suit all GT Mustangs/Eco Boost Models Fits in spare wheel well Fits under boot floor panel Doesn't raise floor panel Retains use of OEM wheel nuts Hub centric same as OEM wheel Wheel and Tyre come fully balanced Includes Insulated Felt Mat for between Wheel and Wheel Well 80 Kph speed rating on approved tyre",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-reproduction-wheels-ford-mustang-gt-1f33e6e7-shop-365eae.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0494/5972/4455/files/mustang-spare-wheel-and-tyre-for-s550-5-0l-gt-ecoboost-alloy-wheels-764.jpg?v=1742409616"
  },
  "Wheels::Reproduction Wheels::Toyota LandCruiser GXL": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Reproduction Wheels::Toyota LandCruiser Sahara": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Reproduction Wheels::Nissan Patrol Warrior": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/modified-silver-nissan-skyline-r32-aftermarket-wheels-body-kit.webp?v=1733804804&width=1500",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Reproduction Wheels::Ranger Wildtrak": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Reproduction Wheels::Raptor Style": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/sleek-black-car-wheel-distinctive-silver-turbine-style-rims-illuminated-pink-lighting.webp?v=1733804826&width=1500",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Reproduction Wheels::BMW M Performance": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-reproduction-wheels-bmw-m-performance-c9b6d4c0-shop-fb5040-cutout.webp",
    "imageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/e3-series-sv-performance-20-inch-shadow-silver-replica-wheels-pre-ve-alloy-multi-spoke-633.png?v=1766035825&width=1000"
  },
  "Wheels::Reproduction Wheels::Mercedes AMG Style": {
    "productUrl": "https://www.reproductionwheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Reproduction Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://reproductionwheels.com.au/cdn/shop/files/sleek-black-car-wheel-distinctive-silver-turbine-style-rims-illuminated-pink-lighting.webp?v=1733804826&width=1500",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::ROH::Assault": {
    "productUrl": "https://roh.com.au/wheels/assault/",
    "description": "NEW FINISH - Assault is now available in an all-new Machined Centre Black Lip finish! Now an icon of the ROH Off-Road range, the ROH Assault 4×4 wheel features 5 unique finishes including Machined Black Lip, Matte Bronze, Graphite Centre, Machined or Full Matte Black, all of which are coupled with anodised aluminium bolts. Assault is available in a range of 16”, 17” and 18” sizes, with fitments to suit most popular 4x4 vehicles. Rally-Inspired Deep-Dish Design Assault is a rally-inspired deep-dish full-faced design enhanced with a beadlock-style lip. Design details include anodised aluminium bolts adorning the outer lip, which features integrated debris release slots.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-roh-assault-cfb9f22f-4f1480-shop-15da98-cutout-clean.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2021/02/ASSAULT-BL.jpg"
  },
  "Wheels::ROH::Avenger": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Blak Trak": {
    "productUrl": "https://roh.com.au/wheels/blak-trak/",
    "description": "ROH Blak Trak steel wheels are engineered, tried and tested in the toughest outback conditions in Australia, surpassing both Australian and international testing standards. ROH is the preferred supplier to mining, government and emergency services across Australia. Available in super tough black powder-coat finish, you can rely on ROH Blak Trak steel wheels to deliver outstanding outback reliability. Please note: Centre caps & nuts sold separately. Not available for every fitment, please confirm with your reseller re cap options for your vehicle.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-roh-blak-trak-335af5e6-shop-9c6bab.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2021/02/Blak-Trak-new-cap-RGB.jpg"
  },
  "Wheels::ROH::Cairo": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Dakar": {
    "productUrl": "https://roh.com.au/dakar-trojan-alloy-wheels/",
    "description": "Wheels LITEFORGED Series Facebook ROH Wheels on Facebook ROH Wheels on Instagram ROH Performance Wheels on Instagram Home Posts Gallery ROH Trojan alloy wheels - Bruce Garland tackling Dakar with ROH! ROH Trojan alloy wheels - Bruce Garland tackling Dakar with ROH!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://roh.com.au/dakar-trojan-alloy-wheels/",
    "localImage": "catalog-wheels-roh-dakar-2addb4ca-836f02-shop-a57635.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2015/04/Bruce-Garland-Isuzu-Rally-Team-Trojan-in-16x7-e1435899188156.jpg"
  },
  "Wheels::ROH::Hammer": {
    "productUrl": "https://roh.com.au/wheels/hammer/",
    "description": "Part of the exclusive range of ROH Dakar Proven Wheels®, the ROH Hammer 4x4 wheel comes in a Matt Black finish with a gloss black outer lip and black anodised aluminium bolts (not chrome plastic) and is available in 16”, 17”, and 18” sizes. Unique Twin 5-Spoke Design Hammer is a unique twin 5-spoke with bold styling features enhanced by the gloss black outer lip and black anodised aluminium bolts. Its rugged good looks will be sure to get you noticed while the gloss black outer lip adds a touch of extra style.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-roh-hammer-19777abf-shop-2d02cf.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2021/02/Hammer-RGB-web.jpg"
  },
  "Wheels::ROH::Havoc": {
    "productUrl": "https://roh.com.au/new-style-4x4-havoc/",
    "description": "Havoc is a unique twin 6-spoke with sweeping styled spokes enhanced by bright undercut machining beneath the gear-like outer lip and anodised aluminium bolts completing the mechanical look.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-roh-havoc-c646517a-shop-717eec.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2021/02/Havoc-wheels-Isuzu-Dmax-on-rocks-in-forest.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://roh.com.au/new-style-4x4-havoc/"
  },
  "Wheels::ROH::Hostage": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Impulse": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Invader": {
    "productUrl": "https://roh.com.au/new-style-4x4-invader/",
    "description": "Attack the outback or just cruise the urban streets with this all-new offroad Flow-forged wheel from ROH.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://roh.com.au/new-style-4x4-invader/"
  },
  "Wheels::ROH::Maverick": {
    "productUrl": "https://roh.com.au/new-style-4x4-maverick/",
    "description": "Maverick is a high load-rated unique billet style wheel enhanced with aggressive billet style milling and bright CNC milled features on the gloss black lip.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://roh.com.au/new-style-4x4-maverick/"
  },
  "Wheels::ROH::Octagon": {
    "productUrl": "https://roh.com.au/new-fitment-roh-17x8-octagon-wheel/",
    "description": "Our popular ROH 17×8 Octagon is now available to suit 2016 LandCruiser 200 Series VX and Sahara models. In stock now.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-roh-octagon-ce0668a2-shop-0db200.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2016/07/New-Product-Bulletin-4x4-Octogan-LC200-2xOctagon-colours-sml.jpg.webp",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://roh.com.au/new-fitment-roh-17x8-octagon-wheel/"
  },
  "Wheels::ROH::Raid": {
    "productUrl": "https://roh.com.au/wheels/raid/",
    "description": "Part of the exclusive ROH Dakar Proven Wheels® range, the ROH Raid 4×4 wheel is available in Machined, Matt Bronze, Matt Gunmetal, and Matt Black finishes, featuring anodised aluminium bolts, and comes in 17”, 18”, and 20” sizes. Bold & Refined Design Raid is a bold yet refined design with a unique multi-spoke configuration enhanced by an aggressive beadlock-style lip and anodised aluminium bolts. Durable ROH Easycleans® Finish Raid features the ROH Easycleans® Bronze, Gunmetal, and Matt Black Baked Enamel finish, providing superior salt spray performance and anti-weathering durability, making it an ideal wheel for both recreational and commercial end-users.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-roh-raid-6fd5b735-shop-460b13.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2024/12/Raid-GM-RGB.jpg"
  },
  "Wheels::ROH::Razor": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Sniper": {
    "productUrl": "https://roh.com.au/new-style-4x4-sniper/",
    "description": "Sniper is deep-dish round-hole design enhanced with bright CNC milling around the 8 windows. Design details include 8 black anodised aluminium bolts assembled to the matt gunmetal beadlock style lip.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://roh.com.au/new-style-4x4-sniper/"
  },
  "Wheels::ROH::Storm": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Trophy": {
    "productUrl": "https://roh.com.au/200-series-landcruiser-trophy-wheels/",
    "description": "Jamie Benaud from Australian Images chose ROH Trophy 4x4 wheels for his trip to Cape York with Project 200.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-roh-trophy-4926461c-shop-dd0170.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2020/04/ROH-4x4-Trophy-wheels-on-LC-200-Cape-York-driving-from-rocks-through-sandy-beach-entry.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://roh.com.au/200-series-landcruiser-trophy-wheels/"
  },
  "Wheels::ROH::Vapour": {
    "productUrl": "https://roh.com.au/wheels/vapour/",
    "description": "Unique Twin 6-Spoke Design Vapour is a unique twin 6-spoke with styling features enhanced by bright undercut machining beneath the outer lip and 6 anodised aluminium bolts adorning the apex of the angled muscular wheel spokes. Durable and Weather-Resistant Finish Vapour features ROH Easycleans® Matt Black Baked Enamel finish which provides superior salt spray performance and anti-weathering durability, making it an ideal wheel for both recreational and commercial end-users. Compatibility with Popular 4x4 and SUV Models Vapour will fit a large range of the most popular 4×4 and SUV vehicles including top-selling Hilux, Ranger, Colorado, BT-50, Triton and Navara.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-roh-vapour-db27ef13-shop-42ab8b.webp",
    "imageSourceUrl": "https://roh.com.au/wp-content/uploads/2017/12/Vapour-Flat-cap.jpg"
  },
  "Wheels::ROH::Vector": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Voltage": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::ROH::Zeta": {
    "productUrl": "https://roh.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "ROH wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rotiform::ZMO-M": {
    "productUrl": "https://www.rotiform.com/rotiform-zmo-m",
    "description": "R181198521+35 - Rotiform R181 ZMO-M - MATTE ANTHRACITE - 19\" Diameter - 19X8.5 35MM offset - 5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-zmo-m-bbcce194-shop-aacd99-hq.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/z/m/zmo-m-rf916-matte-black-a1.png?quality=90&fit=bounds&height=1200&width=1200",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-zmo-m"
  },
  "Wheels::Rotiform::LSE": {
    "productUrl": "https://www.rotiform.com/rotiform-lse-2021-toyota-supra-163",
    "description": "2021 Toyota Supra - Rotiform LSE - Black",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-lse-d52dd084-shop-f1303f.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/rotiform-rc201-lse-satin%20black-20x8.5-20x10-2021%20toyota%20supra%201",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-lse-2021-toyota-supra-163"
  },
  "Wheels::Rotiform::OZR-T": {
    "productUrl": "https://www.rotiform.com/rotiform-ozr-t",
    "description": "RC210SX20856F45 - Rotiform RC210 OZR-T - GLOSS SILVER - 20\" Diameter - 20X8.5 45MM offset - 6X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-ozr-t-14058870-shop-27e801.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/o/rotiform-rc201-ozr-t-20x8.5-6-45-gloss-silver-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-ozr-t"
  },
  "Wheels::Rotiform::BPU": {
    "productUrl": "https://www.rotiform.com/rotiform-bpu",
    "description": "The Rotiform BPU blends modern design with golden-era JDM attitude. It’s a clean, arched 7-spoke layout with a flat, performance-focused lip and sharp surface detailing. Flow-formed construction keeps weight down and strength up, making the BPU a serious option for both street and track. It’s available in 18” and 19” sizes with offsets from +20 to +45mm, built to fit a wide range of 5-lug platforms.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-bpu-0e7512de-shop-540c96.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/o/rotiform-rc208-bpu-18x9-5-5-et25-gloss-black-w-teal-stripe-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-bpu"
  },
  "Wheels::Rotiform::RPS": {
    "productUrl": "https://www.rotiform.com/rotiform-rps",
    "description": "The Rotiform RPS brings forged-level energy to our most advanced cast wheel yet. Inspired by the iconic SIX and influenced by classic motorsport cues, it delivers aggressive spokes, structural webbing, and deep surfacing that hits hard from every angle. Built using Flow Formed Technology to reduce weight while maintaining strength, the RPS comes in fitments ranging from 18x8.5 to 20x12. That includes a proper load-rated spec for the Tesla Model 3 and full brake clearance for R35 GT-Rs and Brembo-equipped cars.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-rps",
    "localImage": "catalog-wheels-rotiform-rps-93dd7063-shop-b488dd.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/o/rotiform-rc209-rps-20x12-5-et25-matte-black-a1-png.png"
  },
  "Wheels::Rotiform::LTN-J": {
    "productUrl": "https://www.rotiform.com/rotiform-ltn-j",
    "description": "The Rotiform LTN-J brings motorsport pedigree and fresh design to the street with a curved, split 5-spoke layout and flat-face profile. Built using Flow Formed Technology, it’s lightweight, strong, and spec’d for everything from FWD Japanese compacts to rear-engine Porsche classics. This wheel introduces staggered 5x130 fitments with proper brake clearance for the 997 Turbo and a deep rear lip that hits hard from every angle.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-ltn-j-c52b72c0-shop-06a4ad.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/o/rotiform-rc207-ltn-j-18x10-5-5-et35-gloss-gold-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-ltn-j"
  },
  "Wheels::Rotiform::356": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-356",
    "description": "rc-356-polished - Rotiform 356 - POLISHED - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-356-d8a554b8-shop-7ffefc.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/3/5/356-polished-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-356"
  },
  "Wheels::Rotiform::917": {
    "productUrl": "https://www.rotiform.com/rotiform-forged-917",
    "description": "Rotiform designs and builds the finest cast and custom forged wheels for your automobile. Focused on style, strength, and aggressive fitment, Rotiform Wheels are the ultimate.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-forged-917"
  },
  "Wheels::Rotiform::ARO": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-aro",
    "description": "rc-aro-glosssilver - Rotiform ARO - Gloss Silver w/ Polished Lip - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-aro-40c073fd-shop-80bcea.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/a/r/aro-19x10-gloss-slvr-w-polished-lip-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-aro"
  },
  "Wheels::Rotiform::AVS": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-avs",
    "description": "rc-avs-brushedsilver - Rotiform AVS - BRUSHED SILVER - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-avs-1a12b2d2-shop-a97a28.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/o/rotiform-forged-avs-22x10.5-5-et10-gloss-black-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-avs"
  },
  "Wheels::Rotiform::BKK": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-bkk",
    "description": "rc-bkk-anthracite - Rotiform BKK - Anthracite w/ Black Lip - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-bkk-12a296ec-shop-9efc4f.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/k/bkk-anthracite-w-blk-lip-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-bkk"
  },
  "Wheels::Rotiform::BLQ": {
    "productUrl": "https://www.rotiform.com/rotiform-blq",
    "description": "R110189543+35 - Rotiform R110 BLQ - GLOSS SILVER MACHINED - 18\" Diameter - 18X9.5 35MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-blq-02744c0f-shop-1ef7fd.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/l/blq-r110-19x10-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-blq"
  },
  "Wheels::Rotiform::BLQ-C": {
    "productUrl": "https://www.rotiform.com/rotiform-blq-c",
    "description": "R1651985F8+45A - Rotiform R165 BLQ-C - MATTE BLACK - 19\" Diameter - 19X8.5 45MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-blq-c-8c386527-shop-584369.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/l/blq-c-r167-19x8-5-et45-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-blq-c"
  },
  "Wheels::Rotiform::BLQ-T": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-blq-t",
    "description": "rc-blq-t-brushedddt - Rotiform BLQ-T - Brushed DDT / Polished Lip - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-blq-t-427b7085-shop-6def0c.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/l/blq-t-candy-black-with-polished-lip_a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-blq-t"
  },
  "Wheels::Rotiform::BM1": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-bm1",
    "description": "rc-bm1-brushedglossclear - Rotiform BM1 - Brushed Gloss Clear w/ Black Windows - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-bm1-ea40a90a-shop-7b3aad.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/m/bm1-hi-luster-polish-matte-black-window-polished-lip_a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-bm1"
  },
  "Wheels::Rotiform::BRU": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-bru",
    "description": "rc-bru-chrome - Rotiform BRU - CHROME - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-bru-b7ad858e-shop-fdbe25.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/r/bru-19x10-chrome-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-bru"
  },
  "Wheels::Rotiform::BTC": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-btc",
    "description": "rc-btc-brushed - Rotiform BTC - Brushed w/ Polished Lip - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-btc-3a99d487-shop-4ce240.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/t/btc-chrome-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-btc"
  },
  "Wheels::Rotiform::BTH": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-bth",
    "description": "rc-bth-gold - Rotiform BTH - Gold w/ Polished Lip - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-bth-04e9bcab-shop-4d785c.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/t/bth-gold-with-polished-lip_a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-bth"
  },
  "Wheels::Rotiform::BTL": {
    "productUrl": "https://www.rotiform.com/rotiform-btl",
    "description": "#html-body [data-pb-style=IJGG5EN]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}Some wheel designs bring you to a different time, no matter how new or fresh. The Rotiform BTL brings visions of worn-leather driving gloves, well-crafted timepieces, and air-cooled flat-six engines echoing between the Rhine and Mosel River valleys.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-btl-020bd923-shop-d6d182.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/o/rotiform-btl-r194-22x12-5-et15-matte-black-with-black-cap-and-inside-spoke-details-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-btl"
  },
  "Wheels::Rotiform::BUC": {
    "productUrl": "https://www.rotiform.com/rotiform-buc",
    "description": "R157189565+40 - Rotiform R157 BUC - MATTE BLACK - 18\" Diameter - 18X9.5 40MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-buc-4cd0175c-shop-ddf67f.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/b/u/buc-r153-19x8-5-slvr-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-buc"
  },
  "Wheels::Rotiform::CCV": {
    "productUrl": "https://www.rotiform.com/rotiform-ccv",
    "description": "R108198543+45 - Rotiform R108 CCV - CANDY RED - 19\" Diameter - 19X8.5 45MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-ccv-32c305a6-shop-aafcc3.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/c/c/ccv-r137-18x9-5-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-ccv"
  },
  "Wheels::Rotiform::CIN": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-ind-t",
    "description": "rc-ind-t-brushedmatteredcenter - Rotiform IND-T - Brushed Matte Red Center w/ Gloss Candy Red Lip - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-cin-fef73885-shop-270352.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/i/n/ind-t-matte-silver-polished-lip_a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-ind-t"
  },
  "Wheels::Rotiform::CVT": {
    "productUrl": "https://www.rotiform.com/rotiform-cvt",
    "description": "R1282085F4+45 - Rotiform R128 CVT - MATTE ANTHRACITE - 20\" Diameter - 20X8.5 45MM offset - 5X112/5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-cvt-e6c09315-shop-2bbdf7.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/c/v/cvt-r124-18x8-5-et45-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-cvt"
  },
  "Wheels::Rotiform::DIA": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-dia",
    "description": "rc-dia-chrome - Rotiform DIA - CHROME - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-dia-2e96fe92-shop-86a6a5.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/d/i/dia-chrome-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-dia"
  },
  "Wheels::Rotiform::DTM": {
    "productUrl": "https://www.rotiform.com/rotiform-dtm",
    "description": "R1682085F4+35A - Rotiform R168 DTM - SATIN BLACK - 20\" Diameter - 20X8.5 35MM offset - 5X112/5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-dtm-a32a7169-shop-f424b8.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/d/t/dtm-r170-19x8-5-et45-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-dtm"
  },
  "Wheels::Rotiform::FLG": {
    "productUrl": "https://www.rotiform.com/rotiform-flg",
    "description": "R133198533+45 - Rotiform R133 FLG - GLOSS SILVER - 19\" Diameter - 19X8.5 45MM offset - 5X108 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-flg-ade49493-shop-09b072.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/f/l/flg-r133-19x8-5-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-flg"
  },
  "Wheels::Rotiform::KPS": {
    "productUrl": "https://www.rotiform.com/rotiform-kps",
    "description": "R139189579+35 - Rotiform R139 KPS - MATTE BLACK - 18\" Diameter - 18X9.5 35MM offset - 5X100 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-kps-3eef8d9a-shop-d3ce91.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/k/p/kps-r138-19x10-matte-blk-face-gloss-blk-windows-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-kps"
  },
  "Wheels::Rotiform::LAS-R": {
    "productUrl": "https://www.rotiform.com/rotiform-las-r",
    "description": "R143189525+35 - Rotiform R143 LAS-R - GLOSS SILVER - 18\" Diameter - 18X9.5 35MM offset - 5X112/5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-las-r-902b0e59-shop-0e7acb.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/l/a/las-r-r143-19x8-5-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-las-r"
  },
  "Wheels::Rotiform::LHR-M": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-lhr-m",
    "description": "rc-lhr-m-brushedwpolish - Rotiform LHR-M - Brushed w/ Polish - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-lhr-m-14a40013-shop-c8a0f2.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/l/h/lhr-m-brushed-w-polish-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-lhr-m"
  },
  "Wheels::Rotiform::MUC": {
    "productUrl": "https://www.rotiform.com/products/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-rotiform-muc-4b2ef9a9-shop-ea4eed.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/o/rotiform-aerodisc-white_a1-min.png?quality=80&fit=bounds&height=&width="
  },
  "Wheels::Rotiform::NUE": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-nue",
    "description": "rc-nue-candyblue - Rotiform NUE - Candy Blue w/Polished Lip - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-nue-a7977ab2-shop-510d61.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/n/u/nue-19x11-gloss-blk-w-polished-lip-a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-nue"
  },
  "Wheels::Rotiform::OZT": {
    "productUrl": "https://www.rotiform.com/rotiform-customspec-ozt",
    "description": "rc-ozt-brushedmatteddt - Rotiform OZT - Brushed Matte DDT - 16 to 24-inch Diameter - Custom offset - Custom Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-ozt-de5c3010-shop-5546e2.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/o/z/ozt-candy-black_a1.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-customspec-ozt"
  },
  "Wheels::Rotiform::RSE": {
    "productUrl": "https://www.rotiform.com/rotiform-rse",
    "description": "R140198502+45 - Rotiform R140 RSE - GLOSS SILVER - 19\" Diameter - 19X8.5 45MM offset - 5X108/5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-rse-987d93a0-shop-63f1c0.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/r/s/rse-r140-19x10-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-rse"
  },
  "Wheels::Rotiform::SGN": {
    "productUrl": "https://www.rotiform.com/rotiform-sgn",
    "description": "R190198565+35 - Rotiform R190 SGN - MATTE BLACK - 19\" Diameter - 19X8.5 35MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-sgn-9b075189-shop-f9a293.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/s/g/sgn-r190-20x9-5lug-et20-matte-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-sgn"
  },
  "Wheels::Rotiform::SIX": {
    "productUrl": "https://www.rotiform.com/rotiform-six",
    "description": "R1131985F3+35 - Rotiform R113 SIX - MATTE BLACK - 19\" Diameter - 19X8.5 35MM offset - 5X100/5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-six-4e573372-shop-f21d24.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/s/i/six-r113-18x8-5-matte-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-six"
  },
  "Wheels::Rotiform::STL": {
    "productUrl": "https://www.rotiform.com/rotiform-stl",
    "description": "R19120908957 - Rotiform R191 STL - GLOSS BLACK - 20\" Diameter - 20X9 18MM offset - 6X135 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-stl-5a9f36af-shop-c88fc5.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/s/t/stl-r191-18x9-5lug-et25-gloss-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-stl"
  },
  "Wheels::Rotiform::TUF-R": {
    "productUrl": "https://www.rotiform.com/rotiform-tuf-r",
    "description": "R188200542+45 - Rotiform R188 TUF-R - SATIN SILVER - 20\" Diameter - 20X10.5 45MM offset - 5X112/5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rotiform wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-rotiform-tuf-r-42ff41c0-shop-76cd4c.webp",
    "imageSourceUrl": "https://www.rotiform.com/media/catalog/product/t/u/tuf-r-r188-19x8-5-5lug-et45-satin-silver-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.rotiform.com/rotiform-tuf-r"
  },
  "Wheels::Speedy::Alpha": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-alpha-bronzeblack-lip",
    "description": "If you're on the hunt for a good looking wheel, check out the ALPHA by Speedy Wheels in a great BRONZE/BLACK LIP finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-alpha-46ed309a-shop-2b8c5a-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11378-1763011222-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-alpha-bronzeblack-lip"
  },
  "Wheels::Speedy::Assault": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-assault-piano-blackmachined",
    "description": "If you're on the hunt for a good looking wheel, check out the ASSAULT by Speedy Wheels in a great PIANO BLACK/MACHINED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-assault-b1356cbc-shop-4b93cf-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/1d9a46f4-d974-4d10-b0b7-fb5dcbf93179.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-assault-piano-blackmachined"
  },
  "Wheels::Speedy::Axe": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-axe-matte-blackpewter",
    "description": "If you're on the hunt for a good looking wheel, check out the AXE by Speedy Wheels in a great MATTE BLACK/PEWTER finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-axe-370844db-shop-6482dd-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11379-1763011369-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-axe-matte-blackpewter"
  },
  "Wheels::Speedy::Beast": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-beast-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the BEAST by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-beast-d7899c65-shop-edf0b9-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/f0ec1770-54a7-4cce-a70c-b6d9da7f391a.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-beast-satin-black"
  },
  "Wheels::Speedy::Bedrock": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-bedrock-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the BEDROCK by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-bedrock-4b19427f-shop-100e0b-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/30599a1e-74cd-4a4d-a1b9-121abcc787d5.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-bedrock-satin-black"
  },
  "Wheels::Speedy::Bronco": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-bronco-satin-blackpewter",
    "description": "If you're on the hunt for a good looking wheel, check out the BRONCO by Speedy Wheels in a great SATIN BLACK/PEWTER finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-bronco-ca8fbeab-shop-0439c3.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/84184d97-4a62-4d8e-b41c-462936287d85.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-bronco-satin-blackpewter"
  },
  "Wheels::Speedy::Chaos": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-chaos-black-shadow",
    "description": "If you're on the hunt for a good looking wheel, check out the CHAOS by Speedy Wheels in a great BLACK SHADOW finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-chaos-3041805a-shop-8d8cd8-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11369-1763011407-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-chaos-black-shadow"
  },
  "Wheels::Speedy::Cobra": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-cobra-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the COBRA by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-cobra-9349dc84-shop-47c991.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/7866f009-4223-4cbf-86b7-804bf44d2427.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-cobra-satin-black"
  },
  "Wheels::Speedy::Combat": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-combat-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the COMBAT by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-combat-0a9243f3-shop-1f2264-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/2b3e3cae-f73e-4e9b-94af-695d493581fa.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-combat-satin-black"
  },
  "Wheels::Speedy::Dart": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-dart-satin-blackbronze",
    "description": "If you're on the hunt for a good looking wheel, check out the DART by Speedy Wheels in a great SATIN BLACK/BRONZE finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-dart-112d84ba-shop-b0919f-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/2c0ca429-d3b6-48bd-85af-1b603ae20db0.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-dart-satin-blackbronze"
  },
  "Wheels::Speedy::Drifter": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-drifter-bronzeblack-lip",
    "description": "If you're on the hunt for a good looking wheel, check out the DRIFTER by Speedy Wheels in a great BRONZE/BLACK LIP finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-drifter-cea9a379-shop-f0c53f-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11372-1763011457-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-drifter-bronzeblack-lip"
  },
  "Wheels::Speedy::Grande 2": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-grande-2-machinedgloss-black",
    "description": "If you're on the hunt for a good looking wheel, check out the GRANDE 2 by Speedy Wheels in a great MACHINED/GLOSS BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-grande-2-51624b66-shop-2c609d-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/d530a82a-fb25-4600-a70f-5e43a1a8d87a.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-grande-2-machinedgloss-black"
  },
  "Wheels::Speedy::Havoc": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-havoc-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the HAVOC by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-havoc-b669e775-shop-f7d4cb.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/e2a53519-9610-479e-9ee7-43849bfe1525.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-havoc-satin-black"
  },
  "Wheels::Speedy::Hotwire": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-hotwire-matte-blackbronze",
    "description": "If you're on the hunt for a good looking wheel, check out the HOTWIRE by Speedy Wheels in a great MATTE BLACK/BRONZE finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-hotwire-b47bbc89-shop-d71b48-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11375-1763011578-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-hotwire-matte-blackbronze"
  },
  "Wheels::Speedy::Interceptor": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-interceptor-gunmetalmachine-face",
    "description": "If you're on the hunt for a good looking wheel, check out the INTERCEPTOR by Speedy Wheels in a great GUNMETAL/MACHINE FACE finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-interceptor-965a6226-shop-f392c5-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/7e3a781e-4423-41db-a80c-e7d64090c3b6.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-interceptor-gunmetalmachine-face"
  },
  "Wheels::Speedy::Matterhorn": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-matterhorn-satin-blackmachined-rivets",
    "description": "If you're on the hunt for a good looking wheel, check out the MATTERHORN by Speedy Wheels in a great SATIN BLACK/MACHINED RIVETS finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-matterhorn-144ce0cd-shop-4d380d.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/6cdfc652-7f11-439e-ac84-2da8734787cf.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-matterhorn-satin-blackmachined-rivets"
  },
  "Wheels::Speedy::Outlaw": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-outlaw-machinedpiano-black",
    "description": "If you're on the hunt for a good looking wheel, check out the OUTLAW by Speedy Wheels in a great MACHINED/PIANO BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-outlaw-f9b28013-shop-0c2497-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/857ba072-94c5-4336-a812-f0d61bd32f3b.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-outlaw-machinedpiano-black"
  },
  "Wheels::Speedy::Rhino": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-rhino-piano-blackblack-milled",
    "description": "If you're on the hunt for a good looking wheel, check out the RHINO by Speedy Wheels in a great PIANO BLACK/BLACK MILLED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-rhino-473d522d-shop-3ecd8b-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/4b2dc6f4-0766-4053-ae8e-127d767bdd20.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-rhino-piano-blackblack-milled"
  },
  "Wheels::Speedy::Sandstorm": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-sandstorm-gloss-blackmachined",
    "description": "If you're on the hunt for a good looking wheel, check out the SANDSTORM by Speedy Wheels in a great GLOSS BLACK/MACHINED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-sandstorm-9ff5ab5f-shop-b82292-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/3a9f627b-f1a3-45af-9ade-60184ab5003c.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-sandstorm-gloss-blackmachined"
  },
  "Wheels::Speedy::Savage": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-savage-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the SAVAGE by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-savage-5a7aa80d-shop-cc7189-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/93fd060e-c64b-45c9-b6d5-51c21ab3924d.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-savage-satin-black"
  },
  "Wheels::Speedy::Territory": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-territory-machinedgloss-black",
    "description": "If you're on the hunt for a good looking wheel, check out the TERRITORY by Speedy Wheels in a great MACHINED/GLOSS BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-territory-5cce6255-shop-a8fd5c-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/8708b348-96cd-4df9-981d-5e6fda6be827.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-territory-machinedgloss-black"
  },
  "Wheels::Speedy::Wasteland": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-wasteland-satin-blackbronze",
    "description": "If you're on the hunt for a good looking wheel, check out the WASTELAND by Speedy Wheels in a great SATIN BLACK/BRONZE finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-wasteland-f888e2a3-shop-c147e1-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/8cb6afa4-787b-40c5-ae6d-794e6c9b9c07.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-wasteland-satin-blackbronze"
  },
  "Wheels::Speedy::Allure": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-allure-piano-blackyellow-accents",
    "description": "If you're on the hunt for a good looking wheel, check out the ALLURE by Speedy Wheels in a great PIANO BLACK/YELLOW ACCENTS finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-allure-5fc2eeec-shop-11d788.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/fa5f9637-73de-4770-b5d7-91b2974318d0.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-allure-piano-blackyellow-accents"
  },
  "Wheels::Speedy::Badger": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-badger-piano-blackmachined",
    "description": "If you're on the hunt for a good looking wheel, check out the BADGER by Speedy Wheels in a great PIANO BLACK/MACHINED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-badger-1999a2ff-shop-f9d270-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/6df3e616-0dfb-45bf-bc01-c1a13fe42b4f.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-badger-piano-blackmachined"
  },
  "Wheels::Speedy::Carbine": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-carbine-black-suede",
    "description": "If you're on the hunt for a good looking wheel, check out the CARBINE by Speedy Wheels in a great BLACK SUEDE finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-carbine-e9780ac4-shop-9fc24b-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/64247694-8fb9-40f9-9b20-8945c663fba4.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-carbine-black-suede"
  },
  "Wheels::Speedy::Cheetah": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-cheetah-black-suede",
    "description": "If you're on the hunt for a good looking wheel, check out the CHEETAH by Speedy Wheels in a great BLACK SUEDE finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-cheetah-3b3ae2cc-shop-9d76bf-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/9136b87d-53ea-470c-b907-9121c3f433e3.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-cheetah-black-suede"
  },
  "Wheels::Speedy::Cobalt RS": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-cobalt-rs-machined-silver",
    "description": "If you're on the hunt for a good looking wheel, check out the COBALT RS by Speedy Wheels in a great MACHINED SILVER finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-cobalt-rs-b50d29b6-shop-e2087d.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/343caa8d-aed1-46e3-9b38-db4153e40af7.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-cobalt-rs-machined-silver"
  },
  "Wheels::Speedy::Deceit": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-deceit-piano-blackblack-shadow",
    "description": "If you're on the hunt for a good looking wheel, check out the DECEIT by Speedy Wheels in a great PIANO BLACK/BLACK SHADOW finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-deceit-3dc428dd-shop-f7131b-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/e6c57610-294c-4778-b3bc-04b430fa9d67.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-deceit-piano-blackblack-shadow"
  },
  "Wheels::Speedy::Hammer": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-hammer-gold",
    "description": "If you're on the hunt for a good looking wheel, check out the HAMMER by Speedy Wheels in a great GOLD finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-hammer-ab556dc9-shop-c0398e-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/164cad39-ec70-4dc9-9433-ed5f99a1a385.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-hammer-gold"
  },
  "Wheels::Speedy::Hotshot": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-hotshot-piano-blackblack-shadow",
    "description": "If you're on the hunt for a good looking wheel, check out the HOTSHOT by Speedy Wheels in a great PIANO BLACK/BLACK SHADOW finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-hotshot-3ceefd0b-shop-d74b24-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/36af89fd-7b2c-4334-88d0-1436386d986a.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-hotshot-piano-blackblack-shadow"
  },
  "Wheels::Speedy::Impala": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-impala-gloss-blackmachined-lip",
    "description": "If you're on the hunt for a good looking wheel, check out the IMPALA by Speedy Wheels in a great GLOSS BLACK/MACHINED LIP finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-impala-374e8121-shop-f6c18a-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/4f09f260-a01a-4223-a921-5e2708eb98b1.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-impala-gloss-blackmachined-lip"
  },
  "Wheels::Speedy::Liberator": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-liberator-machinedgloss-black",
    "description": "If you're on the hunt for a good looking wheel, check out the LIBERATOR by Speedy Wheels in a great MACHINED/GLOSS BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-liberator-661ee45b-shop-b7b598-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/6507b696-0ac6-4c4e-bbe9-a534de6642db.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-liberator-machinedgloss-black"
  },
  "Wheels::Speedy::Monaco": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-monaco-gloss-black",
    "description": "If you're on the hunt for a good looking wheel, check out the MONACO by Speedy Wheels in a great GLOSS BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-monaco-f3adf0b8-shop-cdb7af-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11381-1763011623-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-monaco-gloss-black"
  },
  "Wheels::Speedy::Panther": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-panther-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the PANTHER by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-panther-62ea525e-shop-2a2bbc.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11384-1763944497-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-panther-satin-black"
  },
  "Wheels::Speedy::Podium": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-podium-piano-blackmachined",
    "description": "If you're on the hunt for a good looking wheel, check out the PODIUM by Speedy Wheels in a great PIANO BLACK/MACHINED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-podium-3b8982d0-shop-5bee59-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/a22380c4-57d7-48e7-9b9e-fcb7183c8338.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-podium-piano-blackmachined"
  },
  "Wheels::Speedy::Redback": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-redback-piano-blackgold-undercut",
    "description": "If you're on the hunt for a good looking wheel, check out the REDBACK by Speedy Wheels in a great PIANO BLACK/GOLD UNDERCUT finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-redback-cad4ebc3-shop-b602dd-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/a675ea9a-bbf3-4083-9331-a1b950805acd.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-redback-piano-blackgold-undercut"
  },
  "Wheels::Speedy::Rewind": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-rewind-piano-blackmilled",
    "description": "If you're on the hunt for a good looking wheel, check out the REWIND by Speedy Wheels in a great PIANO BLACK/MILLED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-rewind-826e67d6-shop-f781a5.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/b9493e0a-08bf-4c92-b1ad-fbed4a4376c2.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-rewind-piano-blackmilled"
  },
  "Wheels::Speedy::Sonic": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-sonic-satin-blackmachined",
    "description": "If you're on the hunt for a good looking wheel, check out the SONIC by Speedy Wheels in a great SATIN BLACK/MACHINED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-sonic-4b8fbd68-shop-f7a08e.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11383-1763011660-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-sonic-satin-blackmachined"
  },
  "Wheels::Speedy::Stinger": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-stinger-hyper-silvermachined-lip",
    "description": "If you're on the hunt for a good looking wheel, check out the STINGER by Speedy Wheels in a great HYPER SILVER/MACHINED LIP finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-stinger-ad1b1be2-shop-6b786a-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/11386-1763944675-wheelhighresangle.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-stinger-hyper-silvermachined-lip"
  },
  "Wheels::Speedy::Track": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-track-black-suedesatin-machined",
    "description": "If you're on the hunt for a good looking wheel, check out the TRACK by Speedy Wheels in a great BLACK SUEDE/SATIN MACHINED finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-track-840b6a44-shop-d25924-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/3f30b648-66e2-4027-859e-ca251e166841.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-track-black-suedesatin-machined"
  },
  "Wheels::Speedy::Desert Rat": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-desert-rat-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the DESERT RAT by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-desert-rat-b8fd6c11-shop-4d318b-hq.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/c5121cdd-1dee-43ff-b4c3-b67e5d243dca.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-desert-rat-satin-black"
  },
  "Wheels::Speedy::Swamp Rat": {
    "productUrl": "https://speedywheels.com.au/wheels/speedy-wheels-swamp-rat-satin-black",
    "description": "If you're on the hunt for a good looking wheel, check out the SWAMP RAT by Speedy Wheels in a great SATIN BLACK finish.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Speedy wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-speedy-swamp-rat-37b7b645-shop-5ad7f8.webp",
    "imageSourceUrl": "https://images.vldata.com.au/wheel-styles/24/4c4a21f6-7ce4-4ac6-ac85-be1934f35c7a.png",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://speedywheels.com.au/wheels/speedy-wheels-swamp-rat-satin-black"
  },
  "Wheels::TSW::Bathurst": {
    "productUrl": "https://www.tsw.com/tsw-bathurst",
    "description": "1985BAT155114G76 - TSW BATHURST - GLOSS GUNMETAL - 19\" Diameter - 19X8.5 15MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-bathurst-152108a9-shop-ef4ef4.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-bathurst-silver-machined-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-bathurst"
  },
  "Wheels::TSW::Canard": {
    "productUrl": "https://www.tsw.com/tsw-canard",
    "description": "The Canard is your guide to practical performance and elevated style for your daily driver. Featuring a Flow Formed construction, the Canard is a seamless upgrade for your luxury sedan and coupe with its lightweight performance and understated attitude. Inspired by traditional TSW form language, we carefully executed the Canard’s design by utilizing a wideset 10-spoke design and concave profile - offering a striking visual additive with an easy-to-clean layout and ample brake ventilation.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-canard-fb71df5d-shop-3a4f3a.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-tw004bd-canard-19x9-5-5-et40-gloss-black-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-canard"
  },
  "Wheels::TSW::Clypse": {
    "productUrl": "https://www.tsw.com/tsw-clypse",
    "description": "1985CLP425112B66 - TSW CLYPSE - GLOSS BLACK - 19\" Diameter - 19X8.5 42MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-clypse-d1aa953d-shop-1e9f4e.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/a/l/alloy-wheels-rims-tsw-clypse-5-lug-titanium-matte-brushed-face-22x11-std-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-clypse"
  },
  "Wheels::TSW::Daytona": {
    "productUrl": "https://www.tsw.com/tsw-daytona",
    "description": "TW001SX19855135 - TSW TW001 DAYTONA - GLOSS SILVER - 19\" Diameter - 19X8.5 35MM offset - 5X100 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-daytona-5509e23f-shop-5915e1.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-tw001bx-daytona-20x10-5-5-et30-gloss-black-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-daytona"
  },
  "Wheels::TSW::Esprit": {
    "productUrl": "https://www.tsw.com/tsw-esprit",
    "description": "The TSW Esprit brings back that early 2000s concept car flair with clean lines, crisp surfacing, and a sleek 5-spoke layout that delivers just the right amount of edge. Each spoke tapers with a subtle gullwing contour and setback webbing, adding depth and character without trying too hard. Available in 18\" and 20\" sizes, the Esprit is built for sedans and coupes that punch above their weight. It blends sharp styling with smooth performance, backed by finish options that elevate any setup.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-esprit-b542102d-shop-048cbe.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-tw007-esprit-20x10-5-5-et-10-hyper-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-esprit"
  },
  "Wheels::TSW::Goodwood": {
    "productUrl": "https://www.tsw.com/tsw-goodwood-2023-infiniti-q50s-115",
    "description": "2023 Infiniti Q50S - TSW GOODWOOD - Silver",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-goodwood-3bed1994-shop-ee1d69.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/tsw-tw005-goodwood-hyper%20silver-20x9-20x10.5-2023%20infiniti%20q50%2016",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-goodwood-2023-infiniti-q50s-115"
  },
  "Wheels::TSW::Imatra": {
    "productUrl": "https://www.tsw.com/tsw-imatra",
    "description": "#html-body [data-pb-style=I2PK4BM]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}The TSW Imatra wheel features a track-inspired split five-spoke design that is accented by a deep recessed lug bowl for maximum brake caliper clearance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-imatra-5013e6de-shop-a0b987.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-imatra-18x9-5-5lug-et25-dark-matte-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-imatra"
  },
  "Wheels::TSW::Imola": {
    "productUrl": "https://www.tsw.com/tsw-imola",
    "description": "The TSW Imola stands out with its bold split 5-spoke design and deep concave profile that gives it a powerful, planted look on the road. Subtle details like sculpted side pockets and recessed lug areas add just enough edge without overcomplicating the design. Built using Flow Formed Technology for added strength and reduced weight, the Imola is available in staggered 19\", 20\", and 22\" sizes, ideal for everything from the BMW 4 Series and Audi A5, to the Lexus IS, Infiniti Q50, Genesis G70, and Kia Stinger GT.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-imola-99d697be-shop-78773a.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-tw006-imola-22x10-5-5-et38-gloss-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-imola"
  },
  "Wheels::TSW::Kemora": {
    "productUrl": "https://www.tsw.com/tsw-kemora",
    "description": "#html-body [data-pb-style=DSVDPSR]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}The TSW Kemora wheel features a motorsport inspired 10-spoke design and concave wheel profile that retains maximum brake caliper clearance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-kemora-3d6af7f7-shop-2feaca.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-kemora-18x10-5-5lug-et25-dark-gloss-blue-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-kemora"
  },
  "Wheels::TSW::Lasarthe": {
    "productUrl": "https://www.tsw.com/tsw-lasarthe",
    "description": "#html-body [data-pb-style=SHV6FXR]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}We build the Lasarthe for drivers aiming to upgrade their vehicle with a classic split-spoke design and lightweight performance. Drawing inspiration from the iconic TSW Nurburgring, the Lasarthe boasts a sleek wide-mesh design while retaining all the performance characteristics of its predecessor.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-lasarthe",
    "localImage": "catalog-wheels-tsw-lasarthe-4260df87-shop-b26982.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-tw002bd-lasarthe-20x10-5-5-et30-gloss-black-machined-a1-png.png"
  },
  "Wheels::TSW::Launch": {
    "productUrl": "https://www.tsw.com/tsw-launch",
    "description": "2085LCH325112B66 - TSW LAUNCH - MATTE BLACK W/ GLOSS BLACK LIP - 20\" Diameter - 20X8.5 32MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-launch-3ecd2bf0-shop-881ba2.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-launch-20x10-5lug-et40-matte-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-launch"
  },
  "Wheels::TSW::Max": {
    "productUrl": "https://www.tsw.com/tsw-max",
    "description": "1895MAX455120S76 - TSW MAX - HYPER SILVER - 18\" Diameter - 18X9.5 45MM offset - 5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-max-2186b7f3-shop-e71ab8.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-max-hyper-silver-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-max"
  },
  "Wheels::TSW::Mechanica": {
    "productUrl": "https://www.tsw.com/tsw-mechanica",
    "description": "1995MEC505112M72 - TSW MECHANICA - MATTE GUNMETAL W/ M-BLACK FACE - 19\" Diameter - 19X9.5 50MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-mechanica-ee12119e-shop-507d00.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/a/l/alloy-wheels-rims-tsw-mechanica-5-lug-rotary-forged-matte-gumetal-mbf-std-org-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-mechanica"
  },
  "Wheels::TSW::Neptune": {
    "productUrl": "https://www.tsw.com/tsw-neptune",
    "description": "1885NPT325112B66 - TSW NEPTUNE - SEMI GLOSS BLACK - 18\" Diameter - 18X8.5 32MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-neptune-42c2ae94-shop-8889c7.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/a/l/alloy-wheels-rims-tsw-neptune-5-lug-rotary-forged-bronze-std-org-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-neptune"
  },
  "Wheels::TSW::Pescara": {
    "productUrl": "https://www.tsw.com/tsw-pescara",
    "description": "1995PCA405114Z76 - TSW PESCARA - BRONZE - 19\" Diameter - 19X9.5 40MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-pescara-450893ba-shop-611e21.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/a/l/alloy-wheels-rims-tsw-pescara-5-lug-gloss-black-20x10-std-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-pescara"
  },
  "Wheels::TSW::Sebring": {
    "productUrl": "https://www.tsw.com/tsw-sebring",
    "description": "2010SEB255112M72 - TSW SEBRING - MATTE BLACK - 20\" Diameter - 20X10 25MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-sebring-da78d431-shop-e8ec07.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/a/l/alloy-wheels-rims-tsw-sebring-5-lug-matte-black-std-org-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-sebring"
  },
  "Wheels::TSW::Sector": {
    "productUrl": "https://www.tsw.com/tsw-sector",
    "description": "2005STR235114B76 - TSW SECTOR - SEMI GLOSS BLACK - 20\" Diameter - 20X10.5 23MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-sector-17b188f9-shop-221d7b.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/s/e/sector-20x10-5lug-et38-battleship-grey-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-sector"
  },
  "Wheels::TSW::Silverstone": {
    "productUrl": "https://www.tsw.com/tsw-silverstone",
    "description": "1780SIL405114B76 - TSW SILVERSTONE - GLOSS BLACK W/ MIRROR CUT LIP - 17\" Diameter - 17X8 40MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-silverstone-f7907b9d-shop-810922.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/a/l/alloy-wheels-rims-tsw-silverstone-5-lugs-black-std-org-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-silverstone"
  },
  "Wheels::TSW::Slipstream": {
    "productUrl": "https://www.tsw.com/tsw-slipstream",
    "description": "Sculpted to stand apart, the TW008 Slipstream brings crystalline surfacing and compound-bent geometry to the street. A performance-ready aero lip helps direct cooling airflow to the brakes, while machined spoke faces deliver a striking finish in motion or at rest. The Slipstream is manufactured using TSW’s Flow Formed Technology, which reduces weight and enhances strength for improved responsiveness on today’s sedans, crossovers, and performance coupes.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-slipstream-005ff0a2-shop-aa120d.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/t/s/tsw-tw008sd-slipstream-20x10-5-5-et38-gloss-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-slipstream"
  },
  "Wheels::TSW::Snetterton": {
    "productUrl": "https://www.tsw.com/tsw-snetterton",
    "description": "1880SNT355120C76 - TSW SNETTERTON - CHROME - 18\" Diameter - 18X8 35MM offset - 5X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-snetterton-1aabd018-shop-3eb22c.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/s/n/snetterton_chrome_reg_large_white-copy-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-snetterton"
  },
  "Wheels::TSW::Sprint": {
    "productUrl": "https://www.tsw.com/tsw-sprint",
    "description": "2085SPT305114G76 - TSW SPRINT - GLOSS GUNMETAL - 20\" Diameter - 20X8.5 30MM offset - 5X114.3 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "TSW wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-tsw-sprint-848cf632-shop-6b3acc.webp",
    "imageSourceUrl": "https://www.tsw.com/media/catalog/product/a/l/alloy-wheels-rims-tsw-sprint-5-lug-gloss-black-mirror-cut-face-std-org-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.tsw.com/tsw-sprint"
  },
  "Wheels::US Mags::1 Piece Rambler": {
    "productUrl": "https://legacy.us-mags.com/rambler-u110-w-5959.htm",
    "description": "The US Mags Rambler U110 is a chrome one-piece cast wheel with the classic five-spoke Rambler profile. Published variants cover 15, 17, 18, 20 and 22 inch diameters across common five-lug applications.",
    "availableSizes": [
      "15x7",
      "15x8",
      "17x7",
      "17x8",
      "18x7",
      "18x8",
      "18x9.5",
      "20x8",
      "20x8.5",
      "20x9.5",
      "20x10.5",
      "22x9",
      "22x11"
    ],
    "notes": [
      "Vehicle-specific offset, dish and centre profile can vary. Confirm the final variant with 110 Garage."
    ],
    "localImage": "wheel-us-mags-rambler-u110-exact.webp",
    "imageSourceUrl": "https://www.us-mags.com/media/catalog/product/r/a/rambler-u110-18x9-5-chrome-a1-png.png?quality=90&fit=bounds&height=1200&width=1200",
    "specifications": {
      "Construction": "Vintage one-piece cast",
      "Diameters": "15, 17, 18, 20 and 22 inch",
      "Finish": "Chrome plated"
    },
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://legacy.us-mags.com/rambler-u110-w-5959.htm"
  },
  "Wheels::US Mags::1 Piece Indy": {
    "productUrl": "https://legacy.us-mags.com/indy-u101-w-142.htm",
    "description": "The US Mags Indy U101 is a polished one-piece cast wheel with the classic slotted Indy profile. US Mags publishes 15 and 17 inch variants across 5-lug, 6-lug and 8-lug applications.",
    "availableSizes": [
      "15 and 17 inch diameters"
    ],
    "notes": [
      "Vintage one-piece cast construction",
      "High-luster polished finish",
      "Vehicle-specific profile and dish can vary"
    ],
    "localImage": "wheel-us-mags-indy-u101-exact-shop-f341ab-cutout.webp",
    "imageSourceUrl": "https://www.performanceplustire.com/images_temp/500500100US_Mags_Indy_U101_Polished_Angle.jpg",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://legacy.us-mags.com/indy-u101-w-142.htm"
  },
  "Wheels::US Mags::1 Piece Standard": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.us-mags.com/media/catalog/product/s/t/standard-u104-20x9-5-chrome-a1-png.png?quality=80&fit=bounds&height=350&width=350",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::US Mags::1 Piece Bullet": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-us-mags-1-piece-bullet-af1f5d6c-shop-1cf25f-hq.webp",
    "imageSourceUrl": "https://www.us-mags.com/media/catalog/product/b/u/bullet-u131-20x8-chrome-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::US Mags::1 Piece Bandit": {
    "productUrl": "https://legacy.us-mags.com/bandit-u109-w-3303.htm",
    "description": "The US Mags Bandit U109 is a vintage one-piece cast wheel with a matte black machined finish and diamond-cut lip. US Mags publishes 17 and 18 inch variants.",
    "availableSizes": [
      "17 and 18 inch diameters"
    ],
    "notes": [
      "Vintage one-piece cast construction",
      "Matte black machined finish",
      "Vehicle-specific profile and dish can vary"
    ],
    "localImage": "catalog-wheels-us-mags-1-piece-bandit-5d43c89a-shop-812de7-hq.webp",
    "imageSourceUrl": "https://www.us-mags.com/media/catalog/product/b/a/bandit-u109-17x8-matte-black-machined-a1-png.png?quality=90&fit=bounds&height=1200&width=1200",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://legacy.us-mags.com/bandit-u109-w-3303.htm"
  },
  "Wheels::US Mags::1 Piece Desperado": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-us-mags-1-piece-desperado-2631c2f2-shop-4b4082-hq.webp",
    "imageSourceUrl": "https://www.us-mags.com/media/catalog/product/u/-/u-s-mags-u132-desperado-6-24x10-6lug-et25-chrome-l-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::US Mags::1 Piece Rambler U111": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-us-mags-1-piece-rambler-u111-89f71525-01baca-shop-9e2826.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/us%20mags-rambler-u111-chrome%20plated-20x8-20x9.5-1971%20chevrolet%20c10%202:GLP-card?aemtype=new_products_content_widget_grid"
  },
  "Wheels::US Mags::1 Piece Indy U101": {
    "productUrl": "https://legacy.us-mags.com/indy-u101-w-142.htm",
    "description": "The US Mags Indy U101 is a polished one-piece cast wheel with the classic slotted Indy profile. US Mags publishes 15 and 17 inch variants across 5-lug, 6-lug and 8-lug applications.",
    "availableSizes": [
      "15 and 17 inch diameters"
    ],
    "notes": [
      "Vintage one-piece cast construction",
      "High-luster polished finish",
      "Vehicle-specific profile and dish can vary"
    ],
    "localImage": "wheel-us-mags-indy-u101-exact-shop-f341ab-cutout.webp",
    "imageSourceUrl": "https://www.performanceplustire.com/images_temp/500500100US_Mags_Indy_U101_Polished_Angle.jpg",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://legacy.us-mags.com/indy-u101-w-142.htm"
  },
  "Wheels::US Mags::1 Piece Standard U102": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.us-mags.com/media/catalog/product/s/t/standard-u104-20x9-5-chrome-a1-png.png?quality=80&fit=bounds&height=350&width=350",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::US Mags::1 Piece Bullet U104": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.us-mags.com/media/catalog/product/s/t/standard-u104-20x9-5-chrome-a1-png.png?quality=80&fit=bounds&height=350&width=350",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::US Mags::1 Piece Bandit U109": {
    "productUrl": "https://legacy.us-mags.com/bandit-u109-w-3303.htm",
    "description": "The US Mags Bandit U109 is a vintage one-piece cast wheel with a matte black machined finish and diamond-cut lip. US Mags publishes 17 and 18 inch variants.",
    "availableSizes": [
      "17 and 18 inch diameters"
    ],
    "notes": [
      "Vintage one-piece cast construction",
      "Matte black machined finish",
      "Vehicle-specific profile and dish can vary"
    ],
    "localImage": "catalog-wheels-us-mags-1-piece-bandit-u109-5d43c89a-shop-9e14cf-hq.webp",
    "imageSourceUrl": "https://www.us-mags.com/media/catalog/product/b/a/bandit-u109-17x8-matte-black-machined-a1-png.png?quality=90&fit=bounds&height=1200&width=1200",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://legacy.us-mags.com/bandit-u109-w-3303.htm"
  },
  "Wheels::US Mags::Cast Rambler": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::US Mags::Cast Indy": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::US Mags::Cast Bullet": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::US Mags::Cast Bandit": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::US Mags::Cast Desperado": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::US Mags::Forged Detroit": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::US Mags::Forged Bonneville": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::US Mags::Forged Monaco": {
    "productUrl": "https://www.us-mags.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "US Mags wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::KNP": {
    "productUrl": "https://kanseiwheels.com/products/knp-textured-bronze-1",
    "description": "PATENT #D958039 The wheel that started it all: Our KNP is the perfectly balanced 5 s poke wrapped in a classic stepped lip. Each KNP size features a concave face and is big brake calibrated while maintaining strong and lightweight construction. This is truly the wheel built to do it all, from track to street your car will definitely compliment the KNP. * Tuner Style (60 degree conical bolts) are required.* **PRICE IS PER WHEEL & VALVE STEMS ARE NOT INCLUDED.** Sizing and Specs 17\" 18\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-kensei-knp-1018a401-shop-da56a6.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0024/7175/5825/files/kansei-k12b-wheel-5lug-bronze-18x9_1c84e3c1-c49b-4f55-b86c-dbbec84ab7d7.jpg?v=1701801219"
  },
  "Wheels::Kensei::Tandem": {
    "productUrl": "https://kanseiwheels.com/products/tandem-hyper-silver-1",
    "description": "PATENT #D954627 Our homage to the legendary Godzilla: our Tandem wheel is everything we loved about this mysterious wheel from the 90's now build with better options. Ranging from light to deep concave, our Tandem offers maximum brake clearances and a distinct bold soft spoke design. The Tandem wheel can now compliment all chassis looking to adapt a legend to their unique application. * Tuner Style (60 degree conical lug nuts or bolts) are required.* **PRICE IS PER WHEEL & VALVE STEMS ARE NOT INCLUDED.** Sizing and Specs 17\" 18\" 19\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kensei-tandem-6265c44e-shop-90d9d0.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0024/7175/5825/files/KanseiTandem17x9.0_35-5X120-20220512-HyperSilver_4a8669f4-fc01-4afa-aab2-7364bd611f69.png?v=1701709946"
  },
  "Wheels::Kensei::Roku": {
    "productUrl": "https://kanseiwheels.com/products/roku-chrome",
    "description": "PATENT #D973005 The Kansei Roku is our latest addition to our line of stepped lip wheels. Six spokes are surrounded by a deep set lip while still offering tremendous brake clearances and built with our Formlite construction. Initial launch colors of the Roku consist of a new Matte Grey with a Bright Machined Lip as well has real Chrome. This simple six spoke wheel offers classic soft edged classic looks and packs a modern punch with advanced construction. * Tuner Style (60 degree conical nuts or bolts) are required.* Clears all STI and CTR Brembos. Have a brake clearance question? Just ask us! **PRICE IS PER WHEEL & VALVE STEMS ARE NOT INCLUDED.** Sizing and Specs 18\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kensei-roku-d39a1bd3-shop-401d1e.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0024/7175/5825/files/kansei-k14x-wheel-5lug-chrome-18x9-1000.png?v=1697831826"
  },
  "Wheels::Kensei::Astro": {
    "productUrl": "https://kanseiwheels.com/products/astro-chrome",
    "description": "Patent # D1024892 Our ultimate addition to our massively popular ultra concave series! The ASTRO has landed and offers a big split 5 spoke design with massively soft edges and deep features in the lug area. Inspired? Absolutely! We had a blast coming up with a design that would nod to a mix of some of the best styles from the 90's, all in one wheel! The Astro packs big sweeping spoke curves along with the specialized functionality you expect from us at Kansei.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kensei-astro-4ef21a34-shop-8a7b5a.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0024/7175/5825/files/KANSEIASTRO-18X10.5R2-A1.png?v=1757093257"
  },
  "Wheels::Kensei::Corsa": {
    "productUrl": "https://kanseiwheels.com/products/corsa-textured-bronze",
    "description": "PATENT #D960065 Clean and Classic: our light mesh Corsa design provides superior brake clearances and a timeless look. With a classic stepped lip and spokes with soft edges, the Corsa wheel will compliment chassis old and new. * Tuner Style (60 degree conical bolts) are required.* Clears all STI and CTR Brembos. Have a brake clearance question? Just ask us! **PRICE IS PER WHEEL & VALVE STEMS ARE NOT INCLUDED.** Sizing and Specs 18\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-kensei-corsa-c943779e-shop-7bc644.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0024/7175/5825/products/kansei-k13-wheel-5lug-bronze-18x9.jpg?v=1571948220"
  },
  "Wheels::Kensei::Neo": {
    "productUrl": "https://kanseiwheels.com/products/neo-chrome-copy",
    "description": "Patent #D1031589 Brand new from Kansei is our latest debut featuring a bold and flared split 6 spoke Neo! Heavy in style as well as stout in performance we are proud to offer our 5th new wheel design to our line up. This audacious full faced design brings another massively concave wheel to Kansei's Formlite line up! The Neo is a robust design that incorporates all of the features Kansei is known for when producing tried and true drift wheel. With its Formlite (Flow Formed) barrel construction, pocketed mounting pad, reinforced inner lip, and massive caliper clearances the Neo is ready to thrash as well as clean up for the street!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kensei-neo-32a77a38-shop-7867ea.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0024/7175/5825/products/KanseiK16NEO18x9.0_355x120-20220430-Chrome.png?v=1667253782"
  },
  "Wheels::Kensei::Kegari": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::Kaze": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::Shogun": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::Tandem Aero": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::Roku Beadlock": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::KNP Classic": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::Astro Directional": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Kensei::Corsa Lite": {
    "productUrl": "https://kanseiwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Kensei wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Bronx": {
    "productUrl": "https://csawheels.com.au/wheels/bronx/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Brooklyn": {
    "productUrl": "https://csawheels.com.au/wheels/brooklyn/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Cheetah": {
    "productUrl": "https://csawheels.com.au/wheels/cheetah/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Commando": {
    "productUrl": "https://csawheels.com.au/wheels/commando/",
    "description": "Commando is a bold 6-spoke wheel, featuring a simple design, with strong lines & a subtle curve across the face of the spoke. The wide spokes create a stand-out, tough appearance. The circumference of the wheel is highlighted by twin chrome rivets. Completing the look of the wheel is a satin black cap with chrome",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-commando-440121d9-shop-1dacd9.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/08/mini_COMMANDO-HEADER-gvmONLY.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/commando/"
  },
  "Wheels::CSA Wheels::Corsair": {
    "productUrl": "https://csawheels.com.au/wheels/corsair/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Demon": {
    "productUrl": "https://csawheels.com.au/wheels/demon/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Drift": {
    "productUrl": "https://csawheels.com.au/wheels/drift/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Hawk": {
    "productUrl": "https://csawheels.com.au/wheels/hawk/",
    "description": "The CSA Hawk features a bold, open, seven-spoke design, with a deep swept face and a gloss black finish. Hawk’s timeless, fuss-free aesthetic, mashes off-road toughness, with slick street design cues, making it equally appealing to owners of serious off-roaders and those not-so-serious, but just as cool, mall crawlers. Hawk is protected by a high-tech",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/hawk/",
    "localImage": "catalog-wheels-csa-wheels-hawk-26924e0b-1c41be-shop-6c04f7.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/04/mini_HAWK-HEADER-FULL-PC.jpg"
  },
  "Wheels::CSA Wheels::Hurricane": {
    "productUrl": "https://csawheels.com.au/wheels/hurricane/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Jackal": {
    "productUrl": "https://csawheels.com.au/wheels/jackal/",
    "description": "Jackal is an aggressive, tough-looking alloy wheel suitable for a huge range of 5-stud and 6-stud 4x4's & SUVs. Jackal has a brilliant Gloss Black finish with large machined spokes and a huge, deep lip with rim edge highlights. Jackal is available in 16\" & 17\" sizes with a brilliant machine finish. In 6/114.3 bolt pattern,",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-jackal-3ff0bdad-shop-613171.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/08/mini_JACKAL-HEADER-PC.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/jackal/"
  },
  "Wheels::CSA Wheels::Krawler": {
    "productUrl": "https://csawheels.com.au/wheels/krawler/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Mako": {
    "productUrl": "https://csawheels.com.au/wheels/mako/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Maverick": {
    "productUrl": "https://csawheels.com.au/wheels/maverick/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Militant": {
    "productUrl": "https://csawheels.com.au/wheels/militant/",
    "description": "Militant is a member of the CSA-X Pro-Series alloy wheel range, and that means it’s built tough enough to be covered by a lifetime structural warranty. Militant is a wheel designed for Australia’s harsh environments. Militant’s bold six dual spoke design, with its beadlock style deep rim lip with chrome bolt heads, makes a stylish,",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-militant-e2178e69-shop-7ec67d.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/04/mini_MILITANT-HEADER-PC-1.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/militant/"
  },
  "Wheels::CSA Wheels::Monster": {
    "productUrl": "https://csawheels.com.au/wheels/monster/",
    "description": "Monster is a brilliant, super tough-looking 4x4 wheel, perfectly suited to the Australian market. Monster is finished in brilliant gloss black with machined spoke highlights, machined rim edge highlights, and a huge deep lip. Given the huge success of the CSA Monster wheel in 16\" sizes, we expanded the range to include the 17x8\" wheel",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-monster-0349658a-shop-695c45.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/08/mini_MONSTER-HEADER-PC.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/monster/"
  },
  "Wheels::CSA Wheels::Mullins Trailer": {
    "productUrl": "https://csawheels.com.au/wheels/mullins-trailer/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Outlaw": {
    "productUrl": "https://csawheels.com.au/wheels/outlaw/",
    "description": "Outlaw is an aggressive, tough-looking 4x4 & SUV wheel in a traditional 5-spoke configuration. The five spokes are wide and strong and have sculptured features. The front face has an attractive, deep dish and is very easy to clean. Outlaw is finished in a hardy satin black paint finish, able to withstand the most",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-outlaw-dfc6e793-shop-237d4c.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/08/OUTLAW-HEADER-030924.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/outlaw/"
  },
  "Wheels::CSA Wheels::Predator": {
    "productUrl": "https://csawheels.com.au/wheels/predator/",
    "description": "If Predator looks familiar, you’re right. It’s an amped up evolution of CSA’s ever popular Raptor alloy wheel design, with specs to suit the serious off-road enthusiast. Predator is a member of the CSA-X Pro-Series alloy wheel range, and that means it’s built tough enough to be covered by a lifetime structural warranty. Predator",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-predator-40aa813f-shop-0b192d.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2023/06/PREDATOR-HEADER.webp",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/predator/"
  },
  "Wheels::CSA Wheels::Raptor": {
    "productUrl": "https://csawheels.com.au/wheels/raptor/",
    "description": "The perennially popular CSA Raptor features eight split spokes and the kind of timeless styling that has made it a favourite with Aussie motorists for many years. Raptor features a high-tech satin black baked enamel finish, that is highly resistant to salt spray and colour etching, making it the ideal wheel for off-road and commercial",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-raptor-45b6f1e0-shop-52f468.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/04/mini_RAPTOR-HEADER-FULL-PC.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/raptor/"
  },
  "Wheels::CSA Wheels::Rebel": {
    "productUrl": "https://csawheels.com.au/wheels/rebel/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Renegade": {
    "productUrl": "https://csawheels.com.au/wheels/renegade/",
    "description": "The CSA Renegade features seven split-spokes, machined rivets in the rim, chrome wheel nuts and a chunky centre cap. It’s been built to last and is capable of handling everything from hardcore off-road adventures to outback touring, and the rough and tumble of the local work site. Wash the mud off at the end of",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-renegade-3b45870d-shop-ddfdf7.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/04/mini_RENEGADEHEADER-PC.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/renegade/"
  },
  "Wheels::CSA Wheels::Ridgeline": {
    "productUrl": "https://csawheels.com.au/wheels/ridgeline/",
    "description": "New to CSA’s 4×4 wheel range, the Ridgeline’s combination of style, strength and durability has been an instant hit with 4WDers. The CSA Ridgeline is a super clean eleven-spoke design, with a deep swept face. An instant classic, with a timeless, fuss-free aesthetic, the CSA Ridgeline is the type of wheel that transforms the look",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/ridgeline/",
    "localImage": "catalog-wheels-csa-wheels-ridgeline-23fb8387-d38a74-shop-27a99c.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/07/Ridgeline-Machined-Suzuki-Jimny-New-Release-Header.jpg"
  },
  "Wheels::CSA Wheels::Savanna": {
    "productUrl": "https://csawheels.com.au/wheels/savanna/",
    "description": "Savanna is a bold 10-spoke design, featuring long spokes that extend to the rim edge. Savanna is finished in a Gunmetal Black with machined face spokes and is perfectly suited to the modern vehicle market. Savanna is available in 15x6\", 16x6.5\", 17x7\" and 18x8\" sizes. Savanna suits most late model front wheel drive applications, plus",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-csa-wheels-savanna-b1911975-shop-421bcb.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2024/09/SAVANNA-HEADER.jpg",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://csawheels.com.au/wheels/savanna/"
  },
  "Wheels::CSA Wheels::Scorpion": {
    "productUrl": "https://csawheels.com.au/wheels/scorpion/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Stingray": {
    "productUrl": "https://csawheels.com.au/wheels/stingray/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Typhoon": {
    "productUrl": "https://csawheels.com.au/wheels/typhoon/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Viper": {
    "productUrl": "https://csawheels.com.au/wheels/viper/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::CSA Wheels::Wolf": {
    "productUrl": "https://csawheels.com.au/wheels/wolf/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "CSA Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Konig::Hypergram": {
    "productUrl": "https://konigwheels.com/products/konig-hypergram-b",
    "description": "HYPERGRAM AT A GLANCE... Hypergram AT A GLANCE... The Hypergram is a lightweight, 12-spoke design that is motorsport inspired in its construction, appearance and its ability to clear many big brake cars and upgrades! Utilizing Flow Forming Technology allows the Hypergram to be lighter and stronger. With a large range of aggressive sizing the Hypergram is finished in either Matte Grey, Race Bronze, Metallic Carbon with Machined Lip or Matte Black in 15×7.5, 15×8, 15×8.5, 17×8, 17×9, 18×8.5, 18×9.5, 18×10.5B, 18×11B, 18x12B, 19×8.5, 19×9, 19×9.5, and 19x11B sizes.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-hypergram-a5e9876a-shop-14aef9.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Hypergram-1_Bronze_56d57179-f4a9-47e6-83f6-c3b4077157d5.webp?v=1732235631"
  },
  "Wheels::Konig::Dekagram": {
    "productUrl": "https://konigwheels.com/products/konig-dekagram",
    "description": "DEKAGRAM AT A GLANCE... The Dekagram is a lightweight, 10-spoke design that is developed with flow forming technology that offers benefits for both track and street use. Motorsport inspired, the DekagramÕs spoke profile design lends to efficient brake cooling as well as exceptional brake caliper clearance. With widths up to 10.5_ wide, toughening up the stance on many popular vehicles isnÕt a problem. With any wheel Konig develops with Flow Forming Technology, the end result is stronger, lighter and offers greater elongation and shock resistance than a traditional cast design.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-dekagram-fa2d3961-shop-3ac17f.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_FlowFormed_Dekagram_Gloss_Bronze_34_5c028b8f-cc56-4039-b1e6-31bf289852c5.webp?v=1767799271"
  },
  "Wheels::Konig::Ampliform": {
    "productUrl": "https://konigwheels.com/products/konig-ampliform",
    "description": "AMPLIFORM AT A GLANCE... The Ampliform is a mesh inspired, flow formed wheel design. The Ampliform is offered in 17_8_, 17_9_, 18_8.5_, 18_9.5_, 18_10_, 19_8.5_, 19_9.5_, 19_10_, 19_10.5_, 20_8.5_, 20_9.5_, 20_11_ and finished in Gloss Bronze or Dark Metallic Graphite.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-ampliform-9cccf2dd-shop-d2b941.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_FlowFormed_Ampliform_Dark_Metallic_Graphite_34_15271a0f-ae7c-47a9-acc5-5b4e54ca9521.webp?v=1767798954"
  },
  "Wheels::Konig::Hexaform": {
    "productUrl": "https://konigwheels.com/products/konig-hexaform",
    "description": "HEXAFORM AT A GLANCE... The Hexaform is a 6-spoke design built with flow-forming technology. TWO spoke profiles are available (A & B). Shown is A profile. Available in a NEW! Gloss White, Matte Bronze and Matte Black finishes! We've integrated feedback from our motorsport teams, racers and drivers into both of our new designs this year. WeÕve pushed the face out and allowed for as much brake caliper protrusion as well as overall brake diameter near the drop center. This provides excellent caliper clearance for big brake car and aftermarket big brake kits.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-hexaform-a4c0945c-shop-2e167a.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_FlowFormed_Hexaform_Matte_Black_34_2560852c-7c82-4e49-8cfa-7ee3248c6446.webp?v=1769547354"
  },
  "Wheels::Konig::Rennform": {
    "productUrl": "https://konigwheels.com/products/konig-rennform",
    "description": "RENNFORM AT A GLANCE... The Rennform is a precisely crafted 15-spoke wheel constructed with Forming Technology to ensure a lighter and stronger wheel. Finished in either Matte Grey the Rennform is available in 17_8Ó, 18_8Ó, 18_9Ó sizes. The Rennform has fitment for many popular passenger vehicles as well as European tuning vehicles alike.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-rennform-4a728298-shop-ac27dd.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_FlowFormed_Rennform_Matte_Grey_34_6659a995-8b41-4c71-9957-ec33a01b8b56.webp?v=1720640404"
  },
  "Wheels::Konig::Dial-In": {
    "productUrl": "https://konigwheels.com/products/konig-dial-in",
    "description": "DIAL-IN AT A GLANCE... The Dial Ð In is a 12-spoke design developed utilizing the Flow Forming process. The result is KonigÕs lightest and strongest 15_ wheel ever!!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-dial-in-4943e461-shop-5d423f.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_FlowFormed_Dial_In_Matte_Grey_34_15f4188a-60fb-4214-8ab2-cdfc860574cd.webp?v=1769549907"
  },
  "Wheels::Konig::Diverge": {
    "productUrl": "https://konigwheels.com/products/konig-diverge",
    "description": "DIVERGE AT A GLANCE... The Diverge is Konig's latest split 5-spoke design offering to their mainline of wheels. The Diverge provides the perfect combination of timeless design with classic styling. Available in a Gloss Black finish, with sizing in 16_7.5, 17_8, 18_8, 19_8.5, and 20_8.5 sizes. The Diverge is ready to toughen any vehicle's stance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-diverge-86f115f0-shop-301a21.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Diverge_Gloss_Black_34_deb6a59c-28bf-4271-8a2b-edfc501704f3.webp?v=1720640016"
  },
  "Wheels::Konig::Lockout": {
    "productUrl": "https://konigwheels.com/products/konig-lockout",
    "description": "LOCKOUT AT A GLANCE... The Lockout is a tuner inspired, 8-spoke wheel that is able to provide many popular vehicles with a more aggressive stance. The Lockout is offered in 15_7_, 16_7.5_, 17_8._, 18_8.5_, 18_9.5_ and finished in Bronze and Gloss Black with KonigÕs unque dual drill hole pcd.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-lockout-810d5486-shop-21af9f.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Lockout_Bronze_34_41fc895a-3fd0-4e1b-bf1c-cf9c984c959b.webp?v=1720640279"
  },
  "Wheels::Konig::Tandem": {
    "productUrl": "https://konigwheels.com/products/konig-tandem",
    "description": "TANDEM AT A GLANCE... The Tandem is a 6-spoke wheel design built for the avid car enthusiast, but also perfect for the daily driver looking turn heads at all corners. The Tandem is offered in 16_7.5_, 17_8_, 17_9.5._, 18_8_ and finished in Dark Graphite. The 17_9.5 5_114.3 et 15 is a specialty road race & drift fitment.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-tandem-fd215fea-shop-1fbed0.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Tandem_Dark_Graphite_34_b6a95598-57b5-4de2-b7a9-dc7da9abb073.webp?v=1720640429"
  },
  "Wheels::Konig::Myth": {
    "productUrl": "https://konigwheels.com/products/konig-myth",
    "description": "MYTH AT A GLANCE... The Myth is a uniquely styled, split 5-spoke wheel that is able to provide many vehicles with a more aggressive stance. The Myth is offered in 16_7.5_, 17_8_, 18_8._, 19_8.5_ and finished in Gloss Black, Gloss Black With Red Face and Gloss Black with Blue face. ** Colored face wheels (red & blue) are developed with a tinted clear coat. The appearance of tinted colored wheels may appear different than pictured depending on the available light. **",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-myth-9134ebeb-shop-24a803.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Myth_Gloss_Black_34_e383559d-c9f7-485e-8503-0cb8a52c6eaa.webp?v=1740077233"
  },
  "Wheels::Konig::Countergram": {
    "productUrl": "https://konigwheels.com/products/konig-countergram",
    "description": "COUNTERGRAM AT A GLANCE... The COUNTERGRAM is a new 9-spoke design built with flow-forming technology and offered in TWO FACE profiles (A & B). Available in Matte black w/ matte machined lip and Hyper Chrome center w/ mirror machined lip. We’ve integrated feedback from our motorsport teams, racers and drivers into both of our new designs this year. We’ve pushed the face out and allowed for as much brake caliper protrusion as well as overall brake diameter near the drop center. This provides excellent caliper clearance for big brake car and aftermarket big brake kits.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-countergram-33bf47e7-shop-4e3a97.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/countergram-hyp-34.png?v=1769545306"
  },
  "Wheels::Konig::Freeform": {
    "productUrl": "https://konigwheels.com/collections/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Konig::Oversteer": {
    "productUrl": "https://konigwheels.com/products/konig-oversteer",
    "description": "OVERSTEER AT A GLANCE... The Oversteer is a face forward, split 5-spoke design with an aggressive attitude especially in the wider fitments as the wheel face profile increases in its concave look. From the street to the track the Konig Oversteer improves the stance of many 5-Lug Passenger vehicles and offers staggered applications for those looking to run wider rears.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-oversteer-6418f11a-shop-c1d28e.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Oversteer-mach-34.png?v=1768335279"
  },
  "Wheels::Konig::Runlite": {
    "productUrl": "https://konigwheels.com/products/konig-runlite",
    "description": "RUNLITE AT A GLANCE The Konig Runlite is a tuning inspired 10-spoke design that features KonigÕs unique dual lightening hole PCD and is offered in Gold, Matte Grey and Matte Black.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-runlite-ca750b29-shop-beec6d.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Runlite_Matte_Grey_34_4c05aa72-fe7e-42d8-81a7-78bc95b7e4ca.webp?v=1770067699"
  },
  "Wheels::Konig::Ultraform": {
    "productUrl": "https://konigwheels.com/collections/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "http://konigwheels.com/cdn/shop/collections/fm-bronze-180.png?v=1732308948",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Konig::Control": {
    "productUrl": "https://konigwheels.com/products/konig-control",
    "description": "COUNTERGRAMCONTROL AT A GLANCE... Take Control of your vehicleÕs stance with the Konig Control! The Control features a 10-spoke design and a full range of fitments with diameters starting at 14_ and going up to 18_.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-control-42b278b2-shop-0f63c9.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Control_Matte_Black_34_f13bea52-46cb-4f25-a106-25ae62bcf6d1.webp?v=1770067741"
  },
  "Wheels::Konig::Helium": {
    "productUrl": "https://konigwheels.com/collections/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "http://konigwheels.com/cdn/shop/collections/fm-bronze-180.png?v=1732308948",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Konig::Illusion": {
    "productUrl": "https://konigwheels.com/products/konig-illusion",
    "description": "ILLUSION AT A GLANCE... The Konig Illusion is a tuner inspired 10-spoke design with unique ball cut spoke edges, which are offered in standard machined or with a Red, or Blue tined clear coat. ** Colored accent wheels (red & blue) are developed with a tinted clear coat. The appearance of tinted colored wheels may appear different than pictured depending on the available light. **",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-illusion-fc023fde-shop-2a7625.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Illusion_Gloss_Black_34_5dc4444c-01a6-445b-bac2-061085f63b59.webp?v=1770759320"
  },
  "Wheels::Konig::Incident": {
    "productUrl": "https://konigwheels.com/products/capffc-center-cap-for-incident",
    "description": "Replacement center cap for Konig INCIDENT wheels.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-incident-915c13eb-shop-64c07f.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/IncidentCAPFFC.jpg?v=1755638740"
  },
  "Wheels::Konig::Interflow": {
    "productUrl": "https://konigwheels.com/collections/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "http://konigwheels.com/cdn/shop/collections/fm-bronze-180.png?v=1732308948",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Konig::Mainline": {
    "productUrl": "https://konigwheels.com/collections/mainline",
    "description": "LIGHTER. STRONGER. MOTORSPORT PERFECTED! Konig’s Main line consists of all of the style, quality and dependability that has been leading the aftermarket wheel segment for over 40 years. The Main line includes all of the tuner / sport compact wheels you have come to expect along with many other wheel offerings for ot",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-konig-mainline-6d436493-shop-93e83f.webp",
    "imageSourceUrl": "http://konigwheels.com/cdn/shop/collections/Konig_Mainline_Collection.webp?v=1769538347",
    "descriptionSource": "og:description",
    "descriptionSourceUrl": "https://konigwheels.com/collections/mainline"
  },
  "Wheels::Konig::Reasons": {
    "productUrl": "https://konigwheels.com/collections/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "http://konigwheels.com/cdn/shop/collections/fm-bronze-180.png?v=1732308948",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Konig::Rewind": {
    "productUrl": "https://konigwheels.com/products/konig-rewind",
    "description": "REWIND AT A GLANCE... The Rewind is a classic style wheel with a machined lip. It comes in graphite or silver and has front and rear wheel drive applications. For years this has been a popular choice amount race enthusiast and street enthusiasts alike. With old school fitments you can find the rewind on cars like the BMW E30s, Datsun 240Z, 260Z and 280Z, Triumph TR6s and even the occational vintage mustang. This has also become one of the most popular wheels in NasaÕs Spec-E30 class!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-konig-rewind-81c2e91e-shop-32a038.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0523/9727/7348/files/Konig_MainLine_Rewind_Graphite_34_00c1cb04-d86a-42d2-8c4c-16e7df1cf86b.webp?v=1720640418"
  },
  "Wheels::Konig::Torch": {
    "productUrl": "https://konigwheels.com/collections/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "http://konigwheels.com/cdn/shop/collections/fm-bronze-180.png?v=1732308948",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Konig::Wideopen": {
    "productUrl": "https://konigwheels.com/collections/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Konig wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "http://konigwheels.com/cdn/shop/collections/fm-bronze-180.png?v=1732308948",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Globe::Bathurst": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Sprint": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Rally": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Rallymaster": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Dragway": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Daytona": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Eliminator": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Interceptor": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Classic": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Sportsman": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::GTS": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Monza": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Challenger": {
    "productUrl": "https://www.globewheels.com.au/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Globe::Cruiser": {
    "productUrl": "https://csawheels.com.au/wp-content/uploads/2025/03/CSA-X-Kinetic-Track-correction-wheels-fitted-to-LandCruiser-79-series-on-red-rocky-trail.jpg",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Globe wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-globe-cruiser-9eebfa06-2bac50-shop-0e61da.webp",
    "imageSourceUrl": "https://csawheels.com.au/wp-content/uploads/2025/03/CSA-X-Kinetic-Track-correction-wheels-fitted-to-LandCruiser-79-series-on-red-rocky-trail.jpg"
  },
  "Wheels::Raceline Wheels::Alpha Beadlock": {
    "productUrl": "https://racelinewheels.com/products/a14sb-alpha-beadlock-copy",
    "description": "Patent #D1046745 The new Raceline A14 Alpha beadlock wheel was designed exclusively for the new Can Am Maverick R in 6x139.7, Polaris RZR R in 5x114.3 bolt patterns. Its aggressive 12 scalloped spoke design with its contrasting beadlock ring gives it a true rally inspired race look Constructed out of heavy duty A356 aluminum with a forged 6061 beadlock ring with Grade 8 zinc beadlock hardware included Black-Out snap-in Raceline cap with contrasting red Pro Spec beadlock logos Available in Satin Black w/ Gunmetal Beadlock Ring, Gunmetal w/ Gloss Red Beadlock Ring, and Hyper Silver w/ Black Beadlock Ring Available in 15x7, 15x10, and 17x7 Engineered to be one of the strongest wheels available Click to View Raceli",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-alpha-beadlock-739f0155-shop-f80783.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/files/raceline-a14sb-wheel-6lug-hyper-silver-black-ring-15x6-5-1000.png?v=1716231378"
  },
  "Wheels::Raceline Wheels::Alpha": {
    "productUrl": "https://racelinewheels.com/products/cpr-v14b-114-3-raceline-a14v-alpha-cap",
    "description": "RACELINE A14V Alpha Black Cap Bolt patterns - 5X114.3",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-raceline-wheels-alpha-7e03d7f5-shop-68c494.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/files/CPR951-B_41b2638f-a366-4f31-b577-ff4ca35f5246.jpg?v=1765472402"
  },
  "Wheels::Raceline Wheels::Aviator": {
    "productUrl": "https://racelinewheels.com/pages/catalog",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Raceline Wheels::Clutch": {
    "productUrl": "https://racelinewheels.com/products/cs-m8-1x10-ss-934-clutch-cap-screw",
    "description": "934 Clutch Cap Screw 10MM SS",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-raceline-wheels-clutch-09122f8c-shop-893177.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/1_Bolt_f86675a8-8b4a-45f9-9b88-948ffe2090bf.png?v=1606273975"
  },
  "Wheels::Raceline Wheels::Defender": {
    "productUrl": "https://racelinewheels.com/products/copy-of-cpr-935b-4250-raceline-defender-black-cap-4-250-hub",
    "description": "CPR-GOLF-B RACELINE GOLF BLACK CAP 4.250 HUB",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-raceline-wheels-defender-d5bc15ef-shop-150956.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/files/CPR-GOLF-B_A.jpg?v=1704219078"
  },
  "Wheels::Raceline Wheels::Gauge": {
    "productUrl": "https://racelinewheels.com/products/950b-gauge",
    "description": "Patent #D926654 Modern split spoke vibe on old school truck design Flush face concave spoke design with outer lip features adds contrast Black Out snap in cap with contrasting embossed Raceline logo Push thru cap for 8 lug applications Constructed out of heavy duty A356 aluminum Available in Satin Black finish Available in 15\" to 20\" diameters Passes or exceeds all DOT standard load ratings Hub centric fitments available for select vehicles Engineered to meet Raceline’s strict quality and performance standards Includes a Lifetime Structural Warranty (limitations may apply) Sizes 15\" 16\" 17\" 18\" 20\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-gauge-57c77b55-shop-ea7700.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/950B-Gauge-18x9_1.png?v=1586216586"
  },
  "Wheels::Raceline Wheels::Hostage": {
    "productUrl": "https://racelinewheels.com/products/g92m-hostage",
    "description": "• 8 spoke dimpled design with a flush face contour • Constructed out of heavy duty A356 aluminum with a reinforced lip and end milling for a subtle contrast • Engineered to be one of the strongest wheels available • Available in a Satin Black Milled finish • Includes a satin black snap-in cap with embossed chrome Raceline logo • Available in both 12” and 14” diameters for most golf cart fitments",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-hostage-b009f9b1-shop-c1b486.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/G92m-27040_05-wheel-4lug-matte-black-machined-face-12x7-1000.png?v=1606274040"
  },
  "Wheels::Raceline Wheels::Injector": {
    "productUrl": "https://racelinewheels.com/products/931m-injector",
    "description": "20X9 | 6x139.7 | 20 | 931M-29060+20 • Aggressive concave 10 spoke design • Simulated beadlock lip with stainless steel bolts • Bolt on cap with contrasting embossed Raceline logo • Constructed out of heavy duty A356 aluminum • Available in Satin Black, Bronze and Gunmetal finish • Available in 16”, 17” and 20” diameters • Passes or exceeds all DOT standard load ratings • Hub centric fitments available for select vehicles • Includes a Lifetime Structural Warranty (limitations may apply) • The Official Wheel of SCORE International Off-Road Racing Series Sizes 16\" 17\" 18\" 20\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-injector-9f46af96-shop-674fbd.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/931M_Injector.png?v=1585611961"
  },
  "Wheels::Raceline Wheels::Mamba": {
    "productUrl": "https://racelinewheels.com/products/a71b-mamba",
    "description": "Reg. No. 5482836 One of the first Raceline UTV beadlock designs, and taking cues from our Mamba HD for trucks, the Mamba UTV continues as one of our most popular ever Constructed out of heavy duty A356 aluminum with a forged 6061 beadlock ring with US made Grade 8 zinc beadlock hardware included UTV Beadlock Bolts = 1\" length Engineered to be one of the strongest wheels available Available in both Satin Black and Satin Black with machined spoke ridges Includes a satin black snap-in cap with embossed chrome Raceline logo For thicker beaded tires, Raceline beadlock ring spacers are available to ensure proper ring seating.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/A71B_Mamba_14x7_f5b52062-4d0c-4c82-8d61-84b0df0c92bc.png?v=1585611875",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Raceline Wheels::Monster": {
    "productUrl": "https://racelinewheels.com/products/monster-forged-beadlock",
    "description": "The legendary Raceline Monster beadlock is the wheel that started the industry. The most recognizable and successful beadlock wheel that continues to stack up championships and podiums across all off-road racing categories for almost 20 years, is now available as a forged double beadlock combination for your ultra-duty needs! • The first wheel company to produce an industry leading 20” forged double beadlock. • Iconic 8 spoke design with a milled Raceline logo on the spoke that is easily recognizable. • Wheel and beadlock rings are constructed out of industry best forged 6061 aluminum. • Engineered to be one of the strongest wheels available.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-monster-fbfd3c86-shop-ac4840.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/raceline-monster-wheel-8lug-machined-21x11-5-1000.png?v=1606274545"
  },
  "Wheels::Raceline Wheels::Mamba Beadlock": {
    "productUrl": "https://racelinewheels.com/products/a71b-mamba",
    "description": "Reg. No. 5482836 One of the first Raceline UTV beadlock designs, and taking cues from our Mamba HD for trucks, the Mamba UTV continues as one of our most popular ever Constructed out of heavy duty A356 aluminum with a forged 6061 beadlock ring with US made Grade 8 zinc beadlock hardware included UTV Beadlock Bolts = 1\" length Engineered to be one of the strongest wheels available Available in both Satin Black and Satin Black with machined spoke ridges Includes a satin black snap-in cap with embossed chrome Raceline logo For thicker beaded tires, Raceline beadlock ring spacers are available to ensure proper ring seating.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/A71B_Mamba_14x7_f5b52062-4d0c-4c82-8d61-84b0df0c92bc.png?v=1585611875",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Raceline Wheels::Podium": {
    "productUrl": "https://racelinewheels.com/products/a93-podium",
    "description": "Patent #D934769 Iconic 8 spoke mesh style design Constructed out of heavy duty A356 aluminum with a forged 6061 beadlock ring with US made Grade 8 zinc beadlock hardware included UTV Beadlock Bolts = 1\" length Engineered to be one of the strongest wheels available Available in both Satin Black and Stealth Grey finishes Includes a satin black snap-in cap with embossed chrome Raceline logo For thicker beaded tires, Raceline beadlock ring spacers are available to ensure proper ring seating. Available in both 14” and 15” diameters for most UTV bolt patterns * Raceline Beadlock mounting instructions are available to view and print in the second image below.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-podium-13cd70bf-shop-12a3af.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/A93SG_Podium.png?v=1585612080"
  },
  "Wheels::Raceline Wheels::Raptor": {
    "productUrl": "https://racelinewheels.com/pages/catalog",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Raceline Wheels::Shift": {
    "productUrl": "https://racelinewheels.com/products/cpr930-5-c-raceline-930c-shift-chrome-cap-1",
    "description": "Fits 5 Lug Only (17x8/18x8) CAP SCREW PART# CS-M6-1x20-SS",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-raceline-wheels-shift-9d7ebcba-shop-d1b207.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/files/CPR930-5-C_A.jpg?v=1697234462"
  },
  "Wheels::Raceline Wheels::Scout": {
    "productUrl": "https://racelinewheels.com/products/947-scout",
    "description": "Patent # D957303 Rally inspired 8-spoke design with vented barrel feature Black-Out bolt on cap with contrasting embossed Raceline logo Constructed out of heavy duty A356 aluminum Available in Satin Black finish Available in 15” to 20” diameters as well as some CUV fitments Passes or exceeds all DOT standard load ratings Hub centric fitments available for select vehicles Engineered to meet Raceline’s strict quality and performance standards Includes a Lifetime Structural Warranty (limitations may apply) Sizes 15\" 16\" 17\" 18\" 20\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-scout-6d88a1ba-shop-1987b7.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/947b_blackcap.png?v=1588195955"
  },
  "Wheels::Raceline Wheels::Assault": {
    "productUrl": "https://racelinewheels.com/products/991-assault",
    "description": "Contemporary 8 spoke design with smooth deep lip feature Milled lip adds to wheel design contrast Bolt on cap with contrasting embossed Raceline logo Constructed out of heavy duty A356 aluminum Available in both Satin Black and Chrome finish Available in 16” to 20” diameters Passes or exceeds all DOT standard load ratings Hub centric fitments available for select vehicles Engineered to meet Raceline’s strict quality and performance standards Includes a Lifetime Structural Warranty (limitations may apply) Sizes 16\" 17\" 18\" 20\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-assault-f2f2b70d-shop-802051.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/991B_8_Assault.png?v=1585612112"
  },
  "Wheels::Raceline Wheels::Avenger": {
    "productUrl": "https://racelinewheels.com/products/rt260m-avenger-beadlock-sale",
    "description": "*BEADLOCK WHEELS ARE FOR OFF-ROAD USE ONLY & ARE NOT DOT APPROVED FOR HIGHWAY USE **BEADLOCK WHEELS ARE NOT SUGGESTED FOR ANY 3/4 TON AND LARGER VEHICLES WEIGHING OVER 6500 LBS. Following the success of the Monster, is the Avenger Beadlock by Raceline. Another industry leading wheel and one of the first 20” beadlocks ever releases. Raceline, the leader in wheel performance, design and durability! Classic 8 spoke design with a cast in Raceline logo that is easily recognizable Constructed out of heavy duty A356 aluminum with a forged 6061 beadlock ring. Engineered to be one of the strongest wheels available.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-avenger-5d004046-shop-c51b9d.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/raceline-avenger-rt260m-wheel-8lug-machined-20x10-1000-2_ec5b5ca8-527d-4bd5-b698-0eb4c003dcf9.png?v=1665692662"
  },
  "Wheels::Raceline Wheels::Boost": {
    "productUrl": "https://racelinewheels.com/products/946bz-boost",
    "description": "Patent #D943484 Aggressive off-road inspired 6 spoke design Debossed Raceline logo on spoke Simulated beadlock lip with stainless steel bolts Push thru cap with contrasting embossed Raceline logo Constructed out of heavy duty A356 aluminum Available in Satin Black, Bronze and Gunmetal finish Available in 17” to 20” diameters as well some CUV fitments Passes or exceeds all DOT standard load ratings Hub centric fitments available for select vehicles Includes a Lifetime Structural Warranty (limitations may apply) Sizes 17\" 18\" 20\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-boost-19ea9be5-shop-738cd7.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/946BZ_6_Boost.png?v=1585611903"
  },
  "Wheels::Raceline Wheels::Compass": {
    "productUrl": "https://racelinewheels.com/products/956bs-compass",
    "description": "Patent #D1022836 Rugged 8 split-spoke design Offroad inspired vented simulated outer bead ring Constructed out of heavy duty A356 aluminum Engineered to be one of the strongest wheels available Available in Satin Black and Satin Black w/ Silver Ring finishes Black-Out bolt on cap with contrasting embossed Raceline logo Engineered to meet Raceline’s strict quality and performance standards Includes a Lifetime Structural Warranty (limitations may apply) Sizes 17\" 18\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-compass-6f7364c4-shop-c5a7b0.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/956BS-Compass-wheel-6lug-matte-black-beadlock-17x9-1000.png?v=1645824385"
  },
  "Wheels::Raceline Wheels::Combat": {
    "productUrl": "https://racelinewheels.com/pages/catalog",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Raceline Wheels::Mamba HD": {
    "productUrl": "https://racelinewheels.com/products/a71b-mamba",
    "description": "Reg. No. 5482836 One of the first Raceline UTV beadlock designs, and taking cues from our Mamba HD for trucks, the Mamba UTV continues as one of our most popular ever Constructed out of heavy duty A356 aluminum with a forged 6061 beadlock ring with US made Grade 8 zinc beadlock hardware included UTV Beadlock Bolts = 1\" length Engineered to be one of the strongest wheels available Available in both Satin Black and Satin Black with machined spoke ridges Includes a satin black snap-in cap with embossed chrome Raceline logo For thicker beaded tires, Raceline beadlock ring spacers are available to ensure proper ring seating.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/A71B_Mamba_14x7_f5b52062-4d0c-4c82-8d61-84b0df0c92bc.png?v=1585611875",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Raceline Wheels::Outlander": {
    "productUrl": "https://racelinewheels.com/products/944b-outlander",
    "description": "Patent #D906938 Modern mesh design with outer lip treatment to aid in overall weight savings Debossed Raceline logo feature on lip adds contrast Bolt on cap with contrasting embossed Raceline logo Constructed out of heavy duty A356 aluminum Available in Satin Black and Greystone finish Available in 16” to 20” diameters Passes or exceeds all DOT standard load ratings Hub centric fitments available for select vehicles Engineered to meet Raceline’s strict quality and performance standards Includes a Lifetime Structural Warranty (limitations may apply) Sizes 16\" 17\" 18\" 20\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-outlander-f54568f1-shop-9c3bf3.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/944B_6_Outlander.png?v=1585611909"
  },
  "Wheels::Raceline Wheels::Renegade": {
    "productUrl": "https://racelinewheels.com/products/copy-of-891-renegade",
    "description": "Modern 8 split spoke design with a slight concave Scallops on lip with stainless steel bolts add to contrast Bolt on cap with contrasting embossed Raceline logo Constructed out of heavy duty A356 aluminum Available in 16” to 18” diameters Passes or exceeds all DOT standard load ratings Hub centric fitments available for select vehicles Engineered to meet Raceline’s strict quality and performance standards Includes a Lifetime Structural Warranty (limitations may apply) Sizes 16\" 17\" 18\" [/table]",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-renegade-f38a9563-shop-ab4042.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/files/982_6_Raptor_d7f7a4cc-fb8e-4fef-a762-4adfacb300f8.png?v=1705696497"
  },
  "Wheels::Raceline Wheels::Rockcrusher": {
    "productUrl": "https://racelinewheels.com/products/rivet887hxa",
    "description": "Sku: RIVET887HXA Rivet for 887 Rockcrusher (1 Piece Only)",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-raceline-wheels-rockcrusher-dbe39620-shop-5efa0e.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/files/RIVET887HXA-1.jpg?v=1696964374"
  },
  "Wheels::Raceline Wheels::Ryno": {
    "productUrl": "https://racelinewheels.com/products/rt951m-ryno-cast-beadlock-20",
    "description": "*BEADLOCK WHEELS ARE FOR OFF-ROAD USE ONLY & ARE NOT DOT APPROVED FOR HIGHWAY USE **BEADLOCK WHEELS ARE NOT SUGGESTED FOR ANY 3/4 TON AND LARGER VEHICLES WEIGHING OVER 6500 LBS. Patent #D1016704 Following the success of the RT951 Ryno Cast Beadlock, is the long anticipated 20\" version. Another industry leading race wheel, the RT951 Ryno follows its big brother, the Ryno Forged Beadlock, as a leader in wheel performance, design and durability!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-raceline-wheels-ryno-fda72940-shop-161abf.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/files/RT951M-Ryno-6lug-machined-20x8-5-1000.png?v=1743718837"
  },
  "Wheels::Raceline Wheels::Siege": {
    "productUrl": "https://racelinewheels.com/pages/catalog",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Raceline Wheels::Split": {
    "productUrl": "https://racelinewheels.com/products/948c-split",
    "description": "Patent #D936556 Aggressive split spoke design Debossed Raceline logo on lip Bolt on cap with contrasting embossed Raceline logo Constructed out of heavy duty A356 aluminum Available in Gloss Black Milled, Satin Black and Chrome Finish Available in 16” to 20” diameters Passes or exceeds all DOT standard load ratings Hub centric fitments available for select vehicles Engineered to meet Raceline’s strict quality and performance standards Includes a Lifetime Structural Warranty (limitations may apply) Sizes 16\" 17\" 18\" 20\"",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-raceline-wheels-split-24f0cb0f-shop-c39037.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/948c.png?v=1585611819"
  },
  "Wheels::Raceline Wheels::Twist": {
    "productUrl": "https://racelinewheels.com/products/932b-twist",
    "description": "• Cast and heat treated A356 aluminum construction • Passes or exceeds all DOT standard load ratings • Hub centric fitments available for select vehicles • Lifetime Structural Warranty (limitations may apply)",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Raceline Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-raceline-wheels-twist-ae6b4b00-shop-3313b9.webp",
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0261/5397/5888/products/932B_8_Twist2.png?v=1587517206"
  },
  "Wheels::KMC Wheels::E25 Beadlock": {
    "productUrl": "https://www.kmcwheels.com/kmc-e25-beadlock",
    "description": "KM241DX17906001 - KMC KM241 E25 BEADLOCK - MACHINED - 17\" Diameter - 17X9 1MM offset - 6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-e25-beadlock"
  },
  "Wheels::KMC Wheels::Crux": {
    "productUrl": "https://www.kmcwheels.com/kmc-crux",
    "description": "Looking to add some attitude and edge to your ride? The KMC KM556 Crux steps up. Its aggressive 12-spoke design is packed with detail, from terrain-inspired windows to a fully sculpted rock-retainer ring. Offered in a function-driven 17x8.5\" size with 0mm and +25mm offsets, it's ready to bolt onto 5-lug and 6-lug rigs. Whether you're weekend exploring in a Tacoma, hitting gravel in an F-150, or dialing in your Wrangler's street stance, the Crux brings bold style without overthinking it.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-crux-06ddef51-shop-e955a3.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km556-crux-17x8-5-6-et0-gloss-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-crux"
  },
  "Wheels::KMC Wheels::Attack": {
    "productUrl": "https://www.kmcwheels.com/kmc-attack",
    "description": "The KMC Attack KM555 brings off-road attitude with clean, motorsport-inspired styling. Its bold mesh design is backed by details like hex-head hardware, a sculpted cap, and functional debris scuppers with an easy-access valve pass-through. Built in a 17x8.5\" size and offered in -10mm, 0mm, and +25mm offsets, the Attack fits a wide range of 5-lug and 6-lug applications without the need for adapters or guesswork. It’s a solid choice for drivers who want aggressive styling that fits right and holds up to daily use.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-attack-c0fa0b30-shop-3dddb8.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km555-attack-17x8-5-6-et-10-gloss-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-attack"
  },
  "Wheels::KMC Wheels::Impact FFT": {
    "productUrl": "https://www.kmcwheels.com/kmc-impact-fft",
    "description": "The KMC KM733 Impact FFT delivers off-road attitude in a lightweight, flow-formed wheel built to handle the rough stuff. With a multi-spoke layout and ultra-deep lip, it’s all function and all style. Featuring KMC’s Bead Retention System (BRS), the Impact FFT is engineered for off-road control and daily convenience. Machined grooves grip the tire bead to hold firm even at low PSI, delivering trail-ready traction without the need to remount or the hassle of traditional beadlocks.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-impact-fft-368dcf44-shop-4ad59c.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km733-impact-fft-17x8-5-6-et0-gloss-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-impact-fft"
  },
  "Wheels::KMC Wheels::Archer": {
    "productUrl": "https://www.kmcwheels.com/kmc-archer",
    "description": "The KMC KM732 Archer is built for those who'd rather be off-grid than on pavement. Its split six-spoke design pushes into the lip, giving it a deep, layered look that hits hard from every angle. Flow Formed construction keeps weight down and strength up, so you get quicker acceleration, better mileage for extended trail runs, and less strain on your drivetrain when you're deep in the rough stuff.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-archer-109d27e3-shop-287f9f.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km732-archer-17x8-5-6-et0-matte-black-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-archer"
  },
  "Wheels::KMC Wheels::Impact Beadlock": {
    "productUrl": "https://www.kmcwheels.com/kmc-impact-beadlock",
    "description": "When tire pressure drops and the trail gets wild, the KM239 Impact Beadlock is built to keep your rubber locked in and your rig moving. This functional beadlock wheel is made for serious off-road abuse, featuring a tightly spaced multi-spoke face, ultra-deep lip, and cutouts that shed debris fast. Sized at 17x9” with -38mm, -12mm, and +1mm offset options, it’s ready to bolt up to a wide range of 5, 6, and 8-lug applications.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-impact-beadlock-671c11dc-shop-6f1d39.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km239-impact-bl-17x9-6-et-38-machined-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-impact-beadlock"
  },
  "Wheels::KMC Wheels::Torx": {
    "productUrl": "https://www.kmcwheels.com/kmc-torx",
    "description": "The KMC Torx is built for real off-road use, not just for driveway flex. The KM553 boasts a bold split 6-spoke mesh design, with a deep lip and simulated beadlock that gives it a tough, trail-ready look. You’ve got deep lip styling and mid to negative offset fitments, with sizes landing at 17x8.5” and 17x9”, and offset options from -12mm to +25mm. Perfect for crawling, climbing, or bombing through open desert.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-torx-38b5acf3-shop-b81fca.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km553-torx-17x8-5-6-et0-gloss-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-torx"
  },
  "Wheels::KMC Wheels::Aztec": {
    "productUrl": "https://www.kmcwheels.com/kmc-aztec",
    "description": "Take on the streets or trails with the KM554 Aztec. Featuring a rugged simulated beadlock ring and bold design, the KM554 delivers a tough, trail ready aesthetic without compromising street performance. This wheel is available in 17-inch diameter with a 0 offset for an intimidating fitment style for your vehicle. Choose between two stunning finishes, Gloss Silver or Matte Black, to match your style.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-aztec-42fe0063-shop-877478.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km554-aztec-17x8-5-6-et0-gloss-silver-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-aztec"
  },
  "Wheels::KMC Wheels::Bully": {
    "productUrl": "https://www.kmcwheels.com/kmc-bully",
    "description": "KM70878042738 - KMC KM708 BULLY - SATIN BLACK - 17\" Diameter - 17X8 38MM offset - 5X110 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-bully",
    "rejectedImageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km708-17x8-et38-bronze_a1-png.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::KMC Wheels::Bully OL": {
    "productUrl": "https://www.kmcwheels.com/kmc-bully-ol",
    "description": "KM71778563618 - KMC KM717 BULLY OL - MATTE BRONZE - 17\" Diameter - 17X8.5 18MM offset - 6X135 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-bully-ol-aac37ecf-shop-d506e1.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km7177-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-bully-ol"
  },
  "Wheels::KMC Wheels::Canyon": {
    "productUrl": "https://www.kmcwheels.com/kmc-canyon",
    "description": "#html-body [data-pb-style=DBX90QI]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll;border-style:none;border-width:1px;border-radius:0;margin:0 0 10px;padding:10px}#html-body [data-pb-style=NJK3OJE]{border-style:none;border-width:1px;border-radius:0;margin:0;padding:0}The KMC KM719 Canyon wheel is an excellent option for all your off-road motoring needs.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-canyon-934c9df4-shop-46e603.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km719-17x8-et35-6-black-gray_a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-canyon"
  },
  "Wheels::KMC Wheels::Carnage": {
    "productUrl": "https://www.kmcwheels.com/kmc-carnage",
    "description": "#html-body [data-pb-style=KGG7PME]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll;border-style:none;border-width:1px;border-radius:0;margin:0 0 10px;padding:10px}#html-body [data-pb-style=SQ0RCGL]{border-style:none;border-width:1px;border-radius:0;margin:0;padding:0}The KMC KM547 Carnage wheel features a unique, artisanal crafted face made to combat the havoc of the street.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-carnage-04ca0ab9-shop-362a84.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km5476-6lug-17x9-et-12-matte-bronze-w-blk-lip-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-carnage"
  },
  "Wheels::KMC Wheels::Chase": {
    "productUrl": "https://www.kmcwheels.com/kmc-chase",
    "description": "#html-body [data-pb-style=YELP24M]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll;border-style:none;border-width:1px;border-radius:0;margin:0 0 10px;padding:10px}#html-body [data-pb-style=B2YVV7K]{border-style:none;border-width:1px;border-radius:0;margin:0;padding:0}The KMC KM548 Chase wheel is the perfect solution for adding off-road look to your truck or Jeep.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-chase-f77a1a22-shop-d54c04.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km548-6lug-17x9-et-12-matte-bronze-w_-blk-lip-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-chase"
  },
  "Wheels::KMC Wheels::Dirty Harry": {
    "productUrl": "https://www.kmcwheels.com/kmc-dirty-harry",
    "description": "#html-body [data-pb-style=BO6QTV4]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll;border-style:none;border-width:1px;border-radius:0;margin:0 0 10px;padding:10px}#html-body [data-pb-style=RLPQ2UP]{border-style:none;border-width:1px;border-radius:0;margin:0;padding:0}The KMC KM541 Dirty Harry wheel will make your day.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-dirty-harry-a5550cc2-shop-792085.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km541-6-lug-17x8-5-textured-black-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-dirty-harry"
  },
  "Wheels::KMC Wheels::Enduro": {
    "productUrl": "https://www.kmcwheels.com/kmc-enduro",
    "description": "KM52269050712N - KMC KM522 ENDURO - MATTE BLACK - 16\" Diameter - 16X9 -12MM offset - 5X127 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-enduro-18bfa131-shop-22d7e5.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km5227-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-enduro"
  },
  "Wheels::KMC Wheels::Grenade Crawl Beadlock": {
    "productUrl": "https://www.kmcwheels.com/kmc-grenade-crawl-beadlock",
    "description": "KM23578560700 - KMC KM235 GRENADE CRAWL BEADLOCK - SATIN BLACK - 17\" Diameter - 17X8.5 0MM offset - 6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-grenade-crawl-beadlock"
  },
  "Wheels::KMC Wheels::Grenade Desert Beadlock": {
    "productUrl": "https://www.kmcwheels.com/kmc-grenade-desert-beadlock",
    "description": "KM23478580700 - KMC KM234 GRENADE DESERT BEADLOCK - SATIN BLACK - 17\" Diameter - 17X8.5 0MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-grenade-desert-beadlock"
  },
  "Wheels::KMC Wheels::GRS": {
    "productUrl": "https://www.kmcwheels.com/kmc-grs",
    "description": "We build the KM549 GRS for truck and Jeep enthusiasts seeking off-road style with robust strength for the street and trails. Based on our popular KM235 beadlock wheel, the GRS boasts a simulated beadlock ring and classic split-spoke design, offering superb brake ventilation and debris passthrough in any terrain. Whether modifying your trail-built Tacoma or upgrading your F-150, the KM549 GRS delivers iconic KMC style and versatility.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-grs",
    "localImage": "catalog-wheels-kmc-wheels-grs-d450ada4-shop-5b343a.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km5494-17x9-6-et-12-gloss-silver-w-machined-face-a1-png.png"
  },
  "Wheels::KMC Wheels::Hatchet": {
    "productUrl": "https://www.kmcwheels.com/kmc-hatchet",
    "description": "KM730MX17856825 - KMC KM730 HATCHET - MATTE BLACK - 17\" Diameter - 17X8.5 25MM offset - 6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-hatchet-fec63069-shop-74940e.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km730sd-hatchet-17x8-5-6-et-10-gloss-silver-with-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-hatchet"
  },
  "Wheels::KMC Wheels::Impact": {
    "productUrl": "https://www.kmcwheels.com/kmc-impact",
    "description": "KM70688057738 - KMC KM706 IMPACT - SATIN BLACK - 18\" Diameter - 18X8 38MM offset - 5X112 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-impact-d00b5d7a-shop-e05676.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km542-1890-et18-6-black-machined_a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-impact"
  },
  "Wheels::KMC Wheels::Impact Forged Beadlock": {
    "productUrl": "https://www.kmcwheels.com/kmc-impact-forged-beadlock",
    "description": "KM445DX17909125 - KMC KM445 IMPACT FORGED BEADLOCK - RAW MACHINED - 17\" Diameter - 17X9 25MM offset - 6X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-impact-forged-beadlock"
  },
  "Wheels::KMC Wheels::Impact Forged Monoblock": {
    "productUrl": "https://www.kmcwheels.com/kmc-impact-forged-monoblock",
    "description": "KM452DX18908700 - KMC KM452 IMPACT FORGED MONOBLOCK - RAW MACHINED - 18\" Diameter - 18X9 0MM offset - 8X170 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-impact-forged-monoblock-16488569-shop-a4b07a.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km447-impact-forged-17x8-5-6-et-10-raw-machined-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-impact-forged-monoblock"
  },
  "Wheels::KMC Wheels::Impact OL": {
    "productUrl": "https://www.kmcwheels.com/kmc-impact-ol",
    "description": "#html-body [data-pb-style=Y98L6CC]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll;border-style:none;border-width:1px;border-radius:0;margin:0 0 10px;padding:10px}#html-body [data-pb-style=CTIPA70]{border-style:none;border-width:1px;border-radius:0;margin:0;padding:0}Make a statement with the KMC KM724 Impact OL wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-kmc-wheels-impact-ol-9531fbb7-shop-f97bfc.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km724-17x9-et0-6-bronze_a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-impact-ol"
  },
  "Wheels::KMC Wheels::IMS": {
    "productUrl": "https://www.kmcwheels.com/kmc-ims-2021-toyota-4runner-99",
    "description": "Wheels I Cast I Forged I Flow Formed I UTV I All Wheels I Home Vehicle Gallery 2021 Toyota 4Runner Be the first to review this product Find a Dealer Add to Wish List Locate Your Nearest Installer Covered By Wheel Pros Limited Warranty To the fullest extent recognized by the laws of the state where the wheel was purchased, KMC Wheels issues this limited warranty to define the rights of the purchaser, and limit KMC Wheels liability, with regard to warranty claims.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.kmcwheels.com/kmc-ims-2021-toyota-4runner-99",
    "localImage": "catalog-wheels-kmc-wheels-ims-461f3ae9-06527c-shop-cad456.webp",
    "imageSourceUrl": "https://s7d9.scene7.com/is/image/wheelpros/kmc-km552-ims-matte%20black%20black%20lip-17x8.5-2021%20toyota%204runner%204"
  },
  "Wheels::KMC Wheels::KM535 Grenade OR": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km708-17x8-et38-bronze_a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::KMC Wheels::KM540 Recon": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km708-17x8-et38-bronze_a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::KMC Wheels::KM544 Mesa": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km708-17x8-et38-bronze_a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::KMC Wheels::KM545 Trek": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km708-17x8-et38-bronze_a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::KMC Wheels::KM546 Timer": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km708-17x8-et38-bronze_a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::KMC Wheels::KM549 GRS": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-kmc-wheels-km549-grs-1ca77fb3-shop-5518c3-hq.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km5494-17x9-6-et-12-gloss-silver-w-machined-face-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::KMC Wheels::KM550 Riot": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/km708-17x8-et38-bronze_a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::KMC Wheels::KM552 IMS": {
    "productUrl": "https://www.kmcwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "KMC Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-kmc-wheels-km552-ims-1b074138-shop-f0e23d-hq.webp",
    "imageSourceUrl": "https://www.kmcwheels.com/media/catalog/product/k/m/kmc-km552sd-ims-17x8-5-6-et-10-gloss-silver-w-machined-face-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::Mayhem::Apollo": {
    "productUrl": "https://www.mayhemwheels.com/product/8115-apollo-gloss-black-prism-red-milled/",
    "description": "GLOSS BLACK/PRISM RED MILLED 8114 UTOPIA - GLOSS BLACK/MILLED",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-apollo-95abb59c-shop-d3cd79.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8115BTR1.png"
  },
  "Wheels::Mayhem::Arsenal": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Assault": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Beast": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Bigrig": {
    "productUrl": "https://www.mayhemwheels.com/product/8180-bigrig-black-milled-spokes/",
    "description": "GLOSS BLACK/MILLED SPOKES 8180 BIGRIG - FRONT BLACK/MILLED SPOKES",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-bigrig-8ce71479-shop-0e0b51.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8180BMF1-1.png"
  },
  "Wheels::Mayhem::Challenger": {
    "productUrl": "https://www.mayhemwheels.com/product/8181-challenger-dually-polished/",
    "description": "POLISHED *CAPS NOT INCLUDED 8181 8181 - POLISHED",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-challenger-ebd21840-shop-53e92b.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8181P1F-1-1.png"
  },
  "Wheels::Mayhem::Chaos": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Cogent": {
    "productUrl": "https://www.mayhemwheels.com/product/8107-cogent-dually-polished/",
    "description": "The Mayhem 8107 Cogent Dually is a polished 17x6.5 wheel with separate front and rear dual-wheel variants. Published applications cover 8x165.1, 8x200 and 8x210 bolt patterns.",
    "availableSizes": [
      "17x6.5"
    ],
    "notes": [
      "Polished finish",
      "Front and rear dually variants",
      "Vehicle-specific fitment must be confirmed"
    ],
    "localImage": "product-catalog-wheels-mayhem-cogent-28c9281d-shop-0fe48b.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2023/10/8107DPF1.png",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://www.mayhemwheels.com/product/8107-cogent-dually-polished/"
  },
  "Wheels::Mayhem::Cogent Dually": {
    "productUrl": "https://www.mayhemwheels.com/product/8107-cogent-dually-polished/",
    "description": "The Mayhem 8107 Cogent Dually is a polished 17x6.5 wheel with separate front and rear dual-wheel variants. Published applications cover 8x165.1, 8x200 and 8x210 bolt patterns.",
    "availableSizes": [
      "17x6.5"
    ],
    "notes": [
      "Polished finish",
      "Front and rear dually variants",
      "Vehicle-specific fitment must be confirmed"
    ],
    "localImage": "product-catalog-wheels-mayhem-cogent-dually-28c9281d-shop-1f4ee8.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2023/10/8107DPF1.png",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://www.mayhemwheels.com/product/8107-cogent-dually-polished/"
  },
  "Wheels::Mayhem::Combat": {
    "productUrl": "https://www.mayhemwheels.com/product/8105-combat-gloss-black-milled-spokes/",
    "description": "GLOSS BLACK/MILLED SPOKES 8105 COMBAT - GLOSS BLACK/MILLED SPOKES",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-combat-11f7b10a-shop-76da3d.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8105M1.png"
  },
  "Wheels::Mayhem::Compass": {
    "productUrl": "https://www.mayhemwheels.com/product/8305-compass-matte-gunmetal/",
    "description": "MATTE GUNMETAL 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-compass-d6378dc3-shop-38d4c0.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2022/02/MAYHEM83053MGT1-1.png"
  },
  "Wheels::Mayhem::Convoy": {
    "productUrl": "https://www.mayhemwheels.com/product/8307-convoy-satin-bronze/",
    "description": "Satin Bronze 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-convoy-59827fdf-shop-c817c1.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2023/05/MAYHEM8307MZ1-RENDER.png"
  },
  "Wheels::Mayhem::Cortex": {
    "productUrl": "https://www.mayhemwheels.com/product/8113-cortex-matte-black-machined-dark-tint/",
    "description": "MATTE BLACK W/ MACHINED DARK TINT 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-cortex-10e2de13-shop-745563.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8113TM1.png"
  },
  "Wheels::Mayhem::Crossfire": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Decoy": {
    "productUrl": "https://www.mayhemwheels.com/product/8108-decoy-gloss-black-milled-spokes/",
    "description": "GLOSS BLACK/MILLED SPOKES 8108 DECOY - GLOSS BLACK/MILLED SPOKES",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-decoy-b73ccb26-shop-77d234.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8108GBM1.png"
  },
  "Wheels::Mayhem::Delta": {
    "productUrl": "https://www.mayhemwheels.com/product/8304-delta-matte-gunmetal-matte-black-lip/",
    "description": "MATTE GUNMETAL W/ MATTE BLACK LIP 8304 DELTA - MATTE GUNMETAL W/ MATTE BLACK LIP",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-delta-67ded40e-shop-7d3be0.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8304MGT1.png"
  },
  "Wheels::Mayhem::Essex": {
    "productUrl": "https://www.mayhemwheels.com/product/8112-essex-gloss-black-milled-spokes/",
    "description": "GLOSS BLACK/MILLED SPOKES 8112 ESSEX - GLOSS BLACK/MILLED SPOKES",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-essex-80dab204-shop-2a36ca.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8112GB1.png"
  },
  "Wheels::Mayhem::Fierce": {
    "productUrl": "https://www.mayhemwheels.com/product/8103-fierce-gloss-black-milled-spokes/",
    "description": "GLOSS BLACK/MILLED SPOKES 8103 FIERCE - GLOSS BLACK/MILLED SPOKES",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-fierce-a68d1639-shop-293d14.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8103M1.png"
  },
  "Wheels::Mayhem::Flat Iron": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Flywheel": {
    "productUrl": "https://www.mayhemwheels.com/product/8111-flywheel-gloss-black-milled-spokes/",
    "description": "GLOSS BLACK/MILLED SPOKES 8111 FLYWHEEL - GLOSS BLACK/MILLED SPOKES",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-flywheel-a567b9d2-shop-509291.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8111GB1_6LUG.png"
  },
  "Wheels::Mayhem::Granite": {
    "productUrl": "https://www.mayhemwheels.com/product/8309-granite-satin-black/",
    "description": "Satin Black 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-granite-10143c8b-shop-d8f346.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2023/02/8309SB1.png"
  },
  "Wheels::Mayhem::Hammer": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Hatchet": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Havoc": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Hermosa": {
    "productUrl": "https://www.mayhemwheels.com/product/8117-hermosa-black-milled/",
    "description": "BLACK MILLED 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-hermosa-1a57c5ba-shop-142abb.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2022/02/MAYHEM8117BM1.png"
  },
  "Wheels::Mayhem::Horizon": {
    "productUrl": "https://www.mayhemwheels.com/product/8120-horizon/",
    "description": "Gloss Black 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-horizon-3f8eb365-shop-97bd3b.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2026/03/8120_update.png"
  },
  "Wheels::Mayhem::Intrepid": {
    "productUrl": "https://www.mayhemwheels.com/product/8116-intrepid-bronze/",
    "description": "BRONZE 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-intrepid-3028e0f6-shop-776406.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2022/02/MAYHEM8116MZ1.png"
  },
  "Wheels::Mayhem::Missile": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Monstir": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Ordinance": {
    "productUrl": "https://www.mayhemwheels.com/product/8118-ordinance-matte-bronze-milled/",
    "description": "MATTE BRONZE MILLED 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-ordinance-d6287710-shop-bb1507.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2023/02/8118MZ1.png"
  },
  "Wheels::Mayhem::Patriot": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Prodigy": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Rampage": {
    "productUrl": "https://www.mayhemwheels.com/product/8090-rampage-matte-black/",
    "description": "MATTE BLACK 8090 RAMPAGE - MATTE BLACK",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-rampage-7e96a21b-shop-05a547.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8090MB1v2.png"
  },
  "Wheels::Mayhem::Ridgeline": {
    "productUrl": "https://www.mayhemwheels.com/product/8306-ridgeline-satin-black/",
    "description": "Satin black 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-ridgeline-bf50ef0b-shop-403d1f.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2023/04/MAYHEM8306SB1.png"
  },
  "Wheels::Mayhem::Riot": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Scout": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Tank": {
    "productUrl": "https://www.mayhemwheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mayhem::Tripwire": {
    "productUrl": "https://www.mayhemwheels.com/product/8110-tripwire-matte-black/",
    "description": "MATTE BLACK 8110 TRIPWIRE - MATTE BLACK",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-tripwire-c3c7971b-shop-524335.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8110BM1.png"
  },
  "Wheels::Mayhem::Utopia": {
    "productUrl": "https://www.mayhemwheels.com/product/8114-utopia-gloss-black-milled/",
    "description": "GLOSS BLACK/MILLED 8114 UTOPIA - GLOSS BLACK/MILLED",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-utopia-46226c28-shop-3e3612.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8114BM1-1.png"
  },
  "Wheels::Mayhem::Vanquish": {
    "productUrl": "https://www.mayhemwheels.com/product/8119-vanquish-gloss-black/",
    "description": "Gloss Black 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-vanquish-11ad9a05-shop-36eee4.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2023/10/Mayhem8119GB1.png"
  },
  "Wheels::Mayhem::Vector": {
    "productUrl": "https://www.mayhemwheels.com/product/8310-vector-matte-gunmetal/",
    "description": "Matte Gunmetal Black Lip 8113 CORTEX - MATTE BLACK W/MACHINED DART TINT",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-vector-8a548649-shop-3f9acd.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2024/10/Mayhem8310-6MGT1-1-e1769717380541.png"
  },
  "Wheels::Mayhem::Voyager": {
    "productUrl": "https://www.mayhemwheels.com/product/8303-voyager-dark-bronze/",
    "description": "DARK BRONZE 8303 VOYAGER - DARK BRONZE",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-voyager-f64f93f9-shop-481f29.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8303DB1.png"
  },
  "Wheels::Mayhem::Warrior": {
    "productUrl": "https://www.mayhemwheels.com/product/8015-warrior-matte-black/",
    "description": "MATTE BLACK 8015 WARRIOR - MATTE BLACK",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mayhem wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mayhem-warrior-0f213626-shop-528b56.webp",
    "imageSourceUrl": "https://www.mayhemwheels.com/wp-content/uploads/2021/05/MAYHEM8015MB1.png"
  },
  "Wheels::Level 8 Motorsports::Bully Pro": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Enforcer": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::MK6": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Punch": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Strike 5": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Strike 6": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Tracker": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Tracker Pro": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Slingshot": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::ZX": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Guardian": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Interceptor": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Razor": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Recon": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Slam": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Summit": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Tactic": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Level 8 Motorsports::Vandal": {
    "productUrl": "https://www.level8wheels.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Level 8 Motorsports wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Icon Alloys::Alpha": {
    "productUrl": "https://iconvehicledynamics.com/products/1220908057gm",
    "description": "A potent blend of on-road looks and off-road capability, the ALPHA is aimed to increase both the form and function of your Jeep, truck, or SUV. Staying true to the ICON Alloys approach, the ALPHA has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "17x8.5",
      "20x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Alpha model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "24 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "20 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Gloss Black",
        "Gloss Black with Milled Windows",
        "Gloss Black, Milled Windows",
        "Gun Metal",
        "Satin Black",
        "Satin Black, Milled Windows",
        "Titanium"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET0",
        "ET6",
        "ET12",
        "ET16",
        "ET19"
      ],
      "Published backspacing": [
        "4.75 inch",
        "5 inch",
        "5.5 inch",
        "5.63 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-alpha-1-e00934e7-shop-cb2bf1-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-alpha-1-e00934e7-shop-cb2bf1.webp",
      "product-catalog-wheels-icon-alloys-alpha-2-4ff5199d-shop-97c586.webp",
      "product-catalog-wheels-icon-alloys-alpha-3-a6d11192-shop-6c4dca.webp",
      "product-catalog-wheels-icon-alloys-alpha-4-4985ae31-shop-32d6e5.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/11d894d6cdb3903f25b9a8e3f88daf4c_5691b001-f17f-4441-a785-00224159a329.jpg?v=1765560449",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/1220908057gm"
  },
  "Wheels::Icon Alloys::Anza": {
    "productUrl": "https://iconvehicledynamics.com/products/8217855557sm",
    "description": "Taking its name from Southern California's picturesque Anza-Borrego desert, ICON Alloys returns to its roots with the all-new Anza wheel. Featuring a concave profile and deep stepped lip, you will be ready to take on the trails or look good on the streets in unique style. Offered in a 17” diameter, 8.5” width, and multiple offsets, dialing in the Anza for your specific application will be a breeze. Available in the classic Satin Black, a smart Silver Machined, or an aggressive Gloss Gunmetal - there is a finish that has your name on it. Look the part in any situation with the Anza wheel from ICON Alloys. Staying true to the ICON Alloys approach, the Anza has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function....",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Anza model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "17 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Gun Metal",
        "Satin Black",
        "Silver Machined"
      ],
      "Published PCDs": [
        "5X127",
        "5X139.7",
        "5X150",
        "6X120",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-anza-1-f4a7b0b5-shop-5d95b0-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-anza-1-f4a7b0b5-shop-5d95b0.webp",
      "product-catalog-wheels-icon-alloys-anza-2-30c03854-shop-c0ff67.webp",
      "product-catalog-wheels-icon-alloys-anza-3-c0a13fce-shop-65bf00.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/cab4b66b250a21f734111a35dede7f40_9bda431f-d91a-4976-879b-b39e2e9a98b1.jpg?v=1783370724",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/8217855557sm"
  },
  "Wheels::Icon Alloys::Bandit": {
    "productUrl": "https://iconvehicledynamics.com/products/6020105545gm",
    "description": "Give your vehicle a bold look and an aggressive stance with the ICON Alloys 'BANDIT' wheel! The 20x10” BANDIT is offered in several bolt patterns with backspace and offset dimensions designed to provide a dope style that is guaranteed to turn heads. These wheels yield a beefy 2,750-lb load rating retaining the strength that ICON Alloys is known for. Combining sharp lines, a concave spoke design, an extra deep lip, and style-focused dimensions, these wheels will increase both the form and function of your vehicle. Engineered to enhance the overall look of your vehicle but the durability and ruggedness as well. Available in Gloss Bronze, Gloss Black, and Gun Metal finishes, the BANDIT has a classic style with the strength to match.",
    "availableSizes": [
      "20x10"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Bandit model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "12 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "20 inch"
      ],
      "Available widths": [
        "10 inch"
      ],
      "Published finishes": [
        "Gloss Black",
        "Gloss Bronze",
        "Gun Metal"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-24"
      ],
      "Published backspacing": [
        "4.5 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-bandit-1-43252a1c-shop-ac1f09-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-bandit-1-43252a1c-shop-ac1f09.webp",
      "product-catalog-wheels-icon-alloys-bandit-2-beac0812-shop-0ba17a.webp",
      "product-catalog-wheels-icon-alloys-bandit-3-36feeb94-shop-6ef713.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/2423117521ecb0c8d558f83e5c962f07.jpg?v=1765561510",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/6020105545gm"
  },
  "Wheels::Icon Alloys::Cajon": {
    "productUrl": "https://iconvehicledynamics.com/products/8320905556smgb",
    "description": "Bring a sharp new look to your ride with the ICON Alloys Cajon, a stylish multi-spoke 20” wheel that will set your vehicle apart from the rest. Available in multiple finishes like stealthy Double Black, slick Satin Bronze with Gloss Black Lip, and an eye-catching Silver Machined with Gloss Black Lip; these wheels will increase both the form and function of your Jeep, truck, or SUV. Staying true to the ICON Alloys approach, the Cajon has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "20x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Cajon model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "21 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "20 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Double Black",
        "Satin Bronze w/ Gloss Black Lip",
        "Silver Machined w/ Gloss Black Lip"
      ],
      "Published PCDs": [
        "5X150",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET0",
        "ET6",
        "ET12",
        "ET16"
      ],
      "Published backspacing": [
        "5 inch",
        "5.25 inch",
        "5.5 inch",
        "5.63 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-cajon-1-7e035536-shop-5d7b4d-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-cajon-1-7e035536-shop-5d7b4d.webp",
      "product-catalog-wheels-icon-alloys-cajon-2-e559b11c-shop-3122da.webp",
      "product-catalog-wheels-icon-alloys-cajon-3-525a3e8e-shop-7230ec.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/9d919e5c0685fdbff381052dc97ed96a_a90ab26f-8c07-48b5-8c3d-863a923f724e.jpg?v=1765561461",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/8320905556smgb"
  },
  "Wheels::Icon Alloys::Compass": {
    "productUrl": "https://iconvehicledynamics.com/products/3217856350bs",
    "description": "ICON Alloys is proud to introduce our latest wheel design, the ‘Compass’. Featuring a modern 8-spoke design, sharp lines, a vented rock ring, and \"ICON-optimized\" dimensions, this new wheel is not only designed to improve the looks of your Jeep, truck, or SUV, but the overall function as well. Available in all-new Satin Brass and classic Satin Black finishes, the Compass has a style that is anything but ordinary. Staying true to the ICON Alloys approach, the 17” Compass has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace and wheel offset dimensions have been strategically developed to reduce scrub radius, improving all-around handling and ride quality....",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Compass model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "6 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Satin Black",
        "Satin Brass"
      ],
      "Published PCDs": [
        "5X127",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-compass-1-56eafefd-shop-7ad9f0-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-compass-1-56eafefd-shop-7ad9f0.webp",
      "product-catalog-wheels-icon-alloys-compass-2-b7a91465-shop-4fcfc5.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/ea0d625b68dd5b04deebbbfb50da7d0e_d608324a-0670-4656-aef7-0b416626ca96.jpg?v=1765561411",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/3217856350bs"
  },
  "Wheels::Icon Alloys::Compression": {
    "productUrl": "https://iconvehicledynamics.com/products/2017858347sb",
    "description": "Bring a bold new look to your ride with the all-new ICON Alloys COMPRESSION! Combining sharp lines, a concave spoke design, and \"ICON-optimized\" dimensions, these wheels will increase both the form and function of your Jeep, truck, or SUV. Staying true to the ICON Alloys approach, the COMPRESSION has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "17x8.5",
      "18x9",
      "20x10"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Compression model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "57 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch",
        "20 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch",
        "10 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Double Black",
        "Satin Black",
        "Titanium",
        "Titanium HD"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET-19",
        "ET-12",
        "ET-6",
        "ET0",
        "ET6",
        "ET12",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.25 inch",
        "5.5 inch",
        "5.75 inch",
        "6 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-compression-1-2fbcbe12-shop-a4a3c9-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-compression-1-2fbcbe12-shop-a4a3c9.webp",
      "product-catalog-wheels-icon-alloys-compression-2-f1f5ed81-shop-c8100e.webp",
      "product-catalog-wheels-icon-alloys-compression-3-b438ce39-shop-12e2d2.webp",
      "product-catalog-wheels-icon-alloys-compression-4-9a83f254-shop-2446f1.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/f9680377bbc6a58f8602445032e24e44_b614fd9d-5dbd-4365-a25d-c13e7c338ab0.jpg?v=1765561348",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/2017858347sb"
  },
  "Wheels::Icon Alloys::Compression HD": {
    "productUrl": "https://iconvehicledynamics.com/products/2018908955br",
    "description": "ICON Alloys is pround to announce new 18x9\" sizes of the popular Compression wheel designed for optimal fitment on today’s popular heavy-duty pickup trucks. The \"Compression HD\" is available in common eight lug patterns with application-specific fitment dimensions and these new wheels yield an industry leading 4,000-pound load rating, maintaining ICON Alloys’ commitment to producing wheels that deliver style and strength. The 18x9 \"Comporession HD\" wheel is designed to enhance a truck’s appearance and handling with its application-optimized backspacing for better wheel fitment, maximized caliper clearance, reduced scrub radius and unhindered suspension travel - improving all-around handling and ride quality. Constructed using a high-strength aluminum alloy, the 18x9 \"Compresion HD\" will deliver the strength needed to withstand off-road excursions and towing/hauling duty.",
    "availableSizes": [
      "18x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Compression HD model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "10 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Double Black",
        "Satin Black",
        "Titanium"
      ],
      "Published PCDs": [
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET6",
        "ET12"
      ],
      "Published backspacing": [
        "5.25 inch",
        "5.5 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-compression-hd-1-4e6316f4-shop-e157c5-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-compression-hd-1-4e6316f4-shop-e157c5.webp",
      "product-catalog-wheels-icon-alloys-compression-hd-2-97fec458-shop-da58e4.webp",
      "product-catalog-wheels-icon-alloys-compression-hd-3-87152b41-shop-b591f5.webp",
      "product-catalog-wheels-icon-alloys-compression-hd-4-f6fccbaa-shop-f8913a.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/c4c5f6861c6a78ac2cf314b2823572af_2d19cd72-ec97-4991-8afe-a3f063df7186.jpg?v=1765561466",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/2018908955br"
  },
  "Wheels::Icon Alloys::Hammer Pro": {
    "productUrl": "https://iconvehicledynamics.com/products/21017856350sb",
    "description": "Any hardcore off-road enthusiast knows the numerous benefits that lower tire pressures offer such as improved ride quality and a larger contact patch for increased traction. However, low pressures also increase the risk of de-beading the tire during extreme side loads or aggressive driving. While traditional bead lock wheels address this issue by clamping the tire’s bead, they also need frequent maintenance, require specialty tools/parts, increase rotational mass, and are NOT legal for on-road use. The ICON Alloys Hammer PRO with patented InnerLock technology offers the best of both worlds by using a robust bead retention system to keep the tire bead secured to the wheel while also being fully DOT compliant. This provides confidence in knowing that your wheels are prepared to tackle whatever situation you encounter - on or off the beaten path....",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Hammer Pro model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "15 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Charcoal",
        "Satin Black",
        "Silver Machined"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-hammer-pro-1-55eb9f6b-shop-938d68-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-hammer-pro-1-55eb9f6b-shop-938d68.webp",
      "product-catalog-wheels-icon-alloys-hammer-pro-2-88f522b9-shop-882fea.webp",
      "product-catalog-wheels-icon-alloys-hammer-pro-3-f9d445de-shop-a1145f.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/0eb1be358b42a47d80b2e05e0764cb69_7e188137-718b-489a-b767-16c98bc93f4f.jpg?v=1765561439",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/21017856350sb"
  },
  "Wheels::Icon Alloys::Hulse": {
    "productUrl": "https://iconvehicledynamics.com/products/8017858347sm",
    "description": "The ICON Alloys Hulse makes a bold statement with its motorsport inspired styling. Hulse features an aggressive concave profile that looks good in the dirt and great in the street. Twelve deep spokes, thick lip and oversized ring bolts will set your rig apart from the rest. Available in aggressive Double Black or eye-catching Silver Machined finishes with fitments available for 6 & 5 lug applications. Staying true to the ICON Alloys approach, the Hulse has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "17x8.5",
      "18x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Hulse model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "34 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch"
      ],
      "Published finishes": [
        "Double Black",
        "Satin Bronze w/ Gloss Black Lip & Bolts",
        "Silver Machined"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X114.3",
        "6X120",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET-12",
        "ET-6",
        "ET0",
        "ET6",
        "ET12",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.25 inch",
        "5.5 inch",
        "5.75 inch",
        "6 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-hulse-1-e25ea2cf-shop-317617-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-hulse-1-e25ea2cf-shop-317617.webp",
      "product-catalog-wheels-icon-alloys-hulse-2-5937362d-shop-2d22bc.webp",
      "product-catalog-wheels-icon-alloys-hulse-3-7927f2d3-shop-3fb003.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/0a6d4b3ccef453cfa115e11d910d6072_7836206a-55f5-4266-9ac2-8d71c88f3f09.jpg?v=1765561199",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/8017858347sm"
  },
  "Wheels::Icon Alloys::Journey": {
    "productUrl": "https://iconvehicledynamics.com/products/7117805060gg",
    "description": "The 17x8\" Journey features a modern, rally-inspired 10 spoke design that is strong, lightweight, and optimizes wheel position for the fitment of larger and more aggressive tires. These 17x8\" wheels are available in the popular 5x100 and 5x4.5\" bolt patterns with a 6\" backspace (+38mm offset) and weigh in at 26-lbs. The Journey yields a beefy load rating of 1850-lbs and comes in an all-new Gloss Gold finish, as well as our classic Satin Black offering. In traditional ICON Alloys fashion, the new 17x8\" Journey wheel has not only been engineered to enhance the overall look of your vehicle but the handling and performance as well. With looks and build features such as these, it's clear that a set of ICON Alloys 'Journey' wheels is the perfect addition to your Crossover (CUV).",
    "availableSizes": [
      "17x8"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Journey model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "6 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8 inch"
      ],
      "Published finishes": [
        "Gloss Gold",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X100",
        "5X108",
        "5X114.3"
      ],
      "Published offsets": [
        "ET38"
      ],
      "Published backspacing": [
        "6 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-journey-1-1bbf1ec9-shop-c1141a-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-journey-1-1bbf1ec9-shop-c1141a.webp",
      "product-catalog-wheels-icon-alloys-journey-2-f95cd649-shop-8dd62b.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/3dc586b51f14543190ce5fab1f866d84.jpg?v=1765560942",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/7117805060gg"
  },
  "Wheels::Icon Alloys::Nuevo": {
    "productUrl": "https://iconvehicledynamics.com/products/8117855557sm",
    "description": "Teeming with offroad pedigree, the Nuevo’s modern take on a classic offroad look means all business. The timeless 8 spokes and deep step lip lend the Nuevo a purposeful look, on or off the trail. A sophisticated Silver Machined as well Satin black are offered in both 5 or 6 lug applications. Available offsets ranging from -6mm through +25 are perfect for making the Nuevo ‘at home’ on your ride. Staying true to the ICON Alloys approach, the Nuevo has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Nuevo model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "11 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Satin Black",
        "Silver Machined"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X120",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-nuevo-1-1329cfa1-shop-bc64d3-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-nuevo-1-1329cfa1-shop-bc64d3.webp",
      "product-catalog-wheels-icon-alloys-nuevo-2-5d5a45fd-shop-e1e49a.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/65e07f830454bb9d5fccab6eecddf339_0da91a91-fd05-425e-8c41-7ed7d45cd8aa.jpg?v=1765561191",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/8117855557sm"
  },
  "Wheels::Icon Alloys::Raider": {
    "productUrl": "https://iconvehicledynamics.com/products/3417859447sb",
    "description": "ICON Alloys is proud to introduce our latest wheel design, the ‘Raider’. Featuring a modern 6-spoke design, sharp lines, a vented rock ring, and \"ICON-optimized\" dimensions, this new wheel is not only designed to improve the looks of your truck or SUV, but the overall function as well. Available in Satin Black, Satin Brass, and Titanium finishes, the Raider has a style that is anything but ordinary. Staying true to the ICON Alloys approach, the 17” Raider has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace and wheel offset dimensions have been strategically developed to reduce scrub radius, improving all-around handling and ride quality. The ICON Alloys Raider has also been strength tested to yield a 2,750lb load rating - making it one of the strongest wheel options on the market....",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Raider model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "9 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Satin Black",
        "Satin Brass",
        "Titanium"
      ],
      "Published PCDs": [
        "6X120",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET0",
        "ET6"
      ],
      "Published backspacing": [
        "4.75 inch",
        "5 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-raider-1-44f5f678-shop-1741e5-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-raider-1-44f5f678-shop-1741e5.webp",
      "product-catalog-wheels-icon-alloys-raider-2-2eafef69-shop-92a3c5.webp",
      "product-catalog-wheels-icon-alloys-raider-3-0567e757-shop-c8db7e.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/b2fdd390df9ccb8f8790114c115409c0.jpg?v=1765561408",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/3417859447sb"
  },
  "Wheels::Icon Alloys::Rebound": {
    "productUrl": "https://iconvehicledynamics.com/products/1818907345br",
    "description": "ICON Alloys is pround to announce new 18x9\" sizes of the popular 'Rebound' wheel designed for optimal fitment on today’s popular midsize, full-size and heavy-duty pickup trucks. Available in five, six and eight lug patterns and with application-specific fitment dimensions, these new wheels yield a 2,750-pound load rating for the five and six-lug versions and a 4,000-pound load rating on the eight-lug version, maintaining ICON Alloys’ commitment to producing wheels that deliver style and strength. The 18x9 'Rebound' wheel is designed to enhance a truck’s appearance and handling with its application-optimized backspacing for better wheel fitment, maximized caliper clearance, reduced scrub radius and unhindered suspension travel - improving all-around handling and ride quality....",
    "availableSizes": [
      "17x8.5",
      "18x9",
      "20x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Rebound model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "77 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch",
        "20 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Double Black",
        "Satin Black",
        "Titanium"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127",
        "5X139.7",
        "5X150",
        "6X120",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET-12",
        "ET-6",
        "ET0",
        "ET6",
        "ET12",
        "ET16",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.25 inch",
        "5.5 inch",
        "5.63 inch",
        "5.75 inch",
        "6 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-rebound-1-7b330ee0-shop-420b12-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-rebound-1-7b330ee0-shop-420b12.webp",
      "product-catalog-wheels-icon-alloys-rebound-2-3632edf7-shop-db8092.webp",
      "product-catalog-wheels-icon-alloys-rebound-3-c553c3e9-shop-f8697f.webp",
      "product-catalog-wheels-icon-alloys-rebound-4-6960e0d4-shop-89d161.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/a478328fc0498e64df743ee54a555edc_309457ce-e14c-4159-821d-d7c79f0197c7.jpg?v=1765561167",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/1818907345br"
  },
  "Wheels::Icon Alloys::Rebound HD": {
    "productUrl": "https://iconvehicledynamics.com/products/1818908955sb",
    "description": "ICON Alloys is pround to announce new 18x9\" sizes of the popular 'Rebound' wheel designed for optimal fitment on today’s popular midsize, full-size and heavy-duty pickup trucks. Available in five, six and eight lug patterns and with application-specific fitment dimensions, these new wheels yield a 2,750-pound load rating for the five and six-lug versions and a 4,000-pound load rating on the eight-lug version, maintaining ICON Alloys’ commitment to producing wheels that deliver style and strength. The 18x9 'Rebound' wheel is designed to enhance a truck’s appearance and handling with its application-optimized backspacing for better wheel fitment, maximized caliper clearance, reduced scrub radius and unhindered suspension travel - improving all-around handling and ride quality....",
    "availableSizes": [
      "17x8.5",
      "18x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Rebound HD model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "20 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Double Black",
        "Satin Black",
        "Titanium"
      ],
      "Published PCDs": [
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET6",
        "ET12",
        "ET13"
      ],
      "Published backspacing": [
        "5 inch",
        "5.25 inch",
        "5.5 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-rebound-hd-1-12d1923a-shop-4493f9-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-rebound-hd-1-12d1923a-shop-4493f9.webp",
      "product-catalog-wheels-icon-alloys-rebound-hd-2-1ab2fcbc-shop-213bbf.webp",
      "product-catalog-wheels-icon-alloys-rebound-hd-3-2c5f107d-shop-037bae.webp",
      "product-catalog-wheels-icon-alloys-rebound-hd-4-8d193978-shop-ffe429.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/f2c9364e431a8d2532d66e6e43e20076_4406cf6b-8373-43ef-8a77-1efba088a1a1.jpg?v=1765561189",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/1818908955sb"
  },
  "Wheels::Icon Alloys::Rebound Pro": {
    "productUrl": "https://iconvehicledynamics.com/products/21817855557br",
    "description": "Any hardcore off-road enthusiast knows the numerous benefits that lower tire pressures offer such as improved ride quality and a larger contact patch for increased traction. However, low pressures also increase the risk of de-beading the tire during extreme side loads or aggressive driving. While traditional beadlock wheels address this issue by clamping the tire’s bead, they also need frequent maintenance, require specialty tools/parts, increase rotational mass, and are NOT legal for on-road use. The ICON Alloys Rebound PRO with patented InnerLock technology offers the best of both worlds by using a robust bead retention system to keep the tire bead secured to the wheel while also being fully DOT compliant. This provides confidence in knowing that your wheels are prepared to tackle whatever situation you encounter - on or off the beaten path....",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Rebound Pro model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "21 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Satin Black",
        "Titanium"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127",
        "5X139.7",
        "5X150",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-rebound-pro-1-38e62a38-shop-142dfe-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-rebound-pro-1-38e62a38-shop-142dfe.webp",
      "product-catalog-wheels-icon-alloys-rebound-pro-2-66f7d212-shop-8a296d.webp",
      "product-catalog-wheels-icon-alloys-rebound-pro-3-9a7dd299-shop-438f11.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/52ab781f83a93d473fadd4aa3228dd91_6fabc266-72b5-41c0-ba38-31e86d380ad8.jpg?v=1765560944",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/21817855557br"
  },
  "Wheels::Icon Alloys::Rebound SLX": {
    "productUrl": "https://iconvehicledynamics.com/products/1917857345sb",
    "description": "The Rebound SLX keeps the sharp lines, concave 8-spoke design, and \"ICON-optimized\" styling of the classic Rebound wheel but features a smooth lip. This new wheel is designed not only to improve the look of your vehicle, but the overall function as well. Available in Satin Black and Charcoal finishes, the Rebound SLX has a style that is anything but ordinary. Staying true to the ICON Alloys approach, the Rebound SLX has been engineered to maximize caliper clearance and optimize wheel position for unhindered suspension travel and steering function. Backspace and wheel offset dimensions have been strategically developed to reduce scrub radius, improving all-around handling and ride quality. The Rebound SLX has also been strength tested to yield a 3,200lb load rating - making it one of the strongest wheel options on the market....",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Rebound SLX model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "8 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Charcoal",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X127",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-rebound-slx-1-b787290c-shop-406248-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-rebound-slx-1-b787290c-shop-406248.webp",
      "product-catalog-wheels-icon-alloys-rebound-slx-2-89596e25-shop-77e705.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/957b91a2d974291590968cad238bca24_9fe2f9fd-8410-4397-9c2a-ddb5a21cf9e3.jpg?v=1765561054",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/1917857345sb"
  },
  "Wheels::Icon Alloys::Recoil": {
    "productUrl": "https://iconvehicledynamics.com/products/6220105545gb",
    "description": "Give your vehicle a bold look and an aggressive stance with the ICON Alloys 'Recoil' wheel! The 20x10” Recoil is offered in several bolt patterns with backspace and offset dimensions designed to provide a modern style that is guaranteed to turn heads. These wheels yield a beefy 2,750-lb load rating retaining the strength that ICON Alloys is known for. Combining sharp lines, a concave spoke design, an extra deep lip, and style-focused dimensions, these wheels will increase both the form and function of your vehicle. Engineered to enhance the overall look of your vehicle but the durability and ruggedness as well. Available in Gloss Black and Gloss Black w/ Milled Windows, the Recoil has a classic style with the strength to match.",
    "availableSizes": [
      "20x10"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Recoil model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "5 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "20 inch"
      ],
      "Available widths": [
        "10 inch"
      ],
      "Published finishes": [
        "Gloss Black",
        "Gloss Black w/Milled Windows"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-24"
      ],
      "Published backspacing": [
        "4.5 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-recoil-1-ba19f63d-shop-2f1f9c-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-recoil-1-ba19f63d-shop-2f1f9c.webp",
      "product-catalog-wheels-icon-alloys-recoil-2-db82e096-shop-832772.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/176d791f59f36dd8842c01a22a92c932_aa98c297-0af0-4a77-bc6c-3d7a0be6ea0e.jpg?v=1765561485",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/6220105545gb"
  },
  "Wheels::Icon Alloys::Recon Pro": {
    "productUrl": "https://iconvehicledynamics.com/products/23618909066ch",
    "description": "Any hardcore off-road enthusiast knows the numerous benefits that lower tire pressures offer such as improved ride quality and a larger contact patch for increased traction. However, low pressures also increase the risk of de-beading the tire during extreme side loads or aggressive driving. While traditional bead lock wheels address this issue by clamping the tire’s bead, they also need frequent maintenance, require specialty tools/parts, increase rotational mass, and are NOT legal for on-road use. The ICON Alloys Recon PRO with patented InnerLock technology offers the best of both worlds by using a robust bead retention system to keep the tire bead secured to the wheel while also being fully DOT compliant. This provides confidence in knowing that your wheels are prepared to tackle whatever situation you encounter - on or off the beaten path....",
    "availableSizes": [
      "17x8.5",
      "18x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Recon Pro model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "27 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch"
      ],
      "Published finishes": [
        "Charcoal",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127",
        "5X150",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET12",
        "ET13",
        "ET25",
        "ET40"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.25 inch",
        "5.5 inch",
        "5.75 inch",
        "6 inch",
        "6.6 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-recon-pro-1-12002054-shop-2914ea-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-recon-pro-1-12002054-shop-2914ea.webp",
      "product-catalog-wheels-icon-alloys-recon-pro-2-13913997-shop-7d0519.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/503d1119817ffa066eb363f28222907c_5aa0a178-3214-41dc-ad74-d25d11f22bf3.jpg?v=1765561489",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/23618909066ch"
  },
  "Wheels::Icon Alloys::Recon SLX": {
    "productUrl": "https://iconvehicledynamics.com/products/3618909066gb",
    "description": "The Recon SLX keeps the sharp lines, concave 16-spoke design, and \"ICON-optimized\" styling of any classic ICON Alloys wheel but features a smooth lip and new ICON Alloys embossed cap design. This new wheel is designed not only to improve the look of your vehicle, but the overall function as well. Available in Satin Black, Gloass Black, and Charcoal finishes, the Recon SLX has a style that is anything but ordinary. Staying true to the ICON Alloys approach, the Recon SLX has been engineered to maximize caliper clearance and optimize wheel position for unhindered suspension travel and steering function. Backspace and wheel offset dimensions have been strategically developed to reduce scrub radius, improving all-around handling and ride quality....",
    "availableSizes": [
      "17x8.5",
      "18x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Recon SLX model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "34 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch"
      ],
      "Published finishes": [
        "Charcoal",
        "Gloss Black",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X127",
        "5X139.7",
        "5X150",
        "6X120",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET-12",
        "ET-6",
        "ET0",
        "ET6",
        "ET12",
        "ET25",
        "ET40"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.25 inch",
        "5.5 inch",
        "5.75 inch",
        "6 inch",
        "6.6 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-recon-slx-1-589a1da0-shop-b7e63c-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-recon-slx-1-589a1da0-shop-b7e63c.webp",
      "product-catalog-wheels-icon-alloys-recon-slx-2-85d60137-shop-ff7641.webp",
      "product-catalog-wheels-icon-alloys-recon-slx-3-e3fef10a-shop-69edbc.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/652b5b55fa832cbe12f5c005b7dbf360.jpg?v=1777055096",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/3618909066gb"
  },
  "Wheels::Icon Alloys::Ricochet": {
    "productUrl": "https://iconvehicledynamics.com/products/7017806560gg",
    "description": "The 17x8\" Ricochet features a modern, rally-inspired 12 spoke design that is strong, lightweight, and optimizes wheel position for the fitment of larger and more aggressive tires. These 17x8\" wheels are available in the popular 5x100 and 5x4.5\" bolt patterns with a 6\" backspace (+38mm offset) and weigh in at 26-lbs. The Ricochet yields a beefy load rating of 1850-lbs and comes in an all-new Gloss Gold finish, as well as our classic Satin Black offering. In traditional ICON Alloys fashion, the new 17x8\" Ricochet wheel has not only been engineered to enhance the overall look of your vehicle but the handling and performance as well. With looks and build features such as these, it's clear that a set of ICON Alloys 'Ricochet' wheels is the perfect addition to your Crossover (CUV).",
    "availableSizes": [
      "15x7",
      "17x8"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Ricochet model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "7 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "15 inch",
        "17 inch"
      ],
      "Available widths": [
        "7 inch",
        "8 inch"
      ],
      "Published finishes": [
        "Gloss Gold",
        "Satin Black",
        "Satin Gold"
      ],
      "Published PCDs": [
        "5X100",
        "5X108",
        "5X114.3"
      ],
      "Published offsets": [
        "ET15",
        "ET38"
      ],
      "Published backspacing": [
        "4.6 inch",
        "6 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-ricochet-1-5897b9c2-shop-70980b-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-ricochet-1-5897b9c2-shop-70980b.webp",
      "product-catalog-wheels-icon-alloys-ricochet-2-2b55a9a3-shop-f105da.webp",
      "product-catalog-wheels-icon-alloys-ricochet-3-63716cd6-shop-c66413.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/a0eafac9f2b2ab7aa489be79fcd36667.jpg?v=1765560683",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/7017806560gg"
  },
  "Wheels::Icon Alloys::Shield": {
    "productUrl": "https://iconvehicledynamics.com/products/1020905556mb",
    "description": "A reflection of ICON Vehicle Dynamics’ dedication to proper fit and function, the SHIELD has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. With backspace dimensions developed specifically for Ford, Toyota and Jeep applications, the SHIELD is the perfect complement to an ICON Vehicle Dynamics suspension system. With a solid set of build features, proven strength, and looks that stand out from the rest, the SHIELD has you covered.",
    "availableSizes": [
      "20x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Shield model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "5 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "20 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Satin Black",
        "Satin Black, Machined"
      ],
      "Published PCDs": [
        "5X150",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET0",
        "ET12",
        "ET16"
      ],
      "Published backspacing": [
        "5 inch",
        "5.5 inch",
        "5.63 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-shield-1-ca148325-shop-55adc2-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-shield-1-ca148325-shop-55adc2.webp",
      "product-catalog-wheels-icon-alloys-shield-2-6ac67cae-shop-89e272.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/214d3d65c6729b92dbe2306cd19715f8_cdc13ef9-44ee-48b6-8026-91923c8de100.jpg?v=1765560205",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/1020905556mb"
  },
  "Wheels::Icon Alloys::Six Speed": {
    "productUrl": "https://iconvehicledynamics.com/products/1417858347gm",
    "description": "Shift into top gear with the ICON Alloys SIX SPEED! With a bold look and and \"ICON-optimized\" dimensions, these wheels will increase both the form and function of your Jeep, truck, or SUV. Staying true to the ICON Alloys approach, the SIX SPEED has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Six Speed model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "16 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Gun Metal",
        "Satin Black",
        "Titanium"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-six-speed-1-6e3c2732-shop-5bb094-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-six-speed-1-6e3c2732-shop-5bb094.webp",
      "product-catalog-wheels-icon-alloys-six-speed-2-7fdde616-shop-d20796.webp",
      "product-catalog-wheels-icon-alloys-six-speed-3-617bfd8c-shop-345ebd.webp",
      "product-catalog-wheels-icon-alloys-six-speed-4-c23e1d78-shop-d08506.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/9f1a767ab2d4624e5c7d22e107c1851b_d7f02bdf-290c-486a-8393-024f178ae4af.jpg?v=1765560537",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/1417858347gm"
  },
  "Wheels::Icon Alloys::Thrust": {
    "productUrl": "https://iconvehicledynamics.com/products/2817858347ssbt",
    "description": "Combining sharp concave lines, a unique lip design with imprinted logos, and \"ICON-optimized\" dimensions, the ‘Thrust’ wheel is not only designed to improve the looks of your Jeep, truck, or SUV, but the overall function of the vehicle as well. Available in all-new Smoked Satin Black and our classic Satin Black finishes, the Thrust has a style that is anything but ordinary. Staying true to the ICON Alloys approach, the 17” Thrust has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace and wheel offset dimensions have been strategically developed to reduce scrub radius, improving all-around handling and ride quality. The ICON Alloys Thrust has also been strength tested to yield a 2,750lb load rating - making it one of the strongest wheel options on the market!...",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Thrust model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "12 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Satin Black",
        "Smoked Satin Black"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127",
        "5X150",
        "6X120",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-thrust-1-6146c222-shop-e13127-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-thrust-1-6146c222-shop-e13127.webp",
      "product-catalog-wheels-icon-alloys-thrust-2-d88101b0-shop-afd1c7.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/a013fe8b9ad3ce55f569539bd519a36d_fd3472cb-531b-4634-82b8-286ed7ec809f.jpg?v=1765561385",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/2817858347ssbt"
  },
  "Wheels::Icon Alloys::Vector 5": {
    "productUrl": "https://iconvehicledynamics.com/products/2617855557tt",
    "description": "The ICON Alloys Vector 5 wheel incorporates sharp lines and an aggressive spoke design while a featureless lip provides clean looks and makes care & maintenance an easier task (doesn't trap debris as easily). Combining these bold looks with ICON optimized dimensions, the Vector 6 is designed to improve the form and function of your truck or SUV. Backspace and wheel offset dimensions have been strategically developed to reduce scrub radius, enhancing handling characteristics and ride quality - this is truly a \"wheel designed with suspension in mind\".",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Vector 5 model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "6 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Satin Black",
        "Titanium"
      ],
      "Published PCDs": [
        "5X127",
        "5X150"
      ],
      "Published offsets": [
        "ET-6",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-vector-5-1-278b911e-shop-45bbae-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-vector-5-1-278b911e-shop-45bbae.webp",
      "product-catalog-wheels-icon-alloys-vector-5-2-2fe29b9c-shop-a85c12.webp",
      "product-catalog-wheels-icon-alloys-vector-5-3-2e9008ad-shop-baea93.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/aa16f607b8abb764c91577e97448f2ae.jpg?v=1765561327",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/2617855557tt"
  },
  "Wheels::Icon Alloys::Vector 6": {
    "productUrl": "https://iconvehicledynamics.com/products/2417856350br",
    "description": "Bring a bold new look to your ride with the all-new ICON Alloys VECTOR 6! Combining sharp lines, a concave spoke design, and \"ICON-optimized\" dimensions, these wheels will increase both the form and function of your Jeep, truck, or SUV. Staying true to the ICON Alloys approach, the VECTOR 6 has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Vector 6 model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "15 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Satin Black",
        "Titanium"
      ],
      "Published PCDs": [
        "6X120",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET0",
        "ET6",
        "ET25"
      ],
      "Published backspacing": [
        "4.75 inch",
        "5 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-vector-6-1-1edd170c-shop-2aa390-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-vector-6-1-1edd170c-shop-2aa390.webp",
      "product-catalog-wheels-icon-alloys-vector-6-2-3b44cd8c-shop-4970f6.webp",
      "product-catalog-wheels-icon-alloys-vector-6-3-fed7bcc4-shop-455398.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/fb9a95f69bd62cb336fd4a65a1b3e5ca_96f78653-a971-4a23-bbf3-bbcca9a518fc.jpg?v=1770852913",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/2417856350br"
  },
  "Wheels::Icon Alloys::Victory": {
    "productUrl": "https://iconvehicledynamics.com/products/3017858347sbrt",
    "description": "ICON Alloys is proud to announce the release of our newest wheel design, the ‘Victory’. Combining sharp concave lines, an updated lip design with recessed ICON logos, and \"ICON-optimized\" dimensions, this new wheel is not only designed to improve the looks of your truck, Jeep or SUV, but the overall function of the vehicle as well. Available in Smoked Satin Black and our all-new Satin Black with Red Tint finishes, the Victory has an unprecedented look that is guaranteed to turn heads. Staying true to the ICON Alloys approach, the 17” Victory has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace and wheel offset dimensions have been strategically developed to reduce scrub radius, improving all-around handling and ride quality....",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Victory model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "10 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "8.5 inch"
      ],
      "Published finishes": [
        "Satin Black w/Red",
        "Smoked Satin Black"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127",
        "6X120",
        "6X135",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-victory-1-0946ecf2-shop-0f0ecf-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-victory-1-0946ecf2-shop-0f0ecf.webp",
      "product-catalog-wheels-icon-alloys-victory-2-600de8f2-shop-bdd852.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/747f83d6a7f9d88b972e4ac19f19034c_ef2315d2-dc87-4f4a-8770-53f342e8b401.jpg?v=1765560587",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/3017858347sbrt"
  },
  "Wheels::Rubicon::JL Rubicon OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rubicon::JK Rubicon OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rubicon::Gladiator Rubicon OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rubicon::Rubicon Xtreme Recon OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rubicon::Rubicon 392 OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rubicon::Rubicon Hard Rock OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rubicon::Rubicon Recon OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Rubicon::Rubicon 10th Anniversary OEM Style": {
    "productUrl": "",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Rubicon wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mickey Thompson::Classic III": {
    "productUrl": "https://www.mickeythompsontires.com/wheels/classic-iii",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/wheels/classic-iii",
    "localImage": "product-catalog-wheels-mickey-thompson-classic-iii-5e1f2f42-shop-ba6801.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/classic-iii/b4190ed916-1745134785/classic_iii_wheel_chrome_ol.png"
  },
  "Wheels::Mickey Thompson::Classic Baja Lock": {
    "productUrl": "https://www.mickeythompsontires.com/wheels/classic-baja-lock",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/wheels/classic-baja-lock",
    "rejectedImageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/classic-baja-lock/fd1dd88558-1745134785/classicbajalock-17x9-8lug-hr.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Mickey Thompson::Classic Baja Boss": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/classic-baja-lock/fd1dd88558-1745134785/classicbajalock-17x9-8lug-hr.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Mickey Thompson::Classic Sidebiter II": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-mickey-thompson-classic-sidebiter-ii-eff44f86-shop-6e14b1.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/mt-classic-forged/a5aa3d665b-1764964991/mtt-forged-wheel-3qtr-r-wide1200px.png"
  },
  "Wheels::Mickey Thompson::Classic Lock": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/classic-baja-lock/fd1dd88558-1745134785/classicbajalock-17x9-8lug-hr.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Mickey Thompson::Classic III Black": {
    "productUrl": "https://www.mickeythompsontires.com/wheels/classic-iii-black",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mickey-thompson-classic-iii-black-1a85b86c-shop-78c055.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/classic-iii-black/0564ec1cbc-1745134785/classic_iii_wheel_matteblack_ol.png",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/wheels/classic-iii-black"
  },
  "Wheels::Mickey Thompson::Classic III Polished": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-mickey-thompson-classic-iii-polished-e9b8bc97-shop-1c1e99.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/classic-pro-polished/0e15462051-1745134785/classic-pro-polished.png"
  },
  "Wheels::Mickey Thompson::Deegan 38 Pro 2": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-mickey-thompson-deegan-38-pro-2-a5800a38-shop-d33ba9.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/canyon-pro-polished/cf2c5081de-1745134785/canyon-pro-polished.png"
  },
  "Wheels::Mickey Thompson::Metal Series MM-245": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mickey Thompson::Metal Series MM-366": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Mickey Thompson::Metal Series MM-489": {
    "productUrl": "https://www.mickeythompsontires.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-mickey-thompson-metal-series-mm-489-f4fc2b1c-shop-a0fadd.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/canyon-pro-bronze/e5533b4891-1745134785/canyon-pro-wheel-bronze.png"
  },
  "Wheels::Mickey Thompson::Sidebiter II": {
    "productUrl": "https://www.mickeythompsontires.com/wheels/sidebiter-ii",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/wheels/sidebiter-ii",
    "localImage": "product-catalog-wheels-mickey-thompson-sidebiter-ii-60ea17fb-shop-87471d.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/wheels/sidebiter-ii/fed94eec85-1745134785/sidebiter_ii_17x9_8lug.png"
  },
  "Wheels::Mickey Thompson::Baja Pro": {
    "productUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-pro-xs",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/light-truck-tires/baja-pro-xs",
    "rejectedImageSourceUrl": "https://www.mickeythompsontires.com/media/pages/light-truck-tires/baja-pro-xs/4087612502-1745134785/Baja-pro-xs-side.png",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Mickey Thompson::ET Drag": {
    "productUrl": "https://www.mickeythompsontires.com/drag-tires/et-drag",
    "description": "Mickey Thompson Tires & Wheels - UNDISPUTED.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Mickey Thompson wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-mickey-thompson-et-drag-cd3ff55d-shop-c9fd75.webp",
    "imageSourceUrl": "https://www.mickeythompsontires.com/media/pages/drag-tires/et-drag/bf100c4afa-1745134785/mt-drag-qc_et-drag-sw-overlay.jpg",
    "descriptionSource": "description",
    "descriptionSourceUrl": "https://www.mickeythompsontires.com/drag-tires/et-drag"
  },
  "Wheels::Moto Metal::Tekton": {
    "productUrl": "https://www.motometal.com/moto-metal-tekton",
    "description": "MO814MX20906801 - Moto Metal MO814 TEKTON - MATTE BLACK - 20\" Diameter - 20X9 1MM offset - 6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-tekton-ffe1a5be-shop-85c567.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/moto-metal-mo814-tekton-20x10-5-6-et-18-gloss-black-w-machined-face-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-tekton"
  },
  "Wheels::Moto Metal::Breakout": {
    "productUrl": "https://www.motometal.com/moto-metal-breakout",
    "description": "MO98529063200 - Moto Metal MO985 BREAKOUT - CHROME - 20\" Diameter - 20X9 00MM offset - 6X135 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-breakout-9a1ed9a4-shop-6f9f93.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo9853-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-breakout"
  },
  "Wheels::Moto Metal::Combat": {
    "productUrl": "https://www.motometal.com/moto-metal-combat",
    "description": "MO811PX22128044N - Moto Metal MO811 COMBAT - CHROME - 22\" Diameter - 22X12 -44MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-combat-3ac925ef-shop-f5f591.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/moto-metal-mo811-combat-24x12-8-et-44-chrome-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-combat"
  },
  "Wheels::Moto Metal::Folsom": {
    "productUrl": "https://www.motometal.com/moto-metal-folsom",
    "description": "MO99221280344N - Moto Metal MO992 FOLSOM - GLOSS BLACK MILLED - 20\" Diameter - 20X12 -44MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-folsom-71224fac-shop-b462a9.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo9923-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-folsom"
  },
  "Wheels::Moto Metal::Kraken": {
    "productUrl": "https://www.motometal.com/moto-metal-kraken",
    "description": "MO99822088318N - Moto Metal MO998 KRAKEN - GLOSS BLACK MILLED - 22\" Diameter - 22X10 -18MM offset - 8X180 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-kraken-1faf2eba-shop-ea6de8.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo9983-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-kraken"
  },
  "Wheels::Moto Metal::Legacy": {
    "productUrl": "https://www.motometal.com/moto-metal-legacy",
    "description": "MO810BX20908620 - Moto Metal MO810 LEGACY - GLOSS BLACK - 20\" Diameter - 20X9 20MM offset - 5X139.7/5X150 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-legacy-e820426e-shop-6fd836.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/moto-metal-mo810-legacy-20x10-6-et-18-gloss-black-machined-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-legacy"
  },
  "Wheels::Moto Metal::MO806": {
    "productUrl": "https://www.motometal.com/moto-metal-mo806",
    "description": "MO80621080218N - Moto Metal MO806 - CHROME - 20\" Diameter - 20X10 -18MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-mo806-47f68e97-shop-fa65ff.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo8062-6lug-20x10-et-18-chrome-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-mo806"
  },
  "Wheels::Moto Metal::MO807": {
    "productUrl": "https://www.motometal.com/moto-metal-mo807",
    "description": "MO80722280944N - Moto Metal MO807 - GLOSS BLACK MACH W/ RED TINT - 22\" Diameter - 22X12 -44MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-mo807-181b6eee-shop-ed01aa.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo8075-6lug-20x10-et-18-gloss-blk-machined-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-mo807"
  },
  "Wheels::Moto Metal::MO970": {
    "productUrl": "https://www.motometal.com/moto-metal-mo970",
    "description": "MO97021087918N - Moto Metal MO970 - SEMI GLOSS BLACK MILLED - 20\" Diameter - 20X10 -18MM offset - 8X170 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-mo970-04acc874-shop-454626.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo9703a_6lug_20x10_et12_gloss_blk_milled_lip_a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-mo970"
  },
  "Wheels::Moto Metal::MO995": {
    "productUrl": "https://www.motometal.com/moto-metal-mo995",
    "description": "MO995765893155N - Moto Metal MO995 - GLOSS BLACK MACHINED - 17\" Diameter - 17X6.5 -155MM offset - 8X210 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-mo995-49206580-shop-816152.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo9953f-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-mo995"
  },
  "Wheels::Moto Metal::Razor": {
    "productUrl": "https://www.motometal.com/moto-metal-razor",
    "description": "MO97821287544NRC - Moto Metal MO978 RAZOR - SATIN BLACK MACHINED W/ RED CLEAR COAT - 20\" Diameter - 20X12 -44MM offset - 8X170 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-razor-59398527-shop-b6f1e2.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo9785-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-razor"
  },
  "Wheels::Moto Metal::Siege": {
    "productUrl": "https://www.motometal.com/moto-metal-siege",
    "description": "MO986220353A18N - Moto Metal MO986 SIEGE - GLOSS BLACK - 22\" Diameter - 22X10 -18MM offset - 5X127/5X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-siege-5afc7999-shop-0088cf.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo9862_rt-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-siege"
  },
  "Wheels::Moto Metal::Sniper": {
    "productUrl": "https://www.motometal.com/moto-metal-sniper",
    "description": "MO80829080300 - Moto Metal MO808 SNIPER - GLOSS BLACK MILLED - 20\" Diameter - 20X9 0MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-sniper-69eb40bb-shop-265b90.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/0/m0808-6lug-22x12-et-44-gloss-blk-milled-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-sniper"
  },
  "Wheels::Moto Metal::Spider": {
    "productUrl": "https://www.motometal.com/moto-metal-spider",
    "description": "MO80421080518N - Moto Metal MO804 SPIDER - GLOSS BLACK MACHINED - 20\" Diameter - 20X10 -18MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-spider-75e83d39-shop-553273.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo8049-6lug-20x10-et-18-gloss-blk-n-milled-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-spider"
  },
  "Wheels::Moto Metal::Stinger": {
    "productUrl": "https://www.motometal.com/moto-metal-stinger",
    "description": "MO809BX20108818N - Moto Metal MO809 STINGER - GLOSS BLACK - 20\" Diameter - 20X10 -18MM offset - 8X180 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-stinger-f5820a31-shop-014088.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/moto-metal-mo809-22x12-6lug-chrome-black-ring-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-stinger"
  },
  "Wheels::Moto Metal::Turbine": {
    "productUrl": "https://www.motometal.com/moto-metal-turbine",
    "description": "MO812BX20908020 - Moto Metal MO812 TURBINE - GLOSS BLACK - 20\" Diameter - 20X9 20MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-turbine-725fc4db-shop-a74ee6.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/moto-metal-mo812be-turbine-20x10-8-et-18-gloss-black-milled-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-turbine"
  },
  "Wheels::Moto Metal::Warlock": {
    "productUrl": "https://www.motometal.com/moto-metal-warlock",
    "description": "MO80229063318 - Moto Metal MO802 WARLOCK - GLOSS BLACK MILLED - 20\" Diameter - 20X9 18MM offset - 6X135 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Moto Metal wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-moto-metal-warlock-8df4b72e-shop-a28d8e.webp",
    "imageSourceUrl": "https://www.motometal.com/media/catalog/product/m/o/mo8023-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.motometal.com/moto-metal-warlock"
  },
  "Wheels::Pro Comp::Stryker": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/stryker/stryker-matte-black-16x8-5x5-4-5bs-offset-0mm-cap-p-n-703154500procomp-stryker-series-31-16x8-5x5-4-5bs-0mm-off-set-matte-black-p-n-7031-6873/",
    "description": "Stryker Series 31 16×8 5×5 4.5BS 0mm Off Set Matte Black Part #: 7031-6873 Alt PN: 7031-6873 GTIN: 844658022881 Primary Features Offset: 0 Maxload 2500 Bolt Pattern: 5x5 Back Space: 4.5 Size:16x8 Description Warranty Fitment Prop 65 Description The Pro Comp Stryker is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-stryker-e0df1438-shop-f9b144.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/7031-6865-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/stryker/stryker-matte-black-16x8-5x5-4-5bs-offset-0mm-cap-p-n-703154500procomp-stryker-series-31-16x8-5x5-4-5bs-0mm-off-set-matte-black-p-n-7031-6873/"
  },
  "Wheels::Pro Comp::Snare": {
    "productUrl": "https://www.procompusa.com/product-category/alloy-wheel/snare/",
    "description": "Shop by Category Suspension & Steering Leveling Kits Jeep Suspension Truck Suspension Wheels Lighting Shop by Vehicle Jeep Ram Ford Chevrolet GMC Toyota Shop all Vehicles Find a Dealer Select Your Vehicle Shop for your specific vehicle to find parts that fit. From your garage for this category: select vehicle Shop / Alloy Wheel / Snare PA206 SNARE, 16X8 with 5X114.3 Bolt Pattern - MATTE BLACK View Details PA206 SNARE, 16X8 with 6X139.7 Bolt Pattern - MATTE BLACK View Details",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/product-category/alloy-wheel/snare/",
    "localImage": "catalog-wheels-pro-comp-snare-2b431122-shop-fcb460.webp",
    "imageSourceUrl": "https://www.procompusa.com//wp-content/uploads/product-images/procomp/PRO%20COMP%20PA206%20SNARE%2020X9%206%20ET0%20MATTE%20BLACK%20A1.png"
  },
  "Wheels::Pro Comp::Grid": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/grid/grind-matte-black-18x9-5x5-5-5bs-offset-0mm-cap-p-n-703365500procomp-grind-series-33-18x9-5x5-5-5bs-0mm-off-set-matte-black-p-n-7033-8926/",
    "description": "Grid Series 33 18×9 5×5.5 5BS 0mm Off Set Matte Black P/N [] Part #: 7033-8926 Alt PN: 7033-8926 GTIN: 844658022546 Primary Features Size:18x9 Offset: 0 Bolt Pattern: 5x5.5 Maxload 2500 Back Space: 5 Description Warranty Fitment Prop 65 Description The Pro Comp Grid is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-grid-365457a7-shop-8ef984.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/7033-8926-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/grid/grind-matte-black-18x9-5x5-5-5bs-offset-0mm-cap-p-n-703365500procomp-grind-series-33-18x9-5x5-5-5bs-0mm-off-set-matte-black-p-n-7033-8926/"
  },
  "Wheels::Pro Comp::Wraith": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/wraith/procomp-wheel-wraith-wheel-17x8-with-6-on-4-5-bolt-pattern-matte-black-pa205mx17806420/",
    "description": "This product has limited stock. Please contact customer service at 800-776-0767 for availability. Description Warranty Fitment Prop 65 Description We made the Pro Comp Wraith for drivers seeking function and form. The Wraith features a wide split-spoke high-performance mesh with a simple motorsport-type face design. Subtle yet functional bracing between secondary windows enhances strength, while a ribbed lip edge offers better impact and damage resistance.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/wraith/procomp-wheel-wraith-wheel-17x8-with-6-on-4-5-bolt-pattern-matte-black-pa205mx17806420/",
    "localImage": "catalog-wheels-pro-comp-wraith-f33b99b5-shop-b8bf93.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/PRO-COMP-PA205-17X8.5-6-ET0-MATTE-BLACK-A1.png"
  },
  "Wheels::Pro Comp::Roughneck": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/roughneck/procomp-wheel-roughneck-wheel-17x8-with-5-on-5-bolt-pattern-matte-black-pa204mx17805020/",
    "description": "This product has limited stock. Please contact customer service at 800-776-0767 for availability. Description Warranty Fitment Prop 65 Description We made the Pro Comp Roughneck for drivers seeking a performance-minded and stylish wheel for their off-road vehicles. The Roughneck features a deep concave face with a curved, split 7-spoke design and overhanging spoke ends, offering a rugged-yet-refined aesthetic upgrade for your ½-ton or Jeep.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/roughneck/procomp-wheel-roughneck-wheel-17x8-with-5-on-5-bolt-pattern-matte-black-pa204mx17805020/",
    "localImage": "catalog-wheels-pro-comp-roughneck-554984f0-shop-c34730.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/PRO-COMP-PA204-17X8.5-6-ET0-MATTE-BLACK-A1.png"
  },
  "Wheels::Pro Comp::Heritage": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/heritage/procomp-wheel-heritage-wheel-16x8-with-5-on-4-5-bolt-pattern-polished-pa201hx16805t00/",
    "description": "Select Your Vehicle Shop for your specific vehicle to find parts that fit. Your Garage: select vehicle Shop / Alloy Wheel / Heritage / Wheel HERITAGE Wheel, 16×8 with 5 on 4.5 Bolt Pattern - POLISHED Wheel HERITAGE Wheel, 16×8 with 5 on 4.5 Bolt Pattern - POLISHED Part #: PA201HX16805T00 Alt PN: PA201HX16805T00 GTIN: 194933380268 Primary Features Reminiscent of classic off road wheels, but reimagined Backspace: 4.50 Center Cap PN: PACAP001PXB5114SXT Finish: POLISHED Reimagined design of original Pro Comp 69 S",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-pro-comp-heritage-f0d62fab-shop-fb1b7d.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/PRO-COMP-PA201-HERITAGE-17X8-6-ET0-POLISHED-A1.png",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/heritage/procomp-wheel-heritage-wheel-16x8-with-5-on-4-5-bolt-pattern-polished-pa201hx16805t00/"
  },
  "Wheels::Pro Comp::Beacon": {
    "productUrl": "https://www.procompusa.com/product-category/alloy-wheel/beacon/",
    "description": "Shop by Category Suspension & Steering Leveling Kits Jeep Suspension Truck Suspension Wheels Lighting Shop by Vehicle Jeep Ram Ford Chevrolet GMC Toyota Shop all Vehicles Find a Dealer Select Your Vehicle Shop for your specific vehicle to find parts that fit. From your garage for this category: select vehicle Shop / Alloy Wheel / Beacon Beacon PA203 Wheel, 17×8 with 5×114.3 Bolt Pattern - Matte Black View Details Beacon PA203 Wheel, 17×8 with 5×127 Bolt Pattern - Matte Black View Details",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/product-category/alloy-wheel/beacon/",
    "localImage": "catalog-wheels-pro-comp-beacon-86a7e22c-shop-67f24c.webp",
    "imageSourceUrl": "https://www.procompusa.com//wp-content/uploads/product-images/procomp/PRO%20COMP%20PA203%20BEACON%2017X8.5%206%20ET0%20MATTE%20BLACK%20A1.png"
  },
  "Wheels::Pro Comp::Basecamp": {
    "productUrl": "https://www.procompusa.com/product-category/alloy-wheel/basecamp/",
    "description": "Shop by Category Suspension & Steering Leveling Kits Jeep Suspension Truck Suspension Wheels Lighting Shop by Vehicle Jeep Ram Ford Chevrolet GMC Toyota Shop all Vehicles Find a Dealer Select Your Vehicle Shop for your specific vehicle to find parts that fit. From your garage for this category: select vehicle Shop / Alloy Wheel / Basecamp Basecamp PA202 Wheel, 17×8 with 5×4.5 Bolt Pattern - Matte Black View Details Basecamp PA202 Wheel, 17×8 with 5×5 Bolt Pattern - Matte Black View Details",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/product-category/alloy-wheel/basecamp/",
    "localImage": "catalog-wheels-pro-comp-basecamp-8be2dd6e-shop-437df2.webp",
    "imageSourceUrl": "https://www.procompusa.com//wp-content/uploads/product-images/procomp/PRO%20COMP%20PA202%20BASECAMP%2017X8.5%206%20ET0%20MATTE%20BLACK%20A1.png"
  },
  "Wheels::Pro Comp::Pulse": {
    "productUrl": "https://www.procompusa.com/product-category/alloy-wheel/pulse/",
    "description": "Shop by Category Suspension & Steering Leveling Kits Jeep Suspension Truck Suspension Wheels Lighting Shop by Vehicle Jeep Ram Ford Chevrolet GMC Toyota Shop all Vehicles Find a Dealer Select Your Vehicle Shop for your specific vehicle to find parts that fit. From your garage for this category: select vehicle Shop / Alloy Wheel / Pulse Pulse PE200 Wheel, 17×8 with 5×4.5 Bolt Pattern - Matte Black View Details Pulse PE200 Wheel, 17×8 with 5×5 Bolt Pattern - Matte Black View Details",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/product-category/alloy-wheel/pulse/",
    "localImage": "catalog-wheels-pro-comp-pulse-786fb443-shop-cf426b.webp",
    "imageSourceUrl": "https://www.procompusa.com//wp-content/uploads/product-images/procomp/PRO%20COMP%20PA200%20PULSE%2017X8%206%20ET20%20MATTE%20BLACK%20A1.png"
  },
  "Wheels::Pro Comp::Patriot": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/patriot/patriot-gloss-black-milled-20x9-8x180-5bs-offset-0mm-cap-p-n-818387002procomp-patriot-series76-20x9-8x180-5bs-0mm-off-set-gloss-black-milled-p-n-8176-2989/",
    "description": "Patriot Series76 20×9 8×180 5BS 0mm Off Set Gloss Black Milled Part #: 8176-2989 Alt PN: 8176-2989 GTIN: 844658047785 Primary Features Size:20x9 Offset: 0 Maxload 3650 Bolt Pattern: 8x180 Back Space: 5 Description Warranty Fitment Prop 65 Description The Pro Comp Patriot is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-patriot-adb1e326-shop-601d5b.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/8176-7973-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/patriot/patriot-gloss-black-milled-20x9-8x180-5bs-offset-0mm-cap-p-n-818387002procomp-patriot-series76-20x9-8x180-5bs-0mm-off-set-gloss-black-milled-p-n-8176-2989/"
  },
  "Wheels::Pro Comp::Bandido": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/bandido/bandido-matte-black-16x8-8x6-5-4-5bs-offset-0mm-cap-p-n-703151500procomp-bandido-series-32-16x8-8x6-5-4-5bs-0mm-off-set-matte-black-p-n-7032-6882/",
    "description": "Bandido Series 32 16×8 8×6.5 4.5BS 0mm Off Set Matte Black Part #: 7032-6882 Alt PN: 7032-6882 GTIN: 844658018648 Primary Features Back Space: 4.5 Maxload 3420 Bolt Pattern: 8x6.5 Offset: 0 Size:16x8 Description Warranty Fitment Prop 65 Description The Pro Comp Bandido is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-bandido-ef059f94-shop-a6a4f6.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/7032-7982-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/bandido/bandido-matte-black-16x8-8x6-5-4-5bs-offset-0mm-cap-p-n-703151500procomp-bandido-series-32-16x8-8x6-5-4-5bs-0mm-off-set-matte-black-p-n-7032-6882/"
  },
  "Wheels::Pro Comp::Vintage": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/vintage/vintage-polished-15x10-5x4-5-3-625bs-offset-47mm-cap-p-n-7327041procomp-vintage-series-69-15x10-5x4-5-3-625bs-47mm-off-set-polished-p-n-1069-5165/",
    "description": "Vintage Series 69 15×10 5×4.5 3.625BS -47mm Off Set Polished Part #: 1069-5165 Alt PN: 1069-5165 GTIN: 844658000629 Primary Features Bolt Pattern: 5x4.5 Size:15x10 Offset: -47 Maxload 2500 Back Space: 3.625 Description Warranty Fitment Prop 65 Description The Pro Comp Vintage is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-vintage-cf0e7ec3-shop-98a722.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/1069-5165-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/vintage/vintage-polished-15x10-5x4-5-3-625bs-offset-47mm-cap-p-n-7327041procomp-vintage-series-69-15x10-5x4-5-3-625bs-47mm-off-set-polished-p-n-1069-5165/"
  },
  "Wheels::Pro Comp::Torq": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/torq/pro-comp-05-series-torq-17x8-wheel-with-6x5-5-bolt-pattern-graphite-2605-7883/",
    "description": "05 Series Torq 17×8 Wheel with 6X5.5 Bolt Pattern -Graphite Part #: 2605-7883 Alt PN: 2605-7883 GTIN: 844658056541 Primary Features Size: 17x8 Bolt Pattern: 6X5.5 Finish: Graphite Gray Offset: 0 Backspace: 4.5 Max Load: 2500 lbs Center Bore: 108 Center Cap PN: PXA8425042 Description Warranty Fitment Prop 65 Description Pro Comp Alloys are designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-torq-78b66816-shop-d2d71a.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/2605-7883-02.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/torq/pro-comp-05-series-torq-17x8-wheel-with-6x5-5-bolt-pattern-graphite-2605-7883/"
  },
  "Wheels::Pro Comp::Trilogy": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/trilogy/trilogy-satin-black-20x10-5x5-5-4-75bs-offset-18mm-cap-p-n-518351502procomp-trilogy-series73-20x10-5x5-5-4-75bs-18mm-off-set-satin-black-p-n-5173-21085/",
    "description": "Trilogy Series73 20×10 5×5.5 4.75BS -18mm Off Set Satin Black Part #: 5173-21085 Alt PN: 5173-21085 GTIN: 844658047648 Primary Features Size:20x10 Offset: -18 Bolt Pattern: 5x5.5 Back Space: 4.75 Maxload 2500 Description Warranty Fitment Prop 65 Description The Pro Comp Trilogy is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-trilogy-90fd358e-shop-bc2229.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/5173-21085-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/trilogy/trilogy-satin-black-20x10-5x5-5-4-75bs-offset-18mm-cap-p-n-518351502procomp-trilogy-series73-20x10-5x5-5-4-75bs-18mm-off-set-satin-black-p-n-5173-21085/"
  },
  "Wheels::Pro Comp::Axis": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/axis/axis-satin-black-17x9-8x170-4-75bs-offset-6mm-cap-p-n-517256802procomp-axis-series72-17x9-8x170-4-75bs-6mm-off-set-satin-black-p-n-5172-7970/",
    "description": "Axis Series72 17×9 8×170 4.75BS -6mm Off Set Satin Black Part #: 5172-7970 Alt PN: 5172-7970 GTIN: 844658047570 Primary Features Offset: -6 Maxload 3650 Size:17x9 Bolt Pattern: 8x170 Back Space: 4.75 Description Warranty Fitment Prop 65 Description The Pro Comp Axis is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-axis-2f01859a-shop-e7dd70.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/5172-7970-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/axis/axis-satin-black-17x9-8x170-4-75bs-offset-6mm-cap-p-n-517256802procomp-axis-series72-17x9-8x170-4-75bs-6mm-off-set-satin-black-p-n-5172-7970/"
  },
  "Wheels::Pro Comp::Cognos": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/cognos/cognos-satin-black-milled-18x9-5x150-5bs-offset-0mm-cap-p-n-503445000procomp-cognos-series-61-18x9-5x150-5bs-0mm-off-set-satin-black-milled-p-n-5161-895550/",
    "description": "Cognos Series 61 18×9 5×150 5BS 0mm Off Set Satin Black Milled Part #: 5161-895550 Alt PN: 5161-895550 GTIN: 844658044302 Primary Features Maxload 2500 Offset: 0 Bolt Pattern: 5x150 Size:18x9 Back Space: 5 Description Warranty Fitment Prop 65 Description The Pro Comp Cognos is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-cognos-7b6c45bd-shop-e9fac7.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/5161-895550-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/cognos/cognos-satin-black-milled-18x9-5x150-5bs-offset-0mm-cap-p-n-503445000procomp-cognos-series-61-18x9-5x150-5bs-0mm-off-set-satin-black-milled-p-n-5161-895550/"
  },
  "Wheels::Pro Comp::Rockwell": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/rockwell/pro-comp-34-series-rockwell-17x8-5-wheel-with-5x5-bolt-pattern-graphite-2634-78573/",
    "description": "34 Series Rockwell 17×8.5 Wheel with 5×5 Bolt Pattern -Graphite Part #: 2634-78573 Alt PN: 2634-78573 GTIN: 844658056626 Primary Features Size: 17x8.5 Bolt Pattern: 5x5 Finish: Graphite Gray Offset: 0 Backspace: 4.75 Max Load: 2500 lbs Center Bore: 71.5 Center Cap PN: PXA503432742 Description Warranty Fitment Prop 65 Description Pro Comp Alloys are designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-rockwell-2fc4d594-shop-15de2e.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/2634-78583-02.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/rockwell/pro-comp-34-series-rockwell-17x8-5-wheel-with-5x5-bolt-pattern-graphite-2634-78573/"
  },
  "Wheels::Pro Comp::La Paz": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/la-paz/la-paz-satin-black-17x8-5-6x5-5-4-75bs-offset-0mm-cap-p-n-502942500procomp-la-paz-series-29-17x8-5-6x5-5-4-75bs-0mm-off-set-satin-black-p-n-5029-78583/",
    "description": "La Paz Series 29 17×8.5 6×5.5 4.75BS 0mm Off Set Satin Black Part #: 5029-78583 Alt PN: 5029-78583 GTIN: 844658025882 Primary Features Offset: 0 Bolt Pattern: 6x5.5 Maxload 2500 Size:17x8.5 Back Space: 4.75 Description Warranty Fitment Prop 65 Description The Pro Comp La Paz is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-la-paz-a956d38c-shop-6b4d0c.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/5029-6883-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/la-paz/la-paz-satin-black-17x8-5-6x5-5-4-75bs-offset-0mm-cap-p-n-502942500procomp-la-paz-series-29-17x8-5-6x5-5-4-75bs-0mm-off-set-satin-black-p-n-5029-78583/"
  },
  "Wheels::Pro Comp::Phaser": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/phaser/pro-comp-41-series-phaser-17x9-wheel-with-6x5-5-bolt-pattern-graphite-2641-7983/",
    "description": "41 Series Phaser 17×9 Wheel with 6X5.5 Bolt Pattern -Graphite Part #: 2641-7983 Alt PN: 2641-7983 GTIN: 844658056701 Primary Features Size: 17x9 Bolt Pattern: 6X5.5 Finish: Graphite Gray Offset: -6 Backspace: 4.75 Max Load: 2500 lbs Center Bore: 108 Center Cap PN: PXA504163542 Description Warranty Fitment Prop 65 Description Pro Comp Alloys are designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-phaser-d053fc2c-shop-8e8d45.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/2641-7973-02.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/phaser/pro-comp-41-series-phaser-17x9-wheel-with-6x5-5-bolt-pattern-graphite-2641-7983/"
  },
  "Wheels::Pro Comp::Vertigo": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/vertigo/vertigo-matte-graphite-17x9-5x5-4-75bs-offset-6mm-cap-p-n-5040556000procomp-vertigo-series-40-17x9-5x5-4-75bs-6mm-off-set-matte-graphite-p-n-2640-7973/",
    "description": "Vertigo Series 40 17×9 5×5 4.75BS -6mm Off Set Matte Graphite Part #: 2640-7973 Alt PN: 2640-7973 GTIN: 844658035232 Primary Features Offset: -6 Size:17x9 Maxload 2500 Back Space: 4.75 Bolt Pattern: 5x5 Description Warranty Fitment Prop 65 Description The Pro Comp Vertigo is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-vertigo-e002556f-shop-9698c0.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/2640-7973-01.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/vertigo/vertigo-matte-graphite-17x9-5x5-4-75bs-offset-6mm-cap-p-n-5040556000procomp-vertigo-series-40-17x9-5x5-4-75bs-6mm-off-set-matte-graphite-p-n-2640-7973/"
  },
  "Wheels::Pro Comp::Predator": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/predator/predator-matte-graphite-17x8-5-6x5-5-4-75bs-offset-0mm-cap-p-n-503434200procomp-predator-series-35-17x8-5-6x5-5-4-75bs-0mm-off-set-matte-graphite-p-n-2635-78583/",
    "description": "Predator Series 35 17×8.5 6×5.5 4.75BS 0mm Off Set Matte Graphite Part #: 2635-78583 Alt PN: 2635-78583 GTIN: 844658038073 Primary Features Back Space: 4.75 Maxload 2200 Size:17x8.5 Offset: 0 Bolt Pattern: 6x5.5 Description Warranty Fitment Prop 65 Description The Pro Comp Predator is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-predator-020bec1c-shop-9a7c1b.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/2635-78583-03.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/predator/predator-matte-graphite-17x8-5-6x5-5-4-75bs-offset-0mm-cap-p-n-503434200procomp-predator-series-35-17x8-5-6x5-5-4-75bs-0mm-off-set-matte-graphite-p-n-2635-78583/"
  },
  "Wheels::Pro Comp::Kore": {
    "productUrl": "https://www.procompusa.com/shop/alloy-wheel/kore/kore-polished-17x8-6x5-5-4-5bs-offset-0mm-cap-p-n-7425041procomp-kore-series-89-17x8-6x5-5-4-5bs-0mm-off-set-polished-p-n-1089-7883/",
    "description": "Kore Series 89 17×8 6×5.5 4.5BS 0mm Off Set Polished Part #: 1089-7883 Alt PN: 1089-7883 GTIN: 844658001770 Primary Features Back Space: 4.5 Bolt Pattern: 6x5.5 Maxload 2500 Offset: 0 Size:17x8 Description Warranty Fitment Prop 65 Description The Pro Comp Kore is designed using State-Of-The-Art Low-Pressure-Casting Technology providing unsurpassed wheel strength, style and value. Pro Comp Alloys are amongst the highest load rated wheels in the industry, ranging from 2500 LBS to 3650 LBS per wheel.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-pro-comp-kore-a17e0041-shop-0799c6.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/03/1089-7883-01-scaled.jpg",
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.procompusa.com/shop/alloy-wheel/kore/kore-polished-17x8-6x5-5-4-5bs-offset-0mm-cap-p-n-7425041procomp-kore-series-89-17x8-6x5-5-4-5bs-0mm-off-set-polished-p-n-1089-7883/"
  },
  "Wheels::Pro Comp::Gunner": {
    "productUrl": "https://www.procompusa.com/category/wheels/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Pro Comp::Vapor Pro 2": {
    "productUrl": "https://www.procompusa.com/category/wheels/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pro Comp wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-pro-comp-vapor-pro-2-75cf15b0-shop-10e096.webp",
    "imageSourceUrl": "https://www.procompusa.com/wp-content/uploads/2025/07/PRO-COMP-PA206-SNARE-20X9-6-ET0-MATTE-BLACK-A1.png"
  },
  "Wheels::Ion Wheels::101": {
    "productUrl": "https://www.ionalloy.com/101",
    "description": "&lt;&lt;&lt; Previous Page 101 Finish: Gloss Black W/Machined Face Sizes: 16X6.5 | 16X7 PART NUMBER NAME STYLE NUMBER DIAMETER WHEEL WIDTH HUB PCD1 OFFSETNUM WHEEL CAP FINISH LOAD RATING UPC BACKSPACE 101-6631B 101 101 16 6.5 63.4 5-108 50 C10101B GLOSS BLACK/MACHINED FACE 2500 7.29419E+11 5.72 101-6741B 101 101 16 7 65.1 5-160 55 C10101B GLOSS BLACK/MACHINED FACE 2500 7.29419E+11 6.17 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/101",
    "localImage": "catalog-wheels-ion-wheels-101-9322da81-shop-339c26.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488476294049-F0A8OQUCGR488F077M8L/ION101B1.png"
  },
  "Wheels::Ion Wheels::102": {
    "productUrl": "https://www.ionalloy.com/102-satinblack",
    "description": "&lt;&lt;&lt; Previous Page 102 Finish: Satin Black Sizes: 16X6.5 | 16X7 | 17X7.5 | 18X8 | 19X8 | 20X8.5 PART NUMBER NAME STYLE NUMBER DIAMETER WHEEL WIDTH HUB PCD1 OFFSETNUM WHEEL CAP FINISH LOAD RATING UPC BACKSPACE 102-8830B 102 102 18 8 84.1 5-130 50 C10102C GLOSS BLACK/MACHINED FACE 2800 7.29419E+11 6.47 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/102-satinblack",
    "localImage": "catalog-wheels-ion-wheels-102-c2e50cb3-shop-4f5bf5.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488474071732-ZFJZZHDTPAW9ZDCQZYXW/ION102B1.png"
  },
  "Wheels::Ion Wheels::103": {
    "productUrl": "https://www.ionalloy.com/103-black-machined-face",
    "description": "&lt;&lt;&lt; Previous Page 102 Finish: Black W/Machined Face Sizes: 16X6.5 | 16X7 | 17X7.5 | 18X8 | 19X8 | 20X8.5 PART NUMBER NAME STYLE NUMBER DIAMETER WHEEL WIDTH HUB PCD1 OFFSETNUM WHEEL CAP FINISH LOAD RATING UPC BACKSPACE 102-8830B 102 102 18 8 84.1 5-130 50 C10102C GLOSS BLACK/MACHINED FACE 2800 7.29419E+11 6.47 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/103-black-machined-face",
    "localImage": "catalog-wheels-ion-wheels-103-6be17104-shop-9287d5.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488474045316-O67G7R2G3DQFPFIM2M1O/ION103M1.png"
  },
  "Wheels::Ion Wheels::133": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::135": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::141": {
    "productUrl": "https://www.ionalloy.com/141-black-milled-spokes",
    "description": "&lt;&lt;&lt; Previous Page 141 Finish: Gloss Black W/Milled Spokes Sizes: 17X9 | 18X9 | 20X9 | 20X10 | 20X12 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/141-black-milled-spokes",
    "localImage": "catalog-wheels-ion-wheels-141-f7da4758-shop-cf1b10.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1620169056059-EDAOKWYR7QZD1XII8C6V/ION141M1.png"
  },
  "Wheels::Ion Wheels::143": {
    "productUrl": "https://www.ionalloy.com/143",
    "description": "&lt;&lt;&lt; Previous Page STYLE 143 Finish: Matte Black Sizes: 17X9 | 18x9 | 20X9 | 20X10 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/143",
    "localImage": "catalog-wheels-ion-wheels-143-5ec3b918-shop-216584.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1581463126908-XIH2R7K0NMR4FLPOW0HY/ION143MB1.png"
  },
  "Wheels::Ion Wheels::144": {
    "productUrl": "https://www.ionalloy.com/144-matte-black",
    "description": "&lt;&lt;&lt; Previous Page 144 Finish: Matte Black Sizes: 17X9 | 20X9 | 20X10 PART NUMBER NAME STYLE NUMBER DIAMETER WHEEL WIDTH HUB PCD1 PCD2 OFFSETNUM WHEEL CAP FINISH LOAD RATING UPC BACKSPACE 144-7937MB 144 144 17 9 106 6-135 6-139.7 -12 C10144MB01 MATTE BLACK 2500 729419148492 4.53 144-7952MB 144 144 17 9 87.1 5-127 5-139.7 -12 C10144MB01 MATTE BLACK 2500 729419148508 4.53 144-2937MB 144 144 20 9 106 6-135 6-139.7 0 C10144MB01 MATTE BLACK 2500 729419148577 5 144-2952MB 144 144 20 9 87.1 5-127 5-139.7 0 C10144M",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/144-matte-black",
    "localImage": "catalog-wheels-ion-wheels-144-38215ea4-shop-f172f5.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1581463326934-S2GXAKR8ZQ7PFPNJ8VLS/ION144MB1.png"
  },
  "Wheels::Ion Wheels::146": {
    "productUrl": "https://www.ionalloy.com/146-gb",
    "description": "&lt;&lt;&lt; Previous Page STYLE 146 GLOSS black AVAILABLE FINISHES: SIZES: 17x9 | 20x9 | 20x10 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/146-gb",
    "localImage": "catalog-wheels-ion-wheels-146-11c56e8a-shop-e98749.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1629391280682-YA8MR2C34T7XRKZG3HBG/ION146GB1.png"
  },
  "Wheels::Ion Wheels::147": {
    "productUrl": "https://www.ionalloy.com/147-gloss-black",
    "description": "&lt;&lt;&lt; Previous Page STYLE 147 GLOSS BLACK AVAILABLE FINISHES: SIZES: 17x9 | 20x9 | 20x10 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/147-gloss-black",
    "localImage": "catalog-wheels-ion-wheels-147-3a73ab5a-shop-960db1.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1652133495684-CID9U86GTDXB0XQ2U44M/ION147GB1.png"
  },
  "Wheels::Ion Wheels::149": {
    "productUrl": "https://www.ionalloy.com/149-gloss-black-machined",
    "description": "&lt;&lt;&lt; Previous Page STYLE 149 GLOSS BLACK MACHINED AVAILABLE FINISHES: HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/149-gloss-black-machined",
    "localImage": "catalog-wheels-ion-wheels-149-abdfeb63-shop-859ad6.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1652204473137-RNKB5NLNNDVJKSOHD5BN/ION149M1.png"
  },
  "Wheels::Ion Wheels::151": {
    "productUrl": "https://www.ionalloy.com/151-gloss-black-milled",
    "description": "&lt;&lt;&lt; Previous Page STYLE 151 GLOSS BLACK MILLED SIZES: 20x9 | 20x10 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/151-gloss-black-milled",
    "localImage": "catalog-wheels-ion-wheels-151-8c3ad37e-shop-a8fcf0.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1676494936933-1Q5XZOD86CLKMYWK4EJ6/ION151M1.png"
  },
  "Wheels::Ion Wheels::167": {
    "productUrl": "https://www.ionalloy.com/167",
    "description": "&lt;&lt;&lt; Previous Page 167 Finish: Polished Sizes: 16X6 | 17X6.5 | 20x8.25 PART NUMBER NAME STYLE NUMBER DIAMETER WHEEL WIDTH HUB PCD1 OFFSETNUM WHEEL CAP FINISH LOAD RATING BACKSPACE 167-6670FP 167 167 16 6 130.18 8-170 102 C1016601C POLISHED 3200 7.52 167-6670RP 167 167 16 6 130.18 8-170 -125 C1016602C POLISHED 3200 -1.42 167-6681FP 167 167 16 6 130.18 8-165.1 102 C1016601C POLISHED 3200 7.52 167-6681RP 167 167 16 6 130.18 8-165.1 -125 C1016602C POLISHED 3200 -1.42 167-7677FP 167 167 17 6.5 142.2 8-200 125.3",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/167",
    "localImage": "catalog-wheels-ion-wheels-167-223ff289-shop-bba965.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488491475628-KOSMLOIDWWEN9DGYCXV0/ION167PF1.png"
  },
  "Wheels::Ion Wheels::171": {
    "productUrl": "https://www.ionalloy.com/171",
    "description": "&lt;&lt;&lt; Previous Page 171 Finish: Black W/ Machined Lip Sizes: 15X8 | 15X10 | 16X8 | 16X10 | 17X9 | 18X9 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/171",
    "localImage": "catalog-wheels-ion-wheels-171-4c28bd85-shop-5f4b70.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488484123408-W2UOS7NZ9WFSEG2E6CY4/ION171B1.png"
  },
  "Wheels::Ion Wheels::174": {
    "productUrl": "https://www.ionalloy.com/174",
    "description": "&lt;&lt;&lt; Previous Page 174 Finishes Available: Black Beadlock Sizes: 15X8 | 15X10 | 16X8 | 16X10 | 17X9 | 18X9 | 20X9 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/174",
    "localImage": "catalog-wheels-ion-wheels-174-f1df2795-shop-9533de.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488491989796-UEX2A2YINXFMYQDLQP7F/ION174B1.png"
  },
  "Wheels::Ion Wheels::179": {
    "productUrl": "https://www.ionalloy.com/179-matteblack",
    "description": "&lt;&lt;&lt; Previous Page 179 Finish: Matte Black Sizes: 16X8 | 17X8 | 17X9 | 18X9 | 20X9 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/179-matteblack",
    "localImage": "catalog-wheels-ion-wheels-179-41e39bce-shop-2887cc.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488493258101-OJGTAE9ZJ9Q23DXPXK01/ION179MB1.png"
  },
  "Wheels::Ion Wheels::181": {
    "productUrl": "https://www.ionalloy.com/181",
    "description": "&lt;&lt;&lt; Previous Page 181 Finish: Satin Black W/ Milled Spokes Sizes: 17X9 | 18X9 | 20X9 | 20X12 PART NUMBER NAME STYLE NUMBER DIAMETER WHEEL WIDTH HUB PCD1 PCD2 OFFSETNUM WHEEL CAP FINISH LOAD RATING UPC BACKSPACE 181-7937B18 181 181 17 9 106 6-135 6-139.7 18 C10181MB SATIN BLACK 2500 729419151294 5.71 181-7952B18 181 181 17 9 87 5-127 5-139.7 18 C10181MB SATIN BLACK 2500 729419151300 5.71 181-7976B18 181 181 17 9 130.8 8-165.1 8-170 18 C10181MB SATIN BLACK 3300 729419151317 5.71 181-8937B18 181 181 18 9 106",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/181",
    "localImage": "catalog-wheels-ion-wheels-181-5dedc262-shop-8af756.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488479637846-HRGJVPLSYQUGXQ645PTW/ION181M1.png"
  },
  "Wheels::Ion Wheels::183": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::184": {
    "productUrl": "https://www.ionalloy.com/184",
    "description": "&lt;&lt;&lt; Previous Page 184 Finish: Satin Black W/ Milled Spokes Sizes: 17X9 | 18X9 | 20X9 | 20X10 | 22X10 HOME Ion Wheels Ion Trailer Ion Bilt Dealers Warranty Contact Become A Dealer",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "visible-page",
    "descriptionSourceUrl": "https://www.ionalloy.com/184",
    "localImage": "catalog-wheels-ion-wheels-184-0ed9e90b-shop-868af4.webp",
    "imageSourceUrl": "https://images.squarespace-cdn.com/content/v1/58b46a518419c21735b3f30d/1488478394880-FS7WMD22AG2U20VWNQUO/ION184M1.png"
  },
  "Wheels::Ion Wheels::186": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::187": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::189": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::190": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::193": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::Ion Wheels::194": {
    "productUrl": "https://www.ionalloy.com/",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Ion Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ]
  },
  "Wheels::XD Wheels::Colossus": {
    "productUrl": "https://www.xdwheels.com/xd-colossus",
    "description": "Take on the trails with the XD872 Colossus, built to make a statement on and off the pavement. Its bold split 6-spoke design dives into a deep concave profile, giving your rig serious attitude from every angle. Available in 20x9” and 20x10” sizes with -18mm offset options and multi-lug blanks for 5, 6, or 8-lug applications, this wheel is made to fit a wide range of setups. Whether you're crawling through rocky lines or hammering the pavement, the Colossus is ready to back you up.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-colossus-23dcb190-shop-ad4343.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd-xd872-colossus-20x10-6-et-18-matte-black-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-colossus"
  },
  "Wheels::XD Wheels::Bomber": {
    "productUrl": "https://www.xdwheels.com/xd-bomber",
    "description": "We build the XD870 Bomber with its robust monoblock construction and concave profile to take on the rough country. The Bomber features a removable and replaceable rock ring designed for off-road enthusiasts, ensuring your wheels stay in top shape even after intense off-roading adventures. With a sturdy I-beam spoke design, this wheel is built to withstand the harshest conditions in style.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-bomber-89620434-shop-dd8fb0.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd-xd870mx-bomber-20x10-6-et-18-matte-black-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-bomber"
  },
  "Wheels::XD Wheels::Buck 25": {
    "productUrl": "https://www.xdwheels.com/xd-buck-25",
    "description": "XD82529067300 - XD XD825 BUCK 25 - GLOSS BLACK MILLED - 20\" Diameter - 20X9 0MM offset - 6X135/6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-buck-25-1067f3e2-shop-96d46f.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd8253-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-buck-25"
  },
  "Wheels::XD Wheels::FMJ": {
    "productUrl": "https://www.xdwheels.com/xd-fmj",
    "description": "XD13779087912N - XD XD137 FMJ - SATIN BLACK W/ DARK TINT - 17\" Diameter - 17X9 -12MM offset - 8X170 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-fmj-8248d8ce-shop-25b5ab.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd1379-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-fmj"
  },
  "Wheels::XD Wheels::Gauntlet": {
    "productUrl": "https://www.xdwheels.com/xd-gauntlet",
    "description": "XD85221087418N - XD XD852 GAUNTLET - SATIN BLACK W/ GRAY TINT - 20\" Diameter - 20X10 -18MM offset - 8X170 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-gauntlet-e5b110c8-shop-2df028.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/g/a/gauntlet-xd8527-6lug-17x9-et0-satin-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-gauntlet"
  },
  "Wheels::XD Wheels::Grenade 2": {
    "productUrl": "https://www.xdwheels.com/xd-grenade-2",
    "description": "XD84989088318 - XD XD849 GRENADE 2 - GLOSS BLACK MILLED - 18\" Diameter - 18X9 18MM offset - 8X180 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-grenade-2-5470ad4c-shop-9fb950.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/g/r/grenade-2-xd8493-6lug-20x10-et12-gloss-blk-n-milled-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-grenade-2"
  },
  "Wheels::XD Wheels::Grenade Dually": {
    "productUrl": "https://www.xdwheels.com/xd-grenade-dually",
    "description": "XD843765893111 - XD XD843 GRENADE DUALLY - GLOSS BLACK MILLED - FRONT - 17\" Diameter - 17X6.5 111MM offset - 8X210 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-grenade-dually-abf6b1e2-shop-30966c.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd8433f-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-grenade-dually"
  },
  "Wheels::XD Wheels::Grenade II": {
    "productUrl": "https://www.xdwheels.com/xd-grenade-ii",
    "description": "XD84922268344N - XD XD849 GRENADE II - GLOSS BLACK MILLED - 22\" Diameter - 22X12 -44MM offset - 6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-grenade-ii-5470ad4c-shop-0f0a98.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/g/r/grenade-2-xd8493-6lug-20x10-et12-gloss-blk-n-milled-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-grenade-ii"
  },
  "Wheels::XD Wheels::Hoss II": {
    "productUrl": "https://www.xdwheels.com/xd-hoss-ii",
    "description": "XD82921050324N - XD XD829 HOSS II - GLOSS BLACK - 20\" Diameter - 20X10 -24MM offset - 5X127 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-hoss-ii-f93266aa-shop-a838e7.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd8293-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-hoss-ii"
  },
  "Wheels::XD Wheels::Monster": {
    "productUrl": "https://www.xdwheels.com/xd-monster",
    "description": "The original XD778 Monster is a matte black 18x9 cast wheel. XD publishes seven dual-pattern variants with offsets from -12 mm to +35 mm.",
    "availableSizes": [
      "18x9"
    ],
    "notes": [
      "XD778 original Monster model",
      "Matte black finish",
      "Do not confuse with the later XD822 Monster II"
    ],
    "localImage": "wheel-xd-monster-xd778-official-shop-8facbd.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd7787-a1-png.png?quality=90&fit=bounds&height=1200&width=1200",
    "descriptionSource": "official-manufacturer-product-page",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-monster"
  },
  "Wheels::XD Wheels::Monster 2": {
    "productUrl": "https://www.xdwheels.com/xd-monster-2",
    "description": "XD82221087724N - XD XD822 MONSTER II - MATTE BLACK - 20\" Diameter - 20X10 -24MM offset - 8X170 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-monster-2-590e7329-shop-e3c51f.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd8227-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-monster-2"
  },
  "Wheels::XD Wheels::Monster 3": {
    "productUrl": "https://www.xdwheels.com/xd-monster-3",
    "description": "XD85121035718N - XD XD851 MONSTER 3 - SATIN BLACK - 20\" Diameter - 20X10 -18MM offset - 5X127/5X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-monster-3-f1a6cb76-shop-571aaa.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/m/o/monster-3-xd8517-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-monster-3"
  },
  "Wheels::XD Wheels::Omega": {
    "productUrl": "https://www.xdwheels.com/xd-omega",
    "description": "XD85679067900 - XD XD856 OMEGA - SATIN BLACK MACHINED LIP W/ RED TINT - 17\" Diameter - 17X9 0MM offset - 6X135/6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-omega-fc57c9d7-shop-d28991.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/o/m/omega-xd856-omega-20x10-satin-blk-w-red-tint-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-omega"
  },
  "Wheels::XD Wheels::Onslaught": {
    "productUrl": "https://www.xdwheels.com/xd-onslaught",
    "description": "XD86021080318N - XD XD860 ONSLAUGHT - GLOSS BLACK MILLED - 20\" Diameter - 20X10 -18MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-onslaught-a8f74683-shop-fbf2a8.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/o/n/onslaught-xd860-17x9-6lug-et0-candy-red-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-onslaught"
  },
  "Wheels::XD Wheels::Outbreak": {
    "productUrl": "https://www.xdwheels.com/xd-outbreak",
    "description": "XD84729077418 - XD XD847 OUTBREAK - SATIN BLACK W/ GRAY TINT - 20\" Diameter - 20X9 18MM offset - 6X120 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-outbreak-813525d1-shop-b1da4f.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/o/u/outbreak-xd847-20x10-6lug-et12-satin-blk-n-grey-tint-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-outbreak"
  },
  "Wheels::XD Wheels::Outlander": {
    "productUrl": "https://www.xdwheels.com/xd-outlander",
    "description": "#html-body [data-pb-style=JNCWYXM]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}The XD866 Outlander was designed from the ground up for heavy-duty applications. Not only is the Outlander built like a tank, but its style is reinforced with various functional visual cues.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-outlander-47456d80-shop-bdd4c2.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd866-outlander-22x10-6lug-et-18-gloss-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-outlander"
  },
  "Wheels::XD Wheels::Panzer": {
    "productUrl": "https://www.xdwheels.com/xd-panzer",
    "description": "XD13629035700 - XD XD136 PANZER - SATIN BLACK - 20\" Diameter - 20X9 0MM offset - 5X127/5X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-panzer-ff362754-shop-df9015.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd1367-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-panzer"
  },
  "Wheels::XD Wheels::Pike Dually": {
    "productUrl": "https://www.xdwheels.com/xd-pike-dually",
    "description": "XD845282893221N - XD XD845 PIKE DUALLY - GLOSS BLACK MILLED - REAR - 22\" Diameter - 22X8.25 -221MM offset - 8X210 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-pike-dually-fabcd5c7-shop-56ab18.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd845-dually-front-v2-right-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-pike-dually"
  },
  "Wheels::XD Wheels::R.O.F.": {
    "productUrl": "https://www.xdwheels.com/xd-r-o-f",
    "description": "Introducing the XD869 R.O.F wheel by XD - a sleek and rugged choice for your truck or Jeep. With its matte black finish and gloss black removable knurled attachment ring, this wheel offers iconic XD style and functionality. The XD869 features the classic XD heavy-duty design and robust monoblock construction, engineered to elevate your lifted truck or Jeep's performance and aesthetics.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-r-o-f",
    "localImage": "catalog-wheels-xd-wheels-r-o-f-8472eb8f-shop-3fcc37.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd-xd869mx-r-o-f-20x10-6-et-18-matte-black-a1-png.png"
  },
  "Wheels::XD Wheels::Raid": {
    "productUrl": "https://www.xdwheels.com/xd-raid",
    "description": "XD86279068400 - XD XD862 RAID - CEMENT - 17\" Diameter - 17X9 0MM offset - 6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-raid-cc148023-shop-7d4223.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/r/a/raid-xd862-6lug-20x10-et-18-satin-blk-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-raid"
  },
  "Wheels::XD Wheels::Reactor": {
    "productUrl": "https://www.xdwheels.com/xd-reactor",
    "description": "XD85429035300 - XD XD854 REACTOR - GLOSS BLACK MILLED - 20\" Diameter - 20X9 0MM offset - 5X127/5X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-reactor-b7e3854c-shop-652be0.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/r/e/reactor-xd8549-6lug-20x10-gloss-blk-milled-red-tint-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-reactor"
  },
  "Wheels::XD Wheels::Rockstar": {
    "productUrl": "https://www.xdwheels.com/xd-rockstar",
    "description": "XD77589080300 - XD XD775 ROCKSTAR - MATTE BLACK - 18\" Diameter - 18X9 00MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-rockstar-460830a7-shop-e15b9c.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd7753-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-rockstar"
  },
  "Wheels::XD Wheels::Rover": {
    "productUrl": "https://www.xdwheels.com/xd-rover",
    "description": "XD86421068318N - XD XD864 ROVER - GLOSS BLACK MILLED - 20\" Diameter - 20X10 -18MM offset - 6X139.7 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-rover-d7fb0650-shop-335a90.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd-xd864-22x10-6lug-et-18-polished-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-rover"
  },
  "Wheels::XD Wheels::RS2": {
    "productUrl": "https://www.xdwheels.com/xd-rs2",
    "description": "XD81121280744N - XD XD811 ROCKSTAR II - MATTE BLACK W/ ACCENTS - 20\" Diameter - 20X12 -44MM offset - 8X165.1 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-rs2"
  },
  "Wheels::XD Wheels::Spy": {
    "productUrl": "https://www.xdwheels.com/xd-spy-ii",
    "description": "XD84021087318N - XD XD840 SPY II - GLOSS BLACK MACHINED - 20\" Diameter - 20X10 -18MM offset - 8X170 Bolt Pattern",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "product-catalog-wheels-xd-wheels-spy-9f46f55b-shop-9d7c0d.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd8403-a1-png.png",
    "descriptionSource": "json-ld",
    "descriptionSourceUrl": "https://www.xdwheels.com/xd-spy-ii"
  },
  "Wheels::XD Wheels::Surge": {
    "productUrl": "https://www.xdwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.xdwheels.com/media/catalog/product/r/o/rover-xd864-20x10-6lug-et-18-gloss-blk-n-milled-a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::XD Wheels::Tank": {
    "productUrl": "https://www.xdwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.xdwheels.com/media/catalog/product/r/o/rover-xd864-20x10-6lug-et-18-gloss-blk-n-milled-a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::XD Wheels::Thump": {
    "productUrl": "https://www.xdwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.xdwheels.com/media/catalog/product/r/o/rover-xd864-20x10-6lug-et-18-gloss-blk-n-milled-a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::XD Wheels::XD820 Grenade": {
    "productUrl": "https://www.xdwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "rejectedImageSourceUrl": "https://www.xdwheels.com/media/catalog/product/r/o/rover-xd864-20x10-6lug-et-18-gloss-blk-n-milled-a1-png.png?quality=80&fit=bounds&height=&width=",
    "imageStatus": "blocked-duplicate-or-generic-source"
  },
  "Wheels::Street Pro::002 Series": {
    "productUrl": "https://www.streetprowheels.com.au/wheels/002",
    "description": "Street Pro 002 Series is a road-legal Convo Pro style wheel for classic Holden, Chevrolet and Ford fitments, with polished, black and beadlock-style finishes available across selected sizes.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Street Pro wheel model",
      "Passenger and street performance fitments vary by vehicle",
      "Pricing, stock and fitment are confirmed by enquiry"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-street-pro-002-series-629d8901-shop-cec366.webp",
    "imageSourceUrl": "https://www.streetprowheels.com.au/assets/thumbL/STP002-158000-POL.jpg?20260519061956",
    "descriptionSource": "official-summary",
    "descriptionSourceUrl": "https://www.streetprowheels.com.au/wheels/002"
  },
  "Wheels::Street Pro::005 Series": {
    "productUrl": "https://www.streetprowheels.com.au/wheels/005",
    "description": "Street Pro 005 Series is a Convo Pro wheel range aimed at classic street and muscle car builds, with polished finish options and selected Holden, Chevrolet and Ford fitments.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Street Pro wheel model",
      "Passenger and street performance fitments vary by vehicle",
      "Pricing, stock and fitment are confirmed by enquiry"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-street-pro-005-series-6bbffc34-shop-6136a2.webp",
    "imageSourceUrl": "https://www.streetprowheels.com.au/assets/thumbL/STP005-151000.jpg?20260519062103",
    "descriptionSource": "official-summary",
    "descriptionSourceUrl": "https://www.streetprowheels.com.au/wheels/005"
  },
  "Wheels::Street Pro::007 Series": {
    "productUrl": "https://www.streetprowheels.com.au/wheels/007",
    "description": "Street Pro 007 Series is a street and drag-style wheel line with black, polished and raw-brushed style variants across selected Ford, Holden and Chevrolet bolt-pattern fitments.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Street Pro wheel model",
      "Passenger and street performance fitments vary by vehicle",
      "Pricing, stock and fitment are confirmed by enquiry"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-street-pro-007-series-9482e29c-shop-1badc5.webp",
    "imageSourceUrl": "https://www.streetprowheels.com.au/assets/thumbL/STP007-154000F-BK.jpg?20260519062132",
    "descriptionSource": "official-summary",
    "descriptionSourceUrl": "https://www.streetprowheels.com.au/wheels/007"
  },
  "Wheels::Street Pro::009 Series": {
    "productUrl": "https://www.streetprowheels.com.au/wheels/009-series/",
    "description": "Street Pro 009 Series is a forged street and drag wheel family with front and rear beadlock options, billet beadlock ring options and selected polished or gloss black milled finishes.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Street Pro wheel model",
      "Passenger and street performance fitments vary by vehicle",
      "Pricing, stock and fitment are confirmed by enquiry"
    ],
    "localImage": "product-catalog-keyed-catalog-wheels-street-pro-009-series-77452ed9-shop-b8f5f1.webp",
    "imageSourceUrl": "https://www.streetprowheels.com.au/assets/thumbL/STP009-BL158001-BK.jpg?20260519062243",
    "descriptionSource": "official-summary",
    "descriptionSourceUrl": "https://www.streetprowheels.com.au/wheels/009-series/"
  },
  "Wheels::XD Wheels::XD827 Rockstar III": {
    "productUrl": "https://www.xdwheels.com/wheels",
    "description": "Contact us for more information regarding this product!",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "XD Wheels wheel model",
      "Pricing, stock and fitment are confirmed by enquiry",
      "Can be matched with tyres and accessories where suitable"
    ],
    "localImage": "catalog-wheels-xd-wheels-xd827-rockstar-iii-7d0b6ad8-shop-f71f5a-hq.webp",
    "imageSourceUrl": "https://www.xdwheels.com/media/catalog/product/x/d/xd8277-a1-png.png?quality=90&fit=bounds&height=1200&width=1200"
  },
  "Wheels::Dynamic Steel Wheels::Sunraysia Imitation Beadlock": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/sunraysia-imitation-beadlock/",
    "description": "Dynamic’s steel Imitation Beadlock Sunraysia wheel delivers the aggressive beadlock look in a road-legal design. Built tough with thicker centres and high-grade steel outer rims, it’s engineered for strength and durability on and off the road. Featuring a high load rating for towing, premium powder coat finish, and Australia’s largest range of CBL-compatible steel wheels, it’s made to withstand harsh Aussie conditions. Backed by a lifetime structural warranty* and compatible with GVM upgrades. Dynamic’s Imitation Beadlock Sunraysia wheel is available in a range of in 15’’, 16’’ and 17’’.",
    "availableSizes": [
      "16x8",
      "17x8",
      "17x9",
      "15x7",
      "15x8",
      "16x7"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X150",
        "6X114.3",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-sunraysia-imitation-beadlock-1-8712e319-shop-11f2ca.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-sunraysia-imitation-beadlock-1-8712e319-shop-11f2ca.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Imitation-Beadlock-Sunraysia-Black-BI16813N61397B-Dynamic-Wheel-Co-Steel-Rims01111DWC-Steel-Wheel-Range.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/sunraysia-imitation-beadlock/"
  },
  "Wheels::Dynamic Steel Wheels::Sunraysia Genuine Beadlock": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/sunraysia-genuine-beadlock/",
    "description": "Engineered for serious off-road punishment, the Dynamic Steel Genuine Beadlock Sunraysia is built for those who don’t back down from rugged terrain. This classic black steel wheel features a true beadlock ring, giving hardcore 4WD enthusiasts the grip and security they need when running low pressures in harsh conditions. With its no-fuss Sunraysia design and ultra-strong steel construction, it's purpose-built for tracks, rock crawling, and remote expeditions - not the highway.",
    "availableSizes": [
      "16x8",
      "16x10"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "16 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X150",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-sunraysia-genuine-beadlock-1-97da4044-shop-2388c4.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-sunraysia-genuine-beadlock-1-97da4044-shop-2388c4.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Genuine-Beadlock-Sunraysia-Black-G16822N61397B-Dynamic-Wheel-Co-Steel-Rims01230DWC-Steel-Wheel-Range-1.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/sunraysia-genuine-beadlock/"
  },
  "Wheels::Dynamic Steel Wheels::Sunraysia": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/sunraysia/",
    "description": "Built for tough Aussie terrain, the Dynamic Sunraysia steel wheel delivers classic style with uncompromising strength. Available in Black, silver, chrome, galvanised, and white finishes, these wheels are engineered with thicker centres and high-grade steel rims for maximum durability. With a high load rating perfect for towing, and Australia’s largest range of CBL-compatible steel wheels. Featuring a premium powder coat finish, lifetime structural warranty*, and fitments for 4WDs, trailers, and GVM upgrades, it’s the steel wheel that’s made to last.",
    "availableSizes": [
      "13x4.5",
      "14x6",
      "15x6",
      "16x7",
      "17x7",
      "15x10",
      "15x7",
      "15x8",
      "16x10",
      "16x8",
      "17x7.5",
      "17x8",
      "18x8",
      "17x9",
      "16x6.5"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "13 inch",
        "14 inch",
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch"
      ],
      "Published finishes": [
        "Black",
        "Chrome",
        "Galvanised",
        "Silver",
        "White"
      ],
      "Published PCDs": [
        "4X108",
        "4X140",
        "4X98",
        "5X100",
        "5X108",
        "5X114.3",
        "5X120",
        "5X120.65",
        "5X130",
        "5X139.7",
        "5X150",
        "5X160",
        "5X165.1",
        "6X114.3",
        "6X120",
        "6X130",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-sunraysia-1-1da2bd1e-shop-b21992.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-sunraysia-1-1da2bd1e-shop-b21992.webp",
      "product-catalog-wheels-dynamic-steel-wheels-sunraysia-2-0527bf77-shop-91f1a8.webp",
      "product-catalog-wheels-dynamic-steel-wheels-sunraysia-3-c105fd5b-shop-52a052.webp",
      "product-catalog-wheels-dynamic-steel-wheels-sunraysia-4-a74616b8-shop-279679.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Sunraysia-Black-16813N61397B-Dynamic-Wheel-Co-Steel-Rims01185DWC-Steel-Wheel-Range-1.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/sunraysia/"
  },
  "Wheels::Dynamic Steel Wheels::Soft 8 Imitation Beadlock": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/soft-8-imitation-beadlock/",
    "description": "Dynamic's steel Imitation Beadlock Soft 8 wheel brings bold, off-road style to the street with a road-legal beadlock look. Built with thicker centres and high-grade steel outer rims for dependable durability. Featuring a premium powder coat finish and Australia’s largest range of CBL-compatible steel wheels, it’s backed by a lifetime structural warranty*. Dynamic's Imitation Beadlock Soft 8 have multiple fitments available.",
    "availableSizes": [
      "17x9",
      "17x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X127",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-soft-8-imitation-beadlock-1-d6fa63a6-shop-97c1d8.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-soft-8-imitation-beadlock-1-d6fa63a6-shop-97c1d8.webp",
      "product-catalog-wheels-dynamic-steel-wheels-soft-8-imitation-beadlock-2-e0496cfd-shop-aa95d6.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Imitation-Beadlock-Soft-8-Black-BI1790P5127BS-Dynamic-Wheel-Co-Steel-Rims01262DWC-Steel-Wheel-Range.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/soft-8-imitation-beadlock/"
  },
  "Wheels::Dynamic Steel Wheels::Soft 8": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/soft-8/",
    "description": "The Dynamic Soft 8 steel wheel is a sleek understated design. Featuring thicker centres and high-grade steel outer rims, it’s built to handle everyday adventures and off-road use. Finished in a premium powder coat to withstand the harsh Aussie elements, Dynamic offers Australia’s largest range of CBL-compatible steel wheels. Backed by a lifetime structural warranty* and available in a wide range of fitments.",
    "availableSizes": [
      "15x8",
      "16x8",
      "17x8",
      "17x9"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127",
        "5X150",
        "6X114.3",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-soft-8-1-ef7b953c-shop-05ca4f.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-soft-8-1-ef7b953c-shop-05ca4f.webp",
      "product-catalog-wheels-dynamic-steel-wheels-soft-8-2-741f02a2-shop-d59154.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Soft-8-Black-16822N61397BS-Dynamic-Wheel-Co-Steel-Rims01246DWC-Steel-Wheel-Range.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/soft-8/"
  },
  "Wheels::Dynamic Steel Wheels::Smoothie": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/smoothie/",
    "description": "Upgrade your ride with the industry-leading Dynamic Street Series steel wheels. Dynamic's Smoothie wheel in a chrome finish is sure to turn heads. Our full range of wheels are built by Australia’s steel wheel experts, these wheels combine classic style with proven durability. Dynamic Smoothie is covered by a lifetime structural warranty for peace of mind. With Australia’s largest range of fitments and national stock availability, Dynamic Street Series steel wheels deliver quality, reliability, and standout street appeal.",
    "availableSizes": [
      "15x6",
      "15x7",
      "15x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch"
      ],
      "Published finishes": [
        "Chrome"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-smoothie-1-04d29e35-shop-e9e7cd.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-smoothie-1-04d29e35-shop-e9e7cd.webp",
      "product-catalog-wheels-dynamic-steel-wheels-smoothie-2-22876fd8-shop-531c8a.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Smoothie-Chrome-1576P51145120-Steel-Rims00054DWC-Steel-Wheel-Range.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/smoothie/"
  },
  "Wheels::Dynamic Steel Wheels::Slotted": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/slotted/",
    "description": "Upgrade your ride with the industry-leading Dynamic Street Series steel wheels. Dynamic's Slotted wheel in a chrome finish is sure to turn heads. Our full range of wheels are built by Australia’s steel wheel experts, these wheels combine classic style with proven durability. Dynamic Smoothie is covered by a lifetime structural warranty for peace of mind. With Australia’s largest range of fitments and national stock availability, Dynamic Street Series steel wheels deliver quality, reliability, and standout street appeal.",
    "availableSizes": [
      "15x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch"
      ],
      "Published finishes": [
        "Chrome"
      ],
      "Published PCDs": [
        "5X114.3"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-slotted-1-5c6bfdfb-shop-212bed.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-slotted-1-5c6bfdfb-shop-212bed.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/dynamic-steel-wheels-slotted-chrome-25-angle.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/slotted/"
  },
  "Wheels::Dynamic Steel Wheels::Round Imitation Beadlock": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round-imitation-beadlock/",
    "description": "Dynamic's steel Imitation Beadlock Round Hole wheel brings bold, off-road style to the street with a road-legal beadlock look. Built with thicker centres and high-grade steel outer rims for dependable durability. Featuring a premium powder coat finish and Australia’s largest range of CBL-compatible steel wheels, it’s backed by a lifetime structural warranty*. Dynamic's Imitation Beadlock Round Hole have multiple fitments available.",
    "availableSizes": [
      "15x10"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-round-imitation-beadlock-1-46772e63-shop-39a148.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-round-imitation-beadlock-1-46772e63-shop-39a148.webp",
      "product-catalog-wheels-dynamic-steel-wheels-round-imitation-beadlock-2-27a10c2c-shop-496a27.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Imitation-Beadlock-Round-Black-BI151044N61397BR-Dynamic-Wheel-Co-Steel-Rims01295DWC-Steel-Wheel-Range-1.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round-imitation-beadlock/"
  },
  "Wheels::Dynamic Steel Wheels::Round HL Mine Spec": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round-hl-mine-spec/",
    "description": "Built for tough Aussie terrain, the Dynamic Mine Spec steel wheel delivers classic style with uncompromising strength. Available in Black and White finishes, these wheels are engineered with thicker centres and high-grade steel rims for maximum durability. With a high load rating perfect for towing, and Australia’s largest range of CBL-compatible steel wheels. Featuring a premium powder coat finish, lifetime structural warranty*, and large range fitments for 4WDs - 16'', 17''and 18''.",
    "availableSizes": [
      "16x8",
      "16x7",
      "16x10",
      "17x9"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black",
        "White"
      ],
      "Published PCDs": [
        "5X150",
        "6X139.7",
        "8X165.1",
        "8X170"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-round-hl-mine-spec-1-9ac9f430-shop-ecbaac.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-round-hl-mine-spec-1-9ac9f430-shop-ecbaac.webp",
      "product-catalog-wheels-dynamic-steel-wheels-round-hl-mine-spec-2-be44ef39-shop-b364e1.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Round-Hole-Black-16813N61397BR-Dynamic-Wheel-Co-Steel-Rims01133DWC-Steel-Wheel-Range.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round-hl-mine-spec/"
  },
  "Wheels::Dynamic Steel Wheels::Round Genuine Beadlock": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round-genuine-beadlock/",
    "description": "Designed for dedicated off-road enthusiasts, the Genuine Beadlock Round Hole steel wheel delivers rugged performance where it counts. Built with thicker centres and high-grade steel outer rims for superior durability, this black-finish beadlock wheel is made to tackle tough trails and challenging terrain. Featuring a premium powder coat finish for long-lasting protection against the Aussie elements, it’s CBL-compatible and backed by a lifetime structural warranty*. With a wide range of fitments and national stock availability, it’s the ideal beadlock wheel for your next off-road adventure.",
    "availableSizes": [
      "17x9"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X165.1"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-round-genuine-beadlock-1-88470e55-shop-a5fa36.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-round-genuine-beadlock-1-88470e55-shop-a5fa36.webp",
      "product-catalog-wheels-dynamic-steel-wheels-round-genuine-beadlock-2-845ed8d2-shop-15ca5f.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Genuine-Beadlock-Round-Hole-Black-G1793ON51651BR-Dynamic-Wheel-Co-Steel-Rims01219DWC-Steel-Wheel-Range.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round-genuine-beadlock/"
  },
  "Wheels::Dynamic Steel Wheels::Round": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round/",
    "description": "Tough steel wheel with classic round design, powder coat finish, and wide fitment options for your 4WD.",
    "availableSizes": [
      "15x8",
      "16x8",
      "16x7",
      "17x7.5",
      "15x7",
      "15x10",
      "16x10",
      "17x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X120",
        "5X139.7",
        "5X150",
        "5X165.1",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-round-1-9ac9f430-shop-1f5e98.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-round-1-9ac9f430-shop-1f5e98.webp",
      "product-catalog-wheels-dynamic-steel-wheels-round-2-1b476559-shop-9195cf.webp",
      "product-catalog-wheels-dynamic-steel-wheels-round-3-3e13bbc8-shop-ff2d98.webp",
      "product-catalog-wheels-dynamic-steel-wheels-round-4-1d1a4ec2-shop-d776d5.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Round-Hole-Black-16813N61397BR-Dynamic-Wheel-Co-Steel-Rims01133DWC-Steel-Wheel-Range.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/round/"
  },
  "Wheels::Dynamic Steel Wheels::OEM Plus": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/oem-plus/",
    "description": "The Dynamic OEM Plus steel wheel is an ageless round hole design. Featuring thicker centres and high-grade steel outer rims, it’s built to handle everyday adventures and light off-road use. Finished in a premium powder coat to withstand the harsh Aussie elements, Dynamic Steel wheels offer Australia’s largest range of CBL-compatible steel wheels. Backed by a lifetime structural warranty* and available in a wide range of fitments.",
    "availableSizes": [
      "15x6",
      "14x5.5",
      "16x6.5",
      "17x6.5",
      "19x7.5",
      "15x5.5",
      "17x7",
      "18x7.5",
      "18x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "14 inch",
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "19 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "4X100",
        "4X108",
        "4X114.3",
        "5X100",
        "5X108",
        "5X112",
        "5X114.3",
        "5X127",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-oem-plus-1-6ddc3a31-shop-af391b.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-oem-plus-1-6ddc3a31-shop-af391b.webp",
      "product-catalog-wheels-dynamic-steel-wheels-oem-plus-2-a30de688-shop-0a4a9c.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/OEM-Plus-Black-P15640P4100B-Dynamic-Wheel-Co-Steel-Rims01200DWC-Steel-Wheel-Range.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/oem-plus/"
  },
  "Wheels::Dynamic Steel Wheels::Interceptor": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/interceptor/",
    "description": "The newest addition to Dynamic steel wheel range - Interceptor. This wheel is a simple yet bold design. Our full range of wheels are built by Australia’s steel wheel experts, these wheels combine classic style with proven durability. Dynamic Interceptor is covered by a lifetime structural warranty for peace of mind. With Australia’s largest range of fitments and national stock availability, Dynamic Street Series steel wheels deliver quality, reliability, and standout street appeal.",
    "availableSizes": [
      "15x7",
      "16x7",
      "17x8",
      "17x9",
      "18x8",
      "18x9",
      "20x10",
      "20x8",
      "15x8",
      "20x9"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch",
        "20 inch"
      ],
      "Published finishes": [
        "Silver"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X120"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-interceptor-1-fe263cf3-shop-fb98bf.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-interceptor-1-fe263cf3-shop-fb98bf.webp",
      "product-catalog-wheels-dynamic-steel-wheels-interceptor-2-f18a6511-shop-cf5ee4.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Interceptor-Silver-P17945P5120I-Dynamic-Wheel-Co-Steel-Rims01024DWC-Steel-Wheel-Range-2.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/interceptor/"
  },
  "Wheels::Dynamic Steel Wheels::Drift D": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/drift-d/",
    "description": "Upgrade your ride with the industry-leading Dynamic Street Series steel wheels. Dynamic's Drift D Hole wheel in a satin black finish. Our full range of wheels are built by Australia’s steel wheel experts, these wheels combine classic style with proven durability. Finished in a premium powder coat to withstand the elements, they’re backed by a lifetime structural warranty for peace of mind. With Australia’s largest range of fitments and national stock availability, Dynamic Street Series steel wheels deliver quality, reliability, and standout street appeal.",
    "availableSizes": [
      "15x7",
      "15x8",
      "16x8",
      "17x9",
      "17x10",
      "17x8",
      "18x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch",
        "18 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "4X100",
        "4X114.3",
        "5X100",
        "5X114.3",
        "5X120",
        "5X120.65"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-drift-d-1-ef250ed7-shop-767b4c.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-drift-d-1-ef250ed7-shop-767b4c.webp",
      "product-catalog-wheels-dynamic-steel-wheels-drift-d-2-8bd4690b-shop-c66a59.webp",
      "product-catalog-wheels-dynamic-steel-wheels-drift-d-3-d3465c47-shop-443190.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Drift-D-Black-1680P51143BD-Steel-Rims01170DWC-Steel-Wheel-Range.jpg",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/drift-d/"
  },
  "Wheels::Dynamic Steel Wheels::D Shape Imitation Beadlock": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/d-shape-imitation-beadlock/",
    "description": "Dynamic’s steel Imitation Beadlock D Hole wheel delivers the aggressive beadlock look in a road-legal design. Built tough with thicker centres and high-grade steel outer rims, it’s engineered for strength and durability on and off the road. Featuring a high load rating for towing, premium powder coat finish, and Australia’s largest range of CBL-compatible steel wheels, it’s made to withstand harsh Aussie conditions. Backed by a lifetime structural warranty* and compatible with GVM upgrades. Dynamic’s Imitation Beadlock D Hole wheel is available in a range of in 15’’, 16’’ and 17’’.",
    "availableSizes": [
      "16x8",
      "17x8",
      "16x10",
      "15x8",
      "17x9"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X120",
        "5X127",
        "5X150",
        "6X114.3",
        "6X130",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-d-shape-imitation-beadlock-1-4446eab4-shop-0a2288.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-d-shape-imitation-beadlock-1-4446eab4-shop-0a2288.webp",
      "product-catalog-wheels-dynamic-steel-wheels-d-shape-imitation-beadlock-2-f5a50d88-shop-1f6bb1.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Imitation-Beadlock-D-Hole-Black-BI16813N613397BD-Dynamic-Wheel-Co-Steel-Rims01311DWC-Steel-Wheel-Range-1.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/d-shape-imitation-beadlock/"
  },
  "Wheels::Dynamic Steel Wheels::D Shape Genuine Beadlock": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/d-shape-genuine-beadlock/",
    "description": "Engineered for serious off-roaders, the Genuine Beadlock D hole a steel wheel delivers unmatched strength and performance. Featuring thicker centres and high-grade steel outer rims, this black-finish beadlock wheel is built to handle Australia’s toughest terrain. With a high load rating for heavy towing, premium powder coat for lasting protection, and Australia’s largest range of CBL-compatible steel wheels, it’s ready for any challenge. Backed by a lifetime structural warranty* and compatible with GVM upgrades, this is the ultimate wheel for off-road adventures.",
    "availableSizes": [
      "15x8",
      "16x10",
      "16x8",
      "17x8",
      "17x9"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-d-shape-genuine-beadlock-1-08fe7ea2-shop-566f42.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-d-shape-genuine-beadlock-1-08fe7ea2-shop-566f42.webp",
      "product-catalog-wheels-dynamic-steel-wheels-d-shape-genuine-beadlock-2-f805bbc8-shop-abfb5a.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/Genuine-Beadlock-D-Hole-Black-G16B22N61397BD-Dynamic-Wheel-Co-Steel-Rims01277DWC-Steel-Wheel-Range-1.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/d-shape-genuine-beadlock/"
  },
  "Wheels::Dynamic Steel Wheels::D Shape": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/d-shape/",
    "description": "Dynamic, the D-Hole steel wheel is a classic off-road style, built for strength and performance. Featuring thicker centres and high-grade steel outer rims, it’s engineered to tackle Australia’s toughest terrain. With a high load rating for towing, premium powder coat finish, and Australia’s largest range of CBL-compatible steel wheels, the Dynamic D-Hole is ready for any journey. Backed by a lifetime structural warranty* and available in the widest range of fitments nationwide.",
    "availableSizes": [
      "16x8",
      "17x8",
      "17x9",
      "16x7",
      "15x10",
      "15x8",
      "16x10"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X120",
        "5X127",
        "5X139.7",
        "5X150",
        "5X165.1",
        "6X114.3",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-d-shape-1-d5f83934-shop-e817bb.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-d-shape-1-d5f83934-shop-e817bb.webp",
      "product-catalog-wheels-dynamic-steel-wheels-d-shape-2-11024a0c-shop-bb2d96.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/dynamic-steel-wheels-d-hole-Black-25-angle.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/d-shape/"
  },
  "Wheels::Dynamic Steel Wheels::Drift Soft 8": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/drift-soft-8/",
    "description": "Dynamic Steel Wheels Drift Soft 8 is available through 110 Garage. Contact the team for current fitments, finishes, pricing and stock.",
    "availableSizes": [
      "16x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "High-grade steel construction with thicker centres and outer rims",
      "High-load fitments are available for towing and GVM applications",
      "Centre Bore Locating compatible options are available across the range",
      "Premium powder-coat finishes are built for Australian conditions",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Steel",
      "Available diameters": [
        "16 inch"
      ],
      "Published finishes": [
        "Black"
      ],
      "Published PCDs": [
        "5X114.3"
      ]
    },
    "localImage": "product-catalog-wheels-dynamic-steel-wheels-drift-soft-8-1-5f5217db-shop-b0737e.webp",
    "galleryImages": [
      "product-catalog-wheels-dynamic-steel-wheels-drift-soft-8-1-5f5217db-shop-b0737e.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2026/01/DYNAMIC-STEEL-DRIFT-SOFT-8-BLACK-ANGLE.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/drift-soft-8/"
  },
  "Wheels::DWC Wheels::Sentinel": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/sentinel/",
    "description": "Modern 4WD builds demand more than a good-looking wheel. They demand flexibility. The Sentinel is built around a bold 16-spoke architecture that delivers strength, precision, and a stance that suits today’s generation of lifted utes and touring rigs. At its core is EzyLok technology. Run it as a traditional wheel for everyday driving. Or configure it for beadlock setups when the offroad calls for lower pressures and more grip. Two setups. One wheel.",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Published finishes": [
        "Bronze",
        "Brushed Dark Tint",
        "Gloss Black",
        "Hyper Silver Machined"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X120",
        "5X127",
        "5X150",
        "6X114.3",
        "6X130",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-sentinel-1-a74dc829-shop-94ea3c.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-sentinel-1-a74dc829-shop-94ea3c.webp",
      "product-catalog-wheels-dwc-wheels-sentinel-2-c17096e7-shop-ee9fac.webp",
      "product-catalog-wheels-dwc-wheels-sentinel-3-aed07eeb-shop-f6470d.webp",
      "product-catalog-wheels-dwc-wheels-sentinel-4-572e54c5-shop-8d49c7.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2026/03/DWC-SENTINEL-GLOSS-BLACK-ANGLE-1024x1024.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/sentinel/"
  },
  "Wheels::DWC Wheels::Convict": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/convict/",
    "description": "With its striking 12-spoke design, DWC Convict wheels are engineered for the rugged landscapes and demanding terrains of the Australian outback. These wheels boast specialty fitments designed exclusively for the Australian market, ensuring a perfect match for your 4x4 vehicle. When it comes to durability, DWC Convict 4WD Wheels are second to none. Built to withstand high loads, these wheels are tailor-made to conquer the harsh Australian conditions, whether you're tackling rocky trails or navigating sandy dunes.",
    "availableSizes": [
      "17x8.5",
      "16x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black",
        "Bronze",
        "Gunmetal",
        "Hyper Silver Black Lip"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X114.3",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-convict-1-27f7e79d-shop-de628d.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-convict-1-27f7e79d-shop-de628d.webp",
      "product-catalog-wheels-dwc-wheels-convict-2-d12fd4b2-shop-02a1c8.webp",
      "product-catalog-wheels-dwc-wheels-convict-3-e42eea7d-shop-938d09.webp",
      "product-catalog-wheels-dwc-wheels-convict-4-b4c3d921-shop-93291f.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/DWC-CONVICT-HYPER-SILVER-BLACK-LIP-ANGLE-1024x1024.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/convict/"
  },
  "Wheels::DWC Wheels::Legend": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/legend/",
    "description": "Boasting a timeless 8-hole design, this wheel is now available in two stunning finishes: satin black and polished. Rest assured, it guarantees exceptional quality, strength, and dependability. The Legend comes in a variety of sizes to suit your needs, and its high load rating ensures remarkable durability.",
    "availableSizes": [
      "15x8",
      "17x9",
      "16x8",
      "16x10"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "15 inch",
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black",
        "Polished"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X127",
        "5X139.7",
        "5X150",
        "6X139.7",
        "8X165.1",
        "8X170"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-legend-1-aedd3534-shop-2313c3.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-legend-1-aedd3534-shop-2313c3.webp",
      "product-catalog-wheels-dwc-wheels-legend-2-53dc63e3-shop-a690d8.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/DWC-LEGEND-BLACK-ANGLE.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/legend/"
  },
  "Wheels::DWC Wheels::DWC79": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/dwc79/",
    "description": "Unveiling the DWC 79, the latest addition to our exceptional DWC range! Crafted with a modern and eye-catching design, the DWC 79 will give your SUV a unique and distinguished edge. What sets us apart? Our range features fitments meticulously designed for the Australian market, guaranteeing a seamless match for your vehicle. Elevate your SUV's style and performance with DWC - where excellence meets innovation. Discover the DWC 79 and redefine your SUV experience today!",
    "availableSizes": [
      "17x8",
      "18x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Published finishes": [
        "Brushed Matte Black Dark Tint",
        "Gloss Black"
      ],
      "Published PCDs": [
        "5X108",
        "5X114.3"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-dwc79-1-0ae66591-shop-2a923a.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-dwc79-1-0ae66591-shop-2a923a.webp",
      "product-catalog-wheels-dwc-wheels-dwc79-2-f238d22d-shop-4877de.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/dwc-dwc79-gloss-black-25-angle.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/dwc79/"
  },
  "Wheels::DWC Wheels::Brutal": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/brutal/",
    "description": "A super tough wheel that is designed to take all the punishment you can throw at it. Available to suit a range of popular utes & 4WD’s incl Hilux, Triton, and Colorado.The all-new Dynamic Brutal is one of the only staggered fitment alloy wheels available on the market to suit.",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Published finishes": [
        "Satin Black"
      ],
      "Published PCDs": [
        "5X150"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-brutal-1-5d0f947f-shop-0e39f7.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-brutal-1-5d0f947f-shop-0e39f7.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/dwc-brutal-satin-black-25-angle.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/brutal/"
  },
  "Wheels::DWC Wheels::Lockup": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/lockup/",
    "description": "DWC Lockup wheels have been designed and built for the Australian market. The wheels feature: Largest range of vehicle fitments 16×8.5 & 17×9, 16 & 17 inch 1500kg load rating, two unique finishes, thicker beadlock ring for added strength, thick 6 spoke design for added strength and large 3/8 bolts for additional strength & durability. Available fitments include Nissan Patrol, Toyota Land Cruiser, Nissan Navara, Mazda BT-50, Toyota Hilux/Prado, Ford Ranger, Jeep Wrangler, Mitsubishi Triton, Isuzu Dmax and Holden Colorado.",
    "availableSizes": [
      "17x9",
      "16x8.5"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "16 inch",
        "17 inch"
      ],
      "Published finishes": [
        "Black",
        "Machined",
        "Machined Black Ring"
      ],
      "Published PCDs": [
        "5X150",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-lockup-1-259b07fa-shop-89c20f.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-lockup-1-259b07fa-shop-89c20f.webp",
      "product-catalog-wheels-dwc-wheels-lockup-2-e06e2362-shop-135951.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/DWC-LOCKUP-BLACK-ANGLE.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/lockup/"
  },
  "Wheels::DWC Wheels::DWC92": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/dwc92/",
    "description": "DWC's renowned range has expanded to conquer the SUV market, and leading the charge is the DWC 92 - a sleek and captivating design that's destined to set your SUV apart from the crowd. Our collection boasts fitments expertly tailored for the Australian market, ensuring the perfect match for your vehicle's needs. The DWC 92 is available in two striking finishes: the timeless elegance of gloss black and the luxurious allure of satin gold. Elevate your SUV's style and performance with DWC, where innovation meets sophistication. Explore the DWC 92 today and make your SUV truly exceptional.",
    "availableSizes": [
      "17x8",
      "18x8"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Published finishes": [
        "Gloss Black"
      ],
      "Published PCDs": [
        "5X114.3"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-dwc92-1-05184e0c-shop-0e97ec.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-dwc92-1-05184e0c-shop-0e97ec.webp",
      "product-catalog-wheels-dwc-wheels-dwc92-2-af023a38-shop-266a15.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2025/04/dwc-dwc92-gloss-black-25-angle.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/dwc92/"
  },
  "Wheels::DWC Wheels::666 Devil": {
    "productUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/666-devil/",
    "description": "DWC Wheels 666 Devil is available through 110 Garage. Contact the team for current fitments, finishes, pricing and stock.",
    "availableSizes": [
      "14x6"
    ],
    "notes": [
      "Pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Specialty fitments are developed for the Australian 4WD and SUV market",
      "High-load variants are available for demanding Australian conditions",
      "A one-year finish warranty applies under the supplier's warranty terms",
      "Structural lifetime warranty applies under the supplier's warranty terms"
    ],
    "specifications": {
      "Construction": "Alloy",
      "Available diameters": [
        "14 inch"
      ],
      "Published finishes": [
        "Black Machined",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X108",
        "5X114.3",
        "5X120.65",
        "6X139.7"
      ]
    },
    "localImage": "product-catalog-wheels-dwc-wheels-666-devil-1-86ba3d06-shop-44326a.webp",
    "galleryImages": [
      "product-catalog-wheels-dwc-wheels-666-devil-1-86ba3d06-shop-44326a.webp",
      "product-catalog-wheels-dwc-wheels-666-devil-2-a2fa4a91-shop-905197.webp"
    ],
    "imageSourceUrl": "https://dynamicwheelco.com.au/app/uploads/2024/03/MCP-DEVIL-BLACK-POWER-COATED.png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/666-devil/"
  },
  "Wheels::Icon Alloys::Rancho": {
    "productUrl": "https://iconvehicledynamics.com/products/8420908350sbgb",
    "description": "Bring a bold new look to your ride with the ICON Alloys Rancho, a solidly built 20” wheel that will stand up on the street or trail. Available in multiple finishes like stealthy Double Black, slick Satin Bronze with Gloss Black Lip, and an eye-catching Silver Machined with Gloss Black Lip; these wheels will increase both the form and function of your Jeep, truck, or SUV. Staying true to the ICON Alloys approach, the Rancho has been engineered to maximize caliper clearance and optimize wheel position for un-hindered suspension travel and steering function. Backspace dimensions and wheel offset have been strategically developed to reduce scrub radius, improving all-around handling and ride quality and making a set of these wheels the perfect complement to an ICON Vehicle Dynamics suspension system.",
    "availableSizes": [
      "17x8.5",
      "20x9"
    ],
    "notes": [
      "This is an overseas manufacturer range; Australian pricing, stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Official ICON Alloys Rancho model",
      "Application-specific dimensions are designed to support tyre clearance and vehicle dynamics",
      "Aluminium-alloy construction is intended for on-road and off-road use",
      "36 official manufacturer SKU combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "20 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9 inch"
      ],
      "Published finishes": [
        "Double Black",
        "Satin Bronze w/ Gloss Black Lip",
        "Silver Machined w/ Gloss Black Lip"
      ],
      "Published PCDs": [
        "5X127",
        "5X150",
        "6X135",
        "6X139.7",
        "8X165.1",
        "8X170",
        "8X180"
      ],
      "Published offsets": [
        "ET-6",
        "ET0",
        "ET6",
        "ET12",
        "ET16",
        "ET25"
      ],
      "Published backspacing": [
        "4.5 inch",
        "4.75 inch",
        "5 inch",
        "5.25 inch",
        "5.5 inch",
        "5.63 inch",
        "5.75 inch"
      ]
    },
    "localImage": "product-catalog-wheels-icon-alloys-rancho-1-87dd1aea-shop-9339ed-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-icon-alloys-rancho-1-87dd1aea-shop-9339ed.webp",
      "product-catalog-wheels-icon-alloys-rancho-2-71b5763f-shop-3bd715.webp",
      "product-catalog-wheels-icon-alloys-rancho-3-1cd4d919-shop-d66fc1.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0600/9972/3382/files/af5f78aac3bc5cc794b17cd3d6adb27a_32db6ed5-f1c6-4eee-a28a-e29271886e47.jpg?v=1783370726",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://iconvehicledynamics.com/products/8420908350sbgb"
  },
  "Wheels::Lenso::KAOS": {
    "productUrl": "https://lensowheels.com.au/products/lenso-kaos-wheel-machined-black-ring",
    "description": "The Lenso KAOS is a purpose-built 4x4 wheel designed for demanding off-road use. Its imitation beadlock styling, published 1500 kg load rating and GVM-upgrade compatibility make it suited to overlanding, touring and rugged terrain. Available configurations are sourced from Lenso Australia's current product listings.",
    "availableSizes": [
      "17x9"
    ],
    "notes": [
      "Some official finishes are listed as pre-order; 110 Garage will confirm timing, pricing and final vehicle fitment"
    ],
    "features": [
      "Current official Lenso Australia KAOS model",
      "9 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Full Machined",
        "Machined Black Ring",
        "Satin Black Machined Ring"
      ],
      "Published PCDs": [
        "5X150",
        "6X114.3",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-12",
        "ET0"
      ],
      "Published wheel weights": [
        "12 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-kaos-2-067cec2f-shop-e42763-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-kaos-2-067cec2f-shop-e42763.webp",
      "product-catalog-wheels-lenso-kaos-3-1be92ab3-shop-a23e0e.webp",
      "product-catalog-wheels-lenso-kaos-1-e633773c-shop-a72d1d.webp"
    ],
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-kaos-wheel-machined-black-ring"
  },
  "Wheels::Lenso::AMADA": {
    "productUrl": "https://lensowheels.com.au/products/amada-beadlock-mfbr",
    "description": "Now Available for Pre-Order! Secure yours today and be among the first to receive it when it launches. Limited pre-order availability - don’t miss out! The LENSO AMADA - Engineered for serious off-road performance, the LENSO AMADA is a purpose-built 4x4 wheel featuring a genuine beadlock design for maximum strength and tyre security in extreme conditions. Designed to handle tough terrain and low tyre pressures, the AMADA is ideal for drivers who demand both durability and reliability when heading off the beaten path. Constructed with a 1250 KG load rating, the AMADA is fully compatible with GVM upgrades, making it a dependable choice for overlanding, rock crawling, and heavy-duty touring setups. Its bold, aggressive styling adds a commanding presence to any 4x4 build, combining rugged functionality with head-turning design. \"Not for On-Road Use.\"",
    "availableSizes": [
      "17x9"
    ],
    "notes": [
      "Some official finishes are listed as pre-order; 110 Garage will confirm timing, pricing and final vehicle fitment"
    ],
    "features": [
      "Current official Lenso Australia AMADA model",
      "Beadlock configuration is published for this model",
      "18 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Full Machined",
        "Machined Face Black Ring",
        "Satin Black Machined Ring"
      ],
      "Published PCDs": [
        "5X150",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-59",
        "ET-38",
        "ET-22",
        "ET-12",
        "ET0"
      ],
      "Published wheel weights": [
        "12.65 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-amada-1-e633773c-shop-090917-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-amada-1-e633773c-shop-090917.webp",
      "product-catalog-wheels-lenso-amada-2-882225e1-shop-d6b383.webp",
      "product-catalog-wheels-lenso-amada-3-d51318f4-shop-c76bad.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/2_020ddacb-9f0d-4a4a-beca-f1a7c5e43561.jpg?v=1777944201",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/amada-beadlock-mfbr"
  },
  "Wheels::Lenso::D-1SF": {
    "productUrl": "https://lensowheels.com.au/products/lenso-d-1sf-wheel-gloss-black-milled-mirrorlip",
    "description": "The LENSO D-1SF is one our Greatest Staples to the Street & Race Wheel Collection! The LENSO D-1SF is our FlowFormed Wheel Hero engineered to be even Lighter and Stronger allowing for greater performance benefits on an off the Track! This wheel features the classic 5 Spoke Design with an Aggressive Milled Spoke Effect and up to 95mm of dish! This wheel is an 18” Exclusive offered in a unique Gloss Black Milled Mirror Lip Design! The LENSO D-1SF is offered in 18 x 8.5 , 18 x 9.5 , 18 x 10.5 in varying Offsets to suit most 5-stud vehicles, and is available Australia Wide!",
    "availableSizes": [
      "18x10.5",
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia D-1SF model",
      "Flow-formed construction is published for this model",
      "3 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9.5 inch",
        "10.5 inch"
      ],
      "Published finishes": [
        "Gloss Black Milled Mirror Lip"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET13",
        "ET22",
        "ET35"
      ],
      "Published wheel weights": [
        "8.16 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-d-1sf-1-7a7c854a-shop-ebad87-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-d-1sf-1-7a7c854a-shop-ebad87.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/LensoD-1sf.2.png?v=1768363044",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-d-1sf-wheel-gloss-black-milled-mirrorlip"
  },
  "Wheels::Lenso::V1N": {
    "productUrl": "https://lensowheels.com.au/products/lenso-v1n-wheel-hyper-black",
    "description": "LENSO V1N - Street-Born, Track-Proven Performance Introducing the LENSO V1N, the latest evolution of the iconic LENSO V1N series - a proudly trademarked LENSO design built for true enthusiasts who demand precision, strength, and style. Engineered for both street and race performance , the V1N has earned its place as the driver’s choice across Australia’s drift and motorsport scene , trusted for its balance of lightweight construction and durability under extreme conditions. Featuring a timeless 10-split-spoke design, the V1N delivers superior brake clearance and optimal brake ventilation , making it perfect for high-performance applications. Available in Gloss Black and Hyper Black , it’s the perfect upgrade for drivers who want their setup to look as sharp as it performs. Available Sizes & Specifications Size Offset (ET) Approx. Weight Description 18x8.5 +38 / +10 7.53 kg Lightweight front or square setup - ideal for daily driving or mild stance 18x9.5 +22 8.22 kg Perfect for staggered rear fitment - enhanced grip and sportier presence 18x10.5 +13 9.00 kg Deep concave profile - aggr",
    "availableSizes": [
      "18x10.5",
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia V1N model",
      "8 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9.5 inch",
        "10.5 inch"
      ],
      "Published finishes": [
        "Gloss Black",
        "Hyper Black"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET10",
        "ET13",
        "ET22",
        "ET38"
      ],
      "Published wheel weights": [
        "7.53 kg",
        "8.22 kg",
        "9 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-v1n-1-d6ab655a-shop-6bba9b-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-v1n-1-d6ab655a-shop-6bba9b.webp",
      "product-catalog-wheels-lenso-v1n-2-07b50ea0-shop-af0871.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/LensoV1NWheelHyperBlackSide_951c1765-766a-4978-8ebd-31e53f4ae96f.png?v=1764807899",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-v1n-wheel-hyper-black"
  },
  "Wheels::Lenso::D-1R": {
    "productUrl": "https://lensowheels.com.au/products/lenso-d-1r-hyper-silver-mirror-lip",
    "description": "The Original LENSO D-1R is an Australian Icon and the Greatest Wheel Addition to our Street & Race Wheel Collection! The LENSO D-1R is crowned the Hero 1 PIECE Wheel in terms of it’s Classic Phat 5-Spoke Design, Incredible Finish and Seriously Deep DISH of Over 100mm on our 20 x 10” Masterpiece!",
    "availableSizes": [
      "18x8",
      "18x8.5",
      "18x9",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia D-1R model",
      "4 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "8 inch",
        "8.5 inch",
        "9 inch",
        "9.5 inch"
      ],
      "Published finishes": [
        "Hyper Silver Mirror Lip"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X120"
      ],
      "Published offsets": [
        "ET30",
        "ET32",
        "ET35"
      ],
      "Published wheel weights": [
        "10.58 kg",
        "11 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-d-1r-1-ff881cc3-shop-5a3cc2-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-d-1r-1-ff881cc3-shop-5a3cc2.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/LensoD-1RHyperSilverMirrorLip.webp?v=1745830416",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-d-1r-hyper-silver-mirror-lip"
  },
  "Wheels::Lenso::DINERO": {
    "productUrl": "https://lensowheels.com.au/products/lenso-dinero-wheel-graphite-grey",
    "description": "The LENSO DINERO is the latest addition to our elite 4x4 wheel lineup, built for those who demand both presence and performance. Featuring a sleek yet commanding multi-spoke design with deep dish aesthetics, the DINERO brings a refined toughness to any off-road or street build. Crafted for durability and engineered for heavy-duty applications, the DINERO doesn’t just look powerful - it’s built to handle the demands of real adventure. With a 1500 KG load rating and ultra brake clearance, it’s fully equipped for GVM upgrades and serious touring setups. Available in three head-turning finishes - Satin Black, Dirty Bronze, and Graphite Grey- the DINERO is designed to complement a wide range of 4x4 styles while delivering peak performance in all terrains.",
    "availableSizes": [
      "17x9",
      "18x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia DINERO model",
      "18 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Dirty Bronze",
        "Graphite Grey",
        "Satin Black"
      ],
      "Published PCDs": [
        "6X139.7"
      ],
      "Published offsets": [
        "ET-22",
        "ET0",
        "ET18",
        "ET35"
      ],
      "Published wheel weights": [
        "12.34 kg",
        "12.51 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-dinero-1-c6a1a18b-shop-61fc00-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-dinero-1-c6a1a18b-shop-61fc00.webp",
      "product-catalog-wheels-lenso-dinero-2-405cffef-shop-03628d.webp",
      "product-catalog-wheels-lenso-dinero-3-86f03f5f-shop-2b9d5f.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/Dinerographite2_e27db875-0d33-4c1b-af33-96dfe5130630.png?v=1764810413",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-dinero-wheel-graphite-grey"
  },
  "Wheels::Lenso::CARTEL": {
    "productUrl": "https://lensowheels.com.au/products/lenso-cartel-hyper-black-copy",
    "description": "All-New LENSO CARTEL - Engineered for performance and built to turn heads, the LENSO CARTEL is our latest 4x4 wheel design, combining rugged capability with aggressive styling. Featuring a bold bead-lock inspired look and a sharp, muscular centre face, the CARTEL is made to dominate both off-road trails and urban streets. Tested under extreme conditions, the CARTEL delivers the strength and reliability serious adventurers demand - with style that makes a statement wherever you go. Available in three distinct finishes: Satin Black, Dirty Bronze, and Hyper Black, there’s a look to match every build and personality. Designed with ultra brake clearance and a 1500 KG load rating, the CARTEL is ideal for vehicles with GVM upgrades, giving you both the clearance and strength required for tough touring setups.",
    "availableSizes": [
      "18x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia CARTEL model",
      "6 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Dirty Bronze",
        "Hyper Black",
        "Satin Black"
      ],
      "Published PCDs": [
        "6X139.7"
      ],
      "Published offsets": [
        "ET18",
        "ET35"
      ],
      "Published wheel weights": [
        "13.75 kg",
        "15.62 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-cartel-1-76c88bbc-shop-c41db4-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-cartel-1-76c88bbc-shop-c41db4.webp",
      "product-catalog-wheels-lenso-cartel-2-f78337a5-shop-b78e14.webp",
      "product-catalog-wheels-lenso-cartel-3-0717a436-shop-8a45f6.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/cartelbeadlockblack2_ad2ebb42-c66a-49aa-af0e-b1b59f242429.png?v=1764894995",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-cartel-hyper-black-copy"
  },
  "Wheels::Lenso::D1R-EVO": {
    "productUrl": "https://lensowheels.com.au/products/lenso-d1r-evo-satin-black",
    "description": "The Evolution is Here - Introducing the D1R-EVO Wheel. The D1R-EVO has officially landed in Australia, bringing back Lenso’s iconic 5-spoke dished design with a modern update. Featuring ULTRA Brake Clearance and our signature DEEP Dish look with over 100mm barrels, the D1R-EVO is made for performance and aggressive fitments. Now available in Satin Black, Hyper Silver with Mirror Lip, Copper Edition, and Gloss Black with Milled Mirror Lip, it’s a bold wheel designed for the street or the track.",
    "availableSizes": [
      "20x10",
      "20x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia D1R-EVO model",
      "24 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "20 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "10 inch"
      ],
      "Published finishes": [
        "Copper Edition",
        "Gloss Black Milled Mirror Lip",
        "Hyper Silver Mirror Lip",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X120"
      ],
      "Published offsets": [
        "ET35",
        "ET42"
      ],
      "Published wheel weights": [
        "11.79 kg",
        "12.67 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-d1r-evo-1-7fd2216d-shop-198e81-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-d1r-evo-1-7fd2216d-shop-198e81.webp",
      "product-catalog-wheels-lenso-d1r-evo-2-4d0e8d3e-shop-d10d56.webp",
      "product-catalog-wheels-lenso-d1r-evo-3-940e144a-shop-aa63ec.webp",
      "product-catalog-wheels-lenso-d1r-evo-4-1df7ccf8-shop-6ea48e.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/d1revowheel.png?v=1745896992",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-d1r-evo-satin-black"
  },
  "Wheels::Lenso::BSX": {
    "productUrl": "https://lensowheels.com.au/products/lenso-bsx-silver-mirror-lip",
    "description": "The LENSO BSX is a classic LENSO Street and Race Wheel! The LENSO BSX is known to be the people’s choice when searching for the original trademark mesh designed street wheel with dish! The LENSO BSX features a classic Mesh Design with Studs and over 70mm of Dish including the old-school metallic screw on Cap! This wheel is a 17” Exclusive offered in the neat Silver Mirror Lip finish and is offered in 17 x 7.5 , 17 x 8.5 in varying Offsets to suit most 4-stud and 5-stud vehicles. A classic choice for the E30 BMW’s and later model Euro Vehicles, and is available Australia Wide!",
    "availableSizes": [],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia BSX model",
      "0 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy"
    },
    "localImage": "product-catalog-wheels-lenso-bsx-1-743dc7e7-shop-91112e-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-bsx-1-743dc7e7-shop-91112e.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/BSXsilvermirrorlip.webp?v=1745829410",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-bsx-silver-mirror-lip"
  },
  "Wheels::Lenso::90-Z": {
    "productUrl": "https://lensowheels.com.au/products/lenso-90-z-hyper-black-mirror-lip",
    "description": "The LENSO 90-Z is one of the most Popular Wheel lines in our Street and Race Collection! The LENSO 90-Z is designed to bring a perfect balance to those who love multi-spoke designs and deep dish! The LENSO 90-Z features a classic, 5-split spoke design with up to 85mm barrel’s of dish! This wheel is an 18” Exclusive, offered in a unique Gloss Black Copper Milling Copper Lip / Hyper Black Mirror Lip finish! The LENSO 90-Z is offered in 18 x 8.5 , 18 x 9.5 , 18 x 10.5 in varying Offsets to suit most 5-stud vehicles, and is available Australia Wide!",
    "availableSizes": [
      "18x10.5",
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia 90-Z model",
      "8 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9.5 inch",
        "10.5 inch"
      ],
      "Published finishes": [
        "Gloss Black Copper Milling Copper Lip",
        "Hyper Black Mirror Lip"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3",
        "5X120"
      ],
      "Published offsets": [
        "ET25",
        "ET30",
        "ET35"
      ],
      "Published wheel weights": [
        "9.43 kg",
        "9.87 kg",
        "10.1 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-90-z-1-4d099df1-shop-beeab1-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-90-z-1-4d099df1-shop-beeab1.webp",
      "product-catalog-wheels-lenso-90-z-2-6a23b6ba-shop-a74ae0.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/90zhyperblackmirrorlip.webp?v=1745828783",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-90-z-hyper-black-mirror-lip"
  },
  "Wheels::Lenso::D-1FC": {
    "productUrl": "https://lensowheels.com.au/products/lenso-d-1fc-gloss-black-copper-milling-copper-lip",
    "description": "The LENSO D-1FC is one of the most recent editions to our Street and Race Wheel Collection! The LENSO D-1FC is our Craze NEW Race Wheel, designed to Turn Heads and Perform Under any Race Condition! This wheel features the classic 5 Spoke Design with an Aggressive Milled Spoke Effect and up to 120mm barrel’s of dish! This wheel is an 18” Exclusive offered in a unique Gloss Black Copper Milling Copper Lip Finish! The LENSO D-1FC is offered in 18 x 8.5 , 18 x 9.5 , 18 x 10.5 in varying Offsets to suit most 5-stud vehicles, and is available Australia Wide!",
    "availableSizes": [
      "18x10.5",
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia D-1FC model",
      "5 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9.5 inch",
        "10.5 inch"
      ],
      "Published finishes": [
        "Gloss Black Copper Milling Copper Lip"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET13",
        "ET22",
        "ET35"
      ],
      "Published wheel weights": [
        "9.39 kg",
        "9.8 kg",
        "10.2 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-d-1fc-1-0d403780-shop-5db3bd-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-d-1fc-1-0d403780-shop-5db3bd.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/D-1FCGlossBlackCopperMillingCopperLip.webp?v=1745821034",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-d-1fc-gloss-black-copper-milling-copper-lip"
  },
  "Wheels::Lenso::SPEC-E": {
    "productUrl": "https://lensowheels.com.au/products/lenso-spec-e-matt-black",
    "description": "The LENSO SPEC-E is an original LENSO Trademarked, Street and Race Wheel! The LENSO SPEC-E is known to be the people’s choice when searching for Light Weight Performance Wheels, and is heavily relied upon wheel in both the Drift and Race Industry in Australia! The LENSO SPEC-E features a classic 5 split spokes design, that allows for ultra-brake clearance for most performance vehicles and aeration of brakes! This wheel is an 18” Exclusive in the incredible finish Matt Black and is offered in 18 x 8.5 , 18 x 9.5 , 18 x 10 in varying Offsets to suit most 5-stud vehicles, and is available Australia Wide!",
    "availableSizes": [
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia SPEC-E model",
      "4 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Available widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published finishes": [
        "Matt Black"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET22",
        "ET35"
      ],
      "Published wheel weights": [
        "9.05 kg",
        "9.5 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-spec-e-1-6872f4d8-shop-201804-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-spec-e-1-6872f4d8-shop-201804.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/SPEC-EMattblack.webp?v=1745813881",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-spec-e-matt-black"
  },
  "Wheels::Lenso::D-1SE": {
    "productUrl": "https://lensowheels.com.au/products/lenso-d-1se-copper-volk",
    "description": "The LENSO D-1SE is a high-quality aftermarket Street and Race wheel! The LENSO D-1SE features a popular 5 spoke design with an exclusive double stepped dished feature that has ultra-brake clearance to cater for most performance vehicles. Combined with the latest styling, the LENSO D-1SE is a popular and affordable alloy wheel, available in three elegant finishes Gloss Black Mirror Lip / Hyper Silver Mirror Lip / Copper Volk and size ranging from 17 x 7.5 , 18 x 8.5 to 18 x 9.5 in a variety of fitments to suit most 4-Stud and 5-Stud vehicles and is available Australia wide!",
    "availableSizes": [
      "17x7.5",
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia D-1SE model",
      "13 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "7.5 inch",
        "8.5 inch",
        "9.5 inch"
      ],
      "Published finishes": [
        "Copper Volk",
        "Gloss Black Mirror Lip",
        "Hyper Silver Mirror Lip"
      ],
      "Published PCDs": [
        "10X100",
        "5X100",
        "5X114.3",
        "8X100"
      ],
      "Published offsets": [
        "ET35",
        "ET38",
        "ET42"
      ],
      "Published wheel weights": [
        "8.32 kg",
        "8.41 kg",
        "9.94 kg",
        "10.43 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-d-1se-1-98f1736d-shop-533c5c-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-d-1se-1-98f1736d-shop-533c5c.webp",
      "product-catalog-wheels-lenso-d-1se-2-d9803850-shop-36af50.webp",
      "product-catalog-wheels-lenso-d-1se-3-e017e713-shop-11577a.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/D-1SEcopper.webp?v=1745813142",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-d-1se-copper-volk"
  },
  "Wheels::Lenso::Marvel": {
    "productUrl": "https://lensowheels.com.au/products/lenso-marvel-full-polished",
    "description": "Our Trademark LENSO MARVEL is our Ultimate 4x4 Wheel Release ! A high quality bead-lock design with a clean, sharp and aggressive built center face, tested to combat all Off-Roading adventures and looks fantastic on the Streets! Available in four unique finishes - Satin Black / Dirty Bronze / Graphite Grey / Full Polished . Our 6-stud equipped with ultra Brake Clearance and has a 1250 KG Load Rating ideal for GVM Upgrades ! Now available in 5-stud , the MARVEL boasts exceptional brake clearance and a load rating up to 1500 KG , making it ideal for GVM upgrades, heavy-duty setups, and towing applications.",
    "availableSizes": [
      "17x9",
      "18x9",
      "20x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia Marvel model",
      "40 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch",
        "20 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Dirty Bronze",
        "Full Polished",
        "Graphite Grey",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X150",
        "6X114.3",
        "6X139.7"
      ],
      "Published offsets": [
        "ET-12",
        "ET0",
        "ET18",
        "ET30",
        "ET35"
      ],
      "Published wheel weights": [
        "11.6 kg",
        "12.78 kg",
        "15.03 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-marvel-1-128f8b8b-shop-01c548-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-marvel-1-128f8b8b-shop-01c548.webp",
      "product-catalog-wheels-lenso-marvel-2-58c2950c-shop-c5c1c3.webp",
      "product-catalog-wheels-lenso-marvel-3-6c696e17-shop-43d499.webp",
      "product-catalog-wheels-lenso-marvel-4-c016d593-shop-43f8e4.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/lensomarvelfullpolished_9c486c44-e77b-4638-bca5-c03fb1ba2eea.webp?v=1764895404",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-marvel-full-polished"
  },
  "Wheels::Lenso::Argo": {
    "productUrl": "https://lensowheels.com.au/products/lenso-argo-dirty-bronze",
    "description": "Our Latest LENSO ARGO is one of the Hottest 4x4 Wheel Releases in Australia! A high quality bead-lock design with a clean, sharp and aggressive built center face, tested to combat all Off-Roading adventures and looks fantastic on the Streets! Available in four unique finishes Satin Black / Dirty Bronze / Graphite Grey & Full Machined. Equipped with ultra ultra Brake Clearance and has 1250 KG Load Rating ideal for GVM Upgrades!",
    "availableSizes": [
      "17x9",
      "18x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia Argo model",
      "16 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Dirty Bronze",
        "Full Machined",
        "Graphite Grey",
        "Satin Black"
      ],
      "Published PCDs": [
        "6X139.7"
      ],
      "Published offsets": [
        "ET12",
        "ET30"
      ],
      "Published wheel weights": [
        "12 kg",
        "13 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-argo-1-5bb15024-shop-75861c-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-argo-1-5bb15024-shop-75861c.webp",
      "product-catalog-wheels-lenso-argo-2-cf5aa771-shop-179a61.webp",
      "product-catalog-wheels-lenso-argo-3-58383b90-shop-cf4939.webp",
      "product-catalog-wheels-lenso-argo-4-841b087f-shop-342e07.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/ArgoDirtyBronze_8fb9a7e0-2533-4d2b-bfc1-fe6c26a45bc6.webp?v=1764896165",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-argo-dirty-bronze"
  },
  "Wheels::Lenso::M-79": {
    "productUrl": "https://lensowheels.com.au/products/lenso-m-79-graphite-grey",
    "description": "The LENSO M-79 is our Exclusive 70 Series & 100 Series LandCruiser wheel! A high quality bead-lock design with a clean, sharp and aggressive concave face this wheel is set to turn heads on and off the road! Available in four unique finishes Satin Black / Dirty Bronze / Graphite Grey & Full Polished! Optioned in Track Correction fitments and has a GVM Upgrade 1500 KG Load Rating compatible with a Pop-Out cap for manual hub adjustments!",
    "availableSizes": [
      "17x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia M-79 model",
      "8 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Dirty Bronze",
        "Full Polished",
        "Graphite Grey",
        "Satin Black"
      ],
      "Published PCDs": [
        "5X150"
      ],
      "Published offsets": [
        "ET-59",
        "ET-12"
      ],
      "Published wheel weights": [
        "13.06 kg",
        "13.17 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-m-79-1-4865cc58-shop-f926b2-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-m-79-1-4865cc58-shop-f926b2.webp",
      "product-catalog-wheels-lenso-m-79-2-02e5f510-shop-feb130.webp",
      "product-catalog-wheels-lenso-m-79-3-290dc286-shop-93fbc8.webp",
      "product-catalog-wheels-lenso-m-79-4-4bbf32bb-shop-92c099.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/M-97Graphitegrey2_48b441d9-7f10-49f1-b263-bdaf6ba7b6ac.webp?v=1764896836",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-m-79-graphite-grey"
  },
  "Wheels::Lenso::Hurricane": {
    "productUrl": "https://lensowheels.com.au/products/lenso-hurricane-satin-black",
    "description": "The LENSO HURRICANE is one of our latest 4x4 Wheel Releases! A high quality innovative lip with a web spoke design, this wheel is set to turn heads on and off the road! Available in Full Satin Black with Ultra Brake Clearance and has a MEGA 1500 KG Load Rating ideal for any GVM Upgrades. This wheel is set for the storm!",
    "availableSizes": [
      "17x9",
      "18x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia Hurricane model",
      "4 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Satin Black"
      ],
      "Published PCDs": [
        "6X139.7"
      ],
      "Published offsets": [
        "ET12",
        "ET30"
      ],
      "Published wheel weights": [
        "11.71 kg",
        "13.02 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-hurricane-1-20aa4f33-shop-5bfcd5-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-hurricane-1-20aa4f33-shop-5bfcd5.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/HURRICANEsatinblack_3044aa1e-3097-4321-94d2-357de221f598.webp?v=1764897336",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-hurricane-satin-black"
  },
  "Wheels::Lenso::Gravel": {
    "productUrl": "https://lensowheels.com.au/products/lenso-gravel-passion-black",
    "description": "The LENSO GRAVEL is one of our TRADEMARK Wheel Designs in our Off-Road & 4x4 wheel collection. A high quality bead-lock design wheel available in three unique finishes Satin Black / Copper Tint / Passion Black with ultra Brake Clearance. This wheel is tested to combat all Off-Road adventures and looks MEAN on the streets.",
    "availableSizes": [
      "17x9",
      "18x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle fitment are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Lenso Australia Gravel model",
      "16 official Australian variant combinations recorded"
    ],
    "specifications": {
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch",
        "18 inch"
      ],
      "Available widths": [
        "9 inch"
      ],
      "Published finishes": [
        "Copper Tint",
        "Passion Black",
        "Satin Black"
      ],
      "Published PCDs": [
        "6X114.3",
        "6X139.7"
      ],
      "Published offsets": [
        "ET20",
        "ET30"
      ],
      "Published wheel weights": [
        "11.78 kg",
        "13.56 kg"
      ]
    },
    "localImage": "product-catalog-wheels-lenso-gravel-1-eafcc2df-shop-77b399-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-lenso-gravel-1-eafcc2df-shop-77b399.webp",
      "product-catalog-wheels-lenso-gravel-2-645823ec-shop-7ae735.webp",
      "product-catalog-wheels-lenso-gravel-3-1f02a397-shop-7646b9.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0582/7539/7655/files/Lensogravelpassionblack2_ee72bb5e-641a-4931-b5f3-13b85dac3ac8.webp?v=1764897429",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://lensowheels.com.au/products/lenso-gravel-passion-black"
  },
  "Tyres::Mastercraft::Courser All Weather": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-all-weather/25345.html",
    "description": "Stay the course with the Mastercraft® Courser® All Weather. Mastercraft's first all weather tire, designed for changing road conditions year-round. When life keeps moving, you need lasting traction and dependable control in rain, slush and light snow. Trusted as the Profesional's Choice, Mastercraft is built for those who don't fold, because you deserve a tire that does the same.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser All Weather model",
      "All Season",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Cars Or Minivan",
      "Wet Performance",
      "Handling"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Cars Or Minivan",
        "Wet Performance",
        "Handling"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-all-weather-3e1091e0-shop-10394c.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-all-weather-3e1091e0-shop-10394c.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw472c8859/images/large/Courser_All_Weather_25345.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-all-weather/25345.html"
  },
  "Tyres::Mastercraft::Courser CXT": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-cxt/24736.html",
    "description": "Confidence. No matter where. The Courser® CXT was designed as a premium light-truck commercial traction tire that provides trusted all-terrain performance with enhanced off-road durability. The CXT features variable full-depth siping and a silica-rich tread compound for enhanced wet and winter traction.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser CXT model",
      "All Season",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Wet Performance",
      "Off Road",
      "Truck Or Pickup"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Wet Performance",
        "Off Road",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-cxt-600272b4-shop-54fffb.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-cxt-600272b4-shop-54fffb.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw937e2d57/images/large/Courser_CXT_24736.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-cxt/24736.html"
  },
  "Tyres::Mastercraft::Courser HXT": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-hxt/24739.html",
    "description": "When it matters. And it always matters. The Courser® HXT is a commercial highway light-truck rib tire that provides trusted all-season performance and dependable wear. The HXT was designed to provide enhanced wet and winter traction with increased tread stability. The large, solid shoulder elements help resist abnormal wear that is common with commercial vehicles.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser HXT model",
      "All Season",
      "50k Mi Warranty",
      "Quiet Ride",
      "Cars Or Minivan",
      "Handling",
      "M+s Rated"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "50k Mi Warranty",
        "Quiet Ride",
        "Cars Or Minivan",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-hxt-584ecea5-shop-577087.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-hxt-584ecea5-shop-577087.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwc6cceb8e/images/large/Courser_HXT_24739.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-hxt/24739.html"
  },
  "Tyres::Mastercraft::Courser MXT": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-mxt/24742.html",
    "description": "Life is a highway. And a dirt road. The Courser® MXT is an extreme off-road mud-terrain tire perfect for light truck owners and extreme off-roaders seeking aggressive off-road traction and excellent handling on the highway. The MXT sports an attractive “side biter” design and wide, deep tread grooves for superior off-road mud and snow traction performance.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser MXT model",
      "All Season",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Wet Performance",
      "Off Road",
      "Truck Or Pickup"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Wet Performance",
        "Off Road",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-mxt-a04d75ba-shop-646a79.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-mxt-a04d75ba-shop-646a79.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw618cacb1/images/large/Courser_MXT_24742.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-mxt/24742.html"
  },
  "Tyres::Mastercraft::Courser Quest": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-quest/24746.html",
    "description": "The Courser® Quest™ offers the latest in tire technology for your car providing performance you can depend on. Whether you're driving in inclement weather or just need handling that is reliable when cornering, this tire has you covered.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser Quest model",
      "All Season",
      "70k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Cars Or Minivan",
      "Wet Performance"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "70k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Cars Or Minivan",
        "Wet Performance",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-quest-1ef20073-shop-9c8064.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-quest-1ef20073-shop-9c8064.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwfafc1169/images/large/Courser_Quest_24746.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-quest/24746.html"
  },
  "Tyres::Mastercraft::Courser Quest Plus": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-quest-plus/24747.html",
    "description": "The Courser® Quest Plus™ is a great option for SUVs and pickup trucks of all sizes, designed to bring out the most in your vehicle - whether large, medium, or compact. Whether you're driving in inclement weather or just need handling that is reliable when cornering, the Courser® Quest Plus™ tire has you covered.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser Quest Plus model",
      "All Season",
      "65k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Wet Performance",
      "Sports Utility"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "65k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Wet Performance",
        "Sports Utility",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-quest-plus-ea25fa3d-shop-823e74.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-quest-plus-ea25fa3d-shop-823e74.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwde15753a/images/large/Courser_Quest_Plus_24747.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-quest-plus/24747.html"
  },
  "Tyres::Mastercraft::Courser Trail": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-trail/24744.html",
    "description": "The Courser® Trail™ provides rugged durability through innovative tread compounding. The smooth transition between the tread and sidewall provides longer, cleaner lines for a tough appearance that matches the tire's durable performance. This tire makes your vehicle look great and deliver the performance you’d expect on the trail; toughness that lasts for thousands of miles.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser Trail model",
      "All Season",
      "60k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Wet Performance",
      "Sports Utility"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "60k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Wet Performance",
        "Sports Utility",
        "Off Road",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-trail-9248069a-shop-db35cd.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-trail-9248069a-shop-db35cd.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwadfb0b0f/images/large/Courser_Trail_24744.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-trail/24744.html"
  },
  "Tyres::Mastercraft::Courser Trail HD": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-trail-hd/24745.html",
    "description": "With a deeper, thicker rubber on the tread and sidewall, the Courser® Trail HD™ has an aggressive appearance that matches its tough, durable performance. Combined with reliable wet and winter performance, this tire lives up to your expectations both on the road and the trail.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser Trail HD model",
      "All Season",
      "55k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Wet Performance",
      "Off Road"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "55k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Wet Performance",
        "Off Road",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-trail-hd-1a1f7542-shop-740654.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-trail-hd-1a1f7542-shop-740654.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwa9f4c83f/images/large/Courser_Trail_HD_24745.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-trail-hd/24745.html"
  },
  "Tyres::Mastercraft::Courser Trail RT": {
    "productUrl": "https://www.mastercrafttires.com/tires/courser-trail-rt/25311.html",
    "description": "Looking for a tire designed to handle whatever comes its way? Meet the Mastercraft® Courser® Trail RT: the no-quit tire that masterfully handles both on-road and off-road conditions. With a durable, aggressive tread design for off-road traction and smooth, dependable performance on-road, this tire delivers when you’re cruising on the highway or tackling rugged trails. For a tire that’s tough and delivers real value, look no further.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Courser Trail RT model",
      "All Season",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Wet Performance",
      "Off Road",
      "Truck Or Pickup"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Wet Performance",
        "Off Road",
        "Truck Or Pickup",
        "Handling"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-courser-trail-rt-2038cd5e-shop-da3cc3.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-courser-trail-rt-2038cd5e-shop-da3cc3.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwcc0a4781/images/large/Courser_Trail_RT_25311.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/courser-trail-rt/25311.html"
  },
  "Tyres::Mastercraft::Avenger": {
    "productUrl": "https://www.mastercrafttires.com/tires/avenger/25000.html",
    "description": "Performance at every turn, in every season. The Mastercraft Avenger® is made for drivers seeking high-performance capabilities and all-season handling. This tire combines stability, control and quiet comfort, engineered with technology for enhanced grip in wet and dry conditions, offering performance you can rely on.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Avenger model",
      "All Season",
      "45k Mi Warranty",
      "Cars Or Minivan",
      "Sport Performance"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "45k Mi Warranty",
        "Cars Or Minivan",
        "Sport Performance"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-avenger-32fb305b-shop-3f072c.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-avenger-32fb305b-shop-3f072c.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw8e85fa31/images/large/Avenger_25000.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/avenger/25000.html"
  },
  "Tyres::Mastercraft::Avenger G/T": {
    "productUrl": "https://www.mastercrafttires.com/tires/avenger-gt/24732.html",
    "description": "Muscle. Ready to flex. The Avenger® G/T is a performance tire available in an eye-catching raised white letter that will retain the character of the old muscle car.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Avenger G/T model",
      "All Season",
      "50k Mi Warranty",
      "Dry Performance",
      "Quiet Ride",
      "Cars Or Minivan",
      "Wet Performance",
      "Handling"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "50k Mi Warranty",
        "Dry Performance",
        "Quiet Ride",
        "Cars Or Minivan",
        "Wet Performance",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-avenger-g-t-c342a3c2-shop-db7a71.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-avenger-g-t-c342a3c2-shop-db7a71.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw4d70234f/images/large/Avenger_GT_24732.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/avenger-gt/24732.html"
  },
  "Tyres::Mastercraft::Avenger M8": {
    "productUrl": "https://www.mastercrafttires.com/tires/avenger-m8/24733.html",
    "description": "Performance. For your busy life. The Avenger® M8 is an ultra-high-performance tire for the everyday driver. This is a W-rated tire line that brings performance, comfort, and quiet all together in one great product.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Avenger M8 model",
      "All Season",
      "40k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Cars Or Minivan",
      "Wet Performance"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "40k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Cars Or Minivan",
        "Wet Performance",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-avenger-m8-a4ffcf2f-shop-177dbb.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-avenger-m8-a4ffcf2f-shop-177dbb.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw6e10b076/images/large/Avenger_M8_24733.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/avenger-m8/24733.html"
  },
  "Tyres::Mastercraft::Glacier MSR": {
    "productUrl": "https://www.mastercrafttires.com/tires/glacier-msr/24749.html",
    "description": "The Mastercraft® Glacier MSRTM winter truck & SUV tire provides confidence & control during winter driving. A unique winter tread compound provides balanced grip on dry, wet, and snowy surfaces. This tire delivers the strength, durability and control you expect from a Mastercraft™ truck & SUV tire. Severe Weather Rated and backed by a 45 Day Road Test* for assurance that this product will perform in the cold.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Glacier MSR model",
      "Winter",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Wet Performance",
      "Sports Utility",
      "Truck Or Pickup"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "Winter",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Wet Performance",
        "Sports Utility",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated",
        "Severe Weather Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-glacier-msr-29bbdfdf-shop-51d23a.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-glacier-msr-29bbdfdf-shop-51d23a.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw512bc2d8/images/large/Glacier_MSR_24749.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/glacier-msr/24749.html"
  },
  "Tyres::Mastercraft::Glacier Trex": {
    "productUrl": "https://www.mastercrafttires.com/tires/glacier-trex/24751.html",
    "description": "Winter stops for no one. The Mastercraft® Glacier Trex is a practical winter tire that's designed to get you where you need to go. It exhibits incredible snow performance and is stud-capable to enhance ice traction. The aggressive tread pattern and stable feel will give you confidence all winter long.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Glacier Trex model",
      "Winter",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Cars Or Minivan",
      "Wet Performance",
      "Handling"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "Winter",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Cars Or Minivan",
        "Wet Performance",
        "Handling",
        "M+s Rated",
        "Severe Weather Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-glacier-trex-924f6a15-shop-39374d.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-glacier-trex-924f6a15-shop-39374d.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwbd0fbe24/images/large/Glacier_Trex_24751.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/glacier-trex/24751.html"
  },
  "Tyres::Mastercraft::SRT Touring": {
    "productUrl": "https://www.mastercrafttires.com/tires/srt-touring/24754.html",
    "description": "All seasons. All reasons. The Mastercraft® SRT TouringTM provides comfortable and quiet all-season performance. The SRT has many popular fitments for a wide range of modern passenger touring vehicles at a mid-level price.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft SRT Touring model",
      "All Season",
      "65k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Cars Or Minivan",
      "Handling"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "65k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Cars Or Minivan",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-srt-touring-33ab267e-shop-88fcb1.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-srt-touring-33ab267e-shop-88fcb1.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw3923cd0c/images/large/SRT_Touring_24754.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/srt-touring/24754.html"
  },
  "Tyres::Mastercraft::Stratus AP": {
    "productUrl": "https://www.mastercrafttires.com/tires/stratus-ap/24755.html",
    "description": "The Stratus AP is an all-purpose tire designed for excellent performance at a great value. Capable in various weather conditions and terrain, the Stratus AP offers strong traction and noise reduction for a smoother, quieter ride on SUV and pickup trucks.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Stratus AP model",
      "All Season",
      "50k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Sports Utility",
      "Truck Or Pickup"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "50k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Sports Utility",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-stratus-ap-e5d58f82-shop-10fdaf.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-stratus-ap-e5d58f82-shop-10fdaf.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw90f48345/images/large/Stratus_AP_24755.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/stratus-ap/24755.html"
  },
  "Tyres::Mastercraft::Stratus AS": {
    "productUrl": "https://www.mastercrafttires.com/tires/stratus-as/24759.html",
    "description": "Designed for people that just want a good deal on a great tire, the Stratus AS has been optimized for all-season performance for cars and CUVs. It's ideal for someone looking for plenty of miles, good traction and economy.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Stratus AS model",
      "All Season",
      "50k Mi Warranty",
      "Quiet Ride",
      "Cars Or Minivan",
      "Handling",
      "M+s Rated"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "50k Mi Warranty",
        "Quiet Ride",
        "Cars Or Minivan",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-stratus-as-64238947-shop-6c0a7e.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-stratus-as-64238947-shop-6c0a7e.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dwf137a36e/images/large/Stratus_AS_24759.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/stratus-as/24759.html"
  },
  "Tyres::Mastercraft::Stratus HT": {
    "productUrl": "https://www.mastercrafttires.com/tires/stratus-ht/24757.html",
    "description": "The Stratus HT offers strong highway performance and great value for SUVs and pickup trucks. Built from innovative design and technology, the Stratus HT delivers improved traction in wet conditions and longer tire life.",
    "availableSizes": [],
    "notes": [
      "This manufacturer page is from an overseas market; Australian stock, exact size, load index and speed rating are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Mastercraft Stratus HT model",
      "All Season",
      "50k Mi Warranty",
      "Dry Performance",
      "Tread Wear",
      "Quiet Ride",
      "Sports Utility",
      "Truck Or Pickup"
    ],
    "specifications": {
      "Product type": "Tyre",
      "Published characteristics": [
        "All Season",
        "50k Mi Warranty",
        "Dry Performance",
        "Tread Wear",
        "Quiet Ride",
        "Sports Utility",
        "Truck Or Pickup",
        "Handling",
        "M+s Rated"
      ]
    },
    "localImage": "product-catalog-tyres-mastercraft-stratus-ht-2288b377-shop-31000c.webp",
    "galleryImages": [
      "product-catalog-tyres-mastercraft-stratus-ht-2288b377-shop-31000c.webp"
    ],
    "imageSourceUrl": "https://www.mastercrafttires.com/dw/image/v2/BJQJ_PRD/on/demandware.static/-/Sites-goodyear-master-catalog/default/dw424127f8/images/large/Stratus_HT_24757.png?sw=900&sh=800&sm=fit&sfrm=png",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://www.mastercrafttires.com/tires/stratus-ht/24757.html"
  },
  "Tyres::Marshal by Kumho::MH15": {
    "productUrl": "https://www.marshaltyre.com.au/passenger-tyres",
    "description": "The perfect balance between high performance and comfort. Great value for the everyday car.",
    "availableSizes": [
      "175/70R13",
      "165/65R14",
      "175/65R14",
      "175/70R14",
      "185/60R14",
      "185/65R14",
      "185/70R14",
      "175/65R15",
      "185/60R15",
      "185/65R15",
      "195/60R15",
      "195/65R15",
      "205/65R15",
      "205/55R16",
      "205/60R16",
      "215/60R16",
      "215/65R16",
      "205/55R17",
      "215/60R17"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal MH15 model",
      "STRENGTHENED SHOULDER: Closed shoulder design secures shoulder rigidity and excellent handling performance.",
      "WIDE 4 CHANNEL GROOVES: Four wide grooves to enhance wet performance and reduce hydroplaning.",
      "SOLID RIB TYPE DESIGN: Rib type centre blocks to reinforce stiffness and driving stability."
    ],
    "specifications": {
      "Intended use": "Passenger",
      "Published Australian sizes": 19
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-mh15-90997e20-shop-1b309c.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-mh15-90997e20-shop-1b309c.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/MH15%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/passenger-tyres"
  },
  "Tyres::Marshal by Kumho::MH12": {
    "productUrl": "https://www.marshaltyre.com.au/passenger-tyres",
    "description": "Balanced high performance tyre for optimal handling and comfort.",
    "availableSizes": [
      "165/70R13",
      "165/65R14",
      "165/70R14",
      "175/65R14",
      "175/70R14",
      "185/65R14",
      "185/70R14",
      "175/60R15",
      "175/65R15",
      "185/60R15",
      "185/65R15",
      "195/60R15",
      "195/65R15",
      "205/60R15",
      "205/65R15",
      "215/65R15",
      "205/55R16",
      "205/60R16",
      "215/60R16",
      "215/65R16",
      "235/60R16"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal MH12 model",
      "STRENGTHENED DRIVING STABILITY: With application of the solid type rib in the centre.",
      "GROOVE NOTCH SHOULDER: To maintain block rigidity for cornering and enhance wet performance with groove notch in lateral grooves.",
      "IMPROVEMENT OF PERFORMANCE HANDLING: Excellent performance handling with closed shoulder design."
    ],
    "specifications": {
      "Intended use": "Passenger",
      "Published Australian sizes": 21
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-mh12-045f2c05-shop-faf191.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-mh12-045f2c05-shop-faf191.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/MH12%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/passenger-tyres"
  },
  "Tyres::Marshal by Kumho::MU12": {
    "productUrl": "https://www.marshaltyre.com.au/passenger-tyres",
    "description": "A premium Ultra Performance tyre perfect for the world's best sports performance cars. Offering outstanding handling and braking performance on wet and dry roads. Expect enhanced traction and stability in dry conditions.",
    "availableSizes": [
      "185/55R15",
      "195/50R15",
      "195/55R15",
      "185/50R16",
      "195/45R16",
      "195/50R16",
      "195/55R16",
      "205/45R16",
      "205/50R16",
      "215/55R16",
      "225/55R16",
      "205/40R17",
      "205/45R17",
      "205/50R17",
      "215/40R17",
      "215/45R17",
      "215/50R17",
      "215/55R17",
      "225/45R17",
      "225/50R17",
      "225/55R17",
      "235/45R17",
      "235/55R17",
      "245/40R17",
      "245/45R17",
      "215/40R18",
      "215/45R18",
      "215/55R18",
      "225/40R18",
      "225/45R18",
      "225/50R18",
      "235/40R18",
      "235/45R18",
      "235/50R18",
      "235/55R18",
      "235/65R18",
      "245/40R18",
      "245/45R18",
      "255/35R18",
      "265/35R18",
      "225/35R19",
      "225/40R19",
      "225/45R19",
      "235/35R19",
      "245/35R19",
      "245/40R19",
      "245/45R19",
      "255/35R19",
      "275/40R19",
      "245/35R20",
      "245/40R20",
      "275/35R20",
      "175/70R13",
      "165/65R14",
      "175/65R14",
      "175/70R14",
      "185/60R14",
      "185/65R14",
      "185/70R14",
      "175/65R15",
      "185/60R15",
      "185/65R15",
      "195/60R15",
      "195/65R15",
      "205/65R15",
      "205/55R16",
      "205/60R16",
      "215/60R16",
      "215/65R16",
      "205/55R17",
      "215/60R17",
      "165/70R13",
      "165/70R14",
      "175/60R15",
      "205/60R15",
      "215/65R15",
      "235/60R16"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal MU12 model",
      "SOLID RIB TYPE DESIGN: Rib tyre centre blocks for block stiffness and wet grip performance.",
      "CLOSED AND NOTCHED SHOULDER: High stiffness shoulder block for handling. Groove notch for cornering and wet performance.",
      "WIDE GROOVES FOR WET PERFORMANCE: 4 wide groove for hydroplaning performance."
    ],
    "specifications": {
      "Intended use": "Passenger performance",
      "Published Australian sizes": 77
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-mu12-b0f1a76f-shop-577281.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-mu12-b0f1a76f-shop-577281.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/MU12%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/passenger-tyres"
  },
  "Tyres::Marshal by Kumho::HP91": {
    "productUrl": "https://www.marshaltyre.com.au/suv-tyres",
    "description": "The ultimate high performance tyre for today's luxury and sporty SUV's. Provides superb handling performance with a quiet and comfortable ride.",
    "availableSizes": [
      "285/65R17",
      "225/55R18",
      "235/55R18",
      "255/55R18",
      "255/60R18",
      "265/60R18",
      "235/45R19",
      "235/50R19",
      "235/55R19",
      "255/50R19",
      "265/50R19",
      "275/45R19",
      "285/45R19",
      "245/45R20",
      "255/45R20",
      "255/55R20",
      "265/45R20",
      "265/50R20",
      "275/40R20",
      "275/45R20",
      "275/50R20",
      "285/50R20",
      "295/40R20",
      "315/35R20",
      "255/40R21",
      "275/45R21",
      "295/35R21",
      "265/35R22",
      "275/40R22"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal HP91 model",
      "STRAIGHT DRIVING STABILITY: Longitudinal centre ribs for high speed driving stability with splitting edge blocks.",
      "DRIVING COMFORT: Optimal block size for low road noise.",
      "MAXIMUM STEERING PERFORMANCE: Maximised block stiffness for improving grip power at cornering.",
      "MAXIMUM AQUAPLANING RESISTANCE: Longitudinal 4 channel grooves and lateral water drainage for fast water evacuation."
    ],
    "specifications": {
      "Intended use": "Performance SUV",
      "Published Australian sizes": 29
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-hp91-1c3cb654-shop-b65672.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-hp91-1c3cb654-shop-b65672.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/HP91%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/suv-tyres"
  },
  "Tyres::Marshal by Kumho::KL21": {
    "productUrl": "https://www.marshaltyre.com.au/suv-tyres",
    "description": "Environmentally friendly SUV tyre with unparalleled ride comfort. A tyre recommended for today's modern vehicles which require a high level of grip, handling, safety and comfort.",
    "availableSizes": [
      "215/70R16",
      "215/60R17",
      "225/60R17",
      "225/65R17",
      "235/60R17",
      "235/65R17",
      "235/55R18",
      "245/60R18"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal KL21 model",
      "WET PERFORMANCE: 4 main channel grooves reduce hydroplaning. Embossed shape within the tread grooves to eject stones.",
      "HANDLING STABILITY: Centre solid rib bock in tread area to increase handling stability.",
      "TRACTION PERFORMANCE: Bite edge, sipes & lateral groove increases traction/performance.",
      "NOISE PERFORMANCE: Optimised variable pitch technique applied to minimise noise during travel."
    ],
    "specifications": {
      "Intended use": "SUV",
      "Published Australian sizes": 8
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-kl21-147623d7-shop-c50b07.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-kl21-147623d7-shop-c50b07.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/KL21%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/suv-tyres"
  },
  "Tyres::Marshal by Kumho::HT51": {
    "productUrl": "https://www.marshaltyre.com.au/suv-tyres",
    "description": "Engineered with quality features and details to go the distance in hard working, hard driving, all-weather conditions.",
    "availableSizes": [
      "225/70R16",
      "245/70R16",
      "255/70R16",
      "265/70R16",
      "245/65R17",
      "265/65R17",
      "245/55R19",
      "285/65R17",
      "225/55R18",
      "235/55R18",
      "255/55R18",
      "255/60R18",
      "265/60R18",
      "235/45R19",
      "235/50R19",
      "235/55R19",
      "255/50R19",
      "265/50R19",
      "275/45R19",
      "285/45R19",
      "245/45R20",
      "255/45R20",
      "255/55R20",
      "265/45R20",
      "265/50R20",
      "275/40R20",
      "275/45R20",
      "275/50R20",
      "285/50R20",
      "295/40R20",
      "315/35R20",
      "255/40R21",
      "275/45R21",
      "295/35R21",
      "265/35R22",
      "275/40R22",
      "215/70R16",
      "215/60R17",
      "225/60R17",
      "225/65R17",
      "235/60R17",
      "235/65R17",
      "245/60R18"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal HT51 model",
      "IMPROVED STRAIGHT LINE DRIVING PERFORMANCE: Stiff centre block design reinforces stability, traction and handling capabilities.",
      "EXTENDED TREAD LIFE: An optimal block shape and four channel symmetric layout improves long tread life.",
      "ENHANCED DRIVING PERFORMANCE IN WET CONDITIONS: Application of a zig-zag style groove design for improved drainage performance."
    ],
    "specifications": {
      "Intended use": "SUV highway",
      "Published Australian sizes": 43
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-ht51-b36c7821-shop-723a45.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-ht51-b36c7821-shop-723a45.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/HT51%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/suv-tyres"
  },
  "Tyres::Marshal by Kumho::KL51": {
    "productUrl": "https://www.marshaltyre.com.au/suv-tyres",
    "description": "A classic road tyre for a modern day SUV. This tyre provides excellent handling, performance, ride comfort and low noise.",
    "availableSizes": [
      "265/70R15",
      "215/70R16",
      "245/65R17",
      "265/65R17",
      "235/60R18",
      "275/55R20"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal KL51 model",
      "SOLID CENTRE RIB: Enhances stable driving offering a comfortable ride at high speeds.",
      "4 MAIN RADIAL GROOVES: Improves aquaplaning performance.",
      "WIDE BLOCK RIB: Provides excellent grip during acceleration and braking in both wet and dry conditions.",
      "CLOSED SHOULDER BLOCK: Offers lower noise and stabilised handling performance when changing lanes."
    ],
    "specifications": {
      "Intended use": "SUV highway",
      "Published Australian sizes": 6
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-kl51-c4a0c57a-shop-d65525.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-kl51-c4a0c57a-shop-d65525.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/KL51%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/suv-tyres"
  },
  "Tyres::Marshal by Kumho::AT51": {
    "productUrl": "https://www.marshaltyre.com.au/suv-tyres",
    "description": "Modern all-terrain tyre, providing high levels of braking and handling performance. Suited to 70% on road and 30% off-road use with an aggressive design optimised for dry, off road traction and wear performance.",
    "availableSizes": [
      "30/9.5R15",
      "31/10.5R15",
      "33/12.5R15",
      "205/70R15",
      "215/75R15",
      "235/75R15",
      "205R16",
      "225/75R16",
      "235/70R16",
      "235/85R16",
      "245/70R16",
      "245/75R16",
      "255/70R16",
      "265/70R16",
      "265/75R16",
      "285/75R16",
      "235/65R17",
      "245/65R17",
      "245/70R17",
      "245/75R17",
      "255/65R17",
      "265/65R17",
      "265/70R17",
      "275/65R17",
      "285/70R17",
      "255/60R18",
      "265/60R18",
      "275/65R18",
      "275/70R18",
      "285/65R18",
      "275/55R20",
      "275/60R20",
      "285/55R20",
      "305/55R20"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal AT51 model",
      "IMPROVES OFF-ROAD PERFORMANCE: Full depth circumferential zig-zag groove & multiple lateral grooves improve on/off road performance. Dual pitch in centre block improves off-road traction and enhances stiffness performance.",
      "ENHANCES LONG-TERM DURABILITY: Stone-ejector bar prevents stone &lsquo;pinching' in the tread area. Robust belt/bead design applied for increased durability."
    ],
    "specifications": {
      "Intended use": "All terrain",
      "Published Australian sizes": 34
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-at51-5ea609d9-shop-b3440b.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-at51-5ea609d9-shop-b3440b.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/AT51%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/suv-tyres"
  },
  "Tyres::Marshal by Kumho::MT51": {
    "productUrl": "https://www.marshaltyre.com.au/suv-tyres",
    "description": "Designed and tested in Australia the Road Venture MT51 is designed to balance on and off-road performance. Ideal for mud, track and rock climbing applications while providing a comfortable on road ride.",
    "availableSizes": [
      "31/10.5R15",
      "32/11.5R15",
      "33/12.5R15",
      "235/75R15",
      "235/85R16",
      "245/70R16",
      "265/70R16",
      "265/75R16",
      "285/75R16",
      "305/70R16",
      "265/65R17",
      "265/70R17",
      "285/70R17",
      "265/60R18",
      "265/70R15",
      "215/70R16",
      "245/65R17",
      "235/60R18",
      "275/55R20",
      "30/9.5R15",
      "205/70R15",
      "215/75R15",
      "205R16",
      "225/75R16",
      "235/70R16",
      "245/75R16",
      "255/70R16",
      "235/65R17",
      "245/70R17",
      "245/75R17",
      "255/65R17",
      "275/65R17",
      "255/60R18",
      "275/65R18",
      "275/70R18",
      "285/65R18",
      "275/60R20",
      "285/55R20",
      "305/55R20"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal MT51 model",
      "ON-OFF ROAD BALANCING PERFORMANCE IMPROVEMENT: Rug block and dual pitch applied for mud, rock crawling and on road performance.",
      "TRACTION PERFORMANCE IMPROVEMENT: 3 level high block improves the stiffness. Zig zag groove and a notching shoulder reduces damage and off road traction.",
      "MUD & STONE EMISSION: Stone eject bar improves stones and mud rejection."
    ],
    "specifications": {
      "Intended use": "Mud terrain",
      "Published Australian sizes": 39
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-mt51-858156f8-shop-55a9f5.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-mt51-858156f8-shop-55a9f5.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/MT51%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/suv-tyres"
  },
  "Tyres::Marshal by Kumho::KC53": {
    "productUrl": "https://www.marshaltyre.com.au/light-trucks",
    "description": "The new generation for light commercial vehicle tyre with high mileage and good handling properties.",
    "availableSizes": [
      "165R13",
      "175R13",
      "185R14",
      "195R14",
      "195R15",
      "195/70R15",
      "205/65R15",
      "205/70R15",
      "215/70R15",
      "225/70R15",
      "195/75R16",
      "205/65R16",
      "205/75R16",
      "215/60R16",
      "215/65R16",
      "215/70R16",
      "215/75R16",
      "225/65R16",
      "225/75R16",
      "235/65R16",
      "215/60R17"
    ],
    "notes": [
      "Current stock, the exact load and speed rating, and final vehicle compatibility are confirmed by 110 Garage"
    ],
    "features": [
      "Current official Australian Marshal KC53 model",
      "HIGHER LOAD CAPACITY: Wide tread and stable block pattern for outstanding dry handling even with maximum load.",
      "BROAD CROSS-GROOVES: Precise steering ability even in wet curves.",
      "MILEAGE INCREASE AND OPTIMAL ROLLING RESISTANCE: New rip style design for high durability and low fuel consumption.",
      "IMPROVED WET PERFORMANCE: Wide, straight circumferential grooves for exemplary aquaplaning performance as well as maximum braking ability and easy handling on wet roads."
    ],
    "specifications": {
      "Intended use": "Commercial / light truck",
      "Published Australian sizes": 21
    },
    "localImage": "product-catalog-tyres-marshal-by-kumho-kc53-5786ddc1-shop-be8d91.webp",
    "galleryImages": [
      "product-catalog-tyres-marshal-by-kumho-kc53-5786ddc1-shop-be8d91.webp"
    ],
    "imageSourceUrl": "https://lirp.cdn-website.com/08a60e50/dms3rep/multi/opt/KC53%283%29-1920w.png",
    "descriptionSource": "official-australian-product-page",
    "descriptionSourceUrl": "https://www.marshaltyre.com.au/light-trucks"
  },
  "Wheels::SpeedWorks::SW22": {
    "productUrl": "https://www.speedworks.com.au/products/sw22",
    "description": "The SW22 is a sleek, contemporary wheel designed to deliver a refined performance-inspired look. Its striking directional split-spoke design creates a strong sense of movement, giving your vehicle an aggressive stance whether parked or in motion. Blending clean lines with a minimalist aesthetic, the SW22 is perfectly suited to modern performance cars, luxury sedans and SUVs. Its versatile design complements both factory and modified vehicles, making it an ideal choice for drivers seeking a premium appearance with everyday practicality. With its bold styling and timeless appeal, the SW22 is built to make an impression from every angle.",
    "availableSizes": [
      "19x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "1 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "19 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X112"
      ],
      "Published offsets": [
        "ET35"
      ],
      "Published finishes": [
        "Gloss Black with Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw22-0ab07200-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw22-0ab07200.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/wh-20240614-094341-22955.jpg?v=1783183242",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw22"
  },
  "Wheels::SpeedWorks::SW23": {
    "productUrl": "https://www.speedworks.com.au/products/sw23",
    "description": "*]:pointer-events-auto R6Vx5W_threadScrollVars scroll-mb-[calc(var(--scroll-root-safe-area-inset-bottom,0px)+var(--thread-response-height))] scroll-mt-[calc(var(--header-height)+min(200px,max(70px,20svh)))]\" dir=\"auto\" data-turn-id=\"request-6a492f07-fc8c-83ec-9eb1-65ac7ecb6326-3\" data-turn-id-container=\"request-6a492f07-fc8c-83ec-9eb1-65ac7ecb6326-3\" data-testid=\"conversation-turn-12\" data-turn=\"assistant\"> The SW23 combines sharp styling with a clean, modern design that suits a wide range of vehicles. Featuring an intricate split-spoke directional layout, it delivers a sporty, premium appearance while maintaining a timeless look that complements both factory and modified builds. Designed to stand out from every angle, the SW23 offers the perfect balance of aggressive styling and everyday practicality. It's an excellent choice for enthusiasts looking to elevate the look of their vehicle without compromising on quality. Whether fitted to a performance car, luxury sedan or SUV, the SW23 brings a refined yet purposeful aesthetic that is sure to turn heads.",
    "availableSizes": [
      "18x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "1 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET40"
      ],
      "Published finishes": [
        "Hyper Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw23-62145728-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw23-62145728.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/ChatGPTImageJul5_2026_02_07_03AM.png?v=1783183053",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw23"
  },
  "Wheels::SpeedWorks::SWF20": {
    "productUrl": "https://www.speedworks.com.au/products/swf20",
    "description": "The SWF20 is the perfect combination of lightweight performance and modern motorsport-inspired styling. Featuring a clean multi-spoke design with sculpted windows between each spoke, the SWF20 delivers exceptional strength while reducing unsprung weight for improved handling, acceleration, and braking performance. Its timeless yet aggressive design complements everything from performance sedans and sports cars to premium SUVs. Each set is custom forged to order , allowing you to tailor every aspect of the wheel to suit your vehicle. From diameter, width, offset and bolt pattern to centre bore and finish, every wheel is manufactured to your exact specifications for an uncompromising fit and finish. Precision-machined from aerospace-grade forged aluminium, the SWF20 offers outstanding structural integrity without sacrificing weight, making it ideal for both spirited street driving and track use. Available in a wide range of premium finishes including Gloss, Satin, Brushed, Polished and Chrome , the SWF20 can be customised to perfectly match your build.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf20-a4c8a91b-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf20-a4c8a91b.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/FrontElevation1.jpg?v=1782394082",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf20"
  },
  "Wheels::SpeedWorks::Forge-Fit 004 - BMW X4 M F98/G02": {
    "productUrl": "https://www.speedworks.com.au/products/forge-fit-004-to-suit-bmw-x4m-f98-g02-2018-2025",
    "description": "SWF13 - Designed for the BMW X4 M (G02) Elevate the appearance and performance of your BMW X4M with the SWF13, a premium forged wheel engineered specifically to complement the aggressive styling and high-performance nature of BMW's flagship Sports Activity Coupe. Featuring a striking directional multi-spoke design, the SWF13 creates a powerful sense of motion even when stationary. The sharp, flowing spoke architecture extends seamlessly towards the outer edge of the wheel, enhancing the dynamic proportions of the X4 M while delivering a modern OEM+ aesthetic. Purpose-built for both performance and presence, the directional design accentuates the vehicle's athletic stance and road-going character. Precision-manufactured from aerospace-grade forged aluminium, the SWF13 is designed to minimise unsprung weight while maximising strength and rigidity. The result is improved steering response, enhanced handling characteristics, greater braking performance, and the confidence required from a high-performance BMW M vehicle.",
    "availableSizes": [
      "20x10.5",
      "20x9.5",
      "21x10.5",
      "21x9.5",
      "22x10.5",
      "22x9.5"
    ],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forge-Fit model",
      "6061-T6 aluminium construction",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forge-Fit",
      "Construction": "Vehicle-specific forged monoblock",
      "Available diameters": [
        "20 inch",
        "21 inch",
        "22 inch"
      ],
      "Published widths": [
        "9.5 inch",
        "10.5 inch"
      ],
      "Published offsets": [
        "ET20",
        "ET35"
      ],
      "Published centre bores": [
        "66.6 mm"
      ],
      "Published finishes": [
        "Brushed",
        "Chrome",
        "Gloss",
        "Satin",
        "Satin Black"
      ],
      "Setup": "Staggered",
      "Front guide fitment": "9.5 inch / ET20",
      "Rear guide fitment": "10.5 inch / ET35",
      "Published lead time": "12-14 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-forge-fit-004-bmw-x4-m-f98-g02-b1107bbe.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-forge-fit-004-bmw-x4-m-f98-g02-b1107bbe.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/Screenshot_2026-06-17_at_9.26.32_pm.png?v=1781695601",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/forge-fit-004-to-suit-bmw-x4m-f98-g02-2018-2025"
  },
  "Wheels::SpeedWorks::Forge-Fit 003 - Audi R8 Type 4S": {
    "productUrl": "https://www.speedworks.com.au/products/forge-fit-003-to-suit-audi-r8-type-4s-2016-2024",
    "description": "Elevate the appearance and performance of your Audi R8 with the SWF17, a premium forged multi-piece wheel engineered specifically for the second-generation R8 Type 4S platform. Featuring an intricate split-spoke mesh design with exposed assembly hardware, the SWF17 delivers the perfect balance of aggressive supercar styling, lightweight performance, and bespoke craftsmanship. Precision-manufactured from aerospace-grade forged aluminium, the SWF17 is designed to reduce unsprung weight while maximising strength and rigidity. The result is sharper steering response, improved handling characteristics, enhanced braking performance, and a driving experience worthy of Audi's flagship supercar. The complex multi-spoke architecture creates exceptional visual depth, allowing the wheel to transform the stance of the R8 while maintaining an OEM+ aesthetic. Whether finished in Gloss, Matte, Brushed, Diamond Cut, or Fully Polished finishes, each set is custom-built to complement your vehicle and personal style.",
    "availableSizes": [
      "20x12",
      "20x9.5",
      "21x12",
      "21x9.5"
    ],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forge-Fit model",
      "6061-T6 aluminium construction",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forge-Fit",
      "Construction": "Vehicle-specific forged multi-piece",
      "Available diameters": [
        "20 inch",
        "21 inch"
      ],
      "Published widths": [
        "9.5 inch",
        "12 inch"
      ],
      "Published offsets": [
        "ET35",
        "ET45"
      ],
      "Published centre bores": [
        "57.1 mm",
        "66.5 mm"
      ],
      "Published finishes": [
        "Brushed Gold Face with Polished Lip"
      ],
      "Setup": "Staggered",
      "Front guide fitment": "9.5 inch / ET35",
      "Rear guide fitment": "12 inch / ET45",
      "Published lead time": "12-14 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-forge-fit-003-audi-r8-type-4s-59a3df28.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-forge-fit-003-audi-r8-type-4s-59a3df28.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/PHOTO-2026-06-07-22-05-0118.jpg?v=1781694045",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/forge-fit-003-to-suit-audi-r8-type-4s-2016-2024"
  },
  "Wheels::SpeedWorks::SW21": {
    "productUrl": "https://www.speedworks.com.au/products/sw21",
    "description": "*]:pointer-events-auto [content-visibility:auto] supports-[content-visibility:auto]:[contain-intrinsic-size:auto_100lvh] scroll-mt-[calc(var(--header-height)+min(200px,max(70px,20svh)))]\" dir=\"auto\" data-turn-id=\"request-WEB:690c619a-a78e-4379-b385-7c72ee9a96a0-4\" data-testid=\"conversation-turn-10\" data-scroll-anchor=\"true\" data-turn=\"assistant\" tabindex=\"-1\"> The SW21 brings rugged off-road attitude together with premium machining and a high-end polished finish. Featuring a bold multi-window design, a deep stepped lip, and detailed rivet accents, the SpeedWorks SW21 delivers a commanding presence built for 4x4, truck, and adventure platforms. With its fully machined face and striking beadlock-style detailing, the SW21 adds instant character to any off-road setup. Engineered for strength and visual impact, the SW21 blends durability with refined styling-making it the perfect choice for enthusiasts who want their rig to stand out on the street and the trails.",
    "availableSizes": [
      "17x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Published widths": [
        "9 inch"
      ],
      "Published PCDs": [
        "6X139.7"
      ],
      "Published offsets": [
        "ET0"
      ],
      "Published finishes": [
        "Machined Silver",
        "Machined Silver & Black Ring"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw21-28356a9c-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw21-28356a9c.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/0BDD5F45-B40B-44CC-9985-2C5B44BF57CE.jpg?v=1768850779",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw21"
  },
  "Wheels::SpeedWorks::SW20": {
    "productUrl": "https://www.speedworks.com.au/products/sw20",
    "description": "The SW20 delivers a clean, modern aesthetic with a strong performance edge. Featuring an elegant split-spoke design, a deep concave profile, and sharp precision-cut detailing, the SpeedWorks SW20 offers a sleek and dynamic look that elevates any street or track build. Available in both a hyper black and a bold matte black finish, it brings versatility and attitude to a wide range of vehicles. With its lightweight construction and refined spoke geometry, the SW20 balances style and strength, making it a standout choice for enthusiasts chasing a premium, sporty presence on the road.",
    "availableSizes": [
      "18x8.75"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "4 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.75 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET35"
      ],
      "Published finishes": [
        "Hyper Black",
        "Matte Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw20-eaf8dffe-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw20-eaf8dffe.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/AEBF45D9-89DB-4D18-B57B-972E43054217.jpg?v=1768850821",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw20"
  },
  "Wheels::SpeedWorks::SW19": {
    "productUrl": "https://www.speedworks.com.au/products/sw19",
    "description": "The SW19 combines aggressive performance styling with a refined modern finish. Featuring a crisp multi-spoke layout, concave profile, and precision-machined accents, the SpeedWorks SW19 delivers a bold yet balanced look that transforms any build. Finished in a premium brushed bronze with a polished lip, the SW19 brings a high-end motorsport aesthetic to both street and track cars. Designed for enthusiasts who want lightweight strength without sacrificing visual appeal, the SW19 offers sharp detailing, clean lines, and a dynamic presence that works across a wide range of platforms.",
    "availableSizes": [
      "18x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET38"
      ],
      "Published finishes": [
        "Bronze"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw19-b4f867a2-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw19-b4f867a2.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/EF1F9669-617A-4E65-879E-5776235E4F1E.jpg?v=1768850859",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw19"
  },
  "Wheels::SpeedWorks::WS MAX 20": {
    "productUrl": "https://www.speedworks.com.au/products/wsmax20",
    "description": "The dream wheel for Holden Commodore drivers everywhere. The five spokes evoke the famous Walkinshaw look. The wheels are engineered to clear HSV PRE-VE brakes as standard with no spacer or guard change needed. These wheels also have maximum dish, the deepest dish in this style currently available on the market. 10 year manufacturer's warranty. All the wheels come with a relevant wheel centre cap to suit.OE caps are interchangeable. Brake Clearance: PRE VE 20X8.5J Red Brembo / Silver Brembo / Yellow Brembo 20X9.5J Red Brembo / Silver Brembo / Yellow Brembo",
    "availableSizes": [
      "20x8.5",
      "20x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "20 inch"
      ],
      "Published widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X120"
      ],
      "Published offsets": [
        "ET36",
        "ET48"
      ],
      "Published centre bores": [
        "69.6 mm"
      ],
      "Published finishes": [
        "SILVER MACHINE",
        "SILVER MACHINED LIP"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-ws-max-20-27c96693-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-ws-max-20-27c96693.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/EAE516D4-B6BF-422B-A25B-67D7956B09D7.jpg?v=1757499687",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/wsmax20"
  },
  "Wheels::SpeedWorks::SW05": {
    "productUrl": "https://www.speedworks.com.au/products/sw05",
    "description": "The SpeedWorks SW05 is one of our best sellers, and for good reason too. We combined the classic 10-spoke design with a subtle machined lip to bring you the peak of both form and function.",
    "availableSizes": [
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "4 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET35"
      ],
      "Published finishes": [
        "Hyper Black & Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw05-50300ef2-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw05-50300ef2.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_d14b5abc-a1e6-4e8f-a91b-7cb0d55ed8ff.jpg?v=1729965086",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw05"
  },
  "Wheels::SpeedWorks::SW12": {
    "productUrl": "https://www.speedworks.com.au/products/sw12",
    "description": "The SW12 blends modern design with timeless street appeal. Sporting a sleek 10-spoke layout, a subtle lip, and precision-cut detailing, the SpeedWorks SW12 brings balance and sophistication to any vehicle. Whether in classic silver or eye-catching white, this wheel is designed to elevate your build with a refined yet sporty aesthetic that works across a range of platforms.",
    "availableSizes": [
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "3 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET22",
        "ET30"
      ],
      "Published finishes": [
        "Gloss White & Machine Lip",
        "Hyper Black & Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw12-c87c58f1-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw12-c87c58f1.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/Image7.jpg?v=1743396834",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw12"
  },
  "Wheels::SpeedWorks::SW18": {
    "productUrl": "https://www.speedworks.com.au/products/sw18",
    "description": "The SW18 is crafted for enthusiasts who appreciate precision and design. Featuring a race-inspired 10-spoke mesh layout and a striking matte bronze finish, the SpeedWorks SW18 delivers a refined motorsport aesthetic with a modern edge. The forged monoblock construction ensures a clean, seamless look that complements a wide range of builds-from street to show.",
    "availableSizes": [
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "1 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Forged aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET22"
      ],
      "Published finishes": [
        "Bronze"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw18-bf51903c-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw18-bf51903c.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/K.jpg?v=1743396155",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw18"
  },
  "Wheels::SpeedWorks::SW17": {
    "productUrl": "https://www.speedworks.com.au/products/sw17",
    "description": "The SW17 brings a retro spirit into the modern era. Featuring a bold 5-spoke layout with a deep lip and high-gloss black face, the SpeedWorks SW17 is designed to command attention. Its clean and timeless lines evoke classic motorsport heritage, while the polished step lip adds a premium touch. Ideal for old-school builds or contemporary cars with a nostalgic edge, the SW17 offers versatility with a statement. Classic muscle meets modern standard.",
    "availableSizes": [
      "18x10.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "9.5 inch",
        "10.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET22"
      ],
      "Published finishes": [
        "Gloss Black & Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw17-5dbcf8f8-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw17-5dbcf8f8.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/Image18.jpg?v=1743395909",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw17"
  },
  "Wheels::SpeedWorks::SW16": {
    "productUrl": "https://www.speedworks.com.au/products/sw16",
    "description": "The SW16 fuses aggressive styling with track-ready precision. With its sharp, split 10-spoke design and deep concave profile, the SpeedWorks SW16 offers a modern motorsport aesthetic that elevates any build. The machined face and intricate spoke detailing reflect craftsmanship and intent, perfect for those who demand performance without compromising style. Lightweight yet durable, the SW16 is engineered for responsiveness on the street or at the circuit. Built to perform. Styled to impress.",
    "availableSizes": [
      "18x8.5",
      "19x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "3 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch",
        "19 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X112",
        "5X114.3"
      ],
      "Published offsets": [
        "ET38",
        "ET40"
      ],
      "Published finishes": [
        "Hyper Black",
        "Hyper Silver"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw16-47246184-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw16-47246184.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/Y_90876b48-a496-4f4d-9a45-10069fcc2e00.jpg?v=1743395806",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw16"
  },
  "Wheels::SpeedWorks::SW15": {
    "productUrl": "https://www.speedworks.com.au/products/sw15",
    "description": "The SW15 merges iconic styling with modern craftsmanship. Featuring a bold 6-spoke layout, deep concave face, and a striking machined lip, the SpeedWorks SW15 delivers a clean yet aggressive aesthetic. Its refined metallic finish complements a wide range of builds-from track-inspired to show-stopping street setups. Engineered for enthusiasts who demand both presence and performance, the SW15 is built to turn heads and handle the road with confidence. Quality and safety you can trust.",
    "availableSizes": [
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET22",
        "ET35"
      ],
      "Published finishes": [
        "Hyper Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw15-6332362d-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw15-6332362d.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/Image41_ef45c2d2-c567-4e7b-aaca-16bdc44d7c57.jpg?v=1743395858",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw15"
  },
  "Wheels::SpeedWorks::SW14": {
    "productUrl": "https://www.speedworks.com.au/products/sw14",
    "description": "The SW14 is a statement of performance and modern aesthetics. Designed with a lightweight multi-spoke structure, this wheel delivers both strength and agility, making it ideal for enthusiasts who demand form and function. The deep concave profile enhances its aggressive stance, while the precision-engineered design ensures durability on the street and track. Available in multiple sizes to complement a variety of builds, the SpeedWorks SW14 embodies innovation and craftsmanship.",
    "availableSizes": [
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET22",
        "ET35"
      ],
      "Published finishes": [
        "Matte Gunmetal"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw14-105ebaf1-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw14-105ebaf1.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/Image38_4c7610e6-7b0d-4dcf-b240-9ceb96140695.jpg?v=1743395726",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw14"
  },
  "Wheels::SpeedWorks::SWF18": {
    "productUrl": "https://www.speedworks.com.au/products/swf18",
    "description": "Upgrade your vehicle's style and performance with the SWF18 custom forged wheels, where innovative design meets engineering excellence. These true directional wheels are forged to your precise specifications, offering unmatched flexibility in size and fitment to ensure a perfect match for your vehicle. Made from premium materials, the SWF18 wheels are built for durability and longevity, making them ideal for both daily driving and high-performance needs. Available in gloss, satin, brushed, and chrome finishes, they effortlessly complement a wide range of vehicle styles. Transform your ride with SWF18 wheels and experience the ultimate fusion of style, performance, and innovation. Redefine your driving experience with SWF18 custom forged wheels today. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control. If you aren't able to pick-up in Sydney, allow another 5-7 business days for postage to you.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Twist model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Twist",
      "Construction": "Custom forged directional design",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf18-08bf8b8b-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf18-08bf8b8b.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/c1dffb8a8fcc270c5c223e6e9c54edb1.jpg?v=1738998721",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf18"
  },
  "Wheels::SpeedWorks::SWF16": {
    "productUrl": "https://www.speedworks.com.au/products/swf16",
    "description": "The SWF16 by SpeedWorks Forged is a directional monoblock wheel that redefines modern wheel aesthetics with its bold, sculpted design . Featuring deep-cut sections on the face , the SWF16 creates striking depth and dimensionality, setting it apart from conventional directional wheels. The hollowed-out details further enhance its aggressive look while reducing weight for improved performance. The directional spokes flow seamlessly, reinforcing a sense of motion even at a standstill. Crafted from high-quality forged materials, the SWF16 delivers exceptional strength without unnecessary bulk, making it a perfect balance of style, performance, and precision engineering . Designed for enthusiasts who demand a standout, high-performance wheel , the SWF16 makes a bold statement on any build-whether on the street or the track. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control. If you aren't able to pick-up in Sydney, allow another 5-7 business days for postage to you.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Twist model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Twist",
      "Construction": "Custom forged directional design",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf16-f79acbc7-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf16-f79acbc7.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/2edc2170d63578afe796c318a70ad265.jpg?v=1738995934",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf16"
  },
  "Wheels::SpeedWorks::SWF15": {
    "productUrl": "https://www.speedworks.com.au/products/swf15",
    "description": "The SWF15 by SpeedWorks Forged is a true masterpiece of engineering and design, featuring a unique \"floating\" ring integrated into its face. This distinctive design element creates an illusion of separation, giving the wheel an aggressive yet sophisticated look. The intricate web of spokes seamlessly connects to this outer ring, enhancing the directional flow and reinforcing the wheel's aerodynamic efficiency. Beyond aesthetics, the SWF15 is a fully forged monoblock wheel , ensuring extreme strength and lightweight performance. Its directional structure is not just for show-it optimizes airflow around the brakes, improving cooling and efficiency during high-performance driving. Built for enthusiasts who demand cutting-edge style and superior functionality, the SWF15 redefines what a directional wheel can be, making a bold statement while delivering uncompromising performance. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Twist model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Twist",
      "Construction": "Custom forged directional design",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf15-2d97a9d5-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf15-2d97a9d5.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/c3d69fe32b0efba7fb6e019ea752bff8.jpg?v=1738995498",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf15"
  },
  "Wheels::SpeedWorks::SWF14": {
    "productUrl": "https://www.speedworks.com.au/products/swf14",
    "description": "The SWF14 by SpeedWorks Forged is a precision-engineered directional monoblock wheel , blending cutting-edge design with exceptional performance. Crafted to enhance both the aesthetics and handling of your vehicle, it delivers the perfect fusion of style and function. Designed for enthusiasts who demand premium quality and a bold, dynamic look, the SWF14 stands out with its striking directional design-making a statement while optimising performance and airflow. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control. If you aren't able to pick-up in Sydney, allow another 5-7 business days for postage to you.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Twist model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Twist",
      "Construction": "Custom forged directional design",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf14-0cc6eac1-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf14-0cc6eac1.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/629f9ebb98fd8513b5bbff3bbf348617.jpg?v=1738994579",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf14"
  },
  "Wheels::SpeedWorks::Forge-Fit 002 - Mercedes S-Class W222": {
    "productUrl": "https://www.speedworks.com.au/products/forge-fit-002-to-suit-mercedes-s-class-w222-2014-2020",
    "description": "The Mercedes Turbine-Style Alloy Wheel: Precision and Sophistication for the S-Class Elevate your Mercedes S-Class with the Turbine-Style Alloy Wheel , designed to combine OEM aesthetics with unique aftermarket flair. Inspired by the sleek lines of a turbine, this wheel's design flows seamlessly to create a look of perpetual motion, adding a dynamic touch to your luxury vehicle. Crafted from high-quality forged alloy, the turbine-style wheel ensures both durability and an upscale finish that complements the refined silhouette of the S-Class. Its polished spokes, reminiscent of jet engine blades, reflect light beautifully, giving your car a distinguished yet sporty appearance. Engineered for stability and performance, this wheel enhances handling and delivers a smooth, confident ride on any road. Stand out with a wheel that merges cutting-edge design with performance-oriented engineering, a perfect blend for the discerning S-Class driver.",
    "availableSizes": [
      "20x10.5",
      "20x9",
      "21x10.5",
      "21x9",
      "22x10.5",
      "22x9"
    ],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forge-Fit model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forge-Fit",
      "Construction": "Vehicle-specific forged monoblock",
      "Available diameters": [
        "20 inch",
        "21 inch",
        "22 inch"
      ],
      "Published widths": [
        "9 inch",
        "10.5 inch"
      ],
      "Published offsets": [
        "ET25",
        "ET35"
      ],
      "Published centre bores": [
        "66.6 mm"
      ],
      "Published finishes": [
        "Polished"
      ],
      "Setup": "Staggered",
      "Front guide fitment": "9 inch / ET25",
      "Rear guide fitment": "10.5 inch / ET35",
      "Published lead time": "12-14 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-forge-fit-002-mercedes-s-class-w222-9eab4bd0.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-forge-fit-002-mercedes-s-class-w222-9eab4bd0.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/2024-08-19_95047f62-58b5-497d-b0a5-a08ea5bb77b7.jpg?v=1783510333",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/forge-fit-002-to-suit-mercedes-s-class-w222-2014-2020"
  },
  "Wheels::SpeedWorks::SW13": {
    "productUrl": "https://www.speedworks.com.au/products/sw13",
    "description": "The SW13 brings timeless elegance and performance together. With its deep-dished, five-spoke design and polished lip, the SpeedWorks SW13 is perfect for those who appreciate a bold, classic look. This wheel combines a stylish finish that complements a wide range of vehicles, delivering visual appeal. Built for drivers who value a blend of aesthetics and performance, the SW13 stands out on any road with its iconic design.",
    "availableSizes": [
      "17x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET30"
      ],
      "Published finishes": [
        "Gloss Black & Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw13-e65d6334-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw13-e65d6334.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_d83ab7f1-c1b4-4373-8c8d-cde98546df2e.jpg?v=1729967078",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw13"
  },
  "Wheels::SpeedWorks::SW11": {
    "productUrl": "https://www.speedworks.com.au/products/sw11",
    "description": "The SW11 is the ultimate choice for off-road enthusiasts, crafted to tackle rugged terrains with style and confidence. Featuring a bold, rugged design with reinforced spokes and a beadlock-inspired rim, the SpeedWorks SW11 delivers both striking looks and off-road readiness. This wheel is built for those who demand performance and presence from their 4WD setup.",
    "availableSizes": [
      "17x9"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "17 inch"
      ],
      "Published widths": [
        "9 inch"
      ],
      "Published PCDs": [
        "6X139.7"
      ],
      "Published offsets": [
        "ET0"
      ],
      "Published finishes": [
        "Machined Silver",
        "Matte Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw11-484f1bab-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw11-484f1bab.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_41d66bb1-e013-480d-bc6b-c6dde9292dbc.jpg?v=1729966722",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw11"
  },
  "Wheels::SpeedWorks::SW10": {
    "productUrl": "https://www.speedworks.com.au/products/sw10",
    "description": "The SW10 is a refined addition to the SpeedWorks collection, featuring a classic multi-spoke design that exudes both elegance and performance. The SpeedWorks SW10 is the perfect choice for car enthusiasts looking to enhance their vehicle's aesthetic with a sleek, timeless wheel.",
    "availableSizes": [
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET22",
        "ET38"
      ],
      "Published finishes": [
        "Hyper Silver"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw10-6415517a-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw10-6415517a.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_600e17f2-bd61-43a0-b8ee-f48569972294.jpg?v=1729966249",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw10"
  },
  "Wheels::SpeedWorks::SWF13": {
    "productUrl": "https://www.speedworks.com.au/products/swf13",
    "description": "Upgrade your vehicle's style and performance with the SWF13 custom forged wheels, where innovative design meets engineering excellence. These true directional wheels are forged to your precise specifications, offering unmatched flexibility in size and fitment to ensure a perfect match for your vehicle. Made from premium materials, the SWF13 wheels are built for durability and longevity, making them ideal for both daily driving and high-performance needs. Available in gloss, satin, brushed, and chrome finishes, they effortlessly complement a wide range of vehicle styles. Transform your ride with SWF13 wheels and experience the ultimate fusion of style, performance, and innovation. Redefine your driving experience with SWF13 custom forged wheels today. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control. If you aren't able to pick-up in Sydney, allow another 5-7 business days for postage to you.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Twist model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Twist",
      "Construction": "Custom forged directional design",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf13-bb2318ae-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf13-bb2318ae.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/0d1c79e1f62b87e30af2f3f8fba84e5b.jpg?v=1738999233",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf13"
  },
  "Wheels::SpeedWorks::SWF12": {
    "productUrl": "https://www.speedworks.com.au/products/swf12",
    "description": "Elevate your vehicle's aesthetic and performance with the SWF12 custom forged wheels, where cutting-edge design meets engineering precision. These wheels feature a distinctive design with unique holes integrated into each spoke, enhancing visual appeal and reducing overall weight for improved vehicle performance. Custom forged to your exact specifications, the SWF12 wheels offer unparalleled flexibility in size and fitment, ensuring a perfect match for your vehicle's requirements. Crafted from high-quality materials, they guarantee durability and longevity, making them ideal for both daily driving and high-performance applications. Available in gloss, satin, brushed and chrome finishes, they seamlessly complement a variety of vehicle styles. Transform your ride with the SWF12 wheels and experience the perfect blend of style, performance, and innovation. Upgrade to SWF12 custom forged wheels today and redefine your driving experience Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf12-573f7522-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf12-573f7522.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/F44CF5A9-AEA7-41B7-8835-07787026E5E8.jpg?v=1718453251",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf12"
  },
  "Wheels::SpeedWorks::Forge-Fit 001 - Mercedes S-Class W222": {
    "productUrl": "https://www.speedworks.com.au/products/oem-forged-to-suit-mercedes-s-class-w222-2014-2020",
    "description": "Balancing form and function - OEM style with aftermarket precision. Introducing the Maybach Inspired Forged Alloy Wheel, the perfect upgrade for your luxurious Mercedes S Class. Designed with elegance and style in mind, this wheel embodies the sophistication of the iconic Maybach brand. The polished finish adds a touch of luxury to your vehicle, making it stand out from the crowd. This high-quality forged alloy wheel is not only beautiful but also incredibly strong and durable, ensuring maximum performance and longevity. The forging process enhances the wheel's stability, providing improved handling and a more confident driving experience. Whether you're cruising down the highway or navigating city streets, the Maybach Inspired Forged Alloy Wheel will elevate your driving experience. Upgrade your Mercedes S Class with this stunning wheel and make a statement wherever you go. With its premium construction and sleek finish, this wheel is sure to turn heads and leave a lasting impression. Drive with confidence, knowing that you have the best in both style and performance.",
    "availableSizes": [
      "20x10.5",
      "20x9",
      "21x10.5",
      "21x9",
      "22x10.5",
      "22x9"
    ],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forge-Fit model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forge-Fit",
      "Construction": "Vehicle-specific forged monoblock",
      "Available diameters": [
        "20 inch",
        "21 inch",
        "22 inch"
      ],
      "Published widths": [
        "9 inch",
        "10.5 inch"
      ],
      "Published offsets": [
        "ET30",
        "ET40"
      ],
      "Published centre bores": [
        "66.6 mm"
      ],
      "Published finishes": [
        "Polished"
      ],
      "Setup": "Staggered",
      "Front guide fitment": "9 inch / ET30",
      "Rear guide fitment": "10.5 inch / ET40",
      "Published lead time": "12-14 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-forge-fit-001-mercedes-s-class-w222-f0b52f47.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-forge-fit-001-mercedes-s-class-w222-f0b52f47.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/280984933_567678061626349_7204712189032084700_n_webp.png?v=1676044103",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/oem-forged-to-suit-mercedes-s-class-w222-2014-2020"
  },
  "Wheels::SpeedWorks::SW04": {
    "productUrl": "https://www.speedworks.com.au/products/sw04",
    "description": "Styles come and go, but the SW04 is truly timeless. Featured alongside some of the most popular Japanese and European tuner cars, the SpeedWorks SW04 never gets old. Providing your car with sophistication like no other and striking elegance, you'll be garnering praise wherever you and your car find yourselves.",
    "availableSizes": [
      "18x8"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "6 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET38"
      ],
      "Published finishes": [
        "Bronze",
        "Gloss Black",
        "Hyper Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw04-2407a36e-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw04-2407a36e.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1-Photoroom_71406630-eae8-4312-8e36-81c5ebca16a0.jpg?v=1729964878",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw04"
  },
  "Wheels::SpeedWorks::Eclipse": {
    "productUrl": "https://www.speedworks.com.au/products/eclipse",
    "description": "The Eclipse wheels are now part of our clearance stock, never to return! Be one of the last people to grab your set at a discount!",
    "availableSizes": [
      "18x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Clearance model",
      "1 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Clearance",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X114.3"
      ],
      "Published offsets": [
        "ET35"
      ],
      "Published finishes": [
        "Satin Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-eclipse-2c78328c-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-eclipse-2c78328c.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/image.png?v=1670859712",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/eclipse"
  },
  "Wheels::SpeedWorks::SW09": {
    "productUrl": "https://www.speedworks.com.au/products/sw09",
    "description": "The SW09 is the latest addition to the SpeedWorks lineup, combining modern aesthetics with a sense of timeless appeal. Featuring a sleek, multi-spoke design, the SpeedWorks SW09 is crafted for the discerning car enthusiast who values both style and performance in their wheels. Unlike standard cast wheels, the SW09 is flow forged, providing enhanced strength and reduced weight, making it an ideal choice for performance-focused drivers.",
    "availableSizes": [
      "19x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "1 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Forged aluminium alloy",
      "Available diameters": [
        "19 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X112"
      ],
      "Published offsets": [
        "ET35"
      ],
      "Published finishes": [
        "Gloss Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw09-7423f11f-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw09-7423f11f.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_b25d4c64-a840-4746-9800-57acf4b515fd.jpg?v=1729965816",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw09"
  },
  "Wheels::SpeedWorks::SW08": {
    "productUrl": "https://www.speedworks.com.au/products/sw08",
    "description": "The SpeedWorks SW08 has been a mainstay in the old-school car scene, and for good reason. It features a twin 6-spoke layout with a remarkable amount of dish, making it an ideal choice for serious car enthusiasts looking to make a serious impression.",
    "availableSizes": [
      "15x8"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "2 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "15 inch"
      ],
      "Published widths": [
        "8 inch"
      ],
      "Published PCDs": [
        "4X100",
        "4X114.3"
      ],
      "Published offsets": [
        "ET15"
      ],
      "Published finishes": [
        "Hyper Black & Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw08-9dda80a2-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw08-9dda80a2.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/Image_14.jpg?v=1743397055",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw08"
  },
  "Wheels::SpeedWorks::SW07": {
    "productUrl": "https://www.speedworks.com.au/products/sw07",
    "description": "The SpeedWorks SW07 captures racing spirit, high-calibre functionality, and hypnotising grace all into one sleek package. Long gone are the days where you had to choose between form and function - the SW07 lets you achieve both and does so in tremendous fashion.",
    "availableSizes": [
      "18x8.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "4 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X108",
        "5X112",
        "5X114.3"
      ],
      "Published offsets": [
        "ET40"
      ],
      "Published finishes": [
        "Satin Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw07-f49b796d-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw07-f49b796d.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/E.jpg?v=1743399900",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw07"
  },
  "Wheels::SpeedWorks::SW06": {
    "productUrl": "https://www.speedworks.com.au/products/sw06",
    "description": "The SpeedWorks SW06 is for those of us who like to stand out. A machined lip and dress-up bolts are sure to catch the eyes of anyone that takes a glance. Unapologetically flashy in the best way, the SW06 proves that cars can be an expression of oneself.",
    "availableSizes": [
      "18x8.5",
      "18x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "4 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X114.3",
        "5X120"
      ],
      "Published offsets": [
        "ET25",
        "ET28",
        "ET30",
        "ET35"
      ],
      "Published finishes": [
        "Gloss Black & Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw06-292ebe28-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw06-292ebe28.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_e0e3db01-79be-4c0b-9db4-0af715af586c.jpg?v=1729965216",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw06"
  },
  "Wheels::SpeedWorks::SWF11": {
    "productUrl": "https://www.speedworks.com.au/products/swf11",
    "description": "The SWF11 has a flowing, intricate spoke pattern with a slight directional lean to it, shown here in gunmetal. It's a close cousin to the busier faces in the range, but with longer, more sweeping spokes that draw the eye around the wheel. Being forged, it stays light even with the detailed face, so the look costs you nothing in performance. Built to order in your diameter, width, offset, stud pattern and finish. Priced per wheel, made to order, with a lead time of around 13 to 16 weeks.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13 to 16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf11-65cbdf2e-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf11-65cbdf2e.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/swf11.png?v=1730463490",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf11"
  },
  "Wheels::SpeedWorks::SWF10": {
    "productUrl": "https://www.speedworks.com.au/products/swf10",
    "description": "The SWF10 pairs a dense, twisted multi-spoke face with a deep concave profile, shown here in gloss black with a subtle machined edge. It's one of the deeper, more aggressive shapes in the range: the twist in the spokes gives it a directional, in-motion look even when the car is parked. Forged construction keeps the weight down despite how much wheel is there. Order it in your fitment and finish, diameter, width, offset and stud pattern to suit your car. Priced per wheel, forged and finished to spec, roughly 13 to 16 weeks.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13 to 16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf10-a767962e-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf10-a767962e.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/swf10.png?v=1669483543",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf10"
  },
  "Wheels::SpeedWorks::SWF09": {
    "productUrl": "https://www.speedworks.com.au/products/swf09",
    "description": "The SWF09 is a sculpted split-spoke design with real shaping through each spoke, shown here in satin black. It sits between clean and aggressive: the spokes twist slightly as they run out to the lip, so the face has movement to it rather than sitting flat. Fully forged, which is what lets the spokes be shaped that heavily without adding weight or losing strength. You choose the diameter, width, offset, stud pattern and finish, and each wheel is forged to that spec. Priced per wheel, made to order, around 13 to 16 weeks from order.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13 to 16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf09-52c103d5-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf09-52c103d5.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/swf09.png?v=1669483144",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf09"
  },
  "Wheels::SpeedWorks::SWF08": {
    "productUrl": "https://www.speedworks.com.au/products/swf08",
    "description": "The SWF08 has a delicate, airy face, fine forged spokes spread wide with plenty of open space between them, shown here in silver. It's a lightweight-looking design that shows off a lot of the brake and barrel behind it, which works well on cars where you want the wheel to look technical rather than heavy. Forged rather than cast, so those slim spokes carry real strength and the whole wheel stays light. Made to order in your choice of size, offset, stud pattern and finish. Priced per wheel, built to your spec, with a lead time of about 13 to 16 weeks.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13 to 16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf08-e4750f65-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf08-e4750f65.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/swf081.png?v=1669482898",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf08"
  },
  "Wheels::SpeedWorks::SWF07": {
    "productUrl": "https://www.speedworks.com.au/products/swf07",
    "description": "The SWF07 is a clean split five-spoke, each spoke forking into two as it reaches the lip, shown here in bright machined silver. It's the most classic and understated shape in the forged range, the kind of face that looks right on a European coupe or a restrained street car where you don't want to shout. The forged process means those thin, elegant spokes are far stronger than they look, so you get the light appearance without giving up strength. Built to order in your fitment and finish: diameter, width, offset and stud pattern all your call. Priced per wheel, forged to spec, around 13 to 16 weeks.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13 to 16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf07-d0c0cb25-cutout-clean.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf07-d0c0cb25.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/IMG-0450.jpg?v=1718432121",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf07"
  },
  "Wheels::SpeedWorks::SWF06": {
    "productUrl": "https://www.speedworks.com.au/products/swf06",
    "description": "The SWF06 wears a dense, intricate spoke pattern, thin forged spokes that fan out and split toward the lip for a technical look, shown here in dark gunmetal. It catches light across the whole face rather than just the spokes, which is why it reads more aggressive than a simple five-spoke. Forged construction keeps it light despite the detail, so there's no weight penalty for the busy face. Order it in your diameter, width, offset, stud pattern and finish, and it's built from scratch to fit your car. Priced per wheel, made to order, roughly 13 to 16 weeks from order to delivery.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13 to 16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf06-d487ac70-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf06-d487ac70.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/2-removebg-preview.png?v=1730464260",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf06"
  },
  "Wheels::SpeedWorks::SWF05": {
    "productUrl": "https://www.speedworks.com.au/products/swf05",
    "description": "Shown here in gloss black, the SWF05 has a bold, open spoke face and a deep concave profile with a stepped outer lip. It's the most old-school shape in the SpeedWorks Forged range, a wheel that suits a track build or an aggressive street setup where you want real depth sitting under the guard. Being fully forged, it holds its strength at a fraction of the weight of a cast wheel, so you drop unsprung mass exactly where it helps the car turn and stop. Every SWF05 is made to order in your choice of diameter, width, offset, stud pattern and finish, so it fits your car and no one else's. Priced per wheel, forged and finished to spec, with a lead time of around 12 to 16 weeks.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "12 to 16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf05-029e6cc2-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf05-029e6cc2.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/lmgt.png?v=1730464195",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf05"
  },
  "Wheels::SpeedWorks::SWF04": {
    "productUrl": "https://www.speedworks.com.au/products/swf04",
    "description": "SWF04 is the epitome of style and performance. As a twin spoke wheel, it offers a sleek and modern look that will elevate the appearance of any vehicle. This wheel is crafted from high-quality forged aluminium, ensuring maximum strength and durability. With its unique design, the SWF04 will turn heads wherever you go. Incorporating state-of-the-art technology, the SWF04 is engineered to provide improved handling, stability, and responsiveness, making it the perfect choice for high-performance vehicles. The wheel's lightweight design also helps to reduce unsprung weight, resulting in improved acceleration and braking performance. Whether you're hitting the track or cruising the streets, SWF04 delivers a superior driving experience. This wheel is also designed to meet strict safety standards, so you can drive with confidence knowing that you and your passengers are protected. With its stunning looks and outstanding performance, SWF04 is the ultimate upgrade for any car.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf04-6ec94bce-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf04-6ec94bce.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/IMG_1131.jpg?v=1730463985",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf04"
  },
  "Wheels::SpeedWorks::SWF03": {
    "productUrl": "https://www.speedworks.com.au/products/swf03",
    "description": "The SpeedWorks SWF03 is a race-inspired design made to tear up racetracks worldwide. With a similar twin 5-spoke curved design scheme to the SpeedWorks SWF02, you can rest assured that we have put these to the test, both on the road and on the racecourse. Machined entirely from a single 6061-T6 aluminium block, the SWF03 is tremendously rigid, astonishingly strong, and remarkably lightweight. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control. If you aren't able to pick-up in Sydney, allow another 5-7 business days for postage to you.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "6061-T6 aluminium construction",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf03-53312cff-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf03-53312cff.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/2Side_1.png?v=1730463897",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf03"
  },
  "Wheels::SpeedWorks::SWF02": {
    "productUrl": "https://www.speedworks.com.au/products/swf02",
    "description": "The SpeedWorks SWF02 has been made to be at the forefront of durability and strength whilst maintaining its elegant curves. The twin 5-spoke design features ridges alongside each spoke to stimulate weight-savings whilst its entrancing concavity adds to its high rate of brake clearance. With SpeedWorks' forging process, car enthusiast's may rest assured they are receiving high-grade wheels for their prized possessions. Machined entirely from a single 6061-T6 aluminium block, the SWF02 is extremely stiff, extraordinarily tough, and exceptionally lightweight. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control. If you aren't able to pick-up in Sydney, allow another 5-7 business days for postage to you.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "6061-T6 aluminium construction",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf02-626ff4e9-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf02-626ff4e9.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/Myproject-1_2.png?v=1730463665",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf02"
  },
  "Wheels::SpeedWorks::SWF01": {
    "productUrl": "https://www.speedworks.com.au/products/swf01",
    "description": "The SpeedWorks SWF01 pairs a performance-enhancing design with grippingly charming looks to better equip serious car enthusiasts for both the track and the road. Featuring 10 sleek spokes with great brake-clearance, you can rest assured you're kitting your vehicle with state-of-the-art technology. Machined entirely from a single 6061-T6 aluminium block, the SWF01 is a wheel that provides exceptional strength and rigidity, coupled with an incredibly lightweight. Lead times are approximately 13-16 weeks from the initial payment is received - this includes rendering, production, painting & quality control. If you aren't able to pick-up in Sydney, allow another 5-7 business days for postage to you.",
    "availableSizes": [],
    "notes": [
      "This wheel is made to order; 110 Garage will confirm the final dimensions, finish, timing and vehicle clearance"
    ],
    "features": [
      "Current official SpeedWorks Australia Forged Monoblock model",
      "6061-T6 aluminium construction",
      "Manufactured to order for the selected vehicle and finish",
      "Final dimensions and fitment are configured by enquiry"
    ],
    "specifications": {
      "Range": "Forged Monoblock",
      "Construction": "Custom forged monoblock",
      "Sizing": "Custom diameter, width, offset, stud pattern and centre bore, confirmed for the selected vehicle",
      "Published lead time": "13-16 weeks"
    },
    "localImage": "product-catalog-wheels-speedworks-swf01-00329a3f-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-swf01-00329a3f.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/products/2Side.jpg?v=1730463622",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/swf01"
  },
  "Wheels::SpeedWorks::SW03": {
    "productUrl": "https://www.speedworks.com.au/products/sw03",
    "description": "The SW03 may be a new design, but it fits in as if it has always been a cornerstone of the car scene as we know it. Featuring a 10-spoke look, the SpeedWorks SW03 renders itself to be a natural choice for the serious car enthusiast looking to enhance their ride's looks.",
    "availableSizes": [
      "18x8"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "3 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X112",
        "5X114.3"
      ],
      "Published offsets": [
        "ET38"
      ],
      "Published finishes": [
        "Matte Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw03-8b697570-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw03-8b697570.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1-Photoroom.jpg?v=1729964543",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw03"
  },
  "Wheels::SpeedWorks::SW02": {
    "productUrl": "https://www.speedworks.com.au/products/sw02",
    "description": "Styles come and go, but the SW02 is truly timeless. Featured alongside some of the most popular Japanese and European tuner cars, the SpeedWorks SW02 never gets old. Providing your car with sophistication like no other and striking elegance, you'll be garnering praise wherever you and your car find yourselves.",
    "availableSizes": [
      "18x8",
      "19x8.5",
      "19x9.5"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "5 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch",
        "19 inch"
      ],
      "Published widths": [
        "8 inch",
        "8.5 inch",
        "9.5 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X112",
        "5X114.3",
        "5X120"
      ],
      "Published offsets": [
        "ET25",
        "ET30",
        "ET35"
      ],
      "Published finishes": [
        "Hyper Black & Machine Lip"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw02-649988c3-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw02-649988c3.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_3c1cd4d9-1e41-4350-88a4-426d4af86ce2.jpg?v=1729964432",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw02"
  },
  "Wheels::SpeedWorks::SW01": {
    "productUrl": "https://www.speedworks.com.au/products/sw01",
    "description": "Whether you're looking to add a hint of classic styles to your car or pay ode to the timeless Japanese designs, the SpeedWorks SW01 achieves your goal. Featuring a twin 5-spoke design that we can't stop staring at, you'll be sure to turn heads wherever you go.",
    "availableSizes": [
      "18x8"
    ],
    "notes": [
      "Pricing, current stock and final vehicle clearance are confirmed by 110 Garage"
    ],
    "features": [
      "Current official SpeedWorks Australia Alloy Wheels model",
      "6 supplier-published fitment combinations recorded"
    ],
    "specifications": {
      "Range": "Alloy Wheels",
      "Construction": "Aluminium alloy",
      "Available diameters": [
        "18 inch"
      ],
      "Published widths": [
        "8 inch"
      ],
      "Published PCDs": [
        "5X100",
        "5X114.3"
      ],
      "Published offsets": [
        "ET38"
      ],
      "Published finishes": [
        "Bronze",
        "Gloss Black",
        "Hyper Black"
      ]
    },
    "localImage": "product-catalog-wheels-speedworks-sw01-b19849c4-cutout.webp",
    "galleryImages": [
      "product-catalog-wheels-speedworks-sw01-b19849c4.webp"
    ],
    "imageSourceUrl": "https://cdn.shopify.com/s/files/1/0684/1919/1094/files/1_0952cc6f-34c8-4b1b-97e5-10eb04b0d40a.jpg?v=1729964261",
    "descriptionSource": "official-product-feed",
    "descriptionSourceUrl": "https://www.speedworks.com.au/products/sw01"
  },
  "Wheels::JSR Wheels::ST06": {
    "productUrl": "https://jsrwheels.com/wheels/st06/",
    "description": "JSR ST06 is an official Japan Street Racing wheel model offered in 18-inch and 19-inch diameters. JSR publishes Gloss Black Machined Lip, Gloss White Machined Lip, Gunmetal Grey Machined Lip and Satin Black finishes.",
    "availableSizes": [
      "18 inch",
      "19 inch"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage",
      "Published options can change; confirm the exact size, finish and fitment before ordering"
    ],
    "features": [
      "Official JSR / Japan Street Racing wheel model",
      "Published in 18-inch and 19-inch diameters",
      "Four official finish galleries"
    ],
    "specifications": {
      "Published diameters": [
        "18 inch",
        "19 inch"
      ],
      "Published finishes": [
        "Gloss Black Machined Lip",
        "Gloss White Machined Lip",
        "Gunmetal Grey Machined Lip",
        "Satin Black"
      ],
      "Published PCD options": [
        "5x112",
        "5x114.3",
        "5x115",
        "5x118",
        "5x120"
      ]
    },
    "localImage": "product-catalog-wheels-jsr-wheels-st06-gloss-black-machined-lip-1-bcb0be3b.webp",
    "galleryImages": [
      "product-catalog-wheels-jsr-wheels-st06-gloss-black-machined-lip-1-bcb0be3b.webp",
      "product-catalog-wheels-jsr-wheels-st06-gloss-black-machined-lip-2-009158c2.webp",
      "product-catalog-wheels-jsr-wheels-st06-gloss-black-machined-lip-3-d81db139.webp",
      "product-catalog-wheels-jsr-wheels-st06-gloss-white-machined-lip-1-8d773a41.webp",
      "product-catalog-wheels-jsr-wheels-st06-gloss-white-machined-lip-2-617cda4f.webp",
      "product-catalog-wheels-jsr-wheels-st06-gloss-white-machined-lip-3-1bdc6600.webp",
      "product-catalog-wheels-jsr-wheels-st06-gunmetal-grey-machined-lip-1-b38af102.webp",
      "product-catalog-wheels-jsr-wheels-st06-gunmetal-grey-machined-lip-2-46c29d05.webp",
      "product-catalog-wheels-jsr-wheels-st06-gunmetal-grey-machined-lip-3-d81c52a3.webp",
      "product-catalog-wheels-jsr-wheels-st06-satin-black-1-7a76ef49.webp",
      "product-catalog-wheels-jsr-wheels-st06-satin-black-2-04a20596.webp",
      "product-catalog-wheels-jsr-wheels-st06-satin-black-3-dbdf034a.webp"
    ],
    "imageSourceUrl": "https://jsrwheels.com/wp-content/uploads/2025/05/JDM_WHEELS_JSR_ST06_GLOSS_BLACK_MACHINED_LIP_JAPAN_STREET_RACING_RIMS_18_INCH_STAGGERED_MAGS_1.webp",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://jsrwheels.com/wheels/st06/"
  },
  "Wheels::JSR Wheels::ST10": {
    "productUrl": "https://jsrwheels.com/wheels/st10/",
    "description": "JSR ST10 is a flow-formed Japan Street Racing wheel published in an 18x8.5-inch size for five-stud applications. JSR lists supported PCDs from 5x98 to 5x120 and custom offsets from 22 mm to 40 mm.",
    "availableSizes": [
      "18x8.5"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage",
      "Published options can change; confirm the exact size, finish and fitment before ordering"
    ],
    "features": [
      "Flow-formed construction",
      "Five-stud vehicle applications",
      "Official JSR technical article available"
    ],
    "specifications": {
      "Published size": [
        "18x8.5 inch"
      ],
      "Published PCD range": [
        "5x98 to 5x120"
      ],
      "Published offset range": [
        "22 mm to 40 mm"
      ],
      "Published finishes": [
        "Satin Black",
        "Gloss Black Machined Lip",
        "Gunmetal Grey",
        "Gunmetal Grey Machined Lip",
        "Midnight Blue"
      ],
      "Construction": [
        "Flow formed"
      ]
    },
    "localImage": "product-catalog-wheels-jsr-wheels-st10-gloss-black-machined-lip-1-c86977b5.webp",
    "galleryImages": [
      "product-catalog-wheels-jsr-wheels-st10-gloss-black-machined-lip-1-c86977b5.webp",
      "product-catalog-wheels-jsr-wheels-st10-gloss-black-machined-lip-2-5069aab4.webp",
      "product-catalog-wheels-jsr-wheels-st10-gloss-black-machined-lip-3-de1280d9.webp"
    ],
    "imageSourceUrl": "https://jsrwheels.com/wp-content/uploads/2025/04/JDM_WHEELS_JSR_ST10_GLOSS_BLACK_MACHINED_LIP_JAPAN_STREET_RACING_RIMS_18_INCH_MAGS_1.webp",
    "descriptionSource": "official-technical-article",
    "descriptionSourceUrl": "https://jsrwheels.com/an-inside-look-at-the-jsr-st10-wheel-strength-style-and-speed/"
  },
  "Wheels::JSR Wheels::ST15": {
    "productUrl": "https://jsrwheels.com/wheels/st15/",
    "description": "JSR ST15 is an official Japan Street Racing wheel model with a deep-lip multi-spoke design. Ask 110 Garage to confirm current Australian finish, size and vehicle fitment options before ordering.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage",
      "Published options can change; confirm the exact size, finish and fitment before ordering"
    ],
    "features": [
      "Official JSR / Japan Street Racing wheel model",
      "Deep-lip multi-spoke design",
      "Official silver and black machined-lip product media"
    ],
    "specifications": {
      "Published media finishes": [
        "Gloss Silver Machined Lip",
        "Gloss Black Machined Lip"
      ]
    },
    "localImage": "product-catalog-wheels-jsr-wheels-st15-gloss-silver-machined-lip-1-480ceaa6.webp",
    "galleryImages": [
      "product-catalog-wheels-jsr-wheels-st15-gloss-silver-machined-lip-1-480ceaa6.webp",
      "product-catalog-wheels-jsr-wheels-st15-gloss-silver-machined-lip-2-f9b5333d.webp",
      "product-catalog-wheels-jsr-wheels-st15-gloss-silver-machined-lip-3-2d008806.webp",
      "product-catalog-wheels-jsr-wheels-st15-gloss-black-machined-lip-1-48be15ee.webp",
      "product-catalog-wheels-jsr-wheels-st15-gloss-black-machined-lip-2-9fc350f0.webp",
      "product-catalog-wheels-jsr-wheels-st15-gloss-black-machined-lip-3-6ddfbb15.webp"
    ],
    "imageSourceUrl": "https://jsrwheels.com/wp-content/uploads/2025/04/JDM_WHEELS_JSR_ST15_GLOSS_SILVER_MACHINED_LIP_JAPAN_STREET_RACING_RIMS_18_19_INCH_STAGGERED_MAGS_1.webp",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://jsrwheels.com/wheels/st15/"
  },
  "Wheels::JSR Wheels::ST19": {
    "productUrl": "https://jsrwheels.com/wheels/st19/",
    "description": "JSR ST19 is an official Japan Street Racing mesh wheel model. Ask 110 Garage to confirm current Australian finish, size and vehicle fitment options before ordering.",
    "availableSizes": [
      "Get in contact with us to learn if this fits your vehicle!"
    ],
    "notes": [
      "Pricing, Australian stock and final vehicle fitment are confirmed by 110 Garage",
      "Published options can change; confirm the exact size, finish and fitment before ordering"
    ],
    "features": [
      "Official JSR / Japan Street Racing wheel model",
      "Mesh spoke design",
      "Official silver machined-lip product media"
    ],
    "specifications": {
      "Published media finish": [
        "Silver Machined Lip"
      ]
    },
    "localImage": "product-catalog-wheels-jsr-wheels-st19-silver-machined-lip-1-c6b7ffa2.webp",
    "galleryImages": [
      "product-catalog-wheels-jsr-wheels-st19-silver-machined-lip-1-c6b7ffa2.webp",
      "product-catalog-wheels-jsr-wheels-st19-silver-machined-lip-2-b009a459.webp",
      "product-catalog-wheels-jsr-wheels-st19-silver-machined-lip-3-c624e684.webp"
    ],
    "imageSourceUrl": "https://jsrwheels.com/wp-content/uploads/2025/04/JDM_WHEELS_JSR_ST19_SILVER_MACHINED_LIP_JAPAN_STREET_RACING_RIMS_18_INCH_MESH_MAGS_1.webp",
    "descriptionSource": "official-product-page",
    "descriptionSourceUrl": "https://jsrwheels.com/wheels/st19/"
  }
};
